import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Json: any;
  RawJson: any;
  Date: any;
  ISO8601DateTime: any;
  EventTypeEnum: any;
  BigInt: any;
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  accountBillingInfo: BillingInfo;
  accountConnector?: Maybe<AccountConnector>;
  accountConnectors: Array<AccountConnector>;
  accountNotifications: Array<AccountNotification>;
  adMetrics?: Maybe<AdMetrics>;
  allCompanies: CompanyConnection;
  apiUsage?: Maybe<ApiUsage>;
  attributes: Array<Attribute>;
  audience?: Maybe<Audience>;
  audiencePreview?: Maybe<AudiencePreview>;
  audiences: AudienceConnection;
  availableFeatureFlags: Array<Scalars['String']>;
  campaigns?: Maybe<Array<Campaign>>;
  collection?: Maybe<Collection>;
  collections?: Maybe<CollectionConnection>;
  columns: Array<Scalars['String']>;
  companies: CompanyConnection;
  company?: Maybe<Company>;
  conversionEvents: ConversionEventConnection;
  crmPresence?: Maybe<CrmPresenceConnection>;
  csvImport?: Maybe<CsvImport>;
  csvImports: Array<CsvImport>;
  customObjects: CustomObjectConnection;
  destinationOptions: DestinationOptions;
  enrichmentAttributes: Array<EnrichmentAttribute>;
  enrichmentData: EnrichmentData;
  enrichmentFieldMappings?: Maybe<EnrichmentFieldMappings>;
  enrichmentHealthMetric: EnrichmentHealthMetric;
  enrichmentLog: EnrichmentLogQueryStart;
  enrichmentLogResult?: Maybe<EnrichmentLog>;
  enrichmentLogs: EnrichmentLogQueryStart;
  enrichmentLogsResult: Array<EnrichmentLog>;
  enrichmentLogsStatus?: Maybe<EnrichmentLogQueryStatus>;
  enrichmentRecentUsage: Array<DailyUsage>;
  eventTypes: Array<Scalars['EventTypeEnum']>;
  fieldMapping?: Maybe<FieldMapping>;
  fieldMatchRates: Scalars['Json'];
  fitModel?: Maybe<FitModel>;
  formConfiguration?: Maybe<FormConfiguration>;
  formFieldMapping: FormFieldMappings;
  googleAnalyticsConfig?: Maybe<GoogleAnalytics>;
  googleConversionTrackers: Array<GoogleConversionTracker>;
  googleTagManagerConfig?: Maybe<GoogleTagManager>;
  hubspotEnrichmentSettings?: Maybe<HubspotEnrichmentSettings>;
  hubspotList?: Maybe<HubspotList>;
  hubspotLists?: Maybe<HubspotListConnection>;
  jobHistory: JobHistory;
  news: News;
  people: PersonConnection;
  person?: Maybe<Person>;
  productFeature?: Maybe<ProductFeature>;
  productFeatures: Array<ProductFeature>;
  prospectCrmPresences: Array<ProspectCrmPresence>;
  prospectFilters: ProspectFilters;
  prospectList?: Maybe<ProspectList>;
  prospectListExport?: Maybe<ProspectListExport>;
  prospectListExports?: Maybe<ProspectListExportConnection>;
  prospectLists?: Maybe<ProspectListConnection>;
  prospects?: Maybe<ProspectConnection>;
  publishableKeys?: Maybe<Array<PublishableKey>>;
  rollupCounts: DashboardMetrics;
  salesforceTraits: Array<SalesforceTrait>;
  salesforceUsers?: Maybe<Array<SalesforceUser>>;
  salesPipeline?: Maybe<SalesPipeline>;
  searchAttributes?: Maybe<Array<Attribute>>;
  segment?: Maybe<Segment>;
  segmentExport: Array<Export>;
  segments?: Maybe<SegmentConnection>;
  tagManager?: Maybe<TagManager>;
  targetMarketCompanies: Scalars['Json'];
  targetMarketPreview?: Maybe<TargetMarketPreview>;
  targetMarkets: Scalars['Json'];
  usageActionAllowed: Scalars['Boolean'];
  usageBreakdown: Scalars['Json'];
  usageBreakdownV2: Scalars['Json'];
  viewer: Viewer;
};


export type QueryAccountConnectorArgs = {
  service: Array<AccountConnectorServiceEnum>;
  status: Array<AccountConnectorStatusEnum>;
};


export type QueryAccountConnectorsArgs = {
  service?: InputMaybe<Array<AccountConnectorServiceEnum>>;
  status?: InputMaybe<Array<AccountConnectorStatusEnum>>;
};


export type QueryAccountNotificationsArgs = {
  service?: InputMaybe<AccountConnectorServiceEnum>;
};


export type QueryAdMetricsArgs = {
  dateWindow?: InputMaybe<DateWindowEnum>;
};


export type QueryAllCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryApiUsageArgs = {
  planId?: InputMaybe<ApiUsagePlanEnum>;
};


export type QueryAttributesArgs = {
  categories: Array<AttributeCategoryEnum>;
  nested?: InputMaybe<Scalars['Boolean']>;
  type: AttributeTypeEnum;
};


export type QueryAudienceArgs = {
  id: Scalars['ID'];
};


export type QueryAudiencePreviewArgs = {
  id: Scalars['ID'];
};


export type QueryAudiencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AudienceFilterEnum>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AudienceOrderEnum>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignsArgs = {
  dateWindow?: InputMaybe<DateWindowEnum>;
};


export type QueryCollectionArgs = {
  id: Scalars['ID'];
  type: CollectionTypeEnum;
};


export type QueryCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  type: CollectionLegacyTypeEnum;
};


export type QueryColumnsArgs = {
  segmentId?: InputMaybe<Scalars['ID']>;
  type: ColumnTypeEnum;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  segmentId?: InputMaybe<Scalars['ID']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryConversionEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  destinationId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCrmPresenceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  domains: Array<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCsvImportArgs = {
  id: Scalars['ID'];
};


export type QueryCsvImportsArgs = {
  type: Scalars['String'];
};


export type QueryCustomObjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryEnrichmentAttributesArgs = {
  categorize?: InputMaybe<Scalars['Boolean']>;
  excludePersonPhone?: InputMaybe<Scalars['Boolean']>;
  refreshAttributes?: InputMaybe<Scalars['Boolean']>;
  service?: InputMaybe<Array<AccountConnectorServiceEnum>>;
  traitFilter?: InputMaybe<SystemTraitValueEnum>;
  types: Array<EnrichmentAttributeTypeEnum>;
};


export type QueryEnrichmentDataArgs = {
  encryptedDomain: Scalars['String'];
};


export type QueryEnrichmentHealthMetricArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  externalType?: InputMaybe<AccountConnectorServiceEnum>;
  metricName: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};


export type QueryEnrichmentLogArgs = {
  id: Scalars['ID'];
  type: EnrichmentLogTypeEnum;
};


export type QueryEnrichmentLogResultArgs = {
  queryExecutionId: Scalars['String'];
};


export type QueryEnrichmentLogsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<EnrichmentLogStatusEnum>>;
  type: EnrichmentLogTypeEnum;
};


export type QueryEnrichmentLogsResultArgs = {
  queryExecutionId: Scalars['String'];
};


export type QueryEnrichmentLogsStatusArgs = {
  queryExecutionId: Scalars['String'];
};


export type QueryFieldMappingArgs = {
  accountConnectorId: Scalars['ID'];
  targetObjectType: Scalars['String'];
};


export type QueryFieldMatchRatesArgs = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
  type: RecordIdentifierEnum;
};


export type QueryFitModelArgs = {
  type: FitModelTypeEnum;
};


export type QueryFormConfigurationArgs = {
  integration: FormIntegrationEnum;
};


export type QueryFormFieldMappingArgs = {
  integration: FormIntegrationEnum;
};


export type QueryGoogleConversionTrackersArgs = {
  adAccountId: Scalars['String'];
};


export type QueryHubspotListArgs = {
  id: Scalars['ID'];
};


export type QueryHubspotListsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryJobHistoryArgs = {
  jobId?: InputMaybe<Scalars['String']>;
  queue?: InputMaybe<Scalars['String']>;
};


export type QueryPeopleArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['ID']>;
};


export type QueryPersonArgs = {
  id: Scalars['ID'];
};


export type QueryProductFeatureArgs = {
  id: ProductFeatureEnum;
};


export type QueryProspectCrmPresencesArgs = {
  prospectIds: Array<Scalars['String']>;
};


export type QueryProspectFiltersArgs = {
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryProspectListArgs = {
  id: Scalars['ID'];
};


export type QueryProspectListExportArgs = {
  id: Scalars['ID'];
};


export type QueryProspectListExportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProspectListExportFilterEnum>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryProspectListsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryProspectsArgs = {
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyCities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyCountries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyTech?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  domain?: InputMaybe<Scalars['String']>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  employeesRanges?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  industries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seniorities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRollupCountsArgs = {
  end: Scalars['Date'];
  start: Scalars['Date'];
};


export type QuerySalesforceTraitsArgs = {
  objectType: SalesforceObjectTypeEnum;
};


export type QuerySalesforceUsersArgs = {
  externalIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerySalesPipelineArgs = {
  dateWindow?: InputMaybe<DateWindowEnum>;
};


export type QuerySearchAttributesArgs = {
  categories: Array<AttributeCategoryEnum>;
  hubspotSubCategories?: InputMaybe<Array<AttributeHubspotSubCategoryEnum>>;
  marketoSubCategories?: InputMaybe<Array<AttributeMarketoSubCategoryEnum>>;
  nested?: InputMaybe<Scalars['Boolean']>;
  salesforceSubCategories?: InputMaybe<Array<AttributeSalesforceSubCategoryEnum>>;
  type: AttributeTypeEnum;
};


export type QuerySegmentArgs = {
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<SegmentTypeEnum>;
};


export type QuerySegmentExportArgs = {
  segmentId?: InputMaybe<Scalars['ID']>;
  status: Array<ExportStatusEnum>;
  type: SegmentLegacyTypeEnum;
};


export type QuerySegmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SegmentFilterEnum>;
  first?: InputMaybe<Scalars['Int']>;
  includeTargetMarkets?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  type: SegmentLegacyTypeEnum;
};


export type QueryTagManagerArgs = {
  service: TagManagerServiceEnum;
};


export type QueryTargetMarketCompaniesArgs = {
  country?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Array<Scalars['String']>>;
  employees?: InputMaybe<Array<Scalars['String']>>;
  industry?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  raised?: InputMaybe<Array<Scalars['String']>>;
  tag?: InputMaybe<Array<Scalars['String']>>;
  tech?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryTargetMarketPreviewArgs = {
  businessModel: Array<InputMaybe<Scalars['String']>>;
  country: Array<InputMaybe<Scalars['String']>>;
  employees: Array<InputMaybe<Scalars['String']>>;
  industry: Array<InputMaybe<Scalars['String']>>;
  raised: Array<InputMaybe<Scalars['String']>>;
  tag: Array<InputMaybe<Scalars['String']>>;
  tech: Array<InputMaybe<Scalars['String']>>;
  type: Array<InputMaybe<Scalars['String']>>;
};


export type QueryUsageActionAllowedArgs = {
  credits: Scalars['Int'];
};


export type QueryUsageBreakdownArgs = {
  endDate: Scalars['Date'];
  granularity: UsageBreakdownGranularityEnum;
  startDate: Scalars['Date'];
  usageMetricGraph: Scalars['Json'];
  usageTerm: SubscriptionBillingTermEnum;
};


export type QueryUsageBreakdownV2Args = {
  endDate: Scalars['Date'];
  granularity: UsageBreakdownGranularityEnum;
  startDate: Scalars['Date'];
  usageMetricGraph: Scalars['Json'];
};

export type Account = {
  __typename?: 'Account';
  accountSetting?: Maybe<AccountSetting>;
  apiVersions: AccountApiVersions;
  connectors: Array<AccountConnector>;
  creditsBasedTier?: Maybe<CreditsBasedTierEnum>;
  domain?: Maybe<Scalars['String']>;
  flags: Array<AccountFlagEnum>;
  id: Scalars['ID'];
  members: MembershipConnection;
  membershipInvites: MembershipInviteConnection;
  mfaEnforced?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  plans: Array<AccountPlanEnum>;
  platformAccess: AccountPlatformAccess;
  publishableToken?: Maybe<Scalars['String']>;
  remoteAllowedReferrers: Array<Scalars['String']>;
  secretToken?: Maybe<Scalars['String']>;
  subscriptions: Array<Subscription>;
  suppressionSettings: AccountSuppressionSettings;
  webhookUrl?: Maybe<Scalars['String']>;
};


export type AccountConnectorsArgs = {
  service?: InputMaybe<Array<AccountConnectorServiceEnum>>;
  status?: InputMaybe<Array<AccountConnectorStatusEnum>>;
};


export type AccountMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type AccountMembershipInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type AccountSetting = {
  __typename?: 'AccountSetting';
  dataSources: Array<Scalars['String']>;
  firstPageEventReceivedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  onboardingSkipped: Scalars['Boolean'];
  tamAudience?: Maybe<Scalars['Json']>;
};

export type AccountApiVersions = {
  __typename?: 'AccountApiVersions';
  company: ApiVersion;
  person: ApiVersion;
  prospector: ApiVersion;
  reveal: ApiVersion;
  risk: ApiVersion;
  watchlist: ApiVersion;
};

export type ApiVersion = {
  __typename?: 'ApiVersion';
  current: Scalars['String'];
  latest: Scalars['String'];
};

export enum AccountConnectorServiceEnum {
  Facebook = 'facebook',
  G2 = 'g2',
  Google = 'google',
  Hubspot = 'hubspot',
  Marketo = 'marketo',
  Salesforce = 'salesforce',
  Salesforcesandbox = 'salesforcesandbox',
  Segment = 'segment',
  Slack = 'slack'
}

export enum AccountConnectorStatusEnum {
  Active = 'active',
  Disconnected = 'disconnected',
  Error = 'error'
}

export type AccountConnector = {
  accountId: Scalars['ID'];
  backfillActive: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  fieldMapping?: Maybe<FieldMapping>;
  id: Scalars['ID'];
  isInitialSync?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextSyncAt?: Maybe<Scalars['DateTime']>;
  notification?: Maybe<AccountNotification>;
  remoteMeta: Scalars['Json'];
  selectiveEnrichmentFilters?: Maybe<SelectiveEnrichmentFilters>;
  service: AccountConnectorServiceEnum;
  status: AccountConnectorStatusEnum;
  syncProgress?: Maybe<Scalars['Int']>;
  syncStartedAt?: Maybe<Scalars['DateTime']>;
  syncStatus?: Maybe<Scalars['String']>;
  webhookPassword?: Maybe<Scalars['String']>;
};


export type AccountConnectorBackfillActiveArgs = {
  targetObjectType?: InputMaybe<Scalars['String']>;
};


export type AccountConnectorFieldMappingArgs = {
  targetObjectType: Scalars['String'];
};


export type AccountConnectorSelectiveEnrichmentFiltersArgs = {
  externalObjectType: Scalars['String'];
};

export type FieldMapping = {
  __typename?: 'FieldMapping';
  clearbitAccountId?: Maybe<Scalars['ID']>;
  enabled: Scalars['Boolean'];
  fieldMappings: Array<Scalars['Json']>;
  targetAccountId: Scalars['String'];
  targetObjectType: Scalars['String'];
  targetType: AccountConnectorServiceEnum;
};

export type AccountNotification = {
  __typename?: 'AccountNotification';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  notificationType: AccountNotificationTypeEnum;
  resolved: Scalars['Boolean'];
  segmentId?: Maybe<Scalars['String']>;
  segmentType?: Maybe<Scalars['String']>;
  service?: Maybe<AccountConnectorServiceEnum>;
  sourceId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum AccountNotificationTypeEnum {
  AccountConnectorAuth = 'account_connector_auth',
  AccountConnectorConfirmUser = 'account_connector_confirm_user',
  AccountConnectorEnrichmentError = 'account_connector_enrichment_error',
  AccountConnectorTerms = 'account_connector_terms',
  DestinationArchivedSlackChannel = 'destination_archived_slack_channel',
  GoogleConversionActionNotFound = 'google_conversion_action_not_found',
  SalesforceOrgApiDisabled = 'salesforce_org_api_disabled',
  SalesforceSyncError = 'salesforce_sync_error',
  SalesforceUserApiDisabled = 'salesforce_user_api_disabled',
  UsageCreditsOverQuota = 'usage_credits_over_quota'
}

export type SelectiveEnrichmentFilters = {
  __typename?: 'SelectiveEnrichmentFilters';
  clearbitAccountId: Scalars['ID'];
  externalAccountId: Scalars['String'];
  externalObjectType: Scalars['String'];
  filters?: Maybe<Scalars['RawJson']>;
  targetType: AccountConnectorServiceEnum;
};

export enum CreditsBasedTierEnum {
  BusinessTier = 'business_tier',
  FreeTier = 'free_tier',
  HubspotFreeTier = 'hubspot_free_tier',
  HubspotPaidTier = 'hubspot_paid_tier',
  HubspotPlatformFree = 'hubspot_platform_free',
  HubspotPlatformPaid = 'hubspot_platform_paid',
  PaidTier = 'paid_tier'
}

export enum AccountFlagEnum {
  AllowApiUsageTab = 'allow_api_usage_tab',
  AllowCreditsBasedUsage = 'allow_credits_based_usage',
  AllowDataEnrichmentPreview = 'allow_data_enrichment_preview',
  AllowPlatform = 'allow_platform',
  AllowPlatformAdvertisingMenu = 'allow_platform_advertising_menu',
  AllowPlatformBypassDisabledUpgrade = 'allow_platform_bypass_disabled_upgrade',
  AllowPlatformCapture = 'allow_platform_capture',
  AllowPlatformCapturePreview = 'allow_platform_capture_preview',
  AllowPlatformCaptureProspector = 'allow_platform_capture_prospector',
  AllowPlatformConnectorFacebook = 'allow_platform_connector_facebook',
  AllowPlatformConnectorGoogleAds = 'allow_platform_connector_google_ads',
  AllowPlatformCsvExport = 'allow_platform_csv_export',
  AllowPlatformCsvExportWarningBanner = 'allow_platform_csv_export_warning_banner',
  AllowPlatformDisplayFreeTierApiUsage = 'allow_platform_display_free_tier_api_usage',
  AllowPlatformForceSmallEmailDigest = 'allow_platform_force_small_email_digest',
  AllowPlatformGateUsage = 'allow_platform_gate_usage',
  AllowPlatformGoogleAnalyticsConfig = 'allow_platform_google_analytics_config',
  AllowPlatformHubspotConfig = 'allow_platform_hubspot_config',
  AllowPlatformMarketoConfig = 'allow_platform_marketo_config',
  AllowPlatformSalesforceConfig = 'allow_platform_salesforce_config',
  AllowPlatformSegmentConfig = 'allow_platform_segment_config',
  AllowPlatformShowSelfServeBillingUi = 'allow_platform_show_self_serve_billing_ui',
  AllowPlatformUnboundedSegmentExports = 'allow_platform_unbounded_segment_exports',
  AllowPlatformUsageDetailedBreakdown = 'allow_platform_usage_detailed_breakdown',
  AllowPlatformWebhookDestination = 'allow_platform_webhook_destination',
  AllowProspector = 'allow_prospector',
  AllowShowUpgradeToPaidPlanCta = 'allow_show_upgrade_to_paid_plan_cta',
  AllowUnlimitedAlerts = 'allow_unlimited_alerts',
  AllowUnlimitedCompanyApi = 'allow_unlimited_company_api',
  AllowUnlimitedCrmEnrichments = 'allow_unlimited_crm_enrichments',
  AllowUnlimitedDiscoveryApi = 'allow_unlimited_discovery_api',
  AllowUnlimitedFormEnrichments = 'allow_unlimited_form_enrichments',
  AllowUnlimitedPersonApi = 'allow_unlimited_person_api',
  AllowUnlimitedPlatformExports = 'allow_unlimited_platform_exports',
  AllowUnlimitedProspectorApi = 'allow_unlimited_prospector_api',
  AllowUnlimitedRevealApi = 'allow_unlimited_reveal_api',
  CircuitBreakerPlatformAlerts = 'circuit_breaker_platform_alerts',
  CircuitBreakerPlatformAudiences = 'circuit_breaker_platform_audiences',
  CircuitBreakerPlatformCsvExport = 'circuit_breaker_platform_csv_export',
  CircuitBreakerPlatformFormEnrichment = 'circuit_breaker_platform_form_enrichment',
  FreeBatch = 'free_batch',
  FullVisitorReport = 'full_visitor_report',
  LastInvoiceFailed = 'last_invoice_failed',
  LastInvoiceSucceeded = 'last_invoice_succeeded',
  MarketoConditionalOverwrite = 'marketo_conditional_overwrite',
  NotificationSettingsAdsManagement = 'notification_settings_ads_management',
  PerMatch = 'per_match',
  RolloutBillDirectlyToStripe = 'rollout_bill_directly_to_stripe',
  RolloutPlatformNewDashboard = 'rollout_platform_new_dashboard',
  RolloutPlatformNewSettings = 'rollout_platform_new_settings',
  RolloutPlatformProspectorUi = 'rollout_platform_prospector_ui',
  RolloutPlatformProspectorUiCrmExports = 'rollout_platform_prospector_ui_crm_exports',
  RolloutPlatformProspectorUiExports = 'rollout_platform_prospector_ui_exports',
  RolloutPlatformRelayAudiences = 'rollout_platform_relay_audiences',
  ShowMarketoTalkToSales = 'show_marketo_talk_to_sales',
  ShowPardotTalkToSales = 'show_pardot_talk_to_sales',
  ShowPlatformUnifiedUi = 'show_platform_unified_ui',
  ShowPlatformUniversalUsage = 'show_platform_universal_usage',
  VisitorReportInPlatform = 'visitor_report_in_platform',
  XAudienceExportLinkedin = 'x_audience_export_linkedin',
  XAutomaticIdentifies = 'x_automatic_identifies',
  XClearbitInternal = 'x_clearbit_internal',
  XDataEnrichment = 'x_data_enrichment',
  XDataEnrichmentErrors = 'x_data_enrichment_errors',
  XDataEnrichmentHubspot = 'x_data_enrichment_hubspot',
  XDataEnrichmentLogs = 'x_data_enrichment_logs',
  XDataEnrichmentNewUiBeta = 'x_data_enrichment_new_ui_beta',
  XDeprecateCompaniesTable = 'x_deprecate_companies_table',
  XDestinationCreateSalesforceAccount = 'x_destination_create_salesforce_account',
  XDestinationCreateSalesforceLeadsContacts = 'x_destination_create_salesforce_leads_contacts',
  XEngagement = 'x_engagement',
  XEnrichmentHealth = 'x_enrichment_health',
  XExperimentalTagsJs = 'x_experimental_tags_js',
  XFitScore = 'x_fit_score',
  XGa4Tags = 'x_ga4_tags',
  XGoogleAdsV13 = 'x_google_ads_v13',
  XGoogleApiReplacement = 'x_google_api_replacement',
  XGoogleManagedVisitorAudiences = 'x_google_managed_visitor_audiences',
  XMarketoOnPlatformBeta = 'x_marketo_on_platform_beta',
  XMoreFrequentSlackAlerts = 'x_more_frequent_slack_alerts',
  XPublishUsage = 'x_publish_usage',
  XSalesforceRealtimeIngestionAllFields = 'x_salesforce_realtime_ingestion_all_fields',
  XSfdcAccountGroupingByDomain = 'x_sfdc_account_grouping_by_domain',
  XShowUsageOnPlatform = 'x_show_usage_on_platform',
  XUnifiedForms = 'x_unified_forms',
  XUsageUiDisplayDetailButtons = 'x_usage_ui_display_detail_buttons',
  XUsageUiDisplayLearnMoreLinks = 'x_usage_ui_display_learn_more_links',
  XUseClearbitjsNext = 'x_use_clearbitjs_next',
  XUseCompaniesApiService = 'x_use_companies_api_service'
}

/** The connection type for Membership. */
export type MembershipConnection = {
  __typename?: 'MembershipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MembershipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Membership>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembershipEdge = {
  __typename?: 'MembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Membership>;
};

export type Membership = {
  __typename?: 'Membership';
  account: Account;
  id: Scalars['ID'];
  notificationSettings: NotificationSettings;
  role: UserRoleEnum;
  user: User;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  adsManagementEnabled: Scalars['Boolean'];
  billingEnabled: Scalars['Boolean'];
  usageEnabled: Scalars['Boolean'];
};

export enum UserRoleEnum {
  Owner = 'owner',
  User = 'user'
}

export type User = {
  __typename?: 'User';
  accounts: Array<Account>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  mailing?: Maybe<Scalars['Boolean']>;
  memberships: MembershipConnection;
  name?: Maybe<Scalars['String']>;
  sso?: Maybe<Scalars['Boolean']>;
};


export type UserMembershipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The connection type for MembershipInvite. */
export type MembershipInviteConnection = {
  __typename?: 'MembershipInviteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MembershipInviteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MembershipInvite>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembershipInviteEdge = {
  __typename?: 'MembershipInviteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MembershipInvite>;
};

export type MembershipInvite = {
  __typename?: 'MembershipInvite';
  account: Account;
  email: Scalars['String'];
  id: Scalars['ID'];
  inviter?: Maybe<User>;
};

export enum AccountPlanEnum {
  BusinessTier = 'business_tier',
  EnrichmentHubspot = 'enrichment_hubspot',
  EnrichmentMarketo = 'enrichment_marketo',
  EnrichmentSalesforce = 'enrichment_salesforce',
  FreeTier = 'free_tier',
  HubspotFreeTier = 'hubspot_free_tier',
  HubspotPaidTier = 'hubspot_paid_tier',
  HubspotPlatformFree = 'hubspot_platform_free',
  HubspotPlatformPaid = 'hubspot_platform_paid',
  Ipcompany = 'ipcompany',
  PaidTier = 'paid_tier',
  PlatformAddonAcquisitions = 'platform_addon_acquisitions',
  PlatformAddonConversions = 'platform_addon_conversions',
  PlatformAddonOperations = 'platform_addon_operations',
  PlatformBusiness = 'platform_business',
  PlatformStartup = 'platform_startup',
  Prospector = 'prospector',
  XAdsProspecting = 'x_ads_prospecting',
  XAdsStandard = 'x_ads_standard',
  XAlerting = 'x_alerting',
  XPersonalization = 'x_personalization',
  XPlatform = 'x_platform'
}

export type AccountPlatformAccess = {
  __typename?: 'AccountPlatformAccess';
  acquisitions: Scalars['Boolean'];
  capture: Scalars['Boolean'];
  conversions: Scalars['Boolean'];
  legacyPlan: Scalars['Boolean'];
  operations: Scalars['Boolean'];
  usage: Scalars['Boolean'];
};

export type Subscription = {
  __typename?: 'Subscription';
  amount?: Maybe<Scalars['Int']>;
  downgradeDate?: Maybe<Scalars['String']>;
  downgradeLimit?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  limitOverride?: Maybe<Scalars['Int']>;
  limitTerm: LimitTerm;
  planId: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type LimitTerm = {
  __typename?: 'LimitTerm';
  endAt: Scalars['Date'];
  startAt: Scalars['Date'];
};

export type AccountSuppressionSettings = {
  __typename?: 'AccountSuppressionSettings';
  person: Scalars['Boolean'];
  prospector: Scalars['Boolean'];
};

export type BillingInfo = {
  __typename?: 'BillingInfo';
  address?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingName?: Maybe<Scalars['String']>;
  billingTerm?: Maybe<Scalars['String']>;
  cardLastFour?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  invoices: Array<Invoice>;
  nextInvoiceAt?: Maybe<Scalars['ISO8601DateTime']>;
  nextStripeInvoiceAmount?: Maybe<Scalars['Int']>;
  showAutomaticBillingMessage?: Maybe<Scalars['Boolean']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Int'];
  endAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  startAt: Scalars['ISO8601DateTime'];
};

export enum DateWindowEnum {
  Trailing_14Days = 'trailing_14_days',
  Trailing_30Days = 'trailing_30_days',
  Trailing_7Days = 'trailing_7_days'
}

export type AdMetrics = {
  __typename?: 'AdMetrics';
  influencedClicks?: Maybe<Scalars['Int']>;
  influencedFrequency?: Maybe<Scalars['Float']>;
  influencedImpressions?: Maybe<Scalars['Int']>;
  influencedReach?: Maybe<Scalars['Int']>;
  influencedSpend?: Maybe<Scalars['Float']>;
  influencedSpendPercentage?: Maybe<Scalars['Float']>;
  overallClicks?: Maybe<Scalars['Int']>;
  overallFrequency?: Maybe<Scalars['Float']>;
  overallImpressions?: Maybe<Scalars['Int']>;
  overallReach?: Maybe<Scalars['Int']>;
  overallSpend?: Maybe<Scalars['Float']>;
};

/** The connection type for Company. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Company>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Company>;
};

export type Company = {
  __typename?: 'Company';
  city?: Maybe<Scalars['String']>;
  columns: Scalars['RawJson'];
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  employeesRange?: Maybe<Scalars['String']>;
  enrichment?: Maybe<Scalars['RawJson']>;
  estimatedAnnualRevenue?: Maybe<Scalars['String']>;
  events: EventConnection;
  facebook?: Maybe<Scalars['String']>;
  fitScore?: Maybe<Scalars['String']>;
  github?: Maybe<Scalars['String']>;
  hubspotCompanies: HubspotCompanyConnection;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  lastVisitAt?: Maybe<Scalars['DateTime']>;
  lastVisitPath?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  marketCap?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<SalesforceUser>;
  people: CompanyPersonConnection;
  raised?: Maybe<Scalars['String']>;
  revenue?: Maybe<Scalars['String']>;
  salesforceAccounts: SalesforceAccountConnection;
  salesforceContacts: SalesforceContactConnection;
  salesforceOpportunities: SalesforceOpportunityConnection;
  sector?: Maybe<Scalars['String']>;
  segments: SegmentConnection;
  subIndustry?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  ticker?: Maybe<Scalars['String']>;
  traits?: Maybe<Scalars['RawJson']>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type CompanyColumnsArgs = {
  segmentId?: InputMaybe<Scalars['ID']>;
};


export type CompanyEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludingAnonymous?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['EventTypeEnum']>;
};


export type CompanyHubspotCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyPeopleArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type CompanySalesforceAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanySalesforceContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanySalesforceOpportunitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanySegmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Event. */
export type EventConnection = {
  __typename?: 'EventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

export type Event = {
  __typename?: 'Event';
  anonymousId?: Maybe<Scalars['ID']>;
  context?: Maybe<Scalars['RawJson']>;
  id: Scalars['ID'];
  person?: Maybe<Person>;
  properties?: Maybe<Scalars['RawJson']>;
  receivedAt: Scalars['DateTime'];
  timestamp: Scalars['DateTime'];
  type: Scalars['EventTypeEnum'];
};

export type Person = {
  __typename?: 'Person';
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  columns: Scalars['RawJson'];
  company?: Maybe<Company>;
  companyEnrichment?: Maybe<Scalars['RawJson']>;
  corporateCompany?: Maybe<Company>;
  email?: Maybe<Scalars['String']>;
  employment?: Maybe<Scalars['String']>;
  enrichment?: Maybe<Scalars['RawJson']>;
  events: EventConnection;
  facebook?: Maybe<Scalars['String']>;
  github?: Maybe<Scalars['String']>;
  hubspotCompanies: HubspotCompanyConnection;
  id: Scalars['ID'];
  linkedin?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  salesforceAccounts: SalesforceAccountConnection;
  salesforceContacts: SalesforceContactConnection;
  salesforceLeads: SalesforceLeadConnection;
  segments: Array<Segment>;
  seniority?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  traits?: Maybe<Scalars['RawJson']>;
  twitter?: Maybe<Scalars['String']>;
};


export type PersonColumnsArgs = {
  segmentId?: InputMaybe<Scalars['ID']>;
};


export type PersonEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['EventTypeEnum']>;
};


export type PersonHubspotCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PersonSalesforceAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PersonSalesforceContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PersonSalesforceLeadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for HubspotCompany. */
export type HubspotCompanyConnection = {
  __typename?: 'HubspotCompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HubspotCompanyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<HubspotCompany>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type HubspotCompanyEdge = {
  __typename?: 'HubspotCompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<HubspotCompany>;
};

export type HubspotCompany = {
  __typename?: 'HubspotCompany';
  archived: Scalars['Boolean'];
  deals?: Maybe<HubspotDealConnection>;
  domain: Scalars['String'];
  externalAccountId: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['RawJson']>;
  updatedAt: Scalars['DateTime'];
};


export type HubspotCompanyDealsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for HubspotDeal. */
export type HubspotDealConnection = {
  __typename?: 'HubspotDealConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HubspotDealEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<HubspotDeal>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type HubspotDealEdge = {
  __typename?: 'HubspotDealEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<HubspotDeal>;
};

export type HubspotDeal = {
  __typename?: 'HubspotDeal';
  amount?: Maybe<Scalars['Int']>;
  closed: Scalars['Boolean'];
  daysToClose?: Maybe<Scalars['Int']>;
  hubspotAccountId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['RawJson']>;
};

/** The connection type for SalesforceAccount. */
export type SalesforceAccountConnection = {
  __typename?: 'SalesforceAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SalesforceAccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SalesforceAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SalesforceAccountEdge = {
  __typename?: 'SalesforceAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SalesforceAccount>;
};

export type SalesforceAccount = {
  __typename?: 'SalesforceAccount';
  accountConnector?: Maybe<SalesforceAccountConnector>;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<SalesforceUser>;
  properties?: Maybe<Scalars['RawJson']>;
  salesforceContacts: SalesforceContactConnection;
  salesforceOpportunities: SalesforceOpportunityConnection;
  websiteDomain?: Maybe<Scalars['String']>;
};


export type SalesforceAccountSalesforceContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SalesforceAccountSalesforceOpportunitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SalesforceAccountConnector = AccountConnector & {
  __typename?: 'SalesforceAccountConnector';
  accountId: Scalars['ID'];
  backfillActive: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  externalInstanceUrl: Scalars['String'];
  fieldMapping?: Maybe<FieldMapping>;
  id: Scalars['ID'];
  isInitialSync?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextSyncAt?: Maybe<Scalars['DateTime']>;
  notification?: Maybe<AccountNotification>;
  pardotBusinessUnitId?: Maybe<Scalars['ID']>;
  remoteMeta: Scalars['Json'];
  selectiveEnrichmentFilters?: Maybe<SelectiveEnrichmentFilters>;
  service: AccountConnectorServiceEnum;
  status: AccountConnectorStatusEnum;
  syncProgress?: Maybe<Scalars['Int']>;
  syncStartedAt?: Maybe<Scalars['DateTime']>;
  syncStatus?: Maybe<Scalars['String']>;
  users: Array<SalesforceUser>;
  webhookPassword?: Maybe<Scalars['String']>;
};


export type SalesforceAccountConnectorBackfillActiveArgs = {
  targetObjectType?: InputMaybe<Scalars['String']>;
};


export type SalesforceAccountConnectorFieldMappingArgs = {
  targetObjectType: Scalars['String'];
};


export type SalesforceAccountConnectorSelectiveEnrichmentFiltersArgs = {
  externalObjectType: Scalars['String'];
};

export type SalesforceUser = {
  __typename?: 'SalesforceUser';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** The connection type for SalesforceContact. */
export type SalesforceContactConnection = {
  __typename?: 'SalesforceContactConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SalesforceContactEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SalesforceContact>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SalesforceContactEdge = {
  __typename?: 'SalesforceContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SalesforceContact>;
};

export type SalesforceContact = {
  __typename?: 'SalesforceContact';
  email: Scalars['String'];
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  owner?: Maybe<SalesforceUser>;
  properties?: Maybe<Scalars['RawJson']>;
  salesforceAccount?: Maybe<SalesforceAccount>;
  websiteDomain?: Maybe<Scalars['String']>;
};

/** The connection type for SalesforceOpportunity. */
export type SalesforceOpportunityConnection = {
  __typename?: 'SalesforceOpportunityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SalesforceOpportunityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SalesforceOpportunity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SalesforceOpportunityEdge = {
  __typename?: 'SalesforceOpportunityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SalesforceOpportunity>;
};

export type SalesforceOpportunity = {
  __typename?: 'SalesforceOpportunity';
  accountConnector?: Maybe<SalesforceAccountConnector>;
  amount?: Maybe<Scalars['BigInt']>;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<SalesforceUser>;
  properties?: Maybe<Scalars['RawJson']>;
  stage?: Maybe<Scalars['String']>;
};

/** The connection type for SalesforceLead. */
export type SalesforceLeadConnection = {
  __typename?: 'SalesforceLeadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SalesforceLeadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SalesforceLead>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SalesforceLeadEdge = {
  __typename?: 'SalesforceLeadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SalesforceLead>;
};

export type SalesforceLead = {
  __typename?: 'SalesforceLead';
  email: Scalars['String'];
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  owner?: Maybe<SalesforceUser>;
  properties?: Maybe<Scalars['RawJson']>;
  websiteDomain?: Maybe<Scalars['String']>;
};

export type Segment = {
  __typename?: 'Segment';
  audiences: AudienceConnection;
  collection: Collection;
  collectionId: Scalars['ID'];
  connectorErrors: ConnectorErrors;
  destination?: Maybe<Destination>;
  destinationActivity?: Maybe<Scalars['Json']>;
  destinations: Array<Destination>;
  destinationsCount: Scalars['Int'];
  enabledDestinationsCount: Scalars['Int'];
  id: Scalars['ID'];
  legacyType: SegmentLegacyTypeEnum;
  name: Scalars['String'];
  resultsCount?: Maybe<Scalars['Int']>;
  search: Scalars['RawJson'];
  searchDependencyErrors: Scalars['Boolean'];
  type: SegmentTypeEnum;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type SegmentAudiencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SegmentDestinationArgs = {
  id: Scalars['ID'];
};

/** The connection type for Audience. */
export type AudienceConnection = {
  __typename?: 'AudienceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AudienceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Audience>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AudienceEdge = {
  __typename?: 'AudienceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Audience>;
};

export type Audience = {
  __typename?: 'Audience';
  accountConnector?: Maybe<AccountConnector>;
  companies?: Maybe<Array<AudienceCompany>>;
  companiesCount?: Maybe<Scalars['Int']>;
  companiesFirmographic?: Maybe<AudienceCompaniesFirmographic>;
  companySearch?: Maybe<Scalars['RawJson']>;
  createdAt: Scalars['DateTime'];
  externalAccountId: Scalars['ID'];
  externalAccountName: Scalars['String'];
  externalEstimatedSize?: Maybe<Scalars['Int']>;
  externalEstimatedSizeChange?: Maybe<Scalars['Int']>;
  externalName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  personSearch?: Maybe<Scalars['RawJson']>;
  pushedAt?: Maybe<Scalars['DateTime']>;
  pushProgress?: Maybe<Scalars['Int']>;
  pushRate?: Maybe<Scalars['Int']>;
  segment?: Maybe<Segment>;
  service: AudienceServiceEnum;
  status: AudienceStatusEnum;
  statusMessage?: Maybe<Scalars['String']>;
  subtype: AudienceSubtypeEnum;
  user?: Maybe<User>;
};

export type AudienceCompany = {
  __typename?: 'AudienceCompany';
  domain: Scalars['String'];
  employeesRange?: Maybe<Scalars['String']>;
  estimatedAnnualRevenue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AudienceCompaniesFirmographic = {
  __typename?: 'AudienceCompaniesFirmographic';
  countries?: Maybe<Array<AudienceCompaniesFirmographicCountry>>;
  industries?: Maybe<Array<AudienceCompaniesFirmographicIndustry>>;
};

export type AudienceCompaniesFirmographicCountry = {
  __typename?: 'AudienceCompaniesFirmographicCountry';
  code: Scalars['String'];
  count: Scalars['Int'];
  name: Scalars['String'];
};

export type AudienceCompaniesFirmographicIndustry = {
  __typename?: 'AudienceCompaniesFirmographicIndustry';
  name: Scalars['String'];
  percentage: Scalars['Int'];
};

export enum AudienceServiceEnum {
  Facebook = 'facebook',
  Google = 'google'
}

export enum AudienceStatusEnum {
  Active = 'active',
  Error = 'error',
  InProgress = 'in_progress',
  Inactive = 'inactive',
  Initializing = 'initializing'
}

export enum AudienceSubtypeEnum {
  CompanySegmentProspects = 'company_segment_prospects',
  Contacts = 'contacts',
  ManagedVisitors = 'managed_visitors',
  Prospects = 'prospects',
  Visitors = 'visitors'
}

export type Collection = {
  __typename?: 'Collection';
  id: Scalars['ID'];
  name: Scalars['String'];
  segments?: Maybe<Array<Segment>>;
};

export type ConnectorErrors = {
  __typename?: 'ConnectorErrors';
  destinations: Array<Scalars['String']>;
  search: Array<Scalars['String']>;
};

export type Destination = {
  __typename?: 'Destination';
  accountConnector?: Maybe<AccountConnector>;
  config: Scalars['Json'];
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  segment: Segment;
  triggerType: Scalars['String'];
  type: DestinationTypeEnum;
};

export enum DestinationTypeEnum {
  AssociateEntered = 'associate_entered',
  AssociateExited = 'associate_exited',
  CreateExternalRecordsSalesforceAccount = 'create_external_records_salesforce_account',
  CreateExternalRecordsSalesforceContact = 'create_external_records_salesforce_contact',
  CreateExternalRecordsSalesforceLead = 'create_external_records_salesforce_lead',
  CustomHtml = 'custom_html',
  Email = 'email',
  FacebookConversion = 'facebook_conversion',
  GoogleConversion = 'google_conversion',
  InclusionTraitsEntered = 'inclusion_traits_entered',
  InclusionTraitsExited = 'inclusion_traits_exited',
  Salesforce = 'salesforce',
  Slack = 'slack',
  Webhook = 'webhook'
}

export enum SegmentLegacyTypeEnum {
  Company = 'Company',
  Person = 'Person'
}

export enum SegmentTypeEnum {
  CompanySegment = 'CompanySegment',
  PersonSegment = 'PersonSegment'
}

/** The connection type for Person. */
export type CompanyPersonConnection = {
  __typename?: 'CompanyPersonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PersonEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Person>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type PersonEdge = {
  __typename?: 'PersonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Person>;
};

/** The connection type for Segment. */
export type SegmentConnection = {
  __typename?: 'SegmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SegmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Segment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SegmentEdge = {
  __typename?: 'SegmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Segment>;
};

export enum ApiUsagePlanEnum {
  All = 'all',
  Enrichment = 'enrichment',
  Ipcompany = 'ipcompany',
  IpcompanyPersonalize = 'ipcompany_personalize',
  Ipcompanyga = 'ipcompanyga',
  PlatformAddonCapture = 'platform_addon_capture',
  Prospector = 'prospector',
  Watchlist = 'watchlist'
}

export type ApiUsage = {
  __typename?: 'ApiUsage';
  active?: Maybe<Scalars['Boolean']>;
  billingPeriodCounts?: Maybe<Array<Scalars['Json']>>;
  data?: Maybe<Array<Scalars['Json']>>;
  scope?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export enum AttributeCategoryEnum {
  Enrichment = 'enrichment',
  FieldMapping = 'field_mapping',
  FitScore = 'fit_score',
  G2 = 'g2',
  Hubspot = 'hubspot',
  Marketo = 'marketo',
  PageviewDisplay = 'pageview_display',
  PageviewFieldMapping = 'pageview_field_mapping',
  PageviewFilter = 'pageview_filter',
  Salesforce = 'salesforce',
  SalesforceFieldMapping = 'salesforce_field_mapping',
  System = 'system',
  TargetMarket = 'target_market',
  Traits = 'traits'
}

export enum AttributeTypeEnum {
  Company = 'Company',
  Person = 'Person'
}

export type Attribute = {
  __typename?: 'Attribute';
  attributeType: Scalars['String'];
  category: Scalars['String'];
  details?: Maybe<Scalars['Json']>;
  label: Scalars['String'];
  subCategory?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type AudiencePreview = {
  __typename?: 'AudiencePreview';
  estimatedExternalSize?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  status: Scalars['String'];
};

export enum AudienceFilterEnum {
  Activity = 'ACTIVITY'
}

export enum AudienceOrderEnum {
  CreatedAtAsc = 'created_at_asc',
  CreatedAtDesc = 'created_at_desc',
  ExternalNameAsc = 'external_name_asc',
  ExternalNameDesc = 'external_name_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc',
  UserNameAsc = 'user_name_asc',
  UserNameDesc = 'user_name_desc'
}

export type Campaign = {
  __typename?: 'Campaign';
  audiences: Array<CampaignAudience>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  service: Scalars['String'];
  spend?: Maybe<Scalars['Float']>;
};

export type CampaignAudience = {
  __typename?: 'CampaignAudience';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  subtype?: Maybe<AudienceSubtypeEnum>;
};

export enum CollectionTypeEnum {
  CompanySegmentCollection = 'CompanySegmentCollection',
  PersonSegmentCollection = 'PersonSegmentCollection'
}

export enum CollectionLegacyTypeEnum {
  Company = 'Company',
  Person = 'Person'
}

/** The connection type for Collection. */
export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CollectionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Collection>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Collection>;
};

export enum ColumnTypeEnum {
  Company = 'Company',
  Person = 'Person'
}

/** The connection type for ConversionEvent. */
export type ConversionEventConnection = {
  __typename?: 'ConversionEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConversionEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ConversionEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConversionEventEdge = {
  __typename?: 'ConversionEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ConversionEvent>;
};

export type ConversionEvent = {
  __typename?: 'ConversionEvent';
  clickId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  pageviewAt: Scalars['DateTime'];
  person: Person;
  sentAt?: Maybe<Scalars['DateTime']>;
};

/** The connection type for CrmPresence. */
export type CrmPresenceConnection = {
  __typename?: 'CrmPresenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CrmPresenceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CrmPresence>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CrmPresenceEdge = {
  __typename?: 'CrmPresenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CrmPresence>;
};

export type CrmPresence = {
  __typename?: 'CrmPresence';
  existsInHubspot: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type CsvImport = {
  __typename?: 'CsvImport';
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  mapping?: Maybe<Array<Scalars['Json']>>;
  primaryIdentifierColumn?: Maybe<Scalars['String']>;
  rowsMatchedCount?: Maybe<Scalars['Int']>;
  rowsSkippedCount?: Maybe<Scalars['Int']>;
  sampleData?: Maybe<Scalars['RawJson']>;
  segmentId?: Maybe<Scalars['ID']>;
  sourceName?: Maybe<Scalars['String']>;
  sourceNameUsed: Scalars['Boolean'];
  status: Scalars['String'];
  type: Scalars['String'];
  uploadUrl?: Maybe<Scalars['String']>;
  user: User;
};

/** The connection type for CustomObject. */
export type CustomObjectConnection = {
  __typename?: 'CustomObjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomObjectEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CustomObject>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CustomObjectEdge = {
  __typename?: 'CustomObjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CustomObject>;
};

export type CustomObject = {
  __typename?: 'CustomObject';
  accountId: Scalars['ID'];
  disabled: Scalars['Boolean'];
  externalAccountId: Scalars['String'];
  externalObjectName: Scalars['String'];
  externalObjectType: Scalars['String'];
  externalType: Scalars['String'];
  id: Scalars['ID'];
  identifierField: Scalars['String'];
  identifierType: Scalars['String'];
};

export type DestinationOptions = {
  __typename?: 'DestinationOptions';
  facebookCurrencyOptions: Array<Scalars['String']>;
  facebookEventTypeOptions: Array<Scalars['String']>;
};

export enum SystemTraitValueEnum {
  ClearbitCreatedTime = 'clearbit_created_time',
  ClearbitModifiedTime = 'clearbit_modified_time',
  ClearbitProcessedAt = 'clearbit_processed_at',
  ClearbitReady = 'clearbit_ready',
  ClearbitStatus = 'clearbit_status'
}

export enum EnrichmentAttributeTypeEnum {
  ClearbitCompany = 'clearbit_company',
  ClearbitPerson = 'clearbit_person',
  CustomTraitsCompany = 'custom_traits_company',
  CustomTraitsPerson = 'custom_traits_person',
  HubspotCompany = 'hubspot_company',
  HubspotContact = 'hubspot_contact',
  HubspotDeal = 'hubspot_deal',
  MarketoCompany = 'marketo_company',
  MarketoFormLead = 'marketo_form_lead',
  MarketoLead = 'marketo_lead',
  PardotProspect = 'pardot_prospect',
  RevealCompany = 'reveal_company',
  RevealPerson = 'reveal_person',
  SalesforceAccount = 'salesforce_account',
  SalesforceContact = 'salesforce_contact',
  SalesforceLead = 'salesforce_lead',
  SegmentCompany = 'segment_company',
  SegmentPerson = 'segment_person',
  SystemTraitsCompany = 'system_traits_company',
  SystemTraitsPerson = 'system_traits_person'
}

export type EnrichmentAttribute = {
  __typename?: 'EnrichmentAttribute';
  children?: Maybe<Array<EnrichmentAttribute>>;
  identifier: Scalars['String'];
  label: Scalars['String'];
  meta?: Maybe<Scalars['Json']>;
  source?: Maybe<Scalars['String']>;
  subtypeName?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  value: Scalars['String'];
};

export type EnrichmentData = {
  __typename?: 'EnrichmentData';
  category?: Maybe<Category>;
  crunchbase?: Maybe<SocialMedia>;
  description?: Maybe<Scalars['String']>;
  domain: Scalars['String'];
  domainAliases: Array<Scalars['String']>;
  emailProvider?: Maybe<Scalars['Boolean']>;
  facebook?: Maybe<SocialMedia>;
  foundedYear?: Maybe<Scalars['Int']>;
  geo?: Maybe<Geo>;
  id: Scalars['ID'];
  identifiers?: Maybe<Identifiers>;
  indexedAt?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  linkedin?: Maybe<SocialMedia>;
  location?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  metrics?: Maybe<Metrics>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Domain>;
  phone?: Maybe<Scalars['String']>;
  profane?: Maybe<Scalars['Boolean']>;
  site?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  tech: Array<Scalars['String']>;
  techCategories: Array<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  twitter?: Maybe<SocialMedia>;
  type?: Maybe<Scalars['String']>;
  ultimateParent?: Maybe<Domain>;
  utcOffset?: Maybe<Scalars['Int']>;
};

export type Category = {
  __typename?: 'Category';
  gicsCode?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  industryGroup?: Maybe<Scalars['String']>;
  naics6Codes: Array<Scalars['String']>;
  naics6Codes2022: Array<Scalars['String']>;
  naicsCode?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  sic4Codes: Array<Scalars['String']>;
  sicCode?: Maybe<Scalars['String']>;
  subIndustry?: Maybe<Scalars['String']>;
};

export type SocialMedia = {
  __typename?: 'SocialMedia';
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  followers?: Maybe<Scalars['Int']>;
  following?: Maybe<Scalars['Int']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  location?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
};

export type Geo = {
  __typename?: 'Geo';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  subPremise?: Maybe<Scalars['String']>;
};

export type Identifiers = {
  __typename?: 'Identifiers';
  usCik?: Maybe<Scalars['String']>;
  usEin?: Maybe<Scalars['String']>;
};

export type Metrics = {
  __typename?: 'Metrics';
  alexaGlobalRank?: Maybe<Scalars['Int']>;
  alexaUsRank?: Maybe<Scalars['Int']>;
  annualRevenue?: Maybe<Scalars['BigInt']>;
  employees?: Maybe<Scalars['Int']>;
  employeesRange?: Maybe<Scalars['String']>;
  estimatedAnnualRevenue?: Maybe<Scalars['String']>;
  fiscalYearEnd?: Maybe<Scalars['Int']>;
  marketCap?: Maybe<Scalars['BigInt']>;
  raised?: Maybe<Scalars['String']>;
  trafficRank?: Maybe<Scalars['String']>;
};

export type Domain = {
  __typename?: 'Domain';
  domain?: Maybe<Scalars['String']>;
};

export type EnrichmentFieldMappings = {
  __typename?: 'EnrichmentFieldMappings';
  hubspot?: Maybe<Array<Scalars['Json']>>;
  salesforce?: Maybe<Array<Scalars['Json']>>;
};

export type EnrichmentHealthMetric = {
  __typename?: 'EnrichmentHealthMetric';
  clearbitAccountId?: Maybe<Scalars['ID']>;
  uniques: Scalars['Int'];
};

export enum EnrichmentLogTypeEnum {
  Hubspot = 'hubspot',
  Marketo = 'marketo',
  Salesforce = 'salesforce',
  Unknown = 'unknown'
}

export type EnrichmentLogQueryStart = {
  __typename?: 'EnrichmentLogQueryStart';
  queryExecutionId?: Maybe<Scalars['String']>;
};

export type EnrichmentLog = {
  __typename?: 'EnrichmentLog';
  externalId: Scalars['String'];
  id: Scalars['ID'];
  identifier: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status: EnrichmentLogStatusEnum;
  steps: Array<EnrichmentLogStep>;
  subType: EnrichmentLogSubTypeEnum;
  timestamp: Scalars['DateTime'];
  type: EnrichmentLogTypeEnum;
};

export enum EnrichmentLogStatusEnum {
  Complete = 'complete',
  Error = 'error',
  Info = 'info',
  Pending = 'pending',
  Skipped = 'skipped'
}

export type EnrichmentLogStep = {
  __typename?: 'EnrichmentLogStep';
  changes: Array<EnrichmentLogStepChange>;
  message: Scalars['String'];
  name: Scalars['String'];
  status: EnrichmentLogStatusEnum;
  timestamp: Scalars['DateTime'];
};

export type EnrichmentLogStepChange = {
  __typename?: 'EnrichmentLogStepChange';
  fieldName: Scalars['String'];
  from: Scalars['String'];
  to: Scalars['String'];
};

export enum EnrichmentLogSubTypeEnum {
  Account = 'account',
  Company = 'company',
  Contact = 'contact',
  Deal = 'deal',
  Lead = 'lead'
}

export type EnrichmentLogQueryStatus = {
  __typename?: 'EnrichmentLogQueryStatus';
  queryExecutionId: Scalars['String'];
  state: EnrichmentLogQueryStateEnum;
};

export enum EnrichmentLogQueryStateEnum {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type DailyUsage = {
  __typename?: 'DailyUsage';
  date?: Maybe<Scalars['DateTime']>;
  usage?: Maybe<Scalars['Int']>;
};

export enum RecordIdentifierEnum {
  Domain = 'domain',
  Email = 'email'
}

export enum FitModelTypeEnum {
  ClosedWonLoss = 'closedWonLoss',
  InvalidType = 'invalidType',
  WonVsLossAudience = 'wonVsLossAudience'
}

export type FitModel = {
  __typename?: 'FitModel';
  features?: Maybe<Array<Scalars['Json']>>;
  id?: Maybe<Scalars['ID']>;
  lostAudienceId?: Maybe<Scalars['ID']>;
  lostAudienceName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Json']>;
  status?: Maybe<FitModelStatusEnum>;
  type?: Maybe<FitModelTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wonAudienceId?: Maybe<Scalars['ID']>;
  wonAudienceName?: Maybe<Scalars['String']>;
};

export enum FitModelStatusEnum {
  Created = 'created',
  Errored = 'errored',
  Initializing = 'initializing',
  NotFound = 'notFound'
}

export enum FormIntegrationEnum {
  Hubspot = 'hubspot',
  Marketo = 'marketo',
  Pardot = 'pardot'
}

export type FormConfiguration = {
  __typename?: 'FormConfiguration';
  allowedSites: Array<FormAllowedSitesConfig>;
  autofill: Scalars['Boolean'];
  formShortening: Scalars['Boolean'];
  id: Scalars['ID'];
  identifyOnSubmit: Scalars['Boolean'];
  integration: FormIntegrationEnum;
};

export type FormAllowedSitesConfig = {
  __typename?: 'FormAllowedSitesConfig';
  eventsReceived: Scalars['Boolean'];
  id: Scalars['ID'];
  lastEventAt?: Maybe<Scalars['DateTime']>;
  siteUrl: Scalars['String'];
};

export type FormFieldMappings = {
  __typename?: 'FormFieldMappings';
  fieldMappings: Array<FormFieldMapping>;
  integration: FormIntegrationEnum;
};

export type FormFieldMapping = {
  __typename?: 'FormFieldMapping';
  id: Scalars['ID'];
  sourceAttribute: Scalars['String'];
  targetAttribute: Scalars['String'];
};

export type GoogleAnalytics = {
  __typename?: 'GoogleAnalytics';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type GoogleConversionTracker = {
  __typename?: 'GoogleConversionTracker';
  allowsCustomValues: Scalars['Boolean'];
  defaultCurrency: Scalars['String'];
  defaultValue: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GoogleTagManager = {
  __typename?: 'GoogleTagManager';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type HubspotEnrichmentSettings = {
  __typename?: 'HubspotEnrichmentSettings';
  liveEnrichCompaniesEnabled?: Maybe<Scalars['Boolean']>;
  liveEnrichContactsEnabled?: Maybe<Scalars['Boolean']>;
};

export type HubspotList = {
  __typename?: 'HubspotList';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdById?: Maybe<Scalars['ID']>;
  enrichmentError?: Maybe<Scalars['String']>;
  enrichmentJobId: Scalars['String'];
  enrichmentJobQueue: Scalars['String'];
  enrichmentStatus?: Maybe<HubspotListEnrichmentStatusEnum>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  objectType: HubspotListObjectTypeEnum;
  processingStatus?: Maybe<Scalars['String']>;
  processingType?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedById?: Maybe<Scalars['ID']>;
};

export enum HubspotListEnrichmentStatusEnum {
  Complete = 'complete',
  Error = 'error',
  Processing = 'processing'
}

export enum HubspotListObjectTypeEnum {
  Company = 'company',
  Contact = 'contact'
}

/** The connection type for HubspotList. */
export type HubspotListConnection = {
  __typename?: 'HubspotListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HubspotListEdge>>>;
  hasMore: Scalars['Boolean'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<HubspotList>>>;
  offset: Scalars['Int'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type HubspotListEdge = {
  __typename?: 'HubspotListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<HubspotList>;
};

export type JobHistory = {
  __typename?: 'JobHistory';
  jobId: Scalars['String'];
  queue: Scalars['String'];
  runId?: Maybe<Scalars['String']>;
  status?: Maybe<JobHistoryStatusEnum>;
  timestamp?: Maybe<Scalars['String']>;
};

export enum JobHistoryStatusEnum {
  Completed = 'completed',
  Error = 'error',
  Started = 'started',
  Updated = 'updated'
}

export type News = {
  __typename?: 'News';
  articles: Array<Scalars['Json']>;
};

/** The connection type for Person. */
export type PersonConnection = {
  __typename?: 'PersonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PersonEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Person>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum ProductFeatureEnum {
  Alerts = 'alerts',
  BusinessTier = 'business_tier',
  BusinessTierApi = 'business_tier_api',
  BusinessTierPlatformProspector = 'business_tier_platform_prospector',
  Capture = 'capture',
  CsvExports = 'csv_exports',
  Discovery = 'discovery',
  Enrichment = 'enrichment',
  Forms = 'forms',
  FreeTier = 'free_tier',
  FreeTierApi = 'free_tier_api',
  FreeTierPlatformProspector = 'free_tier_platform_prospector',
  HubspotFreeTier = 'hubspot_free_tier',
  HubspotPaidTier = 'hubspot_paid_tier',
  HubspotPlatformFree = 'hubspot_platform_free',
  HubspotPlatformPaid = 'hubspot_platform_paid',
  PaidTier = 'paid_tier',
  PaidTierApi = 'paid_tier_api',
  PaidTierPlatformProspector = 'paid_tier_platform_prospector',
  Personalization = 'personalization',
  PlatformProspector = 'platform_prospector',
  Prospector = 'prospector',
  Reveal = 'reveal',
  StandardBundle = 'standard_bundle'
}

export type ProductFeature = {
  __typename?: 'ProductFeature';
  currentPeriodEndDate: Scalars['Date'];
  currentPeriodStartDate: Scalars['Date'];
  currentPeriodTotalUsage: Scalars['Json'];
  description: Scalars['String'];
  detailedBreakdownDescription?: Maybe<Scalars['String']>;
  detailedBreakdownTitle?: Maybe<Scalars['String']>;
  documentationUrl: Scalars['String'];
  id: ProductFeatureEnum;
  meteredUnit: Scalars['String'];
  metricSubsets: Array<Scalars['Json']>;
  name: Scalars['String'];
  usageBreakdownDetails?: Maybe<Array<Scalars['Json']>>;
  usageLimit?: Maybe<Scalars['Int']>;
  usageMetricGraph: Scalars['Json'];
  usageTerm: SubscriptionBillingTermEnum;
};

export enum SubscriptionBillingTermEnum {
  Daily = 'daily',
  Monthly = 'monthly',
  Yearly = 'yearly'
}

export type ProspectCrmPresence = {
  __typename?: 'ProspectCrmPresence';
  existsInHubspot: Scalars['Boolean'];
  prospectId: Scalars['ID'];
};

export type ProspectFilters = {
  __typename?: 'ProspectFilters';
  companyCountries: Array<ProspectFilterOption>;
  companyTags: Array<ProspectFilterOption>;
  companyTech: Array<ProspectFilterOption>;
  countries: Array<ProspectFilterOption>;
  country: Array<ProspectFilterOption>;
  employeesRanges: Array<ProspectFilterOption>;
  industries: Array<ProspectFilterOption>;
  role: Array<ProspectFilterOption>;
  seniority: Array<ProspectFilterOption>;
  title: Array<ProspectFilterOption>;
};

export type ProspectFilterOption = {
  __typename?: 'ProspectFilterOption';
  count?: Maybe<Scalars['Int']>;
  label: Scalars['String'];
  value: Scalars['String'];
};

export type ProspectList = {
  __typename?: 'ProspectList';
  account: Account;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  query: ProspectQuery;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ProspectQuery = {
  __typename?: 'ProspectQuery';
  cities?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyCities?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyStates?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyTech?: Maybe<Array<Maybe<Scalars['String']>>>;
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  employeesRanges?: Maybe<Array<Maybe<Scalars['String']>>>;
  industries?: Maybe<Array<Maybe<Scalars['String']>>>;
  names?: Maybe<Array<Maybe<Scalars['String']>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  seniorities?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  titles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProspectListExport = {
  __typename?: 'ProspectListExport';
  account: Account;
  createdAt: Scalars['ISO8601DateTime'];
  exportType: ProspectListExportTypeEnum;
  id: Scalars['ID'];
  items?: Maybe<ProspectListExportItemConnection>;
  lastDownloadedAt?: Maybe<Scalars['ISO8601DateTime']>;
  metadata?: Maybe<ProspectListExportMetadata>;
  prospectList?: Maybe<ProspectList>;
  status: ProspectListExportStatusEnum;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


export type ProspectListExportItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum ProspectListExportTypeEnum {
  Csv = 'csv',
  Hubspot = 'hubspot',
  Salesforce = 'salesforce'
}

/** The connection type for ProspectListExportItem. */
export type ProspectListExportItemConnection = {
  __typename?: 'ProspectListExportItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProspectListExportItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProspectListExportItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProspectListExportItemEdge = {
  __typename?: 'ProspectListExportItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProspectListExportItem>;
};

export type ProspectListExportItem = {
  __typename?: 'ProspectListExportItem';
  account: Account;
  companyCity?: Maybe<Scalars['String']>;
  companyCountry?: Maybe<Scalars['String']>;
  companyDomain?: Maybe<Scalars['String']>;
  companyLocation?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyState?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  linkedin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ProspectListExportMetadata = {
  __typename?: 'ProspectListExportMetadata';
  query?: Maybe<ProspectQuery>;
  totalCount?: Maybe<Scalars['Int']>;
  totalCreated?: Maybe<Scalars['Int']>;
};

export enum ProspectListExportStatusEnum {
  Canceled = 'canceled',
  Completed = 'completed',
  Exporting = 'exporting',
  Failed = 'failed',
  Initializing = 'initializing',
  Pending = 'pending',
  Purchased = 'purchased'
}

export enum ProspectListExportFilterEnum {
  Finished = 'finished',
  Pending = 'pending',
  Purchased = 'purchased'
}

/** The connection type for ProspectListExport. */
export type ProspectListExportConnection = {
  __typename?: 'ProspectListExportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProspectListExportEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProspectListExport>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProspectListExportEdge = {
  __typename?: 'ProspectListExportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProspectListExport>;
};

/** The connection type for ProspectList. */
export type ProspectListConnection = {
  __typename?: 'ProspectListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProspectListEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProspectList>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProspectListEdge = {
  __typename?: 'ProspectListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProspectList>;
};

/** The connection type for Prospect. */
export type ProspectConnection = {
  __typename?: 'ProspectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProspectEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Prospect>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCompanies?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProspectEdge = {
  __typename?: 'ProspectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Prospect>;
};

export type Prospect = {
  __typename?: 'Prospect';
  avatar?: Maybe<Scalars['String']>;
  companyDomain?: Maybe<Scalars['String']>;
  companyIndustry?: Maybe<Scalars['String']>;
  companyLocation?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  email: Scalars['Boolean'];
  id: Scalars['ID'];
  linkedin: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  twitter: Scalars['Boolean'];
  verified: Scalars['Boolean'];
};

export type PublishableKey = {
  __typename?: 'PublishableKey';
  id: Scalars['String'];
  value: Scalars['String'];
};

export type DashboardMetrics = {
  __typename?: 'DashboardMetrics';
  enrichmentsByDomainTotalUniques: Scalars['Int'];
  enrichmentsByEmailTotalUniques: Scalars['Int'];
  visitorsTotalUniques: Scalars['Int'];
};

export enum SalesforceObjectTypeEnum {
  Account = 'account',
  Contact = 'contact',
  Lead = 'lead',
  Opportunity = 'opportunity',
  User = 'user'
}

export type SalesforceTrait = {
  __typename?: 'SalesforceTrait';
  label: Scalars['String'];
  name: Scalars['String'];
  objectType: Scalars['String'];
  options?: Maybe<Array<SalesforceTraitOption>>;
  required: Scalars['Boolean'];
  type: SalesforceTraitTypeEnum;
};

export type SalesforceTraitOption = {
  __typename?: 'SalesforceTraitOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export enum SalesforceTraitTypeEnum {
  Boolean = 'BOOLEAN',
  Datetime = 'DATETIME',
  Number = 'NUMBER',
  Select = 'SELECT',
  String = 'STRING'
}

export type SalesPipeline = {
  __typename?: 'SalesPipeline';
  snapshots?: Maybe<Array<SalesPipelineSnapshot>>;
  stages: SalesPipelineStages;
  status: SalesPipelineStatusEnum;
  syncedAt?: Maybe<Scalars['DateTime']>;
};

export type SalesPipelineSnapshot = {
  __typename?: 'SalesPipelineSnapshot';
  date: Scalars['Date'];
  exportProxyUrl: Scalars['String'];
};

export type SalesPipelineStages = {
  __typename?: 'SalesPipelineStages';
  dealsWon: SalesPipelineStage;
  leads: SalesPipelineStage;
  mqls: SalesPipelineStage;
  opportunities: SalesPipelineStage;
  visitors: SalesPipelineStage;
};

export type SalesPipelineStage = {
  __typename?: 'SalesPipelineStage';
  currentInfluencedValue: Scalars['Int'];
  enabled: Scalars['Boolean'];
  previousInfluencedValue: Scalars['Int'];
  search?: Maybe<Scalars['RawJson']>;
  timeseries: Array<SalesPipelineStageTimeseries>;
};

export type SalesPipelineStageTimeseries = {
  __typename?: 'SalesPipelineStageTimeseries';
  date: Scalars['Date'];
  influencedValue: Scalars['Int'];
};

export enum SalesPipelineStatusEnum {
  Active = 'active',
  InProgress = 'in_progress'
}

export enum AttributeHubspotSubCategoryEnum {
  Company = 'company',
  Contact = 'contact',
  Deal = 'deal'
}

export enum AttributeMarketoSubCategoryEnum {
  Lead = 'lead'
}

export enum AttributeSalesforceSubCategoryEnum {
  Account = 'account',
  Contact = 'contact',
  Lead = 'lead',
  Opportunity = 'opportunity'
}

export enum ExportStatusEnum {
  Cancelled = 'cancelled',
  Error = 'error',
  Queued = 'queued',
  Skipped = 'skipped',
  Success = 'success',
  Uploading = 'uploading'
}

export type Export = {
  __typename?: 'Export';
  createdAt: Scalars['ISO8601DateTime'];
  downloadUrl?: Maybe<Scalars['String']>;
  expired: Scalars['Boolean'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  status: ExportStatusEnum;
  userName?: Maybe<Scalars['String']>;
};

export enum SegmentFilterEnum {
  Activity = 'ACTIVITY',
  NoDestinations = 'NO_DESTINATIONS'
}

export enum TagManagerServiceEnum {
  Facebook = 'facebook',
  Google = 'google',
  GoogleAnalytics = 'google_analytics',
  GoogleTagManager = 'google_tag_manager',
  Reveal = 'reveal'
}

export type TagManager = {
  __typename?: 'TagManager';
  configData?: Maybe<Scalars['Json']>;
  googleDimensionMappings: Array<GoogleDimensionMapping>;
  id: Scalars['ID'];
  pushToDataLayer: Scalars['Boolean'];
  service: TagManagerServiceEnum;
  status: TagManagerStatusEnum;
};

export type GoogleDimensionMapping = {
  __typename?: 'GoogleDimensionMapping';
  createdAt: Scalars['DateTime'];
  data: Array<Scalars['Json']>;
  externalAccountId: Scalars['String'];
  externalPropertyId: Scalars['String'];
  externalPropertyName: Scalars['String'];
  id: Scalars['ID'];
  status: GoogleDimensionMappingStatusEnum;
};

export enum GoogleDimensionMappingStatusEnum {
  Active = 'active',
  Paused = 'paused'
}

export enum TagManagerStatusEnum {
  Active = 'active',
  Disabled = 'disabled'
}

export type TargetMarketPreview = {
  __typename?: 'TargetMarketPreview';
  size: Scalars['Int'];
};

export enum UsageBreakdownGranularityEnum {
  Day = 'day',
  Month = 'month',
  Year = 'year'
}

export type Viewer = {
  __typename?: 'Viewer';
  accountId: Scalars['ID'];
  canAccessGaDataLayer: Scalars['Boolean'];
  canAccessGoogleContactAudiences: Scalars['Boolean'];
  canAccessGoogleManagedVisitorAudiences: Scalars['Boolean'];
  canAccessSalesPipelineExports: Scalars['Boolean'];
  canExportAdAudiencesToLinkedin: Scalars['Boolean'];
  canExportAudiences: Scalars['Boolean'];
  id: Scalars['ID'];
  isImpersonating?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UserRoleEnum>;
  user: User;
};

export type Mutation = {
  __typename?: 'Mutation';
  analyzeCsvImport?: Maybe<CsvImportsAnalyzePayload>;
  cancelBackfill?: Maybe<AccountConnectorsCancelBackfillPayload>;
  cancelDowngradeAccountSubscription?: Maybe<AccountCancelDowngradeSubscriptionPayload>;
  cancelExportCsv?: Maybe<SegmentsCancelExportCsvPayload>;
  cancelProspectListExport?: Maybe<ProspectListExportCancelPayload>;
  cloneSegment?: Maybe<SegmentsClonePayload>;
  copyProspectList?: Maybe<ProspectListCopyPayload>;
  createAccount?: Maybe<AccountCreatePayload>;
  createAccountSubscription?: Maybe<AccountCreateSubscriptionPayload>;
  createAudience?: Maybe<AudiencesCreatePayload>;
  createAudiencePreview?: Maybe<AudiencePreviewsCreatePayload>;
  createCollection?: Maybe<CollectionsCreatePayload>;
  createCsvImport?: Maybe<CsvImportsCreatePayload>;
  createCsvSegment?: Maybe<CsvImportsCreateSegmentPayload>;
  createCustomObject?: Maybe<CustomObjectsCreatePayload>;
  createDestination?: Maybe<DestinationsCreatePayload>;
  createFitModel?: Maybe<FitModelsCreatePayload>;
  createHubspotCompany?: Maybe<HubspotCreateCompanyPayload>;
  createOrUpdateGoogleDimensionMapping?: Maybe<GoogleDimensionMappingCreateOrUpdatePayload>;
  createProspectList?: Maybe<ProspectListCreatePayload>;
  createProspectListExport?: Maybe<ProspectListExportCreatePayload>;
  createSegment?: Maybe<SegmentsCreatePayload>;
  createTargetMarket?: Maybe<TargetMarketsCreatePayload>;
  deleteSelectiveEnrichment?: Maybe<AccountConnectorsDeleteSelectiveEnrichmentPayload>;
  deliverTestDestination?: Maybe<DestinationsDeliverTestPayload>;
  destroyAccountConnector?: Maybe<AccountConnectorsDestroyPayload>;
  destroyAudience?: Maybe<AudiencesDestroyPayload>;
  destroyCollection?: Maybe<CollectionsDestroyPayload>;
  destroyCsvImport?: Maybe<CsvImportsDestroyPayload>;
  destroyCustomObject?: Maybe<CustomObjectsDestroyPayload>;
  destroyDestination?: Maybe<DestinationsDestroyPayload>;
  destroyFitModel?: Maybe<FitModelsDestroyPayload>;
  destroyGoogleDimensionMapping?: Maybe<GoogleDimensionMappingDestroyPayload>;
  destroyProspectList?: Maybe<ProspectListDestroyPayload>;
  destroySegment?: Maybe<SegmentsDestroyPayload>;
  destroyTargetMarket?: Maybe<TargetMarketsDestroyPayload>;
  destroyUser?: Maybe<UserDestroyPayload>;
  downgradeAccountSubscription?: Maybe<AccountDowngradeSubscriptionPayload>;
  downloadProspectListExport?: Maybe<ProspectListExportDownloadPayload>;
  enrichList?: Maybe<HubspotEnrichListPayload>;
  exportAudience?: Maybe<AudiencesExportPayload>;
  exportCsv?: Maybe<SegmentsExportCsvPayload>;
  formsAddAllowedSite?: Maybe<FormsAddAllowedSitePayload>;
  formsRemoveAllowedSite?: Maybe<FormsRemoveAllowedSitePayload>;
  formsUpdateConfiguration?: Maybe<FormsUpdateConfigurationPayload>;
  formsUpsertFieldMappings?: Maybe<FormsUpsertFieldMappingsPayload>;
  inviteCancel?: Maybe<AccountInviteCancelPayload>;
  inviteUser?: Maybe<AccountInviteUserPayload>;
  parseCsvImport?: Maybe<CsvImportsParsePayload>;
  reexportProperties?: Maybe<AccountConnectorsReexportPropertiesPayload>;
  refreshAccountPageEvent?: Maybe<AccountRefreshPageEventPayload>;
  refreshFacebookAdAccount?: Maybe<AccountConnectorsRefreshFacebookAdAccountPayload>;
  refreshGoogleAdAccounts?: Maybe<AccountConnectorsRefreshGoogleAdAccountsPayload>;
  refreshRemoteMeta?: Maybe<AccountConnectorsRefreshRemoteMetaPayload>;
  refreshSegment?: Maybe<SegmentsRefreshPayload>;
  resolveAccountNotification?: Maybe<AccountNotificationResolvePayload>;
  saveSelectiveEnrichment?: Maybe<AccountConnectorsSaveSelectiveEnrichmentPayload>;
  skipOnboarding?: Maybe<AccountSkipOnboardingPayload>;
  toggleFieldMapping?: Maybe<AccountConnectorsToggleFieldMappingPayload>;
  toggleGoogleDimensionMappingStatus?: Maybe<GoogleDimensionMappingToggleStatusPayload>;
  triggerBackfill?: Maybe<AccountConnectorsTriggerBackfillPayload>;
  updateAccount?: Maybe<AccountUpdatePayload>;
  updateAccountApiVersion?: Maybe<AccountUpdateApiVersionPayload>;
  updateAccountBillingInfo?: Maybe<AccountUpdateBillingInfoPayload>;
  updateAccountConnector?: Maybe<AccountConnectorsUpdatePayload>;
  updateAccountDetails?: Maybe<AccountUpdateDetailsPayload>;
  updateAccountSettings?: Maybe<AccountUpdateSettingsPayload>;
  updateAccountSubscription?: Maybe<AccountUpdateSubscriptionPayload>;
  updateAccountSuppressionSettings?: Maybe<AccountUpdateSuppressionSettingsPayload>;
  updateAudience?: Maybe<AudiencesUpdatePayload>;
  updateCollection?: Maybe<CollectionsUpdatePayload>;
  updateDestination?: Maybe<DestinationsUpdatePayload>;
  updateFieldMapping?: Maybe<AccountConnectorsUpdateFieldMappingPayload>;
  updateHubspotLiveEnrichment?: Maybe<AccountConnectorsUpdateHubspotLiveEnrichmentPayload>;
  updatePardotBusinessUnitId?: Maybe<AccountConnectorsUpdatePardotBusinessUnitIdPayload>;
  updateProspectList?: Maybe<ProspectListUpdatePayload>;
  updateSalesPipeline?: Maybe<SalesPipelinesUpdatePayload>;
  updateSegment?: Maybe<SegmentsUpdatePayload>;
  updateTargetMarket?: Maybe<TargetMarketsUpdatePayload>;
  updateUserPassword?: Maybe<UserUpdatePasswordPayload>;
  updateUserProfile?: Maybe<UserUpdateProfilePayload>;
  updateUserRole?: Maybe<UserUpdateRolePayload>;
  upgradeAccountPlan?: Maybe<AccountUpgradePlanPayload>;
  upsertG2Connector?: Maybe<AccountConnectorsUpsertG2ConnectorPayload>;
  upsertGoogleAnalyticsConfig?: Maybe<TagManagerUpsertGoogleAnalyticsConfigPayload>;
  upsertGoogleTagManagerConfig?: Maybe<TagManagerUpsertGoogleTagManagerConfigPayload>;
  upsertMarketoConnector?: Maybe<AccountConnectorsUpsertMarketoConnectorPayload>;
  upsertTagManager?: Maybe<TagManagerUpsertPayload>;
};


export type MutationAnalyzeCsvImportArgs = {
  input: CsvImportsAnalyzeInput;
};


export type MutationCancelBackfillArgs = {
  input: AccountConnectorsCancelBackfillInput;
};


export type MutationCancelDowngradeAccountSubscriptionArgs = {
  input: AccountCancelDowngradeSubscriptionInput;
};


export type MutationCancelExportCsvArgs = {
  input: SegmentsCancelExportCsvInput;
};


export type MutationCancelProspectListExportArgs = {
  input: ProspectListExportCancelInput;
};


export type MutationCloneSegmentArgs = {
  input: SegmentsCloneInput;
};


export type MutationCopyProspectListArgs = {
  input: ProspectListCopyInput;
};


export type MutationCreateAccountArgs = {
  input: AccountCreateInput;
};


export type MutationCreateAccountSubscriptionArgs = {
  input: AccountCreateSubscriptionInput;
};


export type MutationCreateAudienceArgs = {
  input: AudiencesCreateInput;
};


export type MutationCreateAudiencePreviewArgs = {
  input: AudiencePreviewsCreateInput;
};


export type MutationCreateCollectionArgs = {
  input: CollectionsCreateInput;
};


export type MutationCreateCsvImportArgs = {
  input: CsvImportsCreateInput;
};


export type MutationCreateCsvSegmentArgs = {
  input: CsvImportsCreateSegmentInput;
};


export type MutationCreateCustomObjectArgs = {
  input: CustomObjectsCreateInput;
};


export type MutationCreateDestinationArgs = {
  input: DestinationsCreateInput;
};


export type MutationCreateFitModelArgs = {
  input: FitModelsCreateInput;
};


export type MutationCreateHubspotCompanyArgs = {
  input: HubspotCreateCompanyInput;
};


export type MutationCreateOrUpdateGoogleDimensionMappingArgs = {
  input: GoogleDimensionMappingCreateOrUpdateInput;
};


export type MutationCreateProspectListArgs = {
  input: ProspectListCreateInput;
};


export type MutationCreateProspectListExportArgs = {
  input: ProspectListExportCreateInput;
};


export type MutationCreateSegmentArgs = {
  input: SegmentsCreateInput;
};


export type MutationCreateTargetMarketArgs = {
  input: TargetMarketsCreateInput;
};


export type MutationDeleteSelectiveEnrichmentArgs = {
  input: AccountConnectorsDeleteSelectiveEnrichmentInput;
};


export type MutationDeliverTestDestinationArgs = {
  input: DestinationsDeliverTestInput;
};


export type MutationDestroyAccountConnectorArgs = {
  input: AccountConnectorsDestroyInput;
};


export type MutationDestroyAudienceArgs = {
  input: AudiencesDestroyInput;
};


export type MutationDestroyCollectionArgs = {
  input: CollectionsDestroyInput;
};


export type MutationDestroyCsvImportArgs = {
  input: CsvImportsDestroyInput;
};


export type MutationDestroyCustomObjectArgs = {
  input: CustomObjectsDestroyInput;
};


export type MutationDestroyDestinationArgs = {
  input: DestinationsDestroyInput;
};


export type MutationDestroyFitModelArgs = {
  input: FitModelsDestroyInput;
};


export type MutationDestroyGoogleDimensionMappingArgs = {
  input: GoogleDimensionMappingDestroyInput;
};


export type MutationDestroyProspectListArgs = {
  input: ProspectListDestroyInput;
};


export type MutationDestroySegmentArgs = {
  input: SegmentsDestroyInput;
};


export type MutationDestroyTargetMarketArgs = {
  input: TargetMarketsDestroyInput;
};


export type MutationDestroyUserArgs = {
  input: UserDestroyInput;
};


export type MutationDowngradeAccountSubscriptionArgs = {
  input: AccountDowngradeSubscriptionInput;
};


export type MutationDownloadProspectListExportArgs = {
  input: ProspectListExportDownloadInput;
};


export type MutationEnrichListArgs = {
  input: HubspotEnrichListInput;
};


export type MutationExportAudienceArgs = {
  input: AudiencesExportInput;
};


export type MutationExportCsvArgs = {
  input: SegmentsExportCsvInput;
};


export type MutationFormsAddAllowedSiteArgs = {
  input: FormsAddAllowedSiteInput;
};


export type MutationFormsRemoveAllowedSiteArgs = {
  input: FormsRemoveAllowedSiteInput;
};


export type MutationFormsUpdateConfigurationArgs = {
  input: FormsUpdateConfigurationInput;
};


export type MutationFormsUpsertFieldMappingsArgs = {
  input: FormsUpsertFieldMappingsInput;
};


export type MutationInviteCancelArgs = {
  input: AccountInviteCancelInput;
};


export type MutationInviteUserArgs = {
  input: AccountInviteUserInput;
};


export type MutationParseCsvImportArgs = {
  input: CsvImportsParseInput;
};


export type MutationReexportPropertiesArgs = {
  input: AccountConnectorsReexportPropertiesInput;
};


export type MutationRefreshAccountPageEventArgs = {
  input: AccountRefreshPageEventInput;
};


export type MutationRefreshFacebookAdAccountArgs = {
  input: AccountConnectorsRefreshFacebookAdAccountInput;
};


export type MutationRefreshGoogleAdAccountsArgs = {
  input: AccountConnectorsRefreshGoogleAdAccountsInput;
};


export type MutationRefreshRemoteMetaArgs = {
  input: AccountConnectorsRefreshRemoteMetaInput;
};


export type MutationRefreshSegmentArgs = {
  input: SegmentsRefreshInput;
};


export type MutationResolveAccountNotificationArgs = {
  input: AccountNotificationResolveInput;
};


export type MutationSaveSelectiveEnrichmentArgs = {
  input: AccountConnectorsSaveSelectiveEnrichmentInput;
};


export type MutationSkipOnboardingArgs = {
  input: AccountSkipOnboardingInput;
};


export type MutationToggleFieldMappingArgs = {
  input: AccountConnectorsToggleFieldMappingInput;
};


export type MutationToggleGoogleDimensionMappingStatusArgs = {
  input: GoogleDimensionMappingToggleStatusInput;
};


export type MutationTriggerBackfillArgs = {
  input: AccountConnectorsTriggerBackfillInput;
};


export type MutationUpdateAccountArgs = {
  input: AccountUpdateInput;
};


export type MutationUpdateAccountApiVersionArgs = {
  input: AccountUpdateApiVersionInput;
};


export type MutationUpdateAccountBillingInfoArgs = {
  input: AccountUpdateBillingInfoInput;
};


export type MutationUpdateAccountConnectorArgs = {
  input: AccountConnectorsUpdateInput;
};


export type MutationUpdateAccountDetailsArgs = {
  input: AccountUpdateDetailsInput;
};


export type MutationUpdateAccountSettingsArgs = {
  input: AccountUpdateSettingsInput;
};


export type MutationUpdateAccountSubscriptionArgs = {
  input: AccountUpdateSubscriptionInput;
};


export type MutationUpdateAccountSuppressionSettingsArgs = {
  input: AccountUpdateSuppressionSettingsInput;
};


export type MutationUpdateAudienceArgs = {
  input: AudiencesUpdateInput;
};


export type MutationUpdateCollectionArgs = {
  input: CollectionsUpdateInput;
};


export type MutationUpdateDestinationArgs = {
  input: DestinationsUpdateInput;
};


export type MutationUpdateFieldMappingArgs = {
  input: AccountConnectorsUpdateFieldMappingInput;
};


export type MutationUpdateHubspotLiveEnrichmentArgs = {
  input: AccountConnectorsUpdateHubspotLiveEnrichmentInput;
};


export type MutationUpdatePardotBusinessUnitIdArgs = {
  input: AccountConnectorsUpdatePardotBusinessUnitIdInput;
};


export type MutationUpdateProspectListArgs = {
  input: ProspectListUpdateInput;
};


export type MutationUpdateSalesPipelineArgs = {
  input: SalesPipelinesUpdateInput;
};


export type MutationUpdateSegmentArgs = {
  input: SegmentsUpdateInput;
};


export type MutationUpdateTargetMarketArgs = {
  input: TargetMarketsUpdateInput;
};


export type MutationUpdateUserPasswordArgs = {
  input: UserUpdatePasswordInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UserUpdateProfileInput;
};


export type MutationUpdateUserRoleArgs = {
  input: UserUpdateRoleInput;
};


export type MutationUpgradeAccountPlanArgs = {
  input: AccountUpgradePlanInput;
};


export type MutationUpsertG2ConnectorArgs = {
  input: AccountConnectorsUpsertG2ConnectorInput;
};


export type MutationUpsertGoogleAnalyticsConfigArgs = {
  input: TagManagerUpsertGoogleAnalyticsConfigInput;
};


export type MutationUpsertGoogleTagManagerConfigArgs = {
  input: TagManagerUpsertGoogleTagManagerConfigInput;
};


export type MutationUpsertMarketoConnectorArgs = {
  input: AccountConnectorsUpsertMarketoConnectorInput;
};


export type MutationUpsertTagManagerArgs = {
  input: TagManagerUpsertInput;
};

/** Autogenerated input type of CsvImportsAnalyze */
export type CsvImportsAnalyzeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CsvImportsAnalyze */
export type CsvImportsAnalyzePayload = {
  __typename?: 'CsvImportsAnalyzePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<CsvImport>;
};

export type Error = {
  __typename?: 'Error';
  field: Scalars['String'];
  messages: Array<Scalars['String']>;
};

/** Autogenerated input type of AccountConnectorsCancelBackfill */
export type AccountConnectorsCancelBackfillInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  targetObjectType: Scalars['String'];
};

/** Autogenerated return type of AccountConnectorsCancelBackfill */
export type AccountConnectorsCancelBackfillPayload = {
  __typename?: 'AccountConnectorsCancelBackfillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<AccountConnector>;
};

/** Autogenerated input type of AccountCancelDowngradeSubscription */
export type AccountCancelDowngradeSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountCancelDowngradeSubscription */
export type AccountCancelDowngradeSubscriptionPayload = {
  __typename?: 'AccountCancelDowngradeSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of SegmentsCancelExportCsv */
export type SegmentsCancelExportCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  exportId: Scalars['ID'];
};

/** Autogenerated return type of SegmentsCancelExportCsv */
export type SegmentsCancelExportCsvPayload = {
  __typename?: 'SegmentsCancelExportCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Export>;
};

/** Autogenerated input type of ProspectListExportCancel */
export type ProspectListExportCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ProspectListExportCancel */
export type ProspectListExportCancelPayload = {
  __typename?: 'ProspectListExportCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<ProspectListExport>;
};

/** Autogenerated input type of SegmentsClone */
export type SegmentsCloneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  segmentId: Scalars['ID'];
  type: SegmentLegacyTypeEnum;
};

/** Autogenerated return type of SegmentsClone */
export type SegmentsClonePayload = {
  __typename?: 'SegmentsClonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Segment>;
};

/** Autogenerated input type of ProspectListCopy */
export type ProspectListCopyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ProspectListCopy */
export type ProspectListCopyPayload = {
  __typename?: 'ProspectListCopyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<ProspectList>;
};

/** Autogenerated input type of AccountCreate */
export type AccountCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Autogenerated return type of AccountCreate */
export type AccountCreatePayload = {
  __typename?: 'AccountCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountCreateSubscription */
export type AccountCreateSubscriptionInput = {
  amount: Scalars['Int'];
  billingTerm?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  limitTerm?: InputMaybe<Scalars['String']>;
  planId: Scalars['String'];
};

/** Autogenerated return type of AccountCreateSubscription */
export type AccountCreateSubscriptionPayload = {
  __typename?: 'AccountCreateSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AudiencesCreate */
export type AudiencesCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clonedFromAudienceId?: InputMaybe<Scalars['ID']>;
  companySearch?: InputMaybe<Scalars['RawJson']>;
  config?: InputMaybe<Scalars['Json']>;
  externalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  personSearch?: InputMaybe<Scalars['RawJson']>;
  segment?: InputMaybe<AudienceSegmentInput>;
  service?: InputMaybe<AudienceServiceEnum>;
  subtype?: InputMaybe<AudienceSubtypeEnum>;
};

export type AudienceSegmentInput = {
  collectionId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['RawJson']>;
  type: SegmentTypeEnum;
};

/** Autogenerated return type of AudiencesCreate */
export type AudiencesCreatePayload = {
  __typename?: 'AudiencesCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Audience>;
};

/** Autogenerated input type of AudiencePreviewsCreate */
export type AudiencePreviewsCreateInput = {
  audienceType: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companySearch?: InputMaybe<Scalars['RawJson']>;
  personSearch?: InputMaybe<Scalars['RawJson']>;
  segmentSearch?: InputMaybe<Scalars['RawJson']>;
  segmentType?: InputMaybe<SegmentTypeEnum>;
};

/** Autogenerated return type of AudiencePreviewsCreate */
export type AudiencePreviewsCreatePayload = {
  __typename?: 'AudiencePreviewsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<AudiencePreview>;
};

/** Autogenerated input type of CollectionsCreate */
export type CollectionsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type: CollectionLegacyTypeEnum;
};

/** Autogenerated return type of CollectionsCreate */
export type CollectionsCreatePayload = {
  __typename?: 'CollectionsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Collection>;
};

/** Autogenerated input type of CsvImportsCreate */
export type CsvImportsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
  type: Scalars['String'];
};

/** Autogenerated return type of CsvImportsCreate */
export type CsvImportsCreatePayload = {
  __typename?: 'CsvImportsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<CsvImport>;
};

/** Autogenerated input type of CsvImportsCreateSegment */
export type CsvImportsCreateSegmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectionId: Scalars['ID'];
  id: Scalars['ID'];
  segmentName: Scalars['String'];
};

/** Autogenerated return type of CsvImportsCreateSegment */
export type CsvImportsCreateSegmentPayload = {
  __typename?: 'CsvImportsCreateSegmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<CsvImport>;
};

/** Autogenerated input type of CustomObjectsCreate */
export type CustomObjectsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalAccountId: Scalars['String'];
  externalObjectName: Scalars['String'];
  externalObjectType: Scalars['String'];
  externalType: Scalars['String'];
  identifierField: Scalars['String'];
  identifierType: Scalars['String'];
};

/** Autogenerated return type of CustomObjectsCreate */
export type CustomObjectsCreatePayload = {
  __typename?: 'CustomObjectsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<CustomObject>;
};

/** Autogenerated input type of DestinationsCreate */
export type DestinationsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['Json']>;
  segmentId: Scalars['ID'];
  segmentType: SegmentTypeEnum;
  triggerType?: InputMaybe<DestinationTriggerTypeEnum>;
  type: DestinationTypeEnum;
};

export enum DestinationTriggerTypeEnum {
  Page = 'page',
  SegmentEnter = 'segment_enter',
  SegmentExit = 'segment_exit'
}

/** Autogenerated return type of DestinationsCreate */
export type DestinationsCreatePayload = {
  __typename?: 'DestinationsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Destination>;
};

/** Autogenerated input type of FitModelsCreate */
export type FitModelsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lostAudienceId?: InputMaybe<Scalars['ID']>;
  type: FitModelTypeEnum;
  wonAudienceId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of FitModelsCreate */
export type FitModelsCreatePayload = {
  __typename?: 'FitModelsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<FitModel>;
};

/** Autogenerated input type of HubspotCreateCompany */
export type HubspotCreateCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  domain: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of HubspotCreateCompany */
export type HubspotCreateCompanyPayload = {
  __typename?: 'HubspotCreateCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
};

/** Autogenerated input type of GoogleDimensionMappingCreateOrUpdate */
export type GoogleDimensionMappingCreateOrUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: Array<Scalars['Json']>;
  externalAccountId: Scalars['String'];
  externalPropertyId: Scalars['String'];
  externalPropertyName: Scalars['String'];
  status: GoogleDimensionMappingStatusEnum;
};

/** Autogenerated return type of GoogleDimensionMappingCreateOrUpdate */
export type GoogleDimensionMappingCreateOrUpdatePayload = {
  __typename?: 'GoogleDimensionMappingCreateOrUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<GoogleDimensionMapping>;
};

/** Autogenerated input type of ProspectListCreate */
export type ProspectListCreateInput = {
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyCities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyCountries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyTech?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  employeesRanges?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  industries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  names?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seniorities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Autogenerated return type of ProspectListCreate */
export type ProspectListCreatePayload = {
  __typename?: 'ProspectListCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<ProspectList>;
};

/** Autogenerated input type of ProspectListExportCreate */
export type ProspectListExportCreateInput = {
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyCities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyCountries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyTech?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  employeesRanges?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  exportType: ProspectListExportTypeEnum;
  industries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mapping?: InputMaybe<Array<ProspectListExportAttributeMappingInput>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  objectType?: InputMaybe<ProspectListExportObjectTypeEnum>;
  prospectIds: Array<Scalars['ID']>;
  prospectListId?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seniorities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProspectListExportAttributeMappingInput = {
  sourceAttribute: Scalars['String'];
  targetAttribute: Scalars['String'];
};

export enum ProspectListExportObjectTypeEnum {
  Contact = 'contact',
  Lead = 'lead'
}

/** Autogenerated return type of ProspectListExportCreate */
export type ProspectListExportCreatePayload = {
  __typename?: 'ProspectListExportCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<ProspectListExport>;
};

/** Autogenerated input type of SegmentsCreate */
export type SegmentsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['RawJson']>;
  targetMarket?: InputMaybe<Scalars['Boolean']>;
  type: SegmentLegacyTypeEnum;
};

/** Autogenerated return type of SegmentsCreate */
export type SegmentsCreatePayload = {
  __typename?: 'SegmentsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Segment>;
};

/** Autogenerated input type of TargetMarketsCreate */
export type TargetMarketsCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  search: Scalars['Json'];
};

/** Autogenerated return type of TargetMarketsCreate */
export type TargetMarketsCreatePayload = {
  __typename?: 'TargetMarketsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<TargetMarket>;
};

export type TargetMarket = {
  __typename?: 'TargetMarket';
  account: Account;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  search: Scalars['Json'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of AccountConnectorsDeleteSelectiveEnrichment */
export type AccountConnectorsDeleteSelectiveEnrichmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalObjectType: Scalars['String'];
  id: Scalars['ID'];
};

/** Autogenerated return type of AccountConnectorsDeleteSelectiveEnrichment */
export type AccountConnectorsDeleteSelectiveEnrichmentPayload = {
  __typename?: 'AccountConnectorsDeleteSelectiveEnrichmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<AccountConnector>;
};

/** Autogenerated input type of DestinationsDeliverTest */
export type DestinationsDeliverTestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  config: Scalars['Json'];
  segmentId: Scalars['ID'];
  segmentType: SegmentTypeEnum;
  type: DestinationTestTypeEnum;
};

export enum DestinationTestTypeEnum {
  Email = 'email',
  Slack = 'slack',
  Webhook = 'webhook'
}

/** Autogenerated return type of DestinationsDeliverTest */
export type DestinationsDeliverTestPayload = {
  __typename?: 'DestinationsDeliverTestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AccountConnectorsDestroy */
export type AccountConnectorsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AccountConnectorsDestroy */
export type AccountConnectorsDestroyPayload = {
  __typename?: 'AccountConnectorsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<AccountConnector>;
};

/** Autogenerated input type of AudiencesDestroy */
export type AudiencesDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AudiencesDestroy */
export type AudiencesDestroyPayload = {
  __typename?: 'AudiencesDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Audience>;
};

/** Autogenerated input type of CollectionsDestroy */
export type CollectionsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type: CollectionLegacyTypeEnum;
};

/** Autogenerated return type of CollectionsDestroy */
export type CollectionsDestroyPayload = {
  __typename?: 'CollectionsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CsvImportsDestroy */
export type CsvImportsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CsvImportsDestroy */
export type CsvImportsDestroyPayload = {
  __typename?: 'CsvImportsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<CsvImport>;
};

/** Autogenerated input type of CustomObjectsDestroy */
export type CustomObjectsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CustomObjectsDestroy */
export type CustomObjectsDestroyPayload = {
  __typename?: 'CustomObjectsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<CustomObject>;
};

/** Autogenerated input type of DestinationsDestroy */
export type DestinationsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DestinationsDestroy */
export type DestinationsDestroyPayload = {
  __typename?: 'DestinationsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Destination>;
};

/** Autogenerated input type of FitModelsDestroy */
export type FitModelsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of FitModelsDestroy */
export type FitModelsDestroyPayload = {
  __typename?: 'FitModelsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<FitModel>;
};

/** Autogenerated input type of GoogleDimensionMappingDestroy */
export type GoogleDimensionMappingDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated return type of GoogleDimensionMappingDestroy */
export type GoogleDimensionMappingDestroyPayload = {
  __typename?: 'GoogleDimensionMappingDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<GoogleDimensionMapping>;
};

/** Autogenerated input type of ProspectListDestroy */
export type ProspectListDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ProspectListDestroy */
export type ProspectListDestroyPayload = {
  __typename?: 'ProspectListDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<ProspectList>;
};

/** Autogenerated input type of SegmentsDestroy */
export type SegmentsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type: SegmentLegacyTypeEnum;
};

/** Autogenerated return type of SegmentsDestroy */
export type SegmentsDestroyPayload = {
  __typename?: 'SegmentsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
};

/** Autogenerated input type of TargetMarketsDestroy */
export type TargetMarketsDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of TargetMarketsDestroy */
export type TargetMarketsDestroyPayload = {
  __typename?: 'TargetMarketsDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<TargetMarket>;
};

/** Autogenerated input type of UserDestroy */
export type UserDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Autogenerated return type of UserDestroy */
export type UserDestroyPayload = {
  __typename?: 'UserDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<User>;
};

/** Autogenerated input type of AccountDowngradeSubscription */
export type AccountDowngradeSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  downgradeDate?: InputMaybe<Scalars['String']>;
  downgradeLimit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of AccountDowngradeSubscription */
export type AccountDowngradeSubscriptionPayload = {
  __typename?: 'AccountDowngradeSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of ProspectListExportDownload */
export type ProspectListExportDownloadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ProspectListExportDownload */
export type ProspectListExportDownloadPayload = {
  __typename?: 'ProspectListExportDownloadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<ProspectListExport>;
};

/** Autogenerated input type of HubspotEnrichList */
export type HubspotEnrichListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  listId: Scalars['ID'];
  objectType: HubspotListObjectTypeEnum;
};

/** Autogenerated return type of HubspotEnrichList */
export type HubspotEnrichListPayload = {
  __typename?: 'HubspotEnrichListPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AudiencesExport */
export type AudiencesExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  integration?: InputMaybe<AudienceIntegrationsEnum>;
};

export enum AudienceIntegrationsEnum {
  Linkedin = 'linkedin'
}

/** Autogenerated return type of AudiencesExport */
export type AudiencesExportPayload = {
  __typename?: 'AudiencesExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SegmentsExportCsv */
export type SegmentsExportCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  columns: Array<Scalars['Json']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['ID']>;
  type: SegmentLegacyTypeEnum;
};

/** Autogenerated return type of SegmentsExportCsv */
export type SegmentsExportCsvPayload = {
  __typename?: 'SegmentsExportCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Segment>;
};

/** Autogenerated input type of FormsAddAllowedSite */
export type FormsAddAllowedSiteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  integration: FormIntegrationEnum;
  siteUrl: Scalars['String'];
};

/** Autogenerated return type of FormsAddAllowedSite */
export type FormsAddAllowedSitePayload = {
  __typename?: 'FormsAddAllowedSitePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<FormConfiguration>;
};

/** Autogenerated input type of FormsRemoveAllowedSite */
export type FormsRemoveAllowedSiteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  integration: FormIntegrationEnum;
};

/** Autogenerated return type of FormsRemoveAllowedSite */
export type FormsRemoveAllowedSitePayload = {
  __typename?: 'FormsRemoveAllowedSitePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<FormConfiguration>;
};

/** Autogenerated input type of FormsUpdateConfiguration */
export type FormsUpdateConfigurationInput = {
  autofill: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  formShortening: Scalars['Boolean'];
  identifyOnSubmit: Scalars['Boolean'];
  integration: FormIntegrationEnum;
};

/** Autogenerated return type of FormsUpdateConfiguration */
export type FormsUpdateConfigurationPayload = {
  __typename?: 'FormsUpdateConfigurationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<FormConfiguration>;
};

/** Autogenerated input type of FormsUpsertFieldMappings */
export type FormsUpsertFieldMappingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldMappings: Array<Scalars['Json']>;
  integration: FormIntegrationEnum;
};

/** Autogenerated return type of FormsUpsertFieldMappings */
export type FormsUpsertFieldMappingsPayload = {
  __typename?: 'FormsUpsertFieldMappingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<FormFieldMappings>;
};

/** Autogenerated input type of AccountInviteCancel */
export type AccountInviteCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AccountInviteCancel */
export type AccountInviteCancelPayload = {
  __typename?: 'AccountInviteCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountInviteUser */
export type AccountInviteUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** Autogenerated return type of AccountInviteUser */
export type AccountInviteUserPayload = {
  __typename?: 'AccountInviteUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of CsvImportsParse */
export type CsvImportsParseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
  createSegment: Scalars['Boolean'];
  id: Scalars['ID'];
  mapping: Array<Scalars['Json']>;
  primaryIdentifierColumn: Scalars['String'];
  segmentName?: InputMaybe<Scalars['String']>;
  sourceName: Scalars['String'];
};

/** Autogenerated return type of CsvImportsParse */
export type CsvImportsParsePayload = {
  __typename?: 'CsvImportsParsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<CsvImport>;
};

/** Autogenerated input type of AccountConnectorsReexportProperties */
export type AccountConnectorsReexportPropertiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AccountConnectorsReexportProperties */
export type AccountConnectorsReexportPropertiesPayload = {
  __typename?: 'AccountConnectorsReexportPropertiesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<JobHistory>;
};

/** Autogenerated input type of AccountRefreshPageEvent */
export type AccountRefreshPageEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountRefreshPageEvent */
export type AccountRefreshPageEventPayload = {
  __typename?: 'AccountRefreshPageEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountConnectorsRefreshFacebookAdAccount */
export type AccountConnectorsRefreshFacebookAdAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  facebookAdAccountId: Scalars['ID'];
};

/** Autogenerated return type of AccountConnectorsRefreshFacebookAdAccount */
export type AccountConnectorsRefreshFacebookAdAccountPayload = {
  __typename?: 'AccountConnectorsRefreshFacebookAdAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<FacebookAdAccount>;
};

export type FacebookAdAccount = {
  __typename?: 'FacebookAdAccount';
  adPixels: Array<FacebookAdPixel>;
  id: Scalars['String'];
  name: Scalars['String'];
  termsAccepted?: Maybe<Scalars['Boolean']>;
  termsUrl?: Maybe<Scalars['String']>;
};

export type FacebookAdPixel = {
  __typename?: 'FacebookAdPixel';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Autogenerated input type of AccountConnectorsRefreshGoogleAdAccounts */
export type AccountConnectorsRefreshGoogleAdAccountsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountConnectorsRefreshGoogleAdAccounts */
export type AccountConnectorsRefreshGoogleAdAccountsPayload = {
  __typename?: 'AccountConnectorsRefreshGoogleAdAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<GoogleAccountConnector>;
};

export type GoogleAccountConnector = AccountConnector & {
  __typename?: 'GoogleAccountConnector';
  accountId: Scalars['ID'];
  adAccounts?: Maybe<Array<GoogleAdAccount>>;
  backfillActive: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  fieldMapping?: Maybe<FieldMapping>;
  id: Scalars['ID'];
  isInitialSync?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextSyncAt?: Maybe<Scalars['DateTime']>;
  notification?: Maybe<AccountNotification>;
  remoteMeta: Scalars['Json'];
  selectiveEnrichmentFilters?: Maybe<SelectiveEnrichmentFilters>;
  service: AccountConnectorServiceEnum;
  status: AccountConnectorStatusEnum;
  syncProgress?: Maybe<Scalars['Int']>;
  syncStartedAt?: Maybe<Scalars['DateTime']>;
  syncStatus?: Maybe<Scalars['String']>;
  webhookPassword?: Maybe<Scalars['String']>;
};


export type GoogleAccountConnectorBackfillActiveArgs = {
  targetObjectType?: InputMaybe<Scalars['String']>;
};


export type GoogleAccountConnectorFieldMappingArgs = {
  targetObjectType: Scalars['String'];
};


export type GoogleAccountConnectorSelectiveEnrichmentFiltersArgs = {
  externalObjectType: Scalars['String'];
};

export type GoogleAdAccount = {
  __typename?: 'GoogleAdAccount';
  displayName: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Autogenerated input type of AccountConnectorsRefreshRemoteMeta */
export type AccountConnectorsRefreshRemoteMetaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AccountConnectorsRefreshRemoteMeta */
export type AccountConnectorsRefreshRemoteMetaPayload = {
  __typename?: 'AccountConnectorsRefreshRemoteMetaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<AccountConnector>;
};

/** Autogenerated input type of SegmentsRefresh */
export type SegmentsRefreshInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  type: SegmentTypeEnum;
};

/** Autogenerated return type of SegmentsRefresh */
export type SegmentsRefreshPayload = {
  __typename?: 'SegmentsRefreshPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Segment>;
};

/** Autogenerated input type of AccountNotificationResolve */
export type AccountNotificationResolveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of AccountNotificationResolve */
export type AccountNotificationResolvePayload = {
  __typename?: 'AccountNotificationResolvePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<AccountNotification>;
};

/** Autogenerated input type of AccountConnectorsSaveSelectiveEnrichment */
export type AccountConnectorsSaveSelectiveEnrichmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalObjectType: Scalars['String'];
  filters: Scalars['Json'];
  id: Scalars['ID'];
};

/** Autogenerated return type of AccountConnectorsSaveSelectiveEnrichment */
export type AccountConnectorsSaveSelectiveEnrichmentPayload = {
  __typename?: 'AccountConnectorsSaveSelectiveEnrichmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<AccountConnector>;
};

/** Autogenerated input type of AccountSkipOnboarding */
export type AccountSkipOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountSkipOnboarding */
export type AccountSkipOnboardingPayload = {
  __typename?: 'AccountSkipOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountConnectorsToggleFieldMapping */
export type AccountConnectorsToggleFieldMappingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  targetObjectType: Scalars['String'];
};

/** Autogenerated return type of AccountConnectorsToggleFieldMapping */
export type AccountConnectorsToggleFieldMappingPayload = {
  __typename?: 'AccountConnectorsToggleFieldMappingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<AccountConnector>;
};

/** Autogenerated input type of GoogleDimensionMappingToggleStatus */
export type GoogleDimensionMappingToggleStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  status: GoogleDimensionMappingStatusEnum;
};

/** Autogenerated return type of GoogleDimensionMappingToggleStatus */
export type GoogleDimensionMappingToggleStatusPayload = {
  __typename?: 'GoogleDimensionMappingToggleStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<GoogleDimensionMapping>;
};

/** Autogenerated input type of AccountConnectorsTriggerBackfill */
export type AccountConnectorsTriggerBackfillInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  targetObjectType: Scalars['String'];
};

/** Autogenerated return type of AccountConnectorsTriggerBackfill */
export type AccountConnectorsTriggerBackfillPayload = {
  __typename?: 'AccountConnectorsTriggerBackfillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AccountUpdate */
export type AccountUpdateInput = {
  allowedReferrers?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountUpdate */
export type AccountUpdatePayload = {
  __typename?: 'AccountUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountUpdateApiVersion */
export type AccountUpdateApiVersionInput = {
  apiName: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountUpdateApiVersion */
export type AccountUpdateApiVersionPayload = {
  __typename?: 'AccountUpdateApiVersionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountUpdateBillingInfo */
export type AccountUpdateBillingInfoInput = {
  address?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  cardToken?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountUpdateBillingInfo */
export type AccountUpdateBillingInfoPayload = {
  __typename?: 'AccountUpdateBillingInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountConnectorsUpdate */
export type AccountConnectorsUpdateInput = {
  accountType: AccountConnectorGoogleAccountTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum AccountConnectorGoogleAccountTypeEnum {
  Analytics_360Suite = 'analytics_360_suite',
  Standard = 'standard'
}

/** Autogenerated return type of AccountConnectorsUpdate */
export type AccountConnectorsUpdatePayload = {
  __typename?: 'AccountConnectorsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<AccountConnector>;
};

/** Autogenerated input type of AccountUpdateDetails */
export type AccountUpdateDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  mfaEnforced?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountUpdateDetails */
export type AccountUpdateDetailsPayload = {
  __typename?: 'AccountUpdateDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountUpdateSettings */
export type AccountUpdateSettingsInput = {
  allowedReferrers?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  webhookUrl?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountUpdateSettings */
export type AccountUpdateSettingsPayload = {
  __typename?: 'AccountUpdateSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountUpdateSubscription */
export type AccountUpdateSubscriptionInput = {
  amount?: InputMaybe<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  planId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountUpdateSubscription */
export type AccountUpdateSubscriptionPayload = {
  __typename?: 'AccountUpdateSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountUpdateSuppressionSettings */
export type AccountUpdateSuppressionSettingsInput = {
  apiName: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
};

/** Autogenerated return type of AccountUpdateSuppressionSettings */
export type AccountUpdateSuppressionSettingsPayload = {
  __typename?: 'AccountUpdateSuppressionSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AudiencesUpdate */
export type AudiencesUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companySearch?: InputMaybe<Scalars['RawJson']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  personSearch?: InputMaybe<Scalars['RawJson']>;
};

/** Autogenerated return type of AudiencesUpdate */
export type AudiencesUpdatePayload = {
  __typename?: 'AudiencesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Audience>;
};

/** Autogenerated input type of CollectionsUpdate */
export type CollectionsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  type: CollectionLegacyTypeEnum;
};

/** Autogenerated return type of CollectionsUpdate */
export type CollectionsUpdatePayload = {
  __typename?: 'CollectionsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Collection>;
};

/** Autogenerated input type of DestinationsUpdate */
export type DestinationsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['Json']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  triggerType?: InputMaybe<DestinationTriggerTypeEnum>;
};

/** Autogenerated return type of DestinationsUpdate */
export type DestinationsUpdatePayload = {
  __typename?: 'DestinationsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Destination>;
};

/** Autogenerated input type of AccountConnectorsUpdateFieldMapping */
export type AccountConnectorsUpdateFieldMappingInput = {
  backfill?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldMappings: Array<Scalars['Json']>;
  id: Scalars['ID'];
  targetObjectType: Scalars['String'];
};

/** Autogenerated return type of AccountConnectorsUpdateFieldMapping */
export type AccountConnectorsUpdateFieldMappingPayload = {
  __typename?: 'AccountConnectorsUpdateFieldMappingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AccountConnectorsUpdateHubspotLiveEnrichment */
export type AccountConnectorsUpdateHubspotLiveEnrichmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  targetObjectType: HubspotListObjectTypeEnum;
};

/** Autogenerated return type of AccountConnectorsUpdateHubspotLiveEnrichment */
export type AccountConnectorsUpdateHubspotLiveEnrichmentPayload = {
  __typename?: 'AccountConnectorsUpdateHubspotLiveEnrichmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<HubspotEnrichmentSettings>;
};

/** Autogenerated input type of AccountConnectorsUpdatePardotBusinessUnitId */
export type AccountConnectorsUpdatePardotBusinessUnitIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  pardotBusinessUnitId: Scalars['ID'];
};

/** Autogenerated return type of AccountConnectorsUpdatePardotBusinessUnitId */
export type AccountConnectorsUpdatePardotBusinessUnitIdPayload = {
  __typename?: 'AccountConnectorsUpdatePardotBusinessUnitIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<SalesforceAccountConnector>;
};

/** Autogenerated input type of ProspectListUpdate */
export type ProspectListUpdateInput = {
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyCities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyCountries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyTech?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  employeesRanges?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
  industries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  names?: InputMaybe<Array<Scalars['String']>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seniorities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Autogenerated return type of ProspectListUpdate */
export type ProspectListUpdatePayload = {
  __typename?: 'ProspectListUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<ProspectList>;
};

/** Autogenerated input type of SalesPipelinesUpdate */
export type SalesPipelinesUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  leadStageEnabled?: InputMaybe<Scalars['Boolean']>;
  leadStageSearch?: InputMaybe<Scalars['RawJson']>;
  mqlStageEnabled?: InputMaybe<Scalars['Boolean']>;
  mqlStageSearch?: InputMaybe<Scalars['RawJson']>;
};

/** Autogenerated return type of SalesPipelinesUpdate */
export type SalesPipelinesUpdatePayload = {
  __typename?: 'SalesPipelinesUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<SalesPipeline>;
};

/** Autogenerated input type of SegmentsUpdate */
export type SegmentsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['RawJson']>;
  targetMarket?: InputMaybe<Scalars['Boolean']>;
  type: SegmentLegacyTypeEnum;
};

/** Autogenerated return type of SegmentsUpdate */
export type SegmentsUpdatePayload = {
  __typename?: 'SegmentsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Segment>;
};

/** Autogenerated input type of TargetMarketsUpdate */
export type TargetMarketsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['Json']>;
};

/** Autogenerated return type of TargetMarketsUpdate */
export type TargetMarketsUpdatePayload = {
  __typename?: 'TargetMarketsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<TargetMarket>;
};

/** Autogenerated input type of UserUpdatePassword */
export type UserUpdatePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

/** Autogenerated return type of UserUpdatePassword */
export type UserUpdatePasswordPayload = {
  __typename?: 'UserUpdatePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<User>;
};

/** Autogenerated input type of UserUpdateProfile */
export type UserUpdateProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mailing?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UserUpdateProfile */
export type UserUpdateProfilePayload = {
  __typename?: 'UserUpdateProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<User>;
};

/** Autogenerated input type of UserUpdateRole */
export type UserUpdateRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  role: UserRoleEnum;
  userId: Scalars['ID'];
};

/** Autogenerated return type of UserUpdateRole */
export type UserUpdateRolePayload = {
  __typename?: 'UserUpdateRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<User>;
};

/** Autogenerated input type of AccountUpgradePlan */
export type AccountUpgradePlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  creditGrant?: InputMaybe<Scalars['Int']>;
  planId: Scalars['String'];
};

/** Autogenerated return type of AccountUpgradePlan */
export type AccountUpgradePlanPayload = {
  __typename?: 'AccountUpgradePlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<Account>;
};

/** Autogenerated input type of AccountConnectorsUpsertG2Connector */
export type AccountConnectorsUpsertG2ConnectorInput = {
  apiToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountConnectorsUpsertG2Connector */
export type AccountConnectorsUpsertG2ConnectorPayload = {
  __typename?: 'AccountConnectorsUpsertG2ConnectorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<G2AccountConnector>;
};

export type G2AccountConnector = AccountConnector & {
  __typename?: 'G2AccountConnector';
  accountId: Scalars['ID'];
  apiToken: Scalars['String'];
  backfillActive: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  fieldMapping?: Maybe<FieldMapping>;
  id: Scalars['ID'];
  isInitialSync?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextSyncAt?: Maybe<Scalars['DateTime']>;
  notification?: Maybe<AccountNotification>;
  remoteMeta: Scalars['Json'];
  selectiveEnrichmentFilters?: Maybe<SelectiveEnrichmentFilters>;
  service: AccountConnectorServiceEnum;
  status: AccountConnectorStatusEnum;
  syncProgress?: Maybe<Scalars['Int']>;
  syncStartedAt?: Maybe<Scalars['DateTime']>;
  syncStatus?: Maybe<Scalars['String']>;
  webhookPassword?: Maybe<Scalars['String']>;
};


export type G2AccountConnectorBackfillActiveArgs = {
  targetObjectType?: InputMaybe<Scalars['String']>;
};


export type G2AccountConnectorFieldMappingArgs = {
  targetObjectType: Scalars['String'];
};


export type G2AccountConnectorSelectiveEnrichmentFiltersArgs = {
  externalObjectType: Scalars['String'];
};

/** Autogenerated input type of TagManagerUpsertGoogleAnalyticsConfig */
export type TagManagerUpsertGoogleAnalyticsConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
};

/** Autogenerated return type of TagManagerUpsertGoogleAnalyticsConfig */
export type TagManagerUpsertGoogleAnalyticsConfigPayload = {
  __typename?: 'TagManagerUpsertGoogleAnalyticsConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<GoogleAnalytics>;
};

/** Autogenerated input type of TagManagerUpsertGoogleTagManagerConfig */
export type TagManagerUpsertGoogleTagManagerConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
};

/** Autogenerated return type of TagManagerUpsertGoogleTagManagerConfig */
export type TagManagerUpsertGoogleTagManagerConfigPayload = {
  __typename?: 'TagManagerUpsertGoogleTagManagerConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<GoogleTagManager>;
};

/** Autogenerated input type of AccountConnectorsUpsertMarketoConnector */
export type AccountConnectorsUpsertMarketoConnectorInput = {
  clientId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientSecret: Scalars['String'];
  endpointUrl: Scalars['String'];
};

/** Autogenerated return type of AccountConnectorsUpsertMarketoConnector */
export type AccountConnectorsUpsertMarketoConnectorPayload = {
  __typename?: 'AccountConnectorsUpsertMarketoConnectorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<MarketoAccountConnector>;
};

export type MarketoAccountConnector = AccountConnector & {
  __typename?: 'MarketoAccountConnector';
  accountId: Scalars['ID'];
  backfillActive: Scalars['Boolean'];
  clientId: Scalars['ID'];
  clientSecret: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endpointUrl: Scalars['String'];
  fieldMapping?: Maybe<FieldMapping>;
  id: Scalars['ID'];
  isInitialSync?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextSyncAt?: Maybe<Scalars['DateTime']>;
  notification?: Maybe<AccountNotification>;
  remoteMeta: Scalars['Json'];
  selectiveEnrichmentFilters?: Maybe<SelectiveEnrichmentFilters>;
  service: AccountConnectorServiceEnum;
  status: AccountConnectorStatusEnum;
  syncProgress?: Maybe<Scalars['Int']>;
  syncStartedAt?: Maybe<Scalars['DateTime']>;
  syncStatus?: Maybe<Scalars['String']>;
  webhookPassword?: Maybe<Scalars['String']>;
};


export type MarketoAccountConnectorBackfillActiveArgs = {
  targetObjectType?: InputMaybe<Scalars['String']>;
};


export type MarketoAccountConnectorFieldMappingArgs = {
  targetObjectType: Scalars['String'];
};


export type MarketoAccountConnectorSelectiveEnrichmentFiltersArgs = {
  externalObjectType: Scalars['String'];
};

/** Autogenerated input type of TagManagerUpsert */
export type TagManagerUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pushToDataLayer?: InputMaybe<Scalars['Boolean']>;
  service: TagManagerServiceEnum;
  status?: InputMaybe<TagManagerStatusEnum>;
};

/** Autogenerated return type of TagManagerUpsert */
export type TagManagerUpsertPayload = {
  __typename?: 'TagManagerUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Error>;
  node?: Maybe<TagManager>;
};

export type FacebookAccountConnector = AccountConnector & {
  __typename?: 'FacebookAccountConnector';
  accountId: Scalars['ID'];
  adAccounts?: Maybe<Array<FacebookAdAccount>>;
  backfillActive: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  fieldMapping?: Maybe<FieldMapping>;
  id: Scalars['ID'];
  isInitialSync?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextSyncAt?: Maybe<Scalars['DateTime']>;
  notification?: Maybe<AccountNotification>;
  remoteMeta: Scalars['Json'];
  selectiveEnrichmentFilters?: Maybe<SelectiveEnrichmentFilters>;
  service: AccountConnectorServiceEnum;
  status: AccountConnectorStatusEnum;
  syncProgress?: Maybe<Scalars['Int']>;
  syncStartedAt?: Maybe<Scalars['DateTime']>;
  syncStatus?: Maybe<Scalars['String']>;
  webhookPassword?: Maybe<Scalars['String']>;
};


export type FacebookAccountConnectorBackfillActiveArgs = {
  targetObjectType?: InputMaybe<Scalars['String']>;
};


export type FacebookAccountConnectorFieldMappingArgs = {
  targetObjectType: Scalars['String'];
};


export type FacebookAccountConnectorSelectiveEnrichmentFiltersArgs = {
  externalObjectType: Scalars['String'];
};

export type HubspotAccountConnector = AccountConnector & {
  __typename?: 'HubspotAccountConnector';
  accountId: Scalars['ID'];
  backfillActive: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  fieldMapping?: Maybe<FieldMapping>;
  hubspotAccountId: Scalars['String'];
  id: Scalars['ID'];
  isInitialSync?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextSyncAt?: Maybe<Scalars['DateTime']>;
  notification?: Maybe<AccountNotification>;
  owners: Array<HubspotOwner>;
  remoteMeta: Scalars['Json'];
  selectiveEnrichmentFilters?: Maybe<SelectiveEnrichmentFilters>;
  service: AccountConnectorServiceEnum;
  status: AccountConnectorStatusEnum;
  syncProgress?: Maybe<Scalars['Int']>;
  syncStartedAt?: Maybe<Scalars['DateTime']>;
  syncStatus?: Maybe<Scalars['String']>;
  webhookPassword?: Maybe<Scalars['String']>;
};


export type HubspotAccountConnectorBackfillActiveArgs = {
  targetObjectType?: InputMaybe<Scalars['String']>;
};


export type HubspotAccountConnectorFieldMappingArgs = {
  targetObjectType: Scalars['String'];
};


export type HubspotAccountConnectorSelectiveEnrichmentFiltersArgs = {
  externalObjectType: Scalars['String'];
};

export type HubspotOwner = {
  __typename?: 'HubspotOwner';
  id: Scalars['ID'];
  ownerName: Scalars['String'];
};

export type SlackAccountConnector = AccountConnector & {
  __typename?: 'SlackAccountConnector';
  accountId: Scalars['ID'];
  backfillActive: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  fieldMapping?: Maybe<FieldMapping>;
  id: Scalars['ID'];
  isInitialSync?: Maybe<Scalars['Boolean']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextSyncAt?: Maybe<Scalars['DateTime']>;
  notification?: Maybe<AccountNotification>;
  remoteMeta: Scalars['Json'];
  selectiveEnrichmentFilters?: Maybe<SelectiveEnrichmentFilters>;
  service: AccountConnectorServiceEnum;
  status: AccountConnectorStatusEnum;
  syncProgress?: Maybe<Scalars['Int']>;
  syncStartedAt?: Maybe<Scalars['DateTime']>;
  syncStatus?: Maybe<Scalars['String']>;
  webhookPassword?: Maybe<Scalars['String']>;
};


export type SlackAccountConnectorBackfillActiveArgs = {
  targetObjectType?: InputMaybe<Scalars['String']>;
};


export type SlackAccountConnectorFieldMappingArgs = {
  targetObjectType: Scalars['String'];
};


export type SlackAccountConnectorSelectiveEnrichmentFiltersArgs = {
  externalObjectType: Scalars['String'];
};

export type AccountNotificationFragment = { __typename?: 'AccountNotification', id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, resolved: boolean, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null };

export type AccountNotificationsFragment = { __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null };

export type ResolveAccountNotificationMutationVariables = Exact<{
  input: AccountNotificationResolveInput;
}>;


export type ResolveAccountNotificationMutation = { __typename?: 'Mutation', resolveAccountNotification?: { __typename?: 'AccountNotificationResolvePayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AccountSwitchFragment = { __typename?: 'User', id: string, name?: string | null, email: string, accounts: Array<{ __typename?: 'Account', id: string, name?: string | null }> };

type ActiveIntegrationCardAccountConnector_SalesforceAccountConnector_Fragment = { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null };

type ActiveIntegrationCardAccountConnector_GoogleAccountConnector_Fragment = { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null };

type ActiveIntegrationCardAccountConnector_G2AccountConnector_Fragment = { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null };

type ActiveIntegrationCardAccountConnector_MarketoAccountConnector_Fragment = { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null };

type ActiveIntegrationCardAccountConnector_FacebookAccountConnector_Fragment = { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null };

type ActiveIntegrationCardAccountConnector_HubspotAccountConnector_Fragment = { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null };

type ActiveIntegrationCardAccountConnector_SlackAccountConnector_Fragment = { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null };

export type ActiveIntegrationCardAccountConnectorFragment = ActiveIntegrationCardAccountConnector_SalesforceAccountConnector_Fragment | ActiveIntegrationCardAccountConnector_GoogleAccountConnector_Fragment | ActiveIntegrationCardAccountConnector_G2AccountConnector_Fragment | ActiveIntegrationCardAccountConnector_MarketoAccountConnector_Fragment | ActiveIntegrationCardAccountConnector_FacebookAccountConnector_Fragment | ActiveIntegrationCardAccountConnector_HubspotAccountConnector_Fragment | ActiveIntegrationCardAccountConnector_SlackAccountConnector_Fragment;

export type EnrichmentHealthMetricMetricQueryVariables = Exact<{
  metricName: Scalars['String'];
  externalType: AccountConnectorServiceEnum;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;


export type EnrichmentHealthMetricMetricQuery = { __typename?: 'Query', enrichmentHealthMetric: { __typename?: 'EnrichmentHealthMetric', uniques: number } };

export type ActiveIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveIntegrationsQuery = { __typename?: 'Query', accountConnectors: Array<{ __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null }> };

export type CompanyAttributeBrowserFragment = { __typename?: 'Company', salesforceAccounts: { __typename?: 'SalesforceAccountConnection', edges?: Array<{ __typename?: 'SalesforceAccountEdge', node?: { __typename?: 'SalesforceAccount', name?: string | null, externalId: string, id: string, properties?: any | null, salesforceOpportunities: { __typename?: 'SalesforceOpportunityConnection', edges?: Array<{ __typename?: 'SalesforceOpportunityEdge', node?: { __typename?: 'SalesforceOpportunity', id: string, name?: string | null, properties?: any | null, externalId: string } | null } | null> | null } } | null } | null> | null }, hubspotCompanies: { __typename?: 'HubspotCompanyConnection', edges?: Array<{ __typename?: 'HubspotCompanyEdge', node?: { __typename?: 'HubspotCompany', id: string, name?: string | null, domain: string, externalAccountId: string, properties?: any | null, deals?: { __typename?: 'HubspotDealConnection', edges?: Array<{ __typename?: 'HubspotDealEdge', node?: { __typename?: 'HubspotDeal', id: string, daysToClose?: number | null, name?: string | null, amount?: number | null, ownerId?: string | null, properties?: any | null } | null } | null> | null } | null } | null } | null> | null } };

type CompanyAttributeBrowserSalesforceAccountConnector_SalesforceAccountConnector_Fragment = { __typename?: 'SalesforceAccountConnector', id: string };

type CompanyAttributeBrowserSalesforceAccountConnector_GoogleAccountConnector_Fragment = { __typename?: 'GoogleAccountConnector', id: string };

type CompanyAttributeBrowserSalesforceAccountConnector_G2AccountConnector_Fragment = { __typename?: 'G2AccountConnector', id: string };

type CompanyAttributeBrowserSalesforceAccountConnector_MarketoAccountConnector_Fragment = { __typename?: 'MarketoAccountConnector', id: string };

type CompanyAttributeBrowserSalesforceAccountConnector_FacebookAccountConnector_Fragment = { __typename?: 'FacebookAccountConnector', id: string };

type CompanyAttributeBrowserSalesforceAccountConnector_HubspotAccountConnector_Fragment = { __typename?: 'HubspotAccountConnector', id: string };

type CompanyAttributeBrowserSalesforceAccountConnector_SlackAccountConnector_Fragment = { __typename?: 'SlackAccountConnector', id: string };

export type CompanyAttributeBrowserSalesforceAccountConnectorFragment = CompanyAttributeBrowserSalesforceAccountConnector_SalesforceAccountConnector_Fragment | CompanyAttributeBrowserSalesforceAccountConnector_GoogleAccountConnector_Fragment | CompanyAttributeBrowserSalesforceAccountConnector_G2AccountConnector_Fragment | CompanyAttributeBrowserSalesforceAccountConnector_MarketoAccountConnector_Fragment | CompanyAttributeBrowserSalesforceAccountConnector_FacebookAccountConnector_Fragment | CompanyAttributeBrowserSalesforceAccountConnector_HubspotAccountConnector_Fragment | CompanyAttributeBrowserSalesforceAccountConnector_SlackAccountConnector_Fragment;

export type PersonAttributeBrowserFragment = { __typename?: 'Person', enrichment?: any | null, company?: { __typename?: 'Company', enrichment?: any | null } | null, salesforceContacts: { __typename?: 'SalesforceContactConnection', edges?: Array<{ __typename?: 'SalesforceContactEdge', node?: { __typename?: 'SalesforceContact', id: string, email: string, externalId: string, name: string, properties?: any | null, websiteDomain?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null, salesforceAccount?: { __typename?: 'SalesforceAccount', id: string, name?: string | null, properties?: any | null, externalId: string } | null } | null } | null> | null }, salesforceLeads: { __typename?: 'SalesforceLeadConnection', edges?: Array<{ __typename?: 'SalesforceLeadEdge', node?: { __typename?: 'SalesforceLead', id: string, email: string, externalId: string, name: string, properties?: any | null, websiteDomain?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null } | null } | null> | null }, hubspotCompanies: { __typename?: 'HubspotCompanyConnection', edges?: Array<{ __typename?: 'HubspotCompanyEdge', node?: { __typename?: 'HubspotCompany', id: string, name?: string | null, domain: string, externalAccountId: string, properties?: any | null, deals?: { __typename?: 'HubspotDealConnection', edges?: Array<{ __typename?: 'HubspotDealEdge', node?: { __typename?: 'HubspotDeal', id: string, daysToClose?: number | null, name?: string | null, hubspotAccountId?: string | null, amount?: number | null, ownerId?: string | null, properties?: any | null } | null } | null> | null } | null } | null } | null> | null } };

export type CreateHubspotCompanyMutationVariables = Exact<{
  input: HubspotCreateCompanyInput;
}>;


export type CreateHubspotCompanyMutation = { __typename?: 'Mutation', createHubspotCompany?: { __typename?: 'HubspotCreateCompanyPayload', errors: Array<{ __typename?: 'Error', messages: Array<string> }> } | null };

export type CrmPresenceQueryVariables = Exact<{
  domains: Array<Scalars['String']> | Scalars['String'];
}>;


export type CrmPresenceQuery = { __typename?: 'Query', crmPresence?: { __typename?: 'CrmPresenceConnection', nodes?: Array<{ __typename?: 'CrmPresence', id: string, existsInHubspot: boolean } | null> | null } | null };

export type CapturePreviewQueryVariables = Exact<{
  domain: Scalars['String'];
  seniority: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  role: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type CapturePreviewQuery = { __typename?: 'Query', prospects?: { __typename?: 'ProspectConnection', totalCount: number, nodes?: Array<{ __typename?: 'Prospect', id: string, name: string, title?: string | null, avatar?: string | null } | null> | null } | null };

export type RefreshAccountPageEventMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshAccountPageEventMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountRefreshPageEventPayload', node?: { __typename?: 'Account', id: string, accountSetting?: { __typename?: 'AccountSetting', id: string, firstPageEventReceivedAt?: any | null } | null } | null } | null };

export type UpsertG2AccountConnectorMutationVariables = Exact<{
  input: AccountConnectorsUpsertG2ConnectorInput;
}>;


export type UpsertG2AccountConnectorMutation = { __typename?: 'Mutation', upsertG2Connector?: { __typename?: 'AccountConnectorsUpsertG2ConnectorPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type G2ConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type G2ConfigurationQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, flags: Array<AccountFlagEnum> }, accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, apiToken: string } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum } | null };

export type G2FieldsFragment = { __typename?: 'G2AccountConnector', apiToken: string };

export type MarketoConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketoConnectionQuery = { __typename?: 'Query', accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, clientId: string, clientSecret: string, endpointUrl: string } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum } | null };

export type MarketoFieldsFragment = { __typename?: 'MarketoAccountConnector', clientId: string, clientSecret: string, endpointUrl: string };

export type UpsertMarketoAccountConnectorMutationVariables = Exact<{
  input: AccountConnectorsUpsertMarketoConnectorInput;
}>;


export type UpsertMarketoAccountConnectorMutation = { __typename?: 'Mutation', upsertMarketoConnector?: { __typename?: 'AccountConnectorsUpsertMarketoConnectorPayload', node?: { __typename?: 'MarketoAccountConnector', id: string } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type PardotConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type PardotConnectionQuery = { __typename?: 'Query', accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, pardotBusinessUnitId?: string | null } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum } | null };

export type SalesforceFieldsFragment = { __typename?: 'SalesforceAccountConnector', pardotBusinessUnitId?: string | null };

export type UpdatePardotBusinessUnitIdMutationVariables = Exact<{
  input: AccountConnectorsUpdatePardotBusinessUnitIdInput;
}>;


export type UpdatePardotBusinessUnitIdMutation = { __typename?: 'Mutation', updatePardotBusinessUnitId?: { __typename?: 'AccountConnectorsUpdatePardotBusinessUnitIdPayload', node?: { __typename?: 'SalesforceAccountConnector', id: string, pardotBusinessUnitId?: string | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type DevPanelFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type DevPanelFeatureFlagsQuery = { __typename?: 'Query', availableFeatureFlags: Array<string> };

export type CompanySegmentColumnsQueryVariables = Exact<{
  attributeType: AttributeTypeEnum;
  columnType: ColumnTypeEnum;
  segmentId?: InputMaybe<Scalars['ID']>;
}>;


export type CompanySegmentColumnsQuery = { __typename?: 'Query', columns: Array<string>, attributes: Array<{ __typename?: 'Attribute', value: string, label: string, category: string, subCategory?: string | null, attributeType: string }> };

export type EnrichmentLogsResultsQueryVariables = Exact<{
  queryExecutionId: Scalars['String'];
}>;


export type EnrichmentLogsResultsQuery = { __typename?: 'Query', enrichmentLogsResult: Array<{ __typename?: 'EnrichmentLog', id: string, externalId: string, identifier: string, image?: string | null, name?: string | null, status: EnrichmentLogStatusEnum, subType: EnrichmentLogSubTypeEnum, timestamp: any, type: EnrichmentLogTypeEnum, steps: Array<{ __typename?: 'EnrichmentLogStep', name: string, message: string, status: EnrichmentLogStatusEnum, timestamp: any, changes: Array<{ __typename?: 'EnrichmentLogStepChange', fieldName: string, from: string, to: string }> }> }> };

export type EnrichmentLogsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<EnrichmentLogStatusEnum> | EnrichmentLogStatusEnum>;
  type: EnrichmentLogTypeEnum;
}>;


export type EnrichmentLogsQuery = { __typename?: 'Query', enrichmentLogs: { __typename?: 'EnrichmentLogQueryStart', queryExecutionId?: string | null } };

export type EnrichmentLogsStatusQueryVariables = Exact<{
  queryExecutionId: Scalars['String'];
}>;


export type EnrichmentLogsStatusQuery = { __typename?: 'Query', enrichmentLogsStatus?: { __typename?: 'EnrichmentLogQueryStatus', queryExecutionId: string, state: EnrichmentLogQueryStateEnum } | null };

export type EnrichListMutationVariables = Exact<{
  input: HubspotEnrichListInput;
}>;


export type EnrichListMutation = { __typename?: 'Mutation', enrichList?: { __typename?: 'HubspotEnrichListPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type EnrichmentConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type EnrichmentConfigQuery = { __typename?: 'Query', accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | { __typename?: 'GoogleAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | { __typename?: 'G2AccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | { __typename?: 'MarketoAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | { __typename?: 'FacebookAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | { __typename?: 'HubspotAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | { __typename?: 'SlackAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | null, hubspotLists?: { __typename?: 'HubspotListConnection', nodes?: Array<{ __typename?: 'HubspotList', id: string, name?: string | null, createdAt?: any | null, updatedAt?: any | null, objectType: HubspotListObjectTypeEnum, processingStatus?: string | null, processingType?: string | null, size: number } | null> | null } | null, hubspotEnrichmentSettings?: { __typename?: 'HubspotEnrichmentSettings', liveEnrichCompaniesEnabled?: boolean | null, liveEnrichContactsEnabled?: boolean | null } | null };

export type MappingsQueryVariables = Exact<{
  accountConnectorId: Scalars['ID'];
}>;


export type MappingsQuery = { __typename?: 'Query', company?: { __typename?: 'FieldMapping', targetType: AccountConnectorServiceEnum, targetAccountId: string, targetObjectType: string, fieldMappings: Array<any>, enabled: boolean } | null, contact?: { __typename?: 'FieldMapping', targetType: AccountConnectorServiceEnum, targetAccountId: string, targetObjectType: string, fieldMappings: Array<any>, enabled: boolean } | null };

export type MappingFragment = { __typename?: 'FieldMapping', targetType: AccountConnectorServiceEnum, targetAccountId: string, targetObjectType: string, fieldMappings: Array<any>, enabled: boolean };

export type PropertiesQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertiesQuery = { __typename?: 'Query', hubspotCompany: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }>, hubspotContact: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> };

export type AttributeFragment = { __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null };

export type SchemaQueryVariables = Exact<{ [key: string]: never; }>;


export type SchemaQuery = { __typename?: 'Query', clearbitCompany: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }>, clearbitPerson: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }>, hubspotCompany: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }>, hubspotContact: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> };

export type UpdateHubspotLiveEnrichmentMutationVariables = Exact<{
  input: AccountConnectorsUpdateHubspotLiveEnrichmentInput;
}>;


export type UpdateHubspotLiveEnrichmentMutation = { __typename?: 'Mutation', updateHubspotLiveEnrichment?: { __typename?: 'AccountConnectorsUpdateHubspotLiveEnrichmentPayload', node?: { __typename?: 'HubspotEnrichmentSettings', liveEnrichCompaniesEnabled?: boolean | null, liveEnrichContactsEnabled?: boolean | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type HubspotListStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HubspotListStatusQuery = { __typename?: 'Query', hubspotList?: { __typename?: 'HubspotList', id: string, enrichmentStatus?: HubspotListEnrichmentStatusEnum | null, enrichmentError?: string | null } | null };

export type IdealCustomerProfilePageQueryVariables = Exact<{ [key: string]: never; }>;


export type IdealCustomerProfilePageQuery = { __typename?: 'Query', account: { __typename?: 'Account', connectors: Array<{ __typename?: 'SalesforceAccountConnector', id: string, name?: string | null, service: AccountConnectorServiceEnum, remoteMeta: any, backfillActive: boolean } | { __typename?: 'GoogleAccountConnector', id: string, name?: string | null, service: AccountConnectorServiceEnum, remoteMeta: any, backfillActive: boolean } | { __typename?: 'G2AccountConnector', id: string, name?: string | null, service: AccountConnectorServiceEnum, remoteMeta: any, backfillActive: boolean } | { __typename?: 'MarketoAccountConnector', id: string, name?: string | null, service: AccountConnectorServiceEnum, remoteMeta: any, backfillActive: boolean } | { __typename?: 'FacebookAccountConnector', id: string, name?: string | null, service: AccountConnectorServiceEnum, remoteMeta: any, backfillActive: boolean } | { __typename?: 'HubspotAccountConnector', id: string, name?: string | null, service: AccountConnectorServiceEnum, remoteMeta: any, backfillActive: boolean } | { __typename?: 'SlackAccountConnector', id: string, name?: string | null, service: AccountConnectorServiceEnum, remoteMeta: any, backfillActive: boolean }> }, accountNotifications: Array<{ __typename?: 'AccountNotification', service?: AccountConnectorServiceEnum | null, resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null }>, fitModel?: { __typename?: 'FitModel', id?: string | null, type?: FitModelTypeEnum | null, status?: FitModelStatusEnum | null, features?: Array<any> | null, metadata?: any | null, wonAudienceId?: string | null, lostAudienceId?: string | null, wonAudienceName?: string | null, lostAudienceName?: string | null, updatedAt?: any | null } | null };

export type CompanyAudiencesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyAudiencesQuery = { __typename?: 'Query', audiences?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string, segments?: Array<{ __typename?: 'Segment', id: string, name: string, collectionId: string, search: any, resultsCount?: number | null }> | null } | null } | null> | null } | null };

export type ImpersonationWarningQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpersonationWarningQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id: string, accountId: string, isImpersonating?: boolean | null, user: { __typename?: 'User', email: string } } };

export type InitialSyncAlertFragment = { __typename?: 'Account', id: string, flags: Array<AccountFlagEnum>, connectors: Array<{ __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any }> };

export type OnboardingTargetMarketPreviewQueryVariables = Exact<{
  businessModel: Array<Scalars['String']> | Scalars['String'];
  country: Array<Scalars['String']> | Scalars['String'];
  employees: Array<Scalars['String']> | Scalars['String'];
  industry: Array<Scalars['String']> | Scalars['String'];
  raised: Array<Scalars['String']> | Scalars['String'];
  tag: Array<Scalars['String']> | Scalars['String'];
  type: Array<Scalars['String']> | Scalars['String'];
  tech: Array<Scalars['String']> | Scalars['String'];
}>;


export type OnboardingTargetMarketPreviewQuery = { __typename?: 'Query', targetMarketPreview?: { __typename?: 'TargetMarketPreview', size: number } | null };

export type CompanyPageActionsSalesforceAccountFragment = { __typename?: 'SalesforceAccount', id: string, externalId: string, name?: string | null, websiteDomain?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null, salesforceOpportunities: { __typename?: 'SalesforceOpportunityConnection', edges?: Array<{ __typename?: 'SalesforceOpportunityEdge', node?: { __typename?: 'SalesforceOpportunity', id: string, externalId: string, name?: string | null, amount?: any | null, stage?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null, accountConnector?: { __typename?: 'SalesforceAccountConnector', externalInstanceUrl: string } | null } | null } | null> | null }, accountConnector?: { __typename?: 'SalesforceAccountConnector', externalInstanceUrl: string } | null };

export type CompanyPageActionsSalesforceAccountConnectorFragment = { __typename?: 'SalesforceAccountConnector', id: string, externalInstanceUrl: string };

export type CompanyPageActionsSalesforceOpportunityFragment = { __typename?: 'SalesforceOpportunity', id: string, externalId: string, name?: string | null, amount?: any | null, stage?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null, accountConnector?: { __typename?: 'SalesforceAccountConnector', externalInstanceUrl: string } | null };

export type CompanyPageActionsHubspotCompanyFragment = { __typename?: 'HubspotCompany', id: string, name?: string | null, domain: string, externalAccountId: string, properties?: any | null, deals?: { __typename?: 'HubspotDealConnection', edges?: Array<{ __typename?: 'HubspotDealEdge', node?: { __typename?: 'HubspotDeal', id: string, closed: boolean, daysToClose?: number | null, name?: string | null, amount?: number | null, ownerId?: string | null, properties?: any | null } | null } | null> | null } | null };

export type CompanyPageActionsHubspotAccountConnectorFragment = { __typename?: 'HubspotAccountConnector', owners: Array<{ __typename?: 'HubspotOwner', id: string, ownerName: string }> };

export type PersonPageActionsSalesforceAccountConnectorFragment = { __typename?: 'SalesforceAccountConnector', id: string, externalInstanceUrl: string };

export type PersonPageActionsSalesforceContactFragment = { __typename?: 'SalesforceContact', id: string, properties?: any | null, email: string, externalId: string, name: string, websiteDomain?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null, salesforceAccount?: { __typename?: 'SalesforceAccount', id: string, name?: string | null, properties?: any | null, externalId: string } | null };

export type PersonPageActionsSalesforceLeadFragment = { __typename?: 'SalesforceLead', id: string, properties?: any | null, email: string, externalId: string, name: string, websiteDomain?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null };

export type PersonPageActionsHubspotCompanyFragment = { __typename?: 'HubspotCompany', domain: string, externalAccountId: string, name?: string | null, properties?: any | null, deals?: { __typename?: 'HubspotDealConnection', edges?: Array<{ __typename?: 'HubspotDealEdge', node?: { __typename?: 'HubspotDeal', id: string, daysToClose?: number | null, name?: string | null, properties?: any | null, amount?: number | null, ownerId?: string | null } | null } | null> | null } | null };

export type PersonPageActionsHubspotAccountConnectorFragment = { __typename?: 'HubspotAccountConnector', owners: Array<{ __typename?: 'HubspotOwner', id: string, ownerName: string }> };

export type SearchBuilderAttributeFragment = { __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string };

export type CancelExportCsvSegmentMutationVariables = Exact<{
  input: SegmentsCancelExportCsvInput;
}>;


export type CancelExportCsvSegmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'SegmentsCancelExportCsvPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type CsvExportQueryQueryVariables = Exact<{
  attributeType: AttributeTypeEnum;
  columnType: ColumnTypeEnum;
  segmentId?: InputMaybe<Scalars['ID']>;
}>;


export type CsvExportQueryQuery = { __typename?: 'Query', columns: Array<string>, attributes: Array<{ __typename?: 'Attribute', value: string, label: string, category: string, subCategory?: string | null, attributeType: string }>, viewer: { __typename?: 'Viewer', id: string, user: { __typename?: 'User', id: string, email: string } } };

export type ExportCsvSegmentMutationVariables = Exact<{
  input: SegmentsExportCsvInput;
}>;


export type ExportCsvSegmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'SegmentsExportCsvPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type ExistingSegmentExportQueryVariables = Exact<{
  status: Array<ExportStatusEnum> | ExportStatusEnum;
  segmentId?: InputMaybe<Scalars['ID']>;
  type: SegmentLegacyTypeEnum;
}>;


export type ExistingSegmentExportQuery = { __typename?: 'Query', segmentExport: Array<{ __typename?: 'Export', status: ExportStatusEnum, id: string, filename: string, createdAt: any, userName?: string | null, expired: boolean, downloadUrl?: string | null }> };

export type CloneSegmentMutationVariables = Exact<{
  input: SegmentsCloneInput;
}>;


export type CloneSegmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'SegmentsClonePayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }>, node?: { __typename?: 'Segment', id: string, collectionId: string, name: string, search: any, type: SegmentTypeEnum, resultsCount?: number | null, enabledDestinationsCount: number, legacyType: SegmentLegacyTypeEnum, updatedAt?: any | null, connectorErrors: { __typename?: 'ConnectorErrors', search: Array<string>, destinations: Array<string> }, audiences: { __typename?: 'AudienceConnection', totalCount: number } } | null } | null };

export type DestroySegmentMutationVariables = Exact<{
  input: SegmentsDestroyInput;
}>;


export type DestroySegmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'SegmentsDestroyPayload', clientMutationId?: string | null } | null };

export type SegmentActionsDeleteQueryVariables = Exact<{
  segmentId: Scalars['ID'];
  segmentType: SegmentTypeEnum;
}>;


export type SegmentActionsDeleteQuery = { __typename?: 'Query', segment?: { __typename?: 'Segment', id: string, destinations: Array<{ __typename?: 'Destination', id: string, type: DestinationTypeEnum, description?: string | null }> } | null };

export type UsageActionAllowedQueryVariables = Exact<{
  credits: Scalars['Int'];
}>;


export type UsageActionAllowedQuery = { __typename?: 'Query', usageActionAllowed: boolean };

export type SegmentFormAttributeFragment = { __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string };

export type SegmentFormSegmentBuilderSalesforceUserFragment = { __typename?: 'SalesforceUser', id: string, name?: string | null };

export type SegmentTabsFragment = { __typename?: 'Segment', id: string, enabledDestinationsCount: number, type: SegmentTypeEnum, audiences: { __typename?: 'AudienceConnection', totalCount: number } };

export type CreateCollectionMutationVariables = Exact<{
  input: CollectionsCreateInput;
}>;


export type CreateCollectionMutation = { __typename?: 'Mutation', response?: { __typename?: 'CollectionsCreatePayload', clientMutationId?: string | null } | null };

export type UpdateCollectionMutationVariables = Exact<{
  input: CollectionsUpdateInput;
}>;


export type UpdateCollectionMutation = { __typename?: 'Mutation', response?: { __typename?: 'CollectionsUpdatePayload', node?: { __typename?: 'Collection', id: string, name: string } | null } | null };

export type DestroyCollectionMutationVariables = Exact<{
  input: CollectionsDestroyInput;
}>;


export type DestroyCollectionMutation = { __typename?: 'Mutation', response?: { __typename?: 'CollectionsDestroyPayload', clientMutationId?: string | null } | null };

export type SegmentsMenuQueryVariables = Exact<{
  collectionType: CollectionLegacyTypeEnum;
  segmentType: SegmentLegacyTypeEnum;
}>;


export type SegmentsMenuQuery = { __typename?: 'Query', segments?: { __typename?: 'SegmentConnection', edges?: Array<{ __typename?: 'SegmentEdge', node?: { __typename?: 'Segment', id: string, collectionId: string, enabledDestinationsCount: number, searchDependencyErrors: boolean, name: string, resultsCount?: number | null, type: SegmentTypeEnum, destinationsCount: number, audiences: { __typename?: 'AudienceConnection', totalCount: number } } | null } | null> | null } | null, companies: { __typename?: 'CompanyConnection', totalCount?: number | null }, people: { __typename?: 'PersonConnection', totalCount?: number | null }, collections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string } | null } | null> | null } | null };

export type CompanyActivityEventsQueryVariables = Exact<{
  id: Scalars['ID'];
  type?: InputMaybe<Scalars['EventTypeEnum']>;
  path?: InputMaybe<Scalars['String']>;
  excludingAnonymous?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type CompanyActivityEventsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, events: { __typename?: 'EventConnection', edges?: Array<{ __typename?: 'EventEdge', node?: { __typename?: 'Event', id: string, context?: any | null, properties?: any | null, timestamp: any, type: any, person?: { __typename?: 'Person', id: string, name?: string | null, avatar?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type PersonActivityEventsQueryVariables = Exact<{
  id: Scalars['ID'];
  type?: InputMaybe<Scalars['EventTypeEnum']>;
  path?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type PersonActivityEventsQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, events: { __typename?: 'EventConnection', edges?: Array<{ __typename?: 'EventEdge', node?: { __typename?: 'Event', id: string, context?: any | null, properties?: any | null, timestamp: any, type: any, person?: { __typename?: 'Person', id: string, name?: string | null, avatar?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type EventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EventTypesQuery = { __typename?: 'Query', eventTypes: Array<any> };

export type CreateTargetMarketMutationVariables = Exact<{
  input: TargetMarketsCreateInput;
}>;


export type CreateTargetMarketMutation = { __typename?: 'Mutation', createTargetMarket?: { __typename?: 'TargetMarketsCreatePayload', node?: { __typename?: 'TargetMarket', id: string, name: string, search: any } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type DestroyTargetMarketMutationVariables = Exact<{
  input: TargetMarketsDestroyInput;
}>;


export type DestroyTargetMarketMutation = { __typename?: 'Mutation', destroyTargetMarket?: { __typename?: 'TargetMarketsDestroyPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type TargetMarketCompaniesQueryVariables = Exact<{
  country: Array<Scalars['String']> | Scalars['String'];
  description: Array<Scalars['String']> | Scalars['String'];
  employees: Array<Scalars['String']> | Scalars['String'];
  industry: Array<Scalars['String']> | Scalars['String'];
  raised: Array<Scalars['String']> | Scalars['String'];
  tag: Array<Scalars['String']> | Scalars['String'];
  tech: Array<Scalars['String']> | Scalars['String'];
  type: Array<Scalars['String']> | Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type TargetMarketCompaniesQuery = { __typename?: 'Query', targetMarketCompanies: any };

export type TargetMarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type TargetMarketsQuery = { __typename?: 'Query', targetMarkets: any };

export type UpdateTargetMarketMutationVariables = Exact<{
  input: TargetMarketsUpdateInput;
}>;


export type UpdateTargetMarketMutation = { __typename?: 'Mutation', updateTargetMarket?: { __typename?: 'TargetMarketsUpdatePayload', node?: { __typename?: 'TargetMarket', id: string, name: string, search: any } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type UserMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMenuQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, domain?: string | null }, viewer: { __typename?: 'Viewer', id: string, user: { __typename?: 'User', id: string, name?: string | null, email: string, accounts: Array<{ __typename?: 'Account', id: string, name?: string | null }> } } };

export type ApiChartUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiChartUsageQuery = { __typename?: 'Query', apiUsage?: { __typename?: 'ApiUsage', data?: Array<any> | null, total?: number | null, active?: boolean | null, billingPeriodCounts?: Array<any> | null } | null };

export type CancelDowngradeAccountSubscriptionMutationVariables = Exact<{
  input: AccountCancelDowngradeSubscriptionInput;
}>;


export type CancelDowngradeAccountSubscriptionMutation = { __typename?: 'Mutation', cancelDowngradeAccountSubscription?: { __typename?: 'AccountCancelDowngradeSubscriptionPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type CreateAccountSubscriptionMutationVariables = Exact<{
  input: AccountCreateSubscriptionInput;
}>;


export type CreateAccountSubscriptionMutation = { __typename?: 'Mutation', createAccountSubscription?: { __typename?: 'AccountCreateSubscriptionPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type DowngradeAccountSubscriptionMutationVariables = Exact<{
  input: AccountDowngradeSubscriptionInput;
}>;


export type DowngradeAccountSubscriptionMutation = { __typename?: 'Mutation', downgradeAccountSubscription?: { __typename?: 'AccountDowngradeSubscriptionPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSettingsQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, name?: string | null, publishableToken?: string | null, secretToken?: string | null, webhookUrl?: string | null, mfaEnforced?: boolean | null, remoteAllowedReferrers: Array<string>, apiVersions: { __typename?: 'AccountApiVersions', person: { __typename?: 'ApiVersion', current: string, latest: string }, company: { __typename?: 'ApiVersion', current: string, latest: string }, prospector: { __typename?: 'ApiVersion', current: string, latest: string }, watchlist: { __typename?: 'ApiVersion', current: string, latest: string }, risk: { __typename?: 'ApiVersion', current: string, latest: string }, reveal: { __typename?: 'ApiVersion', current: string, latest: string } }, suppressionSettings: { __typename?: 'AccountSuppressionSettings', person: boolean, prospector: boolean } } };

export type AccountUpdateApiVersionMutationVariables = Exact<{
  input: AccountUpdateApiVersionInput;
}>;


export type AccountUpdateApiVersionMutation = { __typename?: 'Mutation', updateAccountApiVersion?: { __typename?: 'AccountUpdateApiVersionPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AccountUpdateBillingInfoMutationVariables = Exact<{
  input: AccountUpdateBillingInfoInput;
}>;


export type AccountUpdateBillingInfoMutation = { __typename?: 'Mutation', updateAccountBillingInfo?: { __typename?: 'AccountUpdateBillingInfoPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AccountUpdateDetailsMutationVariables = Exact<{
  input: AccountUpdateDetailsInput;
}>;


export type AccountUpdateDetailsMutation = { __typename?: 'Mutation', updateAccountDetails?: { __typename?: 'AccountUpdateDetailsPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AccountUpdateSettingsMutationVariables = Exact<{
  input: AccountUpdateSettingsInput;
}>;


export type AccountUpdateSettingsMutation = { __typename?: 'Mutation', updateAccountSettings?: { __typename?: 'AccountUpdateSettingsPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type UpdateAccountSubscriptionMutationVariables = Exact<{
  input: AccountUpdateSubscriptionInput;
}>;


export type UpdateAccountSubscriptionMutation = { __typename?: 'Mutation', updateAccountSubscription?: { __typename?: 'AccountUpdateSubscriptionPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AccountUpdateSuppressionSettingsMutationVariables = Exact<{
  input: AccountUpdateSuppressionSettingsInput;
}>;


export type AccountUpdateSuppressionSettingsMutation = { __typename?: 'Mutation', updateAccountSuppressionSettings?: { __typename?: 'AccountUpdateSuppressionSettingsPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type UpgradeAccountPlanMutationVariables = Exact<{
  input: AccountUpgradePlanInput;
}>;


export type UpgradeAccountPlanMutation = { __typename?: 'Mutation', upgradeAccountPlan?: { __typename?: 'AccountUpgradePlanPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AudiencesServiceIconFragment = { __typename?: 'Audience', id: string, service: AudienceServiceEnum };

export type AudiencesStatusIconFragment = { __typename?: 'Audience', id: string, status: AudienceStatusEnum };

export type AudiencesTileFragment = { __typename?: 'Audience', id: string, subtype: AudienceSubtypeEnum };

export type BatchAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type BatchAuthQuery = { __typename?: 'Query', account: { __typename?: 'Account', secretToken?: string | null } };

export type AccountBillingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountBillingInfoQuery = { __typename?: 'Query', accountBillingInfo: { __typename?: 'BillingInfo', billingName?: string | null, billingEmail?: string | null, address?: string | null, showAutomaticBillingMessage?: boolean | null, cardType?: string | null, cardLastFour?: string | null, nextStripeInvoiceAmount?: number | null, nextInvoiceAt?: any | null, billingTerm?: string | null, invoices: Array<{ __typename?: 'Invoice', id: string, startAt: any, endAt: any, amount: number }> } };

export type AddAllowedSiteMutationVariables = Exact<{
  input: FormsAddAllowedSiteInput;
}>;


export type AddAllowedSiteMutation = { __typename?: 'Mutation', response?: { __typename?: 'FormsAddAllowedSitePayload', node?: { __typename?: 'FormConfiguration', id: string, autofill: boolean, formShortening: boolean, identifyOnSubmit: boolean, allowedSites: Array<{ __typename?: 'FormAllowedSitesConfig', id: string, siteUrl: string, lastEventAt?: any | null, eventsReceived: boolean }> } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type SiteConfigurationFieldsFragment = { __typename?: 'FormConfiguration', id: string, autofill: boolean, formShortening: boolean, identifyOnSubmit: boolean, allowedSites: Array<{ __typename?: 'FormAllowedSitesConfig', id: string, siteUrl: string, lastEventAt?: any | null, eventsReceived: boolean }> };

export type FormConfigurationPageQueryVariables = Exact<{
  integration: FormIntegrationEnum;
}>;


export type FormConfigurationPageQuery = { __typename?: 'Query', formConfiguration?: { __typename?: 'FormConfiguration', id: string, autofill: boolean, formShortening: boolean, identifyOnSubmit: boolean, allowedSites: Array<{ __typename?: 'FormAllowedSitesConfig', id: string, siteUrl: string, lastEventAt?: any | null, eventsReceived: boolean }> } | null };

export type RemoveAllowedSiteMutationVariables = Exact<{
  input: FormsRemoveAllowedSiteInput;
}>;


export type RemoveAllowedSiteMutation = { __typename?: 'Mutation', response?: { __typename?: 'FormsRemoveAllowedSitePayload', node?: { __typename?: 'FormConfiguration', id: string, autofill: boolean, formShortening: boolean, identifyOnSubmit: boolean, allowedSites: Array<{ __typename?: 'FormAllowedSitesConfig', id: string, siteUrl: string, lastEventAt?: any | null, eventsReceived: boolean }> } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type UpdateFormConfigurationMutationVariables = Exact<{
  input: FormsUpdateConfigurationInput;
}>;


export type UpdateFormConfigurationMutation = { __typename?: 'Mutation', response?: { __typename?: 'FormsUpdateConfigurationPayload', node?: { __typename?: 'FormConfiguration', id: string, autofill: boolean, formShortening: boolean, identifyOnSubmit: boolean, allowedSites: Array<{ __typename?: 'FormAllowedSitesConfig', id: string, siteUrl: string, lastEventAt?: any | null, eventsReceived: boolean }> } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type FormAttributesQueryVariables = Exact<{
  targetTypes: Array<EnrichmentAttributeTypeEnum> | EnrichmentAttributeTypeEnum;
  refreshAttributes: Scalars['Boolean'];
  excludePersonPhone: Scalars['Boolean'];
}>;


export type FormAttributesQuery = { __typename?: 'Query', sourceAttributes: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> | null }> | null }>, targetAttributes: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> | null }> };

export type FieldMappingsQueryVariables = Exact<{
  integration: FormIntegrationEnum;
}>;


export type FieldMappingsQuery = { __typename?: 'Query', formFieldMapping: { __typename?: 'FormFieldMappings', integration: FormIntegrationEnum, fieldMappings: Array<{ __typename?: 'FormFieldMapping', id: string, sourceAttribute: string, targetAttribute: string }> } };

export type UpsertFieldMappingsMutationVariables = Exact<{
  input: FormsUpsertFieldMappingsInput;
}>;


export type UpsertFieldMappingsMutation = { __typename?: 'Mutation', response?: { __typename?: 'FormsUpsertFieldMappingsPayload', node?: { __typename?: 'FormFieldMappings', integration: FormIntegrationEnum, fieldMappings: Array<{ __typename?: 'FormFieldMapping', id: string, sourceAttribute: string, targetAttribute: string }> } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type DataOverviewQueryVariables = Exact<{
  start: Scalars['Date'];
  end: Scalars['Date'];
}>;


export type DataOverviewQuery = { __typename?: 'Query', rollupCounts: { __typename?: 'DashboardMetrics', visitorsTotalUniques: number, enrichmentsByEmailTotalUniques: number, enrichmentsByDomainTotalUniques: number } };

export type ConnectorLayoutAccountConnectorQueryVariables = Exact<{
  service: Array<AccountConnectorServiceEnum> | AccountConnectorServiceEnum;
}>;


export type ConnectorLayoutAccountConnectorQuery = { __typename?: 'Query', accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, pardotBusinessUnitId?: string | null } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | null };

export type SegmentLayoutFragment = { __typename?: 'Segment', id: string, name: string, resultsCount?: number | null, collectionId: string, search: any, enabledDestinationsCount: number, legacyType: SegmentLegacyTypeEnum, type: SegmentTypeEnum, updatedAt?: any | null, connectorErrors: { __typename?: 'ConnectorErrors', search: Array<string>, destinations: Array<string> }, audiences: { __typename?: 'AudienceConnection', totalCount: number } };

export type RefreshSegmentMutationVariables = Exact<{
  input: SegmentsRefreshInput;
}>;


export type RefreshSegmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'SegmentsRefreshPayload', node?: { __typename?: 'Segment', id: string } | null } | null };

export type SegmentQueryVariables = Exact<{
  id: Scalars['ID'];
  type: SegmentTypeEnum;
}>;


export type SegmentQuery = { __typename?: 'Query', segment?: { __typename?: 'Segment', id: string, resultsCount?: number | null, type: SegmentTypeEnum, updatedAt?: any | null } | null };

export type LookupPersonRecordQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type LookupPersonRecordQuery = { __typename?: 'Query', people: { __typename?: 'PersonConnection', edges?: Array<{ __typename?: 'PersonEdge', node?: { __typename?: 'Person', id: string, email?: string | null, name?: string | null } | null } | null> | null } };

export type AccountInviteCancelMutationVariables = Exact<{
  input: AccountInviteCancelInput;
}>;


export type AccountInviteCancelMutation = { __typename?: 'Mutation', inviteCancel?: { __typename?: 'AccountInviteCancelPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AccountInviteUserMutationVariables = Exact<{
  input: AccountInviteUserInput;
}>;


export type AccountInviteUserMutation = { __typename?: 'Mutation', inviteUser?: { __typename?: 'AccountInviteUserPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AccountMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountMembersQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, members: { __typename?: 'MembershipConnection', nodes?: Array<{ __typename?: 'Membership', id: string, role: UserRoleEnum, user: { __typename?: 'User', id: string, name?: string | null, email: string }, account: { __typename?: 'Account', id: string, name?: string | null, domain?: string | null }, notificationSettings: { __typename?: 'NotificationSettings', usageEnabled: boolean, billingEnabled: boolean, adsManagementEnabled: boolean } } | null> | null }, membershipInvites: { __typename?: 'MembershipInviteConnection', nodes?: Array<{ __typename?: 'MembershipInvite', id: string, email: string } | null> | null } } };

export type UserDestroyMutationVariables = Exact<{
  input: UserDestroyInput;
}>;


export type UserDestroyMutation = { __typename?: 'Mutation', destroyUser?: { __typename?: 'UserDestroyPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type UserUpdateRoleMutationVariables = Exact<{
  input: UserUpdateRoleInput;
}>;


export type UserUpdateRoleMutation = { __typename?: 'Mutation', updateUserRole?: { __typename?: 'UserUpdateRolePayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AccountCreateMutationVariables = Exact<{
  input: AccountCreateInput;
}>;


export type AccountCreateMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'AccountCreatePayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id: string, role?: UserRoleEnum | null, user: { __typename?: 'User', id: string, name?: string | null, firstName: string, lastName?: string | null, email: string, mailing?: boolean | null, sso?: boolean | null, accounts: Array<{ __typename?: 'Account', id: string, name?: string | null, domain?: string | null }> } }, account: { __typename?: 'Account', id: string, name?: string | null, flags: Array<AccountFlagEnum>, plans: Array<AccountPlanEnum>, domain?: string | null, mfaEnforced?: boolean | null, creditsBasedTier?: CreditsBasedTierEnum | null, subscriptions: Array<{ __typename?: 'Subscription', amount?: number | null, limit?: number | null, limitOverride?: number | null, planId: string, status: string, limitTerm: { __typename?: 'LimitTerm', startAt: any, endAt: any } }> } };

export type UserUpdatePasswordMutationVariables = Exact<{
  input: UserUpdatePasswordInput;
}>;


export type UserUpdatePasswordMutation = { __typename?: 'Mutation', updateUserPassword?: { __typename?: 'UserUpdatePasswordPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type UserUpdateProfileMutationVariables = Exact<{
  input: UserUpdateProfileInput;
}>;


export type UserUpdateProfileMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename?: 'UserUpdateProfilePayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type UserMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMembershipsQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id: string, user: { __typename?: 'User', memberships: { __typename?: 'MembershipConnection', nodes?: Array<{ __typename?: 'Membership', id: string, role: UserRoleEnum, account: { __typename?: 'Account', id: string, name?: string | null, domain?: string | null }, user: { __typename?: 'User', id: string, name?: string | null, email: string }, notificationSettings: { __typename?: 'NotificationSettings', usageEnabled: boolean, billingEnabled: boolean, adsManagementEnabled: boolean } } | null> | null } } } };

export type CancelProspectListExportMutationVariables = Exact<{
  input: ProspectListExportCancelInput;
}>;


export type CancelProspectListExportMutation = { __typename?: 'Mutation', cancelProspectListExport?: { __typename?: 'ProspectListExportCancelPayload', node?: { __typename?: 'ProspectListExport', id: string, status: ProspectListExportStatusEnum, exportType: ProspectListExportTypeEnum, lastDownloadedAt?: any | null, createdAt: any, updatedAt?: any | null, prospectList?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, metadata?: { __typename?: 'ProspectListExportMetadata', totalCount?: number | null, totalCreated?: number | null } | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type CopyProspectListMutationVariables = Exact<{
  input: ProspectListCopyInput;
}>;


export type CopyProspectListMutation = { __typename?: 'Mutation', copyProspectList?: { __typename?: 'ProspectListCopyPayload', node?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type CreateProspectListMutationVariables = Exact<{
  input: ProspectListCreateInput;
}>;


export type CreateProspectListMutation = { __typename?: 'Mutation', createProspectList?: { __typename?: 'ProspectListCreatePayload', node?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type DestroyProspectListMutationVariables = Exact<{
  input: ProspectListDestroyInput;
}>;


export type DestroyProspectListMutation = { __typename?: 'Mutation', destroyProspectList?: { __typename?: 'ProspectListDestroyPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type DownloadProspectListExportMutationVariables = Exact<{
  input: ProspectListExportDownloadInput;
}>;


export type DownloadProspectListExportMutation = { __typename?: 'Mutation', downloadProspectListExport?: { __typename?: 'ProspectListExportDownloadPayload', node?: { __typename?: 'ProspectListExport', id: string, status: ProspectListExportStatusEnum, exportType: ProspectListExportTypeEnum, lastDownloadedAt?: any | null, createdAt: any, updatedAt?: any | null, prospectList?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, metadata?: { __typename?: 'ProspectListExportMetadata', totalCount?: number | null, totalCreated?: number | null } | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type CreateProspectListExportMutationVariables = Exact<{
  input: ProspectListExportCreateInput;
}>;


export type CreateProspectListExportMutation = { __typename?: 'Mutation', createProspectListExport?: { __typename?: 'ProspectListExportCreatePayload', node?: { __typename?: 'ProspectListExport', id: string, status: ProspectListExportStatusEnum, exportType: ProspectListExportTypeEnum, lastDownloadedAt?: any | null, createdAt: any, updatedAt?: any | null, prospectList?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, metadata?: { __typename?: 'ProspectListExportMetadata', totalCount?: number | null, totalCreated?: number | null } | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type ProspectCrmPresencesQueryVariables = Exact<{
  prospectIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ProspectCrmPresencesQuery = { __typename?: 'Query', prospectCrmPresences: Array<{ __typename: 'ProspectCrmPresence', existsInHubspot: boolean, prospectId: string }> };

export type ProspectFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProspectFiltersQuery = { __typename?: 'Query', prospectFilters: { __typename?: 'ProspectFilters', countries: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, title: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, role: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, seniority: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, employeesRanges: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, industries: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, companyCountries: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, companyTags: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string, count?: number | null }>, companyTech: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string, count?: number | null }> } };

export type ProspectListExportFragmentFragment = { __typename?: 'ProspectListExport', id: string, status: ProspectListExportStatusEnum, exportType: ProspectListExportTypeEnum, lastDownloadedAt?: any | null, createdAt: any, updatedAt?: any | null, prospectList?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, metadata?: { __typename?: 'ProspectListExportMetadata', totalCount?: number | null, totalCreated?: number | null } | null };

export type ProspectListExportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProspectListExportQuery = { __typename?: 'Query', prospectListExport?: { __typename?: 'ProspectListExport', id: string, status: ProspectListExportStatusEnum, exportType: ProspectListExportTypeEnum, lastDownloadedAt?: any | null, createdAt: any, updatedAt?: any | null, items?: { __typename?: 'ProspectListExportItemConnection', nodes?: Array<{ __typename?: 'ProspectListExportItem', id: string, name?: string | null, email: string, phone?: string | null, role?: string | null, title?: string | null, linkedin?: string | null, companyName?: string | null, companyDomain?: string | null, companyLocation?: string | null, companyCity?: string | null, companyState?: string | null, companyCountry?: string | null } | null> | null } | null, prospectList?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, metadata?: { __typename?: 'ProspectListExportMetadata', totalCount?: number | null, totalCreated?: number | null } | null } | null };

export type ProspectListExportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProspectListExportsQuery = { __typename?: 'Query', pendingExports?: { __typename?: 'ProspectListExportConnection', nodes?: Array<{ __typename?: 'ProspectListExport', id: string, status: ProspectListExportStatusEnum, exportType: ProspectListExportTypeEnum, lastDownloadedAt?: any | null, createdAt: any, updatedAt?: any | null, prospectList?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, metadata?: { __typename?: 'ProspectListExportMetadata', totalCount?: number | null, totalCreated?: number | null } | null } | null> | null } | null, purchasedExports?: { __typename?: 'ProspectListExportConnection', nodes?: Array<{ __typename?: 'ProspectListExport', id: string, status: ProspectListExportStatusEnum, exportType: ProspectListExportTypeEnum, lastDownloadedAt?: any | null, createdAt: any, updatedAt?: any | null, prospectList?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, metadata?: { __typename?: 'ProspectListExportMetadata', totalCount?: number | null, totalCreated?: number | null } | null } | null> | null } | null };

export type ProspectListFragmentFragment = { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } };

export type ProspectListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProspectListQuery = { __typename?: 'Query', prospectList?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null };

export type ProspectListingQueryVariables = Exact<{ [key: string]: never; }>;


export type ProspectListingQuery = { __typename?: 'Query', prospectLists?: { __typename?: 'ProspectListConnection', nodes?: Array<{ __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null> | null } | null };

export type ProspectsQueryVariables = Exact<{
  cities: Array<Scalars['String']> | Scalars['String'];
  companyCities: Array<Scalars['String']> | Scalars['String'];
  companyCountries: Array<Scalars['String']> | Scalars['String'];
  companyStates: Array<Scalars['String']> | Scalars['String'];
  companyTags: Array<Scalars['String']> | Scalars['String'];
  companyTech: Array<Scalars['String']> | Scalars['String'];
  countries: Array<Scalars['String']> | Scalars['String'];
  domains: Array<Scalars['String']> | Scalars['String'];
  employeesRanges: Array<Scalars['String']> | Scalars['String'];
  industries: Array<Scalars['String']> | Scalars['String'];
  names: Array<Scalars['String']> | Scalars['String'];
  roles: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  seniorities: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  titles: Array<Scalars['String']> | Scalars['String'];
  states: Array<Scalars['String']> | Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type ProspectsQuery = { __typename?: 'Query', prospects?: { __typename?: 'ProspectConnection', totalCount: number, totalCompanies?: number | null, nodes?: Array<{ __typename?: 'Prospect', id: string, name: string, title?: string | null, avatar?: string | null, companyName?: string | null, companyDomain?: string | null, companyIndustry?: string | null, companyLocation?: string | null, companyLogo?: string | null, email: boolean, phone: boolean, linkedin: boolean, twitter: boolean } | null> | null } | null };

export type UpdateProspectListMutationVariables = Exact<{
  input: ProspectListUpdateInput;
}>;


export type UpdateProspectListMutation = { __typename?: 'Mutation', updateProspectList?: { __typename?: 'ProspectListUpdatePayload', node?: { __typename: 'ProspectList', id: string, name: string, query: { __typename?: 'ProspectQuery', cities?: Array<string | null> | null, companyCities?: Array<string | null> | null, companyCountries?: Array<string | null> | null, companyStates?: Array<string | null> | null, companyTags?: Array<string | null> | null, companyTech?: Array<string | null> | null, countries?: Array<string | null> | null, domains?: Array<string | null> | null, employeesRanges?: Array<string | null> | null, industries?: Array<string | null> | null, names?: Array<string | null> | null, roles?: Array<string | null> | null, seniorities?: Array<string | null> | null, states?: Array<string | null> | null, titles?: Array<string | null> | null } } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type UsageDashboardFeaturesListQueryVariables = Exact<{ [key: string]: never; }>;


export type UsageDashboardFeaturesListQuery = { __typename?: 'Query', productFeatures: Array<{ __typename?: 'ProductFeature', id: ProductFeatureEnum, currentPeriodEndDate: any, currentPeriodStartDate: any, currentPeriodTotalUsage: any, description: string, documentationUrl: string, meteredUnit: string, usageTerm: SubscriptionBillingTermEnum, name: string, usageLimit?: number | null, usageMetricGraph: any }> };

export type UsageBreakdownQueryVariables = Exact<{
  usageTerm: SubscriptionBillingTermEnum;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  usageMetricGraph: Scalars['Json'];
  granularity: UsageBreakdownGranularityEnum;
}>;


export type UsageBreakdownQuery = { __typename?: 'Query', usageBreakdown: any };

export type ProductFeatureDetailsQueryVariables = Exact<{
  id: ProductFeatureEnum;
}>;


export type ProductFeatureDetailsQuery = { __typename?: 'Query', productFeature?: { __typename?: 'ProductFeature', currentPeriodEndDate: any, currentPeriodStartDate: any, currentPeriodTotalUsage: any, description: string, documentationUrl: string, detailedBreakdownDescription?: string | null, detailedBreakdownTitle?: string | null, metricSubsets: Array<any>, id: ProductFeatureEnum, meteredUnit: string, name: string, usageLimit?: number | null, usageTerm: SubscriptionBillingTermEnum, usageMetricGraph: any, usageBreakdownDetails?: Array<any> | null } | null };

export type EnrichmentRecentUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type EnrichmentRecentUsageQuery = { __typename?: 'Query', enrichmentRecentUsage: Array<{ __typename?: 'DailyUsage', date?: any | null, usage?: number | null }> };

export type CurrentAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, name?: string | null, flags: Array<AccountFlagEnum>, plans: Array<AccountPlanEnum>, domain?: string | null, creditsBasedTier?: CreditsBasedTierEnum | null, connectors: Array<{ __typename?: 'SalesforceAccountConnector', id: string, name?: string | null, remoteMeta: any, service: AccountConnectorServiceEnum, syncStatus?: string | null, status: AccountConnectorStatusEnum } | { __typename?: 'GoogleAccountConnector', id: string, name?: string | null, remoteMeta: any, service: AccountConnectorServiceEnum, syncStatus?: string | null, status: AccountConnectorStatusEnum } | { __typename?: 'G2AccountConnector', id: string, name?: string | null, remoteMeta: any, service: AccountConnectorServiceEnum, syncStatus?: string | null, status: AccountConnectorStatusEnum } | { __typename?: 'MarketoAccountConnector', id: string, name?: string | null, remoteMeta: any, service: AccountConnectorServiceEnum, syncStatus?: string | null, status: AccountConnectorStatusEnum } | { __typename?: 'FacebookAccountConnector', id: string, name?: string | null, remoteMeta: any, service: AccountConnectorServiceEnum, syncStatus?: string | null, status: AccountConnectorStatusEnum } | { __typename?: 'HubspotAccountConnector', hubspotAccountId: string, id: string, name?: string | null, remoteMeta: any, service: AccountConnectorServiceEnum, syncStatus?: string | null, status: AccountConnectorStatusEnum } | { __typename?: 'SlackAccountConnector', id: string, name?: string | null, remoteMeta: any, service: AccountConnectorServiceEnum, syncStatus?: string | null, status: AccountConnectorStatusEnum }>, platformAccess: { __typename?: 'AccountPlatformAccess', legacyPlan: boolean, acquisitions: boolean, capture: boolean, conversions: boolean, operations: boolean, usage: boolean }, subscriptions: Array<{ __typename?: 'Subscription', amount?: number | null, downgradeDate?: string | null, downgradeLimit?: number | null, planId: string, startDate?: string | null, status: string }> } };

export type JobHistoryQueryVariables = Exact<{
  jobId: Scalars['String'];
  queue: Scalars['String'];
}>;


export type JobHistoryQuery = { __typename?: 'Query', jobHistory: { __typename?: 'JobHistory', jobId: string, queue: string, status?: JobHistoryStatusEnum | null, runId?: string | null, timestamp?: string | null } };

export type PublishableKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishableKeysQuery = { __typename?: 'Query', publishableKeys?: Array<{ __typename?: 'PublishableKey', id: string, value: string }> | null };

export type AnalyzeCsvImportMutationVariables = Exact<{
  input: CsvImportsAnalyzeInput;
}>;


export type AnalyzeCsvImportMutation = { __typename?: 'Mutation', response?: { __typename?: 'CsvImportsAnalyzePayload', node?: { __typename?: 'CsvImport', id: string, uploadUrl?: string | null, filename: string, mapping?: Array<any> | null, sampleData?: any | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type CreateCsvImportMutationVariables = Exact<{
  input: CsvImportsCreateInput;
}>;


export type CreateCsvImportMutation = { __typename?: 'Mutation', response?: { __typename?: 'CsvImportsCreatePayload', node?: { __typename?: 'CsvImport', id: string, uploadUrl?: string | null, filename: string, type: string } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type CreateCsvSegmentMutationVariables = Exact<{
  input: CsvImportsCreateSegmentInput;
}>;


export type CreateCsvSegmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'CsvImportsCreateSegmentPayload', node?: { __typename?: 'CsvImport', id: string, segmentId?: string | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type DestroyCsvImportMutationVariables = Exact<{
  input: CsvImportsDestroyInput;
}>;


export type DestroyCsvImportMutation = { __typename?: 'Mutation', response?: { __typename?: 'CsvImportsDestroyPayload', clientMutationId?: string | null } | null };

export type CsvImportFragmentFragment = { __typename?: 'CsvImport', id: string, filename: string, status: string, type: string, createdAt: any, segmentId?: string | null, sourceName?: string | null, rowsMatchedCount?: number | null, rowsSkippedCount?: number | null, user: { __typename?: 'User', id: string, email: string } };

export type ImportCsvIndexPageQueryVariables = Exact<{
  type: Scalars['String'];
  collectionType: CollectionLegacyTypeEnum;
}>;


export type ImportCsvIndexPageQuery = { __typename?: 'Query', csvImports: Array<{ __typename?: 'CsvImport', id: string, filename: string, status: string, type: string, createdAt: any, segmentId?: string | null, sourceName?: string | null, rowsMatchedCount?: number | null, rowsSkippedCount?: number | null, user: { __typename?: 'User', id: string, email: string } }>, collections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string } | null } | null> | null } | null };

export type ParseCsvImportMutationVariables = Exact<{
  input: CsvImportsParseInput;
}>;


export type ParseCsvImportMutation = { __typename?: 'Mutation', response?: { __typename?: 'CsvImportsParsePayload', node?: { __typename?: 'CsvImport', id: string, rowsSkippedCount?: number | null, rowsMatchedCount?: number | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type ImportCsvPageQueryVariables = Exact<{
  id: Scalars['ID'];
  attributeType: AttributeTypeEnum;
  collectionType: CollectionLegacyTypeEnum;
}>;


export type ImportCsvPageQuery = { __typename?: 'Query', csvImport?: { __typename?: 'CsvImport', id: string, filename: string, sourceName?: string | null, mapping?: Array<any> | null, sampleData?: any | null, type: string, status: string, segmentId?: string | null, rowsMatchedCount?: number | null, rowsSkippedCount?: number | null, primaryIdentifierColumn?: string | null, sourceNameUsed: boolean } | null, searchAttributes?: Array<{ __typename?: 'Attribute', details?: any | null, label: string, value: string, category: string, subCategory?: string | null, attributeType: string }> | null, collections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string } | null } | null> | null } | null };

export type SegmentEditPageDestroyButtonFragment = { __typename?: 'Segment', id: string, legacyType: SegmentLegacyTypeEnum, type: SegmentTypeEnum, destinations: Array<{ __typename?: 'Destination', id: string, type: DestinationTypeEnum, description?: string | null }> };

export type SegmentEditFragment = { __typename?: 'Segment', id: string, collectionId: string, name: string, resultsCount?: number | null, search: any, searchDependencyErrors: boolean, type: SegmentTypeEnum, legacyType: SegmentLegacyTypeEnum, enabledDestinationsCount: number, updatedAt?: any | null, destinations: Array<{ __typename?: 'Destination', id: string, type: DestinationTypeEnum, description?: string | null }>, connectorErrors: { __typename?: 'ConnectorErrors', search: Array<string>, destinations: Array<string> }, audiences: { __typename?: 'AudienceConnection', totalCount: number } };

export type UpdateSegmentMutationVariables = Exact<{
  input: SegmentsUpdateInput;
}>;


export type UpdateSegmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'SegmentsUpdatePayload', node?: { __typename?: 'Segment', id: string, collectionId: string, name: string, resultsCount?: number | null, search: any, searchDependencyErrors: boolean, type: SegmentTypeEnum, legacyType: SegmentLegacyTypeEnum, enabledDestinationsCount: number, updatedAt?: any | null, destinations: Array<{ __typename?: 'Destination', id: string, type: DestinationTypeEnum, description?: string | null }>, connectorErrors: { __typename?: 'ConnectorErrors', search: Array<string>, destinations: Array<string> }, audiences: { __typename?: 'AudienceConnection', totalCount: number } } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type SegmentEditPageQueryVariables = Exact<{
  id: Scalars['ID'];
  type: SegmentTypeEnum;
  attributeType: AttributeTypeEnum;
  collectionType: CollectionLegacyTypeEnum;
  salesforceSubCategories: Array<AttributeSalesforceSubCategoryEnum> | AttributeSalesforceSubCategoryEnum;
  hubspotSubCategories: Array<AttributeHubspotSubCategoryEnum> | AttributeHubspotSubCategoryEnum;
}>;


export type SegmentEditPageQuery = { __typename?: 'Query', segment?: { __typename?: 'Segment', id: string, collectionId: string, name: string, resultsCount?: number | null, search: any, searchDependencyErrors: boolean, type: SegmentTypeEnum, legacyType: SegmentLegacyTypeEnum, enabledDestinationsCount: number, updatedAt?: any | null, destinations: Array<{ __typename?: 'Destination', id: string, type: DestinationTypeEnum, description?: string | null }>, connectorErrors: { __typename?: 'ConnectorErrors', search: Array<string>, destinations: Array<string> }, audiences: { __typename?: 'AudienceConnection', totalCount: number } } | null, searchAttributes?: Array<{ __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string }> | null, salesforceUsers?: Array<{ __typename?: 'SalesforceUser', id: string, name?: string | null }> | null, collections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string } | null } | null> | null } | null };

export type CreateSegmentMutationVariables = Exact<{
  input: SegmentsCreateInput;
}>;


export type CreateSegmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'SegmentsCreatePayload', node?: { __typename?: 'Segment', id: string, name: string, type: SegmentTypeEnum, search: any, resultsCount?: number | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type SegmentNewPageQueryVariables = Exact<{
  type: AttributeTypeEnum;
  collectionType: CollectionLegacyTypeEnum;
  salesforceSubCategories: Array<AttributeSalesforceSubCategoryEnum> | AttributeSalesforceSubCategoryEnum;
  hubspotSubCategories: Array<AttributeHubspotSubCategoryEnum> | AttributeHubspotSubCategoryEnum;
}>;


export type SegmentNewPageQuery = { __typename?: 'Query', searchAttributes?: Array<{ __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string }> | null, salesforceUsers?: Array<{ __typename?: 'SalesforceUser', id: string, name?: string | null }> | null, collections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string } | null } | null> | null } | null };

export type AudienceEditPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AudienceEditPageQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string }, audience?: { __typename?: 'Audience', id: string, companySearch?: any | null, externalName: string, name: string, service: AudienceServiceEnum, subtype: AudienceSubtypeEnum, personSearch?: any | null, createdAt: any, segment?: { __typename?: 'Segment', id: string, collectionId: string, enabledDestinationsCount: number, name: string, search: any, type: SegmentTypeEnum, collection: { __typename?: 'Collection', id: string, name: string } } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null } | null, companyCollections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string, segments?: Array<{ __typename?: 'Segment', id: string, collectionId: string, search: any, legacyType: SegmentLegacyTypeEnum, type: SegmentTypeEnum, enabledDestinationsCount: number, name: string, resultsCount?: number | null, collection: { __typename?: 'Collection', id: string, name: string }, audiences: { __typename?: 'AudienceConnection', totalCount: number } }> | null } | null } | null> | null } | null, companySearchAttributes?: Array<{ __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string }> | null, personCollections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string, segments?: Array<{ __typename?: 'Segment', id: string, collectionId: string, search: any, legacyType: SegmentLegacyTypeEnum, type: SegmentTypeEnum, enabledDestinationsCount: number, name: string, resultsCount?: number | null, collection: { __typename?: 'Collection', id: string, name: string }, audiences: { __typename?: 'AudienceConnection', totalCount: number } }> | null } | null } | null> | null } | null, personSearchAttributes?: Array<{ __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string }> | null, prospectAudienceCompanySearchAttributes?: Array<{ __typename?: 'Attribute', value: string, category: string, details?: any | null, label: string, subCategory?: string | null, attributeType: string }> | null, prospectAudiencePersonSearchAttributes?: Array<{ __typename?: 'Attribute', value: string, category: string, details?: any | null, label: string, subCategory?: string | null, attributeType: string }> | null, salesforceUsers?: Array<{ __typename?: 'SalesforceUser', id: string, name?: string | null }> | null, viewer: { __typename?: 'Viewer', id: string, canExportAudiences: boolean, canExportAdAudiencesToLinkedin: boolean } };

export type UpdateMutationVariables = Exact<{
  input: SalesPipelinesUpdateInput;
}>;


export type UpdateMutation = { __typename?: 'Mutation', response?: { __typename?: 'SalesPipelinesUpdatePayload', node?: { __typename?: 'SalesPipeline', status: SalesPipelineStatusEnum, syncedAt?: any | null, stages: { __typename?: 'SalesPipelineStages', visitors: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> }, opportunities: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> }, dealsWon: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> } } } | null } | null };

export type RoiConfigurationQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RoiConfigurationQueryQuery = { __typename?: 'Query', searchAttributes?: Array<{ __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string }> | null, salesPipeline?: { __typename?: 'SalesPipeline', status: SalesPipelineStatusEnum, syncedAt?: any | null, stages: { __typename?: 'SalesPipelineStages', visitors: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> }, opportunities: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> }, dealsWon: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> } } } | null };

export type UpdateAudienceMutationVariables = Exact<{
  input: AudiencesUpdateInput;
}>;


export type UpdateAudienceMutation = { __typename?: 'Mutation', response?: { __typename?: 'AudiencesUpdatePayload', node?: { __typename?: 'Audience', id: string } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type ExportSalesPipelineQueryQueryVariables = Exact<{
  dateWindow?: InputMaybe<DateWindowEnum>;
}>;


export type ExportSalesPipelineQueryQuery = { __typename?: 'Query', salesPipeline?: { __typename?: 'SalesPipeline', snapshots?: Array<{ __typename?: 'SalesPipelineSnapshot', date: any, exportProxyUrl: string }> | null } | null };

export type CampaignsFragment = { __typename?: 'Campaign', id: string, name?: string | null, spend?: number | null, service: string, audiences: Array<{ __typename?: 'CampaignAudience', id: string, name?: string | null, subtype?: AudienceSubtypeEnum | null }> };

export type AdMetricsFragment = { __typename?: 'AdMetrics', influencedClicks?: number | null, influencedImpressions?: number | null, influencedSpend?: number | null, influencedSpendPercentage?: number | null, overallClicks?: number | null, overallImpressions?: number | null, overallSpend?: number | null };

export type StageFragment = { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> };

export type SalesPipelineFragment = { __typename?: 'SalesPipeline', status: SalesPipelineStatusEnum, syncedAt?: any | null, stages: { __typename?: 'SalesPipelineStages', visitors: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> }, opportunities: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> }, dealsWon: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> } } };

export type AudiencesPageQueryVariables = Exact<{
  order?: InputMaybe<AudienceOrderEnum>;
  query?: InputMaybe<Scalars['String']>;
  dateWindow?: InputMaybe<DateWindowEnum>;
}>;


export type AudiencesPageQuery = { __typename?: 'Query', accountNotifications: Array<{ __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null }>, audiences: { __typename?: 'AudienceConnection', totalCount: number, edges?: Array<{ __typename?: 'AudienceEdge', node?: { __typename?: 'Audience', id: string, createdAt: any, externalName: string, name: string, pushProgress?: number | null, pushedAt?: any | null, status: AudienceStatusEnum, statusMessage?: string | null, subtype: AudienceSubtypeEnum, externalEstimatedSize?: number | null, service: AudienceServiceEnum, user?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null> | null }, adMetrics?: { __typename?: 'AdMetrics', influencedClicks?: number | null, influencedImpressions?: number | null, influencedSpend?: number | null, influencedSpendPercentage?: number | null, overallClicks?: number | null, overallImpressions?: number | null, overallSpend?: number | null } | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, spend?: number | null, service: string, audiences: Array<{ __typename?: 'CampaignAudience', id: string, name?: string | null, subtype?: AudienceSubtypeEnum | null }> }> | null, salesPipeline?: { __typename?: 'SalesPipeline', status: SalesPipelineStatusEnum, syncedAt?: any | null, stages: { __typename?: 'SalesPipelineStages', visitors: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> }, opportunities: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> }, dealsWon: { __typename?: 'SalesPipelineStage', currentInfluencedValue: number, previousInfluencedValue: number, enabled: boolean, search?: any | null, timeseries: Array<{ __typename?: 'SalesPipelineStageTimeseries', date: any, influencedValue: number }> } } } | null, viewer: { __typename?: 'Viewer', canExportAdAudiencesToLinkedin: boolean, canAccessSalesPipelineExports: boolean, id: string } };

export type AudienceNewPageTypePickerAccountFragment = { __typename?: 'Account', id: string, plans: Array<AccountPlanEnum> };

export type CreateAudienceMutationVariables = Exact<{
  input: AudiencesCreateInput;
}>;


export type CreateAudienceMutation = { __typename?: 'Mutation', response?: { __typename?: 'AudiencesCreatePayload', node?: { __typename?: 'Audience', id: string } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AudienceNewPageQueryVariables = Exact<{
  segmentId?: InputMaybe<Scalars['ID']>;
  segmentType?: InputMaybe<SegmentTypeEnum>;
}>;


export type AudienceNewPageQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, plans: Array<AccountPlanEnum> }, companyCollections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string, segments?: Array<{ __typename?: 'Segment', id: string, collectionId: string, search: any, legacyType: SegmentLegacyTypeEnum, type: SegmentTypeEnum, enabledDestinationsCount: number, name: string, resultsCount?: number | null, collection: { __typename?: 'Collection', id: string, name: string }, audiences: { __typename?: 'AudienceConnection', totalCount: number } }> | null } | null } | null> | null } | null, companySearchAttributes?: Array<{ __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string }> | null, personCollections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string, segments?: Array<{ __typename?: 'Segment', id: string, collectionId: string, search: any, legacyType: SegmentLegacyTypeEnum, type: SegmentTypeEnum, enabledDestinationsCount: number, name: string, resultsCount?: number | null, collection: { __typename?: 'Collection', id: string, name: string }, audiences: { __typename?: 'AudienceConnection', totalCount: number } }> | null } | null } | null> | null } | null, personSearchAttributes?: Array<{ __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string }> | null, prospectAudienceCompanySearchAttributes?: Array<{ __typename?: 'Attribute', value: string, category: string, details?: any | null, label: string, subCategory?: string | null, attributeType: string }> | null, prospectAudiencePersonSearchAttributes?: Array<{ __typename?: 'Attribute', value: string, category: string, details?: any | null, label: string, subCategory?: string | null, attributeType: string }> | null, salesforceUsers?: Array<{ __typename?: 'SalesforceUser', id: string, name?: string | null }> | null, segment?: { __typename?: 'Segment', id: string, name: string, type: SegmentTypeEnum, collectionId: string, search: any } | null, viewer: { __typename?: 'Viewer', id: string, canAccessGoogleContactAudiences: boolean, canAccessGoogleManagedVisitorAudiences: boolean } };

export type AudienceCompanyInsightsFragment = { __typename?: 'Audience', id: string, companiesCount?: number | null, companies?: Array<{ __typename?: 'AudienceCompany', id: string, domain: string, employeesRange?: string | null, estimatedAnnualRevenue?: string | null, industry?: string | null, name?: string | null }> | null, companiesFirmographic?: { __typename?: 'AudienceCompaniesFirmographic', countries?: Array<{ __typename?: 'AudienceCompaniesFirmographicCountry', code: string, count: number, name: string }> | null, industries?: Array<{ __typename?: 'AudienceCompaniesFirmographicIndustry', name: string, percentage: number }> | null } | null, segment?: { __typename?: 'Segment', id: string, type: SegmentTypeEnum } | null };

export type AudiencePersonInsightsFragment = { __typename?: 'Audience', id: string, subtype: AudienceSubtypeEnum };

export type AudienceSourceDestinationInfoFragment = { __typename?: 'Audience', id: string, externalAccountId: string, externalName: string, subtype: AudienceSubtypeEnum, service: AudienceServiceEnum, segment?: { __typename?: 'Segment', id: string, name: string, type: SegmentTypeEnum } | null };

export type AudienceSummaryFragment = { __typename?: 'Audience', id: string, externalAccountId: string, externalAccountName: string, externalEstimatedSize?: number | null, externalEstimatedSizeChange?: number | null, externalName: string, pushProgress?: number | null, pushRate?: number | null, pushedAt?: any | null, service: AudienceServiceEnum, status: AudienceStatusEnum, segment?: { __typename?: 'Segment', id: string, type: SegmentTypeEnum } | null };

export type AudiencePageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AudiencePageQuery = { __typename?: 'Query', audience?: { __typename?: 'Audience', id: string, name: string, status: AudienceStatusEnum, subtype: AudienceSubtypeEnum, companiesCount?: number | null, externalAccountId: string, externalName: string, service: AudienceServiceEnum, externalAccountName: string, externalEstimatedSize?: number | null, externalEstimatedSizeChange?: number | null, pushProgress?: number | null, pushRate?: number | null, pushedAt?: any | null, createdAt: any, companies?: Array<{ __typename?: 'AudienceCompany', id: string, domain: string, employeesRange?: string | null, estimatedAnnualRevenue?: string | null, industry?: string | null, name?: string | null }> | null, companiesFirmographic?: { __typename?: 'AudienceCompaniesFirmographic', countries?: Array<{ __typename?: 'AudienceCompaniesFirmographicCountry', code: string, count: number, name: string }> | null, industries?: Array<{ __typename?: 'AudienceCompaniesFirmographicIndustry', name: string, percentage: number }> | null } | null, segment?: { __typename?: 'Segment', id: string, type: SegmentTypeEnum, name: string } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null } | null, viewer: { __typename?: 'Viewer', id: string, canExportAudiences: boolean, canExportAdAudiencesToLinkedin: boolean } };

export type DestroyAudienceMutationVariables = Exact<{
  input: AudiencesDestroyInput;
}>;


export type DestroyAudienceMutation = { __typename?: 'Mutation', response?: { __typename?: 'AudiencesDestroyPayload', clientMutationId?: string | null } | null };

export type AudiencesHealthIndicatorFragment = { __typename?: 'Audience', id: string, externalEstimatedSize?: number | null, status: AudienceStatusEnum };

export type ExportAudienceMutationVariables = Exact<{
  input: AudiencesExportInput;
}>;


export type ExportAudienceMutation = { __typename?: 'Mutation', response?: { __typename?: 'AudiencesExportPayload', clientMutationId?: string | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type AudiencesLayoutActionsMenuFragment = { __typename?: 'Viewer', id: string, canExportAudiences: boolean, canExportAdAudiencesToLinkedin: boolean };

export type AudiencesLayoutFragment = { __typename?: 'Audience', id: string, createdAt: any, name: string, subtype: AudienceSubtypeEnum, user?: { __typename?: 'User', id: string, name?: string | null } | null };

export type AudiencesLayoutViewerFragment = { __typename?: 'Viewer', id: string, canExportAudiences: boolean, canExportAdAudiencesToLinkedin: boolean };

export type CreateAudienceSizePreviewMutationVariables = Exact<{
  input: AudiencePreviewsCreateInput;
}>;


export type CreateAudienceSizePreviewMutation = { __typename?: 'Mutation', response?: { __typename?: 'AudiencePreviewsCreatePayload', node?: { __typename?: 'AudiencePreview', id: string, status: string } | null } | null };

export type AudiencePreviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AudiencePreviewQuery = { __typename?: 'Query', audiencePreview?: { __typename?: 'AudiencePreview', estimatedExternalSize?: number | null, id: string, status: string } | null };

export type AudiencesProspectsFormAccountFragment = { __typename?: 'Account', id: string };

export type AudiencesProspectsFormAttributeFragment = { __typename?: 'Attribute', value: string, category: string, details?: any | null, label: string, subCategory?: string | null, attributeType: string };

export type AudiencesProspectsFormSegmentBuilderSalesforceUserFragment = { __typename?: 'SalesforceUser', id: string, name?: string | null };

export type AudiencesSegmentFormSegmentBuilderCollectionFragment = { __typename?: 'Collection', id: string, name: string, segments?: Array<{ __typename?: 'Segment', id: string, collectionId: string, search: any, legacyType: SegmentLegacyTypeEnum, type: SegmentTypeEnum, collection: { __typename?: 'Collection', id: string, name: string } }> | null };

export type AudiencesSegmentFormSegmentBuilderAttributeFragment = { __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string };

export type AudiencesSegmentFormSegmentBuilderSalesforceUserFragment = { __typename?: 'SalesforceUser', id: string, name?: string | null };

export type AudiencesSegmentFormSegmentPickerCollectionFragment = { __typename?: 'Collection', id: string, name: string, segments?: Array<{ __typename?: 'Segment', id: string, collectionId: string, enabledDestinationsCount: number, legacyType: SegmentLegacyTypeEnum, name: string, resultsCount?: number | null, type: SegmentTypeEnum, audiences: { __typename?: 'AudienceConnection', totalCount: number } }> | null };

export type AudiencesSegmentFormAttributeFragment = { __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string };

export type AudiencesSegmentFormCollectionFragment = { __typename?: 'Collection', id: string, name: string, segments?: Array<{ __typename?: 'Segment', id: string, collectionId: string, search: any, legacyType: SegmentLegacyTypeEnum, type: SegmentTypeEnum, enabledDestinationsCount: number, name: string, resultsCount?: number | null, collection: { __typename?: 'Collection', id: string, name: string }, audiences: { __typename?: 'AudienceConnection', totalCount: number } }> | null };

export type AudiencesSegmentFormSegmentFragment = { __typename?: 'Segment', id: string, collectionId: string, name: string, search: any, type: SegmentTypeEnum };

export type RefreshFacebookAdAccountMutationVariables = Exact<{
  input: AccountConnectorsRefreshFacebookAdAccountInput;
}>;


export type RefreshFacebookAdAccountMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsRefreshFacebookAdAccountPayload', node?: { __typename?: 'FacebookAdAccount', id: string, termsAccepted?: boolean | null } | null } | null };

export type AudienceNewPageSyncStepQueryVariables = Exact<{
  fetchGoogle: Scalars['Boolean'];
}>;


export type AudienceNewPageSyncStepQuery = { __typename?: 'Query', facebookAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string, adAccounts?: Array<{ __typename?: 'FacebookAdAccount', id: string, termsUrl?: string | null, termsAccepted?: boolean | null, name: string, adPixels: Array<{ __typename?: 'FacebookAdPixel', id: string, name: string }> }> | null } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string } | null, googleAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, remoteMeta: any } | { __typename?: 'GoogleAccountConnector', id: string, remoteMeta: any, adAccounts?: Array<{ __typename?: 'GoogleAdAccount', id: string, name: string }> | null } | { __typename?: 'G2AccountConnector', id: string, remoteMeta: any } | { __typename?: 'MarketoAccountConnector', id: string, remoteMeta: any } | { __typename?: 'FacebookAccountConnector', id: string, remoteMeta: any } | { __typename?: 'HubspotAccountConnector', id: string, remoteMeta: any } | { __typename?: 'SlackAccountConnector', id: string, remoteMeta: any } | null };

export type AllCompaniesPageQueryVariables = Exact<{
  companiesSegmentId?: InputMaybe<Scalars['ID']>;
}>;


export type AllCompaniesPageQuery = { __typename?: 'Query', columns: Array<string>, companies: { __typename?: 'CompanyConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'Company', id: string, name?: string | null, columns: any, domain?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } }, account: { __typename?: 'Account', id: string, flags: Array<AccountFlagEnum>, connectors: Array<{ __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any }> } };

export type CompaniesListFragment = { __typename?: 'Company', id: string, name?: string | null, columns: any, domain?: string | null };

export type CompaniesListConnectionFragment = { __typename?: 'CompanyConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'Company', id: string, name?: string | null, columns: any, domain?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } };

export type CompaniesSegmentPageQueryVariables = Exact<{
  companiesSegmentId: Scalars['ID'];
}>;


export type CompaniesSegmentPageQuery = { __typename?: 'Query', columns: Array<string>, companies: { __typename?: 'CompanyConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'Company', id: string, name?: string | null, columns: any, domain?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } }, segment?: { __typename?: 'Segment', id: string, type: SegmentTypeEnum, name: string, resultsCount?: number | null, collectionId: string, search: any, enabledDestinationsCount: number, legacyType: SegmentLegacyTypeEnum, updatedAt?: any | null, connectorErrors: { __typename?: 'ConnectorErrors', search: Array<string>, destinations: Array<string> }, audiences: { __typename?: 'AudienceConnection', totalCount: number } } | null };

export type CompanyPageDetailsFragmentFragment = { __typename?: 'Company', city?: string | null, country?: string | null, countryCode?: string | null, description?: string | null, employeesRange?: string | null, estimatedAnnualRevenue?: string | null, facebook?: string | null, id: string, subIndustry?: string | null, linkedin?: string | null, marketCap?: string | null, raised?: string | null, sector?: string | null, tags?: Array<string> | null, ticker?: string | null, twitter?: string | null, type?: string | null, hubspotCompanies: { __typename?: 'HubspotCompanyConnection', edges?: Array<{ __typename?: 'HubspotCompanyEdge', node?: { __typename?: 'HubspotCompany', id: string, name?: string | null, domain: string, externalAccountId: string, properties?: any | null, deals?: { __typename?: 'HubspotDealConnection', edges?: Array<{ __typename?: 'HubspotDealEdge', node?: { __typename?: 'HubspotDeal', id: string, hubspotAccountId?: string | null, daysToClose?: number | null, name?: string | null, closed: boolean, amount?: number | null, ownerId?: string | null, properties?: any | null } | null } | null> | null } | null } | null } | null> | null } };

export type CompanyPersonListRowFragment = { __typename?: 'Person', id: string, avatar?: string | null, email?: string | null, name?: string | null, title?: string | null };

export type CompaniesPagePeopleQueryVariables = Exact<{
  id: Scalars['ID'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
}>;


export type CompaniesPagePeopleQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, people: { __typename?: 'CompanyPersonConnection', edges?: Array<{ __typename?: 'PersonEdge', node?: { __typename?: 'Person', id: string, avatar?: string | null, email?: string | null, name?: string | null, title?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type CompanySegmentsPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompanySegmentsPageQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, segments: { __typename?: 'SegmentConnection', totalCount: number, edges?: Array<{ __typename?: 'SegmentEdge', node?: { __typename?: 'Segment', type: SegmentTypeEnum, id: string, name: string, destinationsCount: number, updatedAt?: any | null, audiences: { __typename?: 'AudienceConnection', totalCount: number }, collection: { __typename?: 'Collection', id: string, name: string } } | null } | null> | null } } | null };

export type CompanyPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompanyPageQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name?: string | null, domain?: string | null, employeesRange?: string | null, enrichment?: any | null, description?: string | null, legalName?: string | null, revenue?: string | null, location?: string | null, fitScore?: string | null, twitter?: string | null, facebook?: string | null, github?: string | null, linkedin?: string | null, traits?: any | null, city?: string | null, country?: string | null, countryCode?: string | null, estimatedAnnualRevenue?: string | null, subIndustry?: string | null, marketCap?: string | null, raised?: string | null, sector?: string | null, tags?: Array<string> | null, ticker?: string | null, type?: string | null, people: { __typename?: 'CompanyPersonConnection', totalCount?: number | null }, salesforceAccounts: { __typename?: 'SalesforceAccountConnection', edges?: Array<{ __typename?: 'SalesforceAccountEdge', node?: { __typename?: 'SalesforceAccount', id: string, name?: string | null, externalId: string, properties?: any | null, websiteDomain?: string | null, salesforceOpportunities: { __typename?: 'SalesforceOpportunityConnection', edges?: Array<{ __typename?: 'SalesforceOpportunityEdge', node?: { __typename?: 'SalesforceOpportunity', id: string, name?: string | null, properties?: any | null, externalId: string, amount?: any | null, stage?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null, accountConnector?: { __typename?: 'SalesforceAccountConnector', externalInstanceUrl: string } | null } | null } | null> | null }, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null, accountConnector?: { __typename?: 'SalesforceAccountConnector', externalInstanceUrl: string } | null } | null } | null> | null }, hubspotCompanies: { __typename?: 'HubspotCompanyConnection', edges?: Array<{ __typename?: 'HubspotCompanyEdge', node?: { __typename?: 'HubspotCompany', id: string, name?: string | null, domain: string, externalAccountId: string, properties?: any | null, deals?: { __typename?: 'HubspotDealConnection', edges?: Array<{ __typename?: 'HubspotDealEdge', node?: { __typename?: 'HubspotDeal', id: string, daysToClose?: number | null, name?: string | null, amount?: number | null, ownerId?: string | null, properties?: any | null, hubspotAccountId?: string | null, closed: boolean } | null } | null> | null } | null } | null } | null> | null } } | null, salesforceAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, externalInstanceUrl: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string } | null, hubspotAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string, owners: Array<{ __typename?: 'HubspotOwner', id: string, ownerName: string }> } | { __typename?: 'SlackAccountConnector', id: string } | null };

export type ConfigurationPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigurationPageQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, flags: Array<AccountFlagEnum>, accountSetting?: { __typename?: 'AccountSetting', id: string, dataSources: Array<string> } | null, connectors: Array<{ __typename?: 'SalesforceAccountConnector', remoteMeta: any, id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, createdAt: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, createdAt: any } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, createdAt: any } | { __typename?: 'MarketoAccountConnector', remoteMeta: any, id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, createdAt: any } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, createdAt: any } | { __typename?: 'HubspotAccountConnector', remoteMeta: any, id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, createdAt: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, createdAt: any }> }, viewer: { __typename?: 'Viewer', id: string, canAccessGaDataLayer: boolean }, tagManager?: { __typename?: 'TagManager', id: string, status: TagManagerStatusEnum, pushToDataLayer: boolean } | null, googleAnalyticsConfig?: { __typename?: 'GoogleAnalytics', id: string, enabled: boolean } | null, googleTagManagerConfig?: { __typename?: 'GoogleTagManager', id: string, enabled: boolean } | null };

export type UpsertTagManagerMutationVariables = Exact<{
  input: TagManagerUpsertInput;
}>;


export type UpsertTagManagerMutation = { __typename?: 'Mutation', response?: { __typename?: 'TagManagerUpsertPayload', clientMutationId?: string | null } | null };

export type DestroyAccountConnectorMutationVariables = Exact<{
  input: AccountConnectorsDestroyInput;
}>;


export type DestroyAccountConnectorMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsDestroyPayload', node?: { __typename?: 'SalesforceAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'GoogleAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'G2AccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'MarketoAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'FacebookAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'HubspotAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'SlackAccountConnector', id: string, status: AccountConnectorStatusEnum } | null } | null };

export type AccountConnectorConfigurationQueryVariables = Exact<{
  service: Array<AccountConnectorServiceEnum> | AccountConnectorServiceEnum;
}>;


export type AccountConnectorConfigurationQuery = { __typename?: 'Query', accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null, notification?: { __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null } | null } | { __typename?: 'GoogleAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null, adAccounts?: Array<{ __typename?: 'GoogleAdAccount', id: string, name: string, displayName: string }> | null, notification?: { __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null } | null } | { __typename?: 'G2AccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null, notification?: { __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null } | null } | { __typename?: 'MarketoAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null, notification?: { __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null } | null } | { __typename?: 'FacebookAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null, notification?: { __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null } | null } | { __typename?: 'HubspotAccountConnector', hubspotAccountId: string, id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null, notification?: { __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null } | null } | { __typename?: 'SlackAccountConnector', id: string, status: AccountConnectorStatusEnum, service: AccountConnectorServiceEnum, createdAt: any, remoteMeta: any, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null, notification?: { __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null } | null } | null };

export type DisconnectedAccountConnectorQueryVariables = Exact<{
  service: Array<AccountConnectorServiceEnum> | AccountConnectorServiceEnum;
}>;


export type DisconnectedAccountConnectorQuery = { __typename?: 'Query', accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum } | null };

export type UpdateDisconnectedAccountConnectorMutationVariables = Exact<{
  input: AccountConnectorsUpdateInput;
}>;


export type UpdateDisconnectedAccountConnectorMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsUpdatePayload', node?: { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum } | null } | null };

export type SegmentConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentConfigQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, publishableToken?: string | null } };

export type UpdateAccountMutationVariables = Exact<{
  input: AccountUpdateInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountUpdatePayload', node?: { __typename?: 'Account', id: string, remoteAllowedReferrers: Array<string> } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type JavaScriptConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type JavaScriptConfigurationQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, plans: Array<AccountPlanEnum>, publishableToken?: string | null, remoteAllowedReferrers: Array<string> }, tagManager?: { __typename?: 'TagManager', id: string, status: TagManagerStatusEnum } | null };

export type UpdateGoogleAccountTypeMutationVariables = Exact<{
  input: AccountConnectorsUpdateInput;
}>;


export type UpdateGoogleAccountTypeMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsUpdatePayload', node?: { __typename?: 'SalesforceAccountConnector', id: string, remoteMeta: any } | { __typename?: 'GoogleAccountConnector', id: string, remoteMeta: any } | { __typename?: 'G2AccountConnector', id: string, remoteMeta: any } | { __typename?: 'MarketoAccountConnector', id: string, remoteMeta: any } | { __typename?: 'FacebookAccountConnector', id: string, remoteMeta: any } | { __typename?: 'HubspotAccountConnector', id: string, remoteMeta: any } | { __typename?: 'SlackAccountConnector', id: string, remoteMeta: any } | null } | null };

export type CreateOrUpdateGoogleDimensionMappingMutationVariables = Exact<{
  input: GoogleDimensionMappingCreateOrUpdateInput;
}>;


export type CreateOrUpdateGoogleDimensionMappingMutation = { __typename?: 'Mutation', response?: { __typename?: 'GoogleDimensionMappingCreateOrUpdatePayload', node?: { __typename?: 'GoogleDimensionMapping', id: string, data: Array<any>, status: GoogleDimensionMappingStatusEnum, externalPropertyId: string, externalPropertyName: string, externalAccountId: string } | null } | null };

export type DestroyGoogleDimensionMappingMutationVariables = Exact<{
  input: GoogleDimensionMappingDestroyInput;
}>;


export type DestroyGoogleDimensionMappingMutation = { __typename?: 'Mutation', response?: { __typename?: 'GoogleDimensionMappingDestroyPayload', clientMutationId?: string | null } | null };

export type GoogleAnalyticsDimensionMappingFragment = { __typename?: 'GoogleDimensionMapping', id: string, data: Array<any>, status: GoogleDimensionMappingStatusEnum, externalPropertyId: string, externalPropertyName: string, externalAccountId: string };

export type RevealGaQueryVariables = Exact<{
  attributeType: AttributeTypeEnum;
}>;


export type RevealGaQuery = { __typename?: 'Query', attributes: Array<{ __typename?: 'Attribute', value: string, label: string, category: string, subCategory?: string | null, attributeType: string }>, tagManager?: { __typename?: 'TagManager', id: string, pushToDataLayer: boolean, googleDimensionMappings: Array<{ __typename?: 'GoogleDimensionMapping', id: string, data: Array<any>, status: GoogleDimensionMappingStatusEnum, externalPropertyId: string, externalPropertyName: string, externalAccountId: string }> } | null, googleTagManagerConfig?: { __typename?: 'GoogleTagManager', id: string } | null };

export type RefreshRemoteMetaMutationVariables = Exact<{
  input: AccountConnectorsRefreshRemoteMetaInput;
}>;


export type RefreshRemoteMetaMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsRefreshRemoteMetaPayload', node?: { __typename?: 'SalesforceAccountConnector', id: string, remoteMeta: any } | { __typename?: 'GoogleAccountConnector', id: string, remoteMeta: any } | { __typename?: 'G2AccountConnector', id: string, remoteMeta: any } | { __typename?: 'MarketoAccountConnector', id: string, remoteMeta: any } | { __typename?: 'FacebookAccountConnector', id: string, remoteMeta: any } | { __typename?: 'HubspotAccountConnector', id: string, remoteMeta: any } | { __typename?: 'SlackAccountConnector', id: string, remoteMeta: any } | null } | null };

export type ToggleStatusGoogleDimensionMappingMutationVariables = Exact<{
  input: GoogleDimensionMappingToggleStatusInput;
}>;


export type ToggleStatusGoogleDimensionMappingMutation = { __typename?: 'Mutation', response?: { __typename?: 'GoogleDimensionMappingToggleStatusPayload', node?: { __typename?: 'GoogleDimensionMapping', id: string, data: Array<any>, status: GoogleDimensionMappingStatusEnum, externalPropertyId: string, externalPropertyName: string, externalAccountId: string } | null } | null };

export type RefreshGoogleAdsConnectorMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshGoogleAdsConnectorMutation = { __typename?: 'Mutation', refreshGoogleAdAccounts?: { __typename?: 'AccountConnectorsRefreshGoogleAdAccountsPayload', node?: { __typename?: 'GoogleAccountConnector', id: string, lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null } | null } | null };

export type ConfigureAnalytics4MutationVariables = Exact<{
  input: TagManagerUpsertGoogleAnalyticsConfigInput;
}>;


export type ConfigureAnalytics4Mutation = { __typename?: 'Mutation', upsertGoogleAnalyticsConfig?: { __typename?: 'TagManagerUpsertGoogleAnalyticsConfigPayload', node?: { __typename?: 'GoogleAnalytics', id: string, enabled: boolean } | null } | null };

export type GoogleAnalytics4ConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GoogleAnalytics4ConfigurationQuery = { __typename?: 'Query', googleAnalyticsConfig?: { __typename?: 'GoogleAnalytics', id: string, enabled: boolean } | null };

export type ConfigureGoogleTagManagerMutationVariables = Exact<{
  input: TagManagerUpsertGoogleTagManagerConfigInput;
}>;


export type ConfigureGoogleTagManagerMutation = { __typename?: 'Mutation', upsertGoogleTagManagerConfig?: { __typename?: 'TagManagerUpsertGoogleTagManagerConfigPayload', node?: { __typename?: 'GoogleTagManager', id: string, enabled: boolean } | null } | null };

export type GoogleTagManagerConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GoogleTagManagerConfigurationQuery = { __typename?: 'Query', googleTagManagerConfig?: { __typename?: 'GoogleTagManager', id: string, enabled: boolean } | null };

type AccountConnectorSyncStatus_SalesforceAccountConnector_Fragment = { __typename?: 'SalesforceAccountConnector', lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null };

type AccountConnectorSyncStatus_GoogleAccountConnector_Fragment = { __typename?: 'GoogleAccountConnector', lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null };

type AccountConnectorSyncStatus_G2AccountConnector_Fragment = { __typename?: 'G2AccountConnector', lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null };

type AccountConnectorSyncStatus_MarketoAccountConnector_Fragment = { __typename?: 'MarketoAccountConnector', lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null };

type AccountConnectorSyncStatus_FacebookAccountConnector_Fragment = { __typename?: 'FacebookAccountConnector', lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null };

type AccountConnectorSyncStatus_HubspotAccountConnector_Fragment = { __typename?: 'HubspotAccountConnector', lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null };

type AccountConnectorSyncStatus_SlackAccountConnector_Fragment = { __typename?: 'SlackAccountConnector', lastSyncedAt?: any | null, syncStartedAt?: any | null, nextSyncAt?: any | null, syncStatus?: string | null, syncProgress?: number | null, isInitialSync?: boolean | null };

export type AccountConnectorSyncStatusFragment = AccountConnectorSyncStatus_SalesforceAccountConnector_Fragment | AccountConnectorSyncStatus_GoogleAccountConnector_Fragment | AccountConnectorSyncStatus_G2AccountConnector_Fragment | AccountConnectorSyncStatus_MarketoAccountConnector_Fragment | AccountConnectorSyncStatus_FacebookAccountConnector_Fragment | AccountConnectorSyncStatus_HubspotAccountConnector_Fragment | AccountConnectorSyncStatus_SlackAccountConnector_Fragment;

export type DestroyDestinationMutationVariables = Exact<{
  input: DestinationsDestroyInput;
}>;


export type DestroyDestinationMutation = { __typename?: 'Mutation', response?: { __typename?: 'DestinationsDestroyPayload', clientMutationId?: string | null } | null };

export type SegmentDestinationEditPageQueryVariables = Exact<{
  attributeType: AttributeTypeEnum;
  destinationId: Scalars['ID'];
  segmentId: Scalars['ID'];
  segmentType: SegmentTypeEnum;
}>;


export type SegmentDestinationEditPageQuery = { __typename?: 'Query', facebookAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string, status: AccountConnectorStatusEnum, adAccounts?: Array<{ __typename?: 'FacebookAdAccount', id: string, name: string, adPixels: Array<{ __typename?: 'FacebookAdPixel', id: string, name: string }> }> | null } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string } | null, googleAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string, status: AccountConnectorStatusEnum, adAccounts?: Array<{ __typename?: 'GoogleAdAccount', id: string, displayName: string }> | null } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string } | null, hubspotAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string } | null, salesforceAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'GoogleAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'G2AccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'MarketoAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'FacebookAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'HubspotAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'SlackAccountConnector', id: string, status: AccountConnectorStatusEnum } | null, slackAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | null, attributes: Array<{ __typename?: 'Attribute', value: string, label: string, category: string, subCategory?: string | null, attributeType: string }>, segment?: { __typename?: 'Segment', id: string, name: string, type: SegmentTypeEnum, collection: { __typename?: 'Collection', id: string, name: string }, destination?: { __typename?: 'Destination', id: string, config: any, triggerType: string, type: DestinationTypeEnum, accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'GoogleAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'G2AccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'MarketoAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'FacebookAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'HubspotAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'SlackAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | null } | null } | null, destinationOptions: { __typename?: 'DestinationOptions', facebookCurrencyOptions: Array<string>, facebookEventTypeOptions: Array<string> } };

export type UpdateDestinationMutationVariables = Exact<{
  input: DestinationsUpdateInput;
}>;


export type UpdateDestinationMutation = { __typename?: 'Mutation', response?: { __typename?: 'DestinationsUpdatePayload', node?: { __typename?: 'Destination', id: string, config: any, triggerType: string, segment: { __typename?: 'Segment', id: string, type: SegmentTypeEnum } } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type SegmentDestinationsPageAudienceFragment = { __typename?: 'Audience', id: string, createdAt: any, externalName: string, subtype: AudienceSubtypeEnum, service: AudienceServiceEnum, user?: { __typename?: 'User', id: string, name?: string | null } | null };

export type SegmentDestinationsFragment = { __typename?: 'Segment', id: string, type: SegmentTypeEnum, destinationsCount: number, audiences: { __typename?: 'AudienceConnection', totalCount: number, edges?: Array<{ __typename?: 'AudienceEdge', node?: { __typename?: 'Audience', id: string, createdAt: any, externalName: string, subtype: AudienceSubtypeEnum, service: AudienceServiceEnum, user?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null> | null }, destinations: Array<{ __typename?: 'Destination', id: string, description?: string | null, type: DestinationTypeEnum, config: any, enabled: boolean, segment: { __typename?: 'Segment', id: string, name: string, enabledDestinationsCount: number } }> };

export type SegmentDestinationsPreloadCountFragment = { __typename?: 'Segment', id: string, destinationsCount: number, audiences: { __typename?: 'AudienceConnection', totalCount: number } };

export type SegmentDestinationsPageQueryVariables = Exact<{
  segmentId: Scalars['ID'];
  segmentType: SegmentTypeEnum;
}>;


export type SegmentDestinationsPageQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, plans: Array<AccountPlanEnum> }, slackAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, remoteMeta: any } | { __typename?: 'GoogleAccountConnector', id: string, remoteMeta: any } | { __typename?: 'G2AccountConnector', id: string, remoteMeta: any } | { __typename?: 'MarketoAccountConnector', id: string, remoteMeta: any } | { __typename?: 'FacebookAccountConnector', id: string, remoteMeta: any } | { __typename?: 'HubspotAccountConnector', id: string, remoteMeta: any } | { __typename?: 'SlackAccountConnector', id: string, remoteMeta: any } | null, segment?: { __typename?: 'Segment', id: string, name: string, resultsCount?: number | null, enabledDestinationsCount: number, updatedAt?: any | null, type: SegmentTypeEnum, collectionId: string, search: any, legacyType: SegmentLegacyTypeEnum, destinationsCount: number, audiences: { __typename?: 'AudienceConnection', totalCount: number, edges?: Array<{ __typename?: 'AudienceEdge', node?: { __typename?: 'Audience', id: string, createdAt: any, externalName: string, subtype: AudienceSubtypeEnum, service: AudienceServiceEnum, user?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null> | null }, destinations: Array<{ __typename?: 'Destination', id: string, description?: string | null, type: DestinationTypeEnum, config: any, enabled: boolean, segment: { __typename?: 'Segment', id: string, name: string, enabledDestinationsCount: number } }>, connectorErrors: { __typename?: 'ConnectorErrors', search: Array<string>, destinations: Array<string> } } | null };

export type CreateDestinationMutationVariables = Exact<{
  input: DestinationsCreateInput;
}>;


export type CreateDestinationMutation = { __typename?: 'Mutation', response?: { __typename?: 'DestinationsCreatePayload', node?: { __typename?: 'Destination', id: string, type: DestinationTypeEnum, config: any, triggerType: string, accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'GoogleAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'G2AccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'MarketoAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'FacebookAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'HubspotAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | { __typename?: 'SlackAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | null, segment: { __typename?: 'Segment', id: string, name: string, type: SegmentTypeEnum } } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type SegmentDestinationNewPageQueryVariables = Exact<{
  attributeType: AttributeTypeEnum;
  includeFacebookAccountConnector: Scalars['Boolean'];
  includeGoogleAccountConnector: Scalars['Boolean'];
  includeHubspotAccountConnector: Scalars['Boolean'];
  includeSalesforceAccountConnector: Scalars['Boolean'];
  includeSlackAccountConnector: Scalars['Boolean'];
  segmentId: Scalars['ID'];
  segmentType: SegmentTypeEnum;
}>;


export type SegmentDestinationNewPageQuery = { __typename?: 'Query', facebookAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string, status: AccountConnectorStatusEnum, adAccounts?: Array<{ __typename?: 'FacebookAdAccount', id: string, name: string, adPixels: Array<{ __typename?: 'FacebookAdPixel', id: string, name: string }> }> | null } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string } | null, googleAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string, status: AccountConnectorStatusEnum, adAccounts?: Array<{ __typename?: 'GoogleAdAccount', id: string, displayName: string }> | null } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string } | null, hubspotAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string } | null, salesforceAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'GoogleAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'G2AccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'MarketoAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'FacebookAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'HubspotAccountConnector', id: string, status: AccountConnectorStatusEnum } | { __typename?: 'SlackAccountConnector', id: string, status: AccountConnectorStatusEnum } | null, slackAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum } | null, attributes: Array<{ __typename?: 'Attribute', value: string, label: string, category: string, subCategory?: string | null, attributeType: string }>, segment?: { __typename?: 'Segment', id: string, name: string, type: SegmentTypeEnum, collection: { __typename?: 'Collection', id: string, name: string } } | null, viewer: { __typename?: 'Viewer', id: string, user: { __typename?: 'User', id: string, firstName: string } }, destinationOptions: { __typename?: 'DestinationOptions', facebookCurrencyOptions: Array<string>, facebookEventTypeOptions: Array<string> } };

export type ConversionEventsQueryVariables = Exact<{
  destinationId: Scalars['ID'];
}>;


export type ConversionEventsQuery = { __typename?: 'Query', conversionEvents: { __typename?: 'ConversionEventConnection', nodes?: Array<{ __typename?: 'ConversionEvent', clickId?: string | null, pageviewAt: any, createdAt: any, person: { __typename?: 'Person', id: string, name?: string | null } } | null> | null } };

export type DeliverTestDestinationMutationVariables = Exact<{
  input: DestinationsDeliverTestInput;
}>;


export type DeliverTestDestinationMutation = { __typename?: 'Mutation', response?: { __typename?: 'DestinationsDeliverTestPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type DestinationsEnabledSwitchDestinationFragment = { __typename?: 'Destination', id: string, enabled: boolean, segment: { __typename?: 'Segment', id: string, name: string, enabledDestinationsCount: number } };

export type UpdateDestinationEnabledMutationVariables = Exact<{
  input: DestinationsUpdateInput;
}>;


export type UpdateDestinationEnabledMutation = { __typename?: 'Mutation', response?: { __typename?: 'DestinationsUpdatePayload', node?: { __typename?: 'Destination', id: string, enabled: boolean, segment: { __typename?: 'Segment', id: string, enabledDestinationsCount: number } } | null } | null };

export type CreateExternalRecordsSalesforceAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateExternalRecordsSalesforceAccountsQuery = { __typename?: 'Query', salesforceTraits: Array<{ __typename?: 'SalesforceTrait', name: string, label: string, type: SalesforceTraitTypeEnum, objectType: string, required: boolean, options?: Array<{ __typename?: 'SalesforceTraitOption', label: string, value: string }> | null }>, companyAttributes: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> | null }> | null }> };

export type CreateExternalRecordsSalesforceContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateExternalRecordsSalesforceContactsQuery = { __typename?: 'Query', salesforceTraits: Array<{ __typename?: 'SalesforceTrait', name: string, label: string, type: SalesforceTraitTypeEnum, objectType: string, required: boolean, options?: Array<{ __typename?: 'SalesforceTraitOption', label: string, value: string }> | null }>, personAttributes: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> | null }> | null }>, prospectFilters: { __typename?: 'ProspectFilters', role: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, seniority: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, country: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, title: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }> } };

export type CreateExternalRecordsSalesforceLeadsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateExternalRecordsSalesforceLeadsQuery = { __typename?: 'Query', salesforceTraits: Array<{ __typename?: 'SalesforceTrait', name: string, label: string, type: SalesforceTraitTypeEnum, objectType: string, required: boolean, options?: Array<{ __typename?: 'SalesforceTraitOption', label: string, value: string }> | null }>, personAttributes: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> | null }> | null }>, companyAttributes: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> | null }> | null }>, prospectFilters: { __typename?: 'ProspectFilters', role: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, seniority: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, country: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }>, title: Array<{ __typename?: 'ProspectFilterOption', value: string, label: string }> } };

export type SegmentDestinationNewPageFacebookAccountConnectorFragment = { __typename?: 'FacebookAccountConnector', status: AccountConnectorStatusEnum, adAccounts?: Array<{ __typename?: 'FacebookAdAccount', id: string, name: string, adPixels: Array<{ __typename?: 'FacebookAdPixel', id: string, name: string }> }> | null };

export type GoogleConversionTrackerLookupQueryVariables = Exact<{
  adAccountId: Scalars['String'];
}>;


export type GoogleConversionTrackerLookupQuery = { __typename?: 'Query', googleConversionTrackers: Array<{ __typename?: 'GoogleConversionTracker', id: string, name: string, defaultValue: number, defaultCurrency: string, allowsCustomValues: boolean }> };

export type SegmentDestinationNewPageGoogleAccountConnectorFragment = { __typename?: 'GoogleAccountConnector', status: AccountConnectorStatusEnum, adAccounts?: Array<{ __typename?: 'GoogleAdAccount', id: string, displayName: string }> | null };

export type SegmentDestinationNewPageSlackAccountConnectorFragment = { __typename?: 'SlackAccountConnector', id: string, remoteMeta: any, status: AccountConnectorStatusEnum };

export type EnrichmentLogsShowPageQueryVariables = Exact<{
  service: Array<AccountConnectorServiceEnum> | AccountConnectorServiceEnum;
}>;


export type EnrichmentLogsShowPageQuery = { __typename?: 'Query', accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any } | null };

export type EnrichmentLogResultsQueryVariables = Exact<{
  queryExecutionId: Scalars['String'];
}>;


export type EnrichmentLogResultsQuery = { __typename?: 'Query', enrichmentLogResult?: { __typename?: 'EnrichmentLog', id: string, externalId: string, identifier: string, image?: string | null, name?: string | null, status: EnrichmentLogStatusEnum, subType: EnrichmentLogSubTypeEnum, type: EnrichmentLogTypeEnum, steps: Array<{ __typename?: 'EnrichmentLogStep', name: string, message: string, status: EnrichmentLogStatusEnum, timestamp: any, changes: Array<{ __typename?: 'EnrichmentLogStepChange', fieldName: string, from: string, to: string }> }> } | null };

export type EnrichmentLogQueryVariables = Exact<{
  type: EnrichmentLogTypeEnum;
  id: Scalars['ID'];
}>;


export type EnrichmentLogQuery = { __typename?: 'Query', enrichmentLog: { __typename?: 'EnrichmentLogQueryStart', queryExecutionId?: string | null } };

export type CancelBackfillMutationVariables = Exact<{
  input: AccountConnectorsCancelBackfillInput;
}>;


export type CancelBackfillMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsCancelBackfillPayload', clientMutationId?: string | null } | null };

export type TriggerBackfillMutationVariables = Exact<{
  input: AccountConnectorsTriggerBackfillInput;
}>;


export type TriggerBackfillMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsTriggerBackfillPayload', clientMutationId?: string | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type FieldMappingQueryVariables = Exact<{
  targetObjectType: Scalars['String'];
  accountConnectorId: Scalars['ID'];
}>;


export type FieldMappingQuery = { __typename?: 'Query', fieldMapping?: { __typename?: 'FieldMapping', targetType: AccountConnectorServiceEnum, targetAccountId: string, targetObjectType: string, fieldMappings: Array<any>, enabled: boolean } | null };

export type UpdateFieldMappingMutationVariables = Exact<{
  input: AccountConnectorsUpdateFieldMappingInput;
}>;


export type UpdateFieldMappingMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsUpdateFieldMappingPayload', errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type FieldMappingFormQueryVariables = Exact<{
  service: Array<AccountConnectorServiceEnum> | AccountConnectorServiceEnum;
  sourceTypes: Array<EnrichmentAttributeTypeEnum> | EnrichmentAttributeTypeEnum;
  targetObjectType: Scalars['String'];
  targetTypes: Array<EnrichmentAttributeTypeEnum> | EnrichmentAttributeTypeEnum;
  refreshAttributes: Scalars['Boolean'];
  externalObjectType: Scalars['String'];
}>;


export type FieldMappingFormQuery = { __typename?: 'Query', accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, backfillActive: boolean, selectiveEnrichmentFilters?: { __typename?: 'SelectiveEnrichmentFilters', filters?: any | null } | null } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, backfillActive: boolean, selectiveEnrichmentFilters?: { __typename?: 'SelectiveEnrichmentFilters', filters?: any | null } | null } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, backfillActive: boolean, selectiveEnrichmentFilters?: { __typename?: 'SelectiveEnrichmentFilters', filters?: any | null } | null } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, backfillActive: boolean, selectiveEnrichmentFilters?: { __typename?: 'SelectiveEnrichmentFilters', filters?: any | null } | null } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, backfillActive: boolean, selectiveEnrichmentFilters?: { __typename?: 'SelectiveEnrichmentFilters', filters?: any | null } | null } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, backfillActive: boolean, selectiveEnrichmentFilters?: { __typename?: 'SelectiveEnrichmentFilters', filters?: any | null } | null } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, backfillActive: boolean, selectiveEnrichmentFilters?: { __typename?: 'SelectiveEnrichmentFilters', filters?: any | null } | null } | null, sourceAttributes: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null, children?: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> | null }> | null }>, targetAttributes: Array<{ __typename?: 'EnrichmentAttribute', type: string, identifier: string, label: string, value: string, meta?: any | null, source?: string | null, subtypeName?: string | null }> };

export type ReexportPropertiesMutationVariables = Exact<{
  input: AccountConnectorsReexportPropertiesInput;
}>;


export type ReexportPropertiesMutation = { __typename?: 'Mutation', reexportProperties?: { __typename?: 'AccountConnectorsReexportPropertiesPayload', node?: { __typename?: 'JobHistory', jobId: string, queue: string, status?: JobHistoryStatusEnum | null, runId?: string | null, timestamp?: string | null } | null } | null };

export type ToggleFieldMappingMutationVariables = Exact<{
  input: AccountConnectorsToggleFieldMappingInput;
  targetObjectType: Scalars['String'];
}>;


export type ToggleFieldMappingMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsToggleFieldMappingPayload', node?: { __typename?: 'SalesforceAccountConnector', id: string, fieldMapping?: { __typename?: 'FieldMapping', targetObjectType: string, enabled: boolean } | null } | { __typename?: 'GoogleAccountConnector', id: string, fieldMapping?: { __typename?: 'FieldMapping', targetObjectType: string, enabled: boolean } | null } | { __typename?: 'G2AccountConnector', id: string, fieldMapping?: { __typename?: 'FieldMapping', targetObjectType: string, enabled: boolean } | null } | { __typename?: 'MarketoAccountConnector', id: string, fieldMapping?: { __typename?: 'FieldMapping', targetObjectType: string, enabled: boolean } | null } | { __typename?: 'FacebookAccountConnector', id: string, fieldMapping?: { __typename?: 'FieldMapping', targetObjectType: string, enabled: boolean } | null } | { __typename?: 'HubspotAccountConnector', id: string, fieldMapping?: { __typename?: 'FieldMapping', targetObjectType: string, enabled: boolean } | null } | { __typename?: 'SlackAccountConnector', id: string, fieldMapping?: { __typename?: 'FieldMapping', targetObjectType: string, enabled: boolean } | null } | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type DeleteSelectiveEnrichmentMutationVariables = Exact<{
  input: AccountConnectorsDeleteSelectiveEnrichmentInput;
}>;


export type DeleteSelectiveEnrichmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsDeleteSelectiveEnrichmentPayload', clientMutationId?: string | null } | null };

export type SaveSelectiveEnrichmentMutationVariables = Exact<{
  input: AccountConnectorsSaveSelectiveEnrichmentInput;
}>;


export type SaveSelectiveEnrichmentMutation = { __typename?: 'Mutation', response?: { __typename?: 'AccountConnectorsSaveSelectiveEnrichmentPayload', clientMutationId?: string | null, errors: Array<{ __typename?: 'Error', field: string, messages: Array<string> }> } | null };

export type SelectiveEnrichmentConfigQueryVariables = Exact<{
  type: AttributeTypeEnum;
  integrationCategory: AttributeCategoryEnum;
  collectionType: CollectionLegacyTypeEnum;
  salesforceSubCategories: Array<AttributeSalesforceSubCategoryEnum> | AttributeSalesforceSubCategoryEnum;
  hubspotSubCategories: Array<AttributeHubspotSubCategoryEnum> | AttributeHubspotSubCategoryEnum;
  marketoSubCategories: Array<AttributeMarketoSubCategoryEnum> | AttributeMarketoSubCategoryEnum;
}>;


export type SelectiveEnrichmentConfigQuery = { __typename?: 'Query', searchAttributes?: Array<{ __typename?: 'Attribute', category: string, details?: any | null, label: string, subCategory?: string | null, value: string, attributeType: string }> | null, salesforceUsers?: Array<{ __typename?: 'SalesforceUser', id: string, name?: string | null }> | null, collections?: { __typename?: 'CollectionConnection', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'Collection', id: string, name: string } | null } | null> | null } | null };

export type WebhookConfigAccountConnectorQueryVariables = Exact<{
  service: Array<AccountConnectorServiceEnum> | AccountConnectorServiceEnum;
}>;


export type WebhookConfigAccountConnectorQuery = { __typename?: 'Query', accountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, webhookPassword?: string | null } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, webhookPassword?: string | null } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, webhookPassword?: string | null } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, webhookPassword?: string | null } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, webhookPassword?: string | null } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, webhookPassword?: string | null } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, webhookPassword?: string | null } | null };

export type EnrichmentShowQueryVariables = Exact<{
  service?: InputMaybe<AccountConnectorServiceEnum>;
}>;


export type EnrichmentShowQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, flags: Array<AccountFlagEnum> }, accountNotifications: Array<{ __typename?: 'AccountNotification', service?: AccountConnectorServiceEnum | null, resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null }> };

export type HomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, name?: string | null, domain?: string | null }, accountConnectors: Array<{ __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, remoteMeta: any, accountId: string, syncStatus?: string | null }>, viewer: { __typename?: 'Viewer', id: string, user: { __typename?: 'User', firstName: string, id: string, name?: string | null, email: string, accounts: Array<{ __typename?: 'Account', id: string, name?: string | null }> } }, accountNotifications: Array<{ __typename?: 'AccountNotification', resolved: boolean, id: string, message?: string | null, notificationType: AccountNotificationTypeEnum, sourceName?: string | null, segmentType?: string | null, segmentId?: string | null, sourceId?: string | null }>, news: { __typename?: 'News', articles: Array<any> } };

export type PeoplePageQueryVariables = Exact<{
  peopleCursor?: InputMaybe<Scalars['String']>;
  peoplePageSize: Scalars['Int'];
  peopleSearchQuery?: InputMaybe<Scalars['String']>;
  peopleSegmentId?: InputMaybe<Scalars['ID']>;
}>;


export type PeoplePageQuery = { __typename?: 'Query', columns: Array<string>, people: { __typename?: 'PersonConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'PersonEdge', node?: { __typename?: 'Person', id: string, avatar?: string | null, columns: any, title?: string | null, company?: { __typename?: 'Company', id: string, domain?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } }, account: { __typename?: 'Account', id: string, flags: Array<AccountFlagEnum>, connectors: Array<{ __typename?: 'SalesforceAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'GoogleAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'G2AccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'MarketoAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'FacebookAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'HubspotAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any } | { __typename?: 'SlackAccountConnector', id: string, service: AccountConnectorServiceEnum, status: AccountConnectorStatusEnum, remoteMeta: any }> } };

export type PeopleSegmentPageQueryVariables = Exact<{
  peopleCursor?: InputMaybe<Scalars['String']>;
  peoplePageSize: Scalars['Int'];
  peopleSearchQuery?: InputMaybe<Scalars['String']>;
  peopleSegmentId: Scalars['ID'];
}>;


export type PeopleSegmentPageQuery = { __typename?: 'Query', columns: Array<string>, people: { __typename?: 'PersonConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'PersonEdge', node?: { __typename?: 'Person', id: string, avatar?: string | null, columns: any, title?: string | null, company?: { __typename?: 'Company', id: string, domain?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } }, segment?: { __typename?: 'Segment', id: string, type: SegmentTypeEnum, name: string, resultsCount?: number | null, collectionId: string, search: any, enabledDestinationsCount: number, legacyType: SegmentLegacyTypeEnum, updatedAt?: any | null, connectorErrors: { __typename?: 'ConnectorErrors', search: Array<string>, destinations: Array<string> }, audiences: { __typename?: 'AudienceConnection', totalCount: number } } | null };

export type PersonPageDetailsFragment = { __typename?: 'Person', bio?: string | null, email?: string | null, employment?: string | null, location?: string | null, name?: string | null, role?: string | null, seniority?: string | null, facebook?: string | null, github?: string | null, twitter?: string | null, linkedin?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null, domain?: string | null, fitScore?: string | null, employeesRange?: string | null, estimatedAnnualRevenue?: string | null, facebook?: string | null, linkedin?: string | null, twitter?: string | null, type?: string | null, raised?: string | null, ticker?: string | null, marketCap?: string | null, country?: string | null, countryCode?: string | null, sector?: string | null, industry?: string | null, tags?: Array<string> | null, description?: string | null } | null };

export type PersonSegmentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PersonSegmentsQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, segments: Array<{ __typename?: 'Segment', type: SegmentTypeEnum, id: string, name: string, updatedAt?: any | null, audiences: { __typename?: 'AudienceConnection', edges?: Array<{ __typename?: 'AudienceEdge', node?: { __typename?: 'Audience', id: string } | null } | null> | null }, destinations: Array<{ __typename?: 'Destination', id: string, description?: string | null, type: DestinationTypeEnum }>, collection: { __typename?: 'Collection', id: string, name: string } }> } | null };

export type PersonPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PersonPageQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, name?: string | null, email?: string | null, avatar?: string | null, enrichment?: any | null, traits?: any | null, companyEnrichment?: any | null, bio?: string | null, employment?: string | null, location?: string | null, role?: string | null, seniority?: string | null, facebook?: string | null, github?: string | null, twitter?: string | null, linkedin?: string | null, salesforceAccounts: { __typename?: 'SalesforceAccountConnection', edges?: Array<{ __typename?: 'SalesforceAccountEdge', node?: { __typename?: 'SalesforceAccount', id: string, name?: string | null, properties?: any | null } | null } | null> | null }, salesforceContacts: { __typename?: 'SalesforceContactConnection', edges?: Array<{ __typename?: 'SalesforceContactEdge', node?: { __typename?: 'SalesforceContact', id: string, email: string, externalId: string, name: string, properties?: any | null, websiteDomain?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null, salesforceAccount?: { __typename?: 'SalesforceAccount', id: string, name?: string | null, properties?: any | null, externalId: string } | null } | null } | null> | null }, salesforceLeads: { __typename?: 'SalesforceLeadConnection', edges?: Array<{ __typename?: 'SalesforceLeadEdge', node?: { __typename?: 'SalesforceLead', id: string, email: string, externalId: string, name: string, properties?: any | null, websiteDomain?: string | null, owner?: { __typename?: 'SalesforceUser', id: string, name?: string | null } | null } | null } | null> | null }, hubspotCompanies: { __typename?: 'HubspotCompanyConnection', edges?: Array<{ __typename?: 'HubspotCompanyEdge', node?: { __typename?: 'HubspotCompany', id: string, name?: string | null, domain: string, externalAccountId: string, properties?: any | null, deals?: { __typename?: 'HubspotDealConnection', edges?: Array<{ __typename?: 'HubspotDealEdge', node?: { __typename?: 'HubspotDeal', id: string, daysToClose?: number | null, name?: string | null, hubspotAccountId?: string | null, amount?: number | null, ownerId?: string | null, properties?: any | null } | null } | null> | null } | null } | null } | null> | null }, company?: { __typename?: 'Company', id: string, name?: string | null, domain?: string | null, fitScore?: string | null, employeesRange?: string | null, estimatedAnnualRevenue?: string | null, facebook?: string | null, linkedin?: string | null, twitter?: string | null, type?: string | null, raised?: string | null, ticker?: string | null, marketCap?: string | null, country?: string | null, countryCode?: string | null, sector?: string | null, industry?: string | null, tags?: Array<string> | null, description?: string | null, enrichment?: any | null } | null } | null, salesforceAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string, externalInstanceUrl: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string } | { __typename?: 'SlackAccountConnector', id: string } | null, hubspotAccountConnector?: { __typename?: 'SalesforceAccountConnector', id: string } | { __typename?: 'GoogleAccountConnector', id: string } | { __typename?: 'G2AccountConnector', id: string } | { __typename?: 'MarketoAccountConnector', id: string } | { __typename?: 'FacebookAccountConnector', id: string } | { __typename?: 'HubspotAccountConnector', id: string, owners: Array<{ __typename?: 'HubspotOwner', id: string, ownerName: string }> } | { __typename?: 'SlackAccountConnector', id: string } | null };

export type PeopleListFragment = { __typename?: 'Person', id: string, avatar?: string | null, columns: any, title?: string | null, company?: { __typename?: 'Company', id: string, domain?: string | null } | null };

export type PeopleListConnectionFragment = { __typename?: 'PersonConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'PersonEdge', node?: { __typename?: 'Person', id: string, avatar?: string | null, columns: any, title?: string | null, company?: { __typename?: 'Company', id: string, domain?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } };

export const AccountNotificationFragmentDoc = gql`
    fragment AccountNotification on AccountNotification {
  id
  message
  notificationType
  sourceName
  resolved
  segmentType
  segmentId
  sourceId
}
    `;
export const AccountNotificationsFragmentDoc = gql`
    fragment AccountNotifications on AccountNotification {
  resolved
  ...AccountNotification
}
    ${AccountNotificationFragmentDoc}`;
export const AccountSwitchFragmentDoc = gql`
    fragment AccountSwitch on User {
  id
  name
  email
  accounts {
    id
    name
  }
}
    `;
export const ActiveIntegrationCardAccountConnectorFragmentDoc = gql`
    fragment ActiveIntegrationCardAccountConnector on AccountConnector {
  id
  service
  remoteMeta
  accountId
  syncStatus
}
    `;
export const CompanyAttributeBrowserFragmentDoc = gql`
    fragment CompanyAttributeBrowser on Company {
  salesforceAccounts {
    edges {
      node {
        name
        externalId
        salesforceOpportunities {
          edges {
            node {
              id
              name
              properties
              externalId
            }
          }
        }
        id
        properties
      }
    }
  }
  hubspotCompanies {
    edges {
      node {
        id
        name
        domain
        externalAccountId
        properties
        deals {
          edges {
            node {
              id
              daysToClose
              name
              amount
              ownerId
              properties
            }
          }
        }
      }
    }
  }
}
    `;
export const CompanyAttributeBrowserSalesforceAccountConnectorFragmentDoc = gql`
    fragment CompanyAttributeBrowserSalesforceAccountConnector on AccountConnector {
  id
}
    `;
export const PersonAttributeBrowserFragmentDoc = gql`
    fragment PersonAttributeBrowser on Person {
  enrichment
  company {
    enrichment
  }
  salesforceContacts {
    edges {
      node {
        id
        email
        externalId
        name
        properties
        websiteDomain
        owner {
          id
          name
        }
        salesforceAccount {
          id
          name
          properties
          externalId
        }
      }
    }
  }
  salesforceLeads {
    edges {
      node {
        id
        email
        externalId
        name
        properties
        websiteDomain
        owner {
          id
          name
        }
      }
    }
  }
  hubspotCompanies {
    edges {
      node {
        id
        name
        domain
        externalAccountId
        properties
        deals {
          edges {
            node {
              id
              daysToClose
              name
              hubspotAccountId
              amount
              ownerId
              properties
            }
          }
        }
      }
    }
  }
}
    `;
export const G2FieldsFragmentDoc = gql`
    fragment G2Fields on G2AccountConnector {
  apiToken
}
    `;
export const MarketoFieldsFragmentDoc = gql`
    fragment MarketoFields on MarketoAccountConnector {
  clientId
  clientSecret
  endpointUrl
}
    `;
export const SalesforceFieldsFragmentDoc = gql`
    fragment SalesforceFields on SalesforceAccountConnector {
  pardotBusinessUnitId
}
    `;
export const MappingFragmentDoc = gql`
    fragment Mapping on FieldMapping {
  targetType
  targetAccountId
  targetObjectType
  fieldMappings
  enabled
}
    `;
export const AttributeFragmentDoc = gql`
    fragment Attribute on EnrichmentAttribute {
  type
  identifier
  label
  value
  meta
  source
  subtypeName
}
    `;
export const InitialSyncAlertFragmentDoc = gql`
    fragment InitialSyncAlert on Account {
  id
  flags
  connectors(service: [salesforce, salesforcesandbox, hubspot], status: [active]) {
    id
    service
    status
    remoteMeta
  }
}
    `;
export const CompanyPageActionsSalesforceOpportunityFragmentDoc = gql`
    fragment CompanyPageActionsSalesforceOpportunity on SalesforceOpportunity {
  id
  externalId
  name
  amount
  stage
  owner {
    id
    name
  }
  accountConnector {
    externalInstanceUrl
  }
}
    `;
export const CompanyPageActionsSalesforceAccountFragmentDoc = gql`
    fragment CompanyPageActionsSalesforceAccount on SalesforceAccount {
  id
  externalId
  name
  websiteDomain
  owner {
    id
    name
  }
  salesforceOpportunities {
    edges {
      node {
        id
        ...CompanyPageActionsSalesforceOpportunity
      }
    }
  }
  accountConnector {
    externalInstanceUrl
  }
}
    ${CompanyPageActionsSalesforceOpportunityFragmentDoc}`;
export const CompanyPageActionsSalesforceAccountConnectorFragmentDoc = gql`
    fragment CompanyPageActionsSalesforceAccountConnector on SalesforceAccountConnector {
  id
  externalInstanceUrl
}
    `;
export const CompanyPageActionsHubspotCompanyFragmentDoc = gql`
    fragment CompanyPageActionsHubspotCompany on HubspotCompany {
  id
  name
  domain
  externalAccountId
  properties
  deals {
    edges {
      node {
        id
        closed
        daysToClose
        name
        amount
        ownerId
        properties
      }
    }
  }
}
    `;
export const CompanyPageActionsHubspotAccountConnectorFragmentDoc = gql`
    fragment CompanyPageActionsHubspotAccountConnector on HubspotAccountConnector {
  owners {
    id
    ownerName
  }
}
    `;
export const PersonPageActionsSalesforceAccountConnectorFragmentDoc = gql`
    fragment PersonPageActionsSalesforceAccountConnector on SalesforceAccountConnector {
  id
  externalInstanceUrl
}
    `;
export const PersonPageActionsSalesforceContactFragmentDoc = gql`
    fragment PersonPageActionsSalesforceContact on SalesforceContact {
  id
  properties
  email
  externalId
  name
  websiteDomain
  owner {
    id
    name
  }
  salesforceAccount {
    id
    name
    properties
    externalId
  }
}
    `;
export const PersonPageActionsSalesforceLeadFragmentDoc = gql`
    fragment PersonPageActionsSalesforceLead on SalesforceLead {
  id
  properties
  email
  externalId
  name
  websiteDomain
  owner {
    id
    name
  }
}
    `;
export const PersonPageActionsHubspotCompanyFragmentDoc = gql`
    fragment PersonPageActionsHubspotCompany on HubspotCompany {
  domain
  externalAccountId
  name
  properties
  deals {
    edges {
      node {
        id
        daysToClose
        name
        properties
        amount
        ownerId
      }
    }
  }
}
    `;
export const PersonPageActionsHubspotAccountConnectorFragmentDoc = gql`
    fragment PersonPageActionsHubspotAccountConnector on HubspotAccountConnector {
  owners {
    id
    ownerName
  }
}
    `;
export const SearchBuilderAttributeFragmentDoc = gql`
    fragment SearchBuilderAttribute on Attribute {
  category
  details
  label
  subCategory
  value
  attributeType
}
    `;
export const SegmentFormAttributeFragmentDoc = gql`
    fragment SegmentFormAttribute on Attribute {
  ...SearchBuilderAttribute
}
    ${SearchBuilderAttributeFragmentDoc}`;
export const SegmentFormSegmentBuilderSalesforceUserFragmentDoc = gql`
    fragment SegmentFormSegmentBuilderSalesforceUser on SalesforceUser {
  id
  name
}
    `;
export const SiteConfigurationFieldsFragmentDoc = gql`
    fragment SiteConfigurationFields on FormConfiguration {
  id
  autofill
  formShortening
  identifyOnSubmit
  allowedSites {
    id
    siteUrl
    lastEventAt
    eventsReceived
  }
}
    `;
export const ProspectListFragmentFragmentDoc = gql`
    fragment ProspectListFragment on ProspectList {
  __typename
  id
  name
  query {
    cities
    companyCities
    companyCountries
    companyStates
    companyTags
    companyTech
    countries
    domains
    employeesRanges
    industries
    names
    roles
    seniorities
    states
    titles
  }
}
    `;
export const ProspectListExportFragmentFragmentDoc = gql`
    fragment ProspectListExportFragment on ProspectListExport {
  id
  status
  exportType
  lastDownloadedAt
  createdAt
  updatedAt
  prospectList {
    ...ProspectListFragment
  }
  metadata {
    totalCount
    totalCreated
  }
}
    ${ProspectListFragmentFragmentDoc}`;
export const CsvImportFragmentFragmentDoc = gql`
    fragment CsvImportFragment on CsvImport {
  id
  filename
  status
  type
  createdAt
  segmentId
  sourceName
  rowsMatchedCount
  rowsSkippedCount
  user {
    id
    email
  }
}
    `;
export const SegmentEditPageDestroyButtonFragmentDoc = gql`
    fragment SegmentEditPageDestroyButton on Segment {
  id
  destinations {
    id
    type
    description
  }
  legacyType
  type
}
    `;
export const SegmentTabsFragmentDoc = gql`
    fragment SegmentTabs on Segment {
  id
  audiences {
    totalCount
  }
  enabledDestinationsCount
  type
}
    `;
export const SegmentLayoutFragmentDoc = gql`
    fragment SegmentLayout on Segment {
  id
  name
  resultsCount
  collectionId
  search
  enabledDestinationsCount
  legacyType
  type
  connectorErrors {
    search
    destinations
  }
  updatedAt
  ...SegmentTabs
}
    ${SegmentTabsFragmentDoc}`;
export const SegmentEditFragmentDoc = gql`
    fragment SegmentEdit on Segment {
  id
  collectionId
  name
  resultsCount
  search
  searchDependencyErrors
  type
  ...SegmentEditPageDestroyButton
  ...SegmentLayout
}
    ${SegmentEditPageDestroyButtonFragmentDoc}
${SegmentLayoutFragmentDoc}`;
export const CampaignsFragmentDoc = gql`
    fragment Campaigns on Campaign {
  id
  name
  spend
  service
  audiences {
    id
    name
    subtype
  }
}
    `;
export const AdMetricsFragmentDoc = gql`
    fragment AdMetrics on AdMetrics {
  influencedClicks
  influencedImpressions
  influencedSpend
  influencedSpendPercentage
  overallClicks
  overallImpressions
  overallSpend
}
    `;
export const StageFragmentDoc = gql`
    fragment Stage on SalesPipelineStage {
  currentInfluencedValue
  previousInfluencedValue
  enabled
  search
  timeseries {
    date
    influencedValue
  }
}
    `;
export const SalesPipelineFragmentDoc = gql`
    fragment SalesPipeline on SalesPipeline {
  stages {
    visitors {
      ...Stage
    }
    opportunities {
      ...Stage
    }
    dealsWon {
      ...Stage
    }
  }
  status
  syncedAt
}
    ${StageFragmentDoc}`;
export const AudienceNewPageTypePickerAccountFragmentDoc = gql`
    fragment AudienceNewPageTypePickerAccount on Account {
  id
  plans
}
    `;
export const AudienceCompanyInsightsFragmentDoc = gql`
    fragment AudienceCompanyInsights on Audience {
  id
  companies {
    id
    domain
    employeesRange
    estimatedAnnualRevenue
    industry
    name
  }
  companiesFirmographic {
    countries {
      code
      count
      name
    }
    industries {
      name
      percentage
    }
  }
  companiesCount
  segment {
    id
    type
  }
}
    `;
export const AudiencePersonInsightsFragmentDoc = gql`
    fragment AudiencePersonInsights on Audience {
  id
  subtype
}
    `;
export const AudiencesServiceIconFragmentDoc = gql`
    fragment AudiencesServiceIcon on Audience {
  id
  service
}
    `;
export const AudiencesTileFragmentDoc = gql`
    fragment AudiencesTile on Audience {
  id
  subtype
}
    `;
export const AudienceSourceDestinationInfoFragmentDoc = gql`
    fragment AudienceSourceDestinationInfo on Audience {
  id
  externalAccountId
  externalName
  subtype
  segment {
    id
    name
    type
  }
  service
  ...AudiencesServiceIcon
  ...AudiencesTile
}
    ${AudiencesServiceIconFragmentDoc}
${AudiencesTileFragmentDoc}`;
export const AudiencesStatusIconFragmentDoc = gql`
    fragment AudiencesStatusIcon on Audience {
  id
  status
}
    `;
export const AudiencesHealthIndicatorFragmentDoc = gql`
    fragment AudiencesHealthIndicator on Audience {
  id
  externalEstimatedSize
  status
  ...AudiencesStatusIcon
}
    ${AudiencesStatusIconFragmentDoc}`;
export const AudienceSummaryFragmentDoc = gql`
    fragment AudienceSummary on Audience {
  id
  externalAccountId
  externalAccountName
  externalEstimatedSize
  externalEstimatedSizeChange
  externalName
  pushProgress
  pushRate
  pushedAt
  segment {
    id
    type
  }
  service
  status
  ...AudiencesHealthIndicator
  ...AudiencesServiceIcon
  ...AudiencesStatusIcon
}
    ${AudiencesHealthIndicatorFragmentDoc}
${AudiencesServiceIconFragmentDoc}
${AudiencesStatusIconFragmentDoc}`;
export const AudiencesLayoutFragmentDoc = gql`
    fragment AudiencesLayout on Audience {
  id
  createdAt
  name
  subtype
  user {
    id
    name
  }
  ...AudiencesTile
}
    ${AudiencesTileFragmentDoc}`;
export const AudiencesLayoutActionsMenuFragmentDoc = gql`
    fragment AudiencesLayoutActionsMenu on Viewer {
  id
  canExportAudiences
  canExportAdAudiencesToLinkedin
}
    `;
export const AudiencesLayoutViewerFragmentDoc = gql`
    fragment AudiencesLayoutViewer on Viewer {
  id
  ...AudiencesLayoutActionsMenu
}
    ${AudiencesLayoutActionsMenuFragmentDoc}`;
export const AudiencesProspectsFormAccountFragmentDoc = gql`
    fragment AudiencesProspectsFormAccount on Account {
  id
}
    `;
export const AudiencesProspectsFormAttributeFragmentDoc = gql`
    fragment AudiencesProspectsFormAttribute on Attribute {
  value
  ...SearchBuilderAttribute
}
    ${SearchBuilderAttributeFragmentDoc}`;
export const AudiencesProspectsFormSegmentBuilderSalesforceUserFragmentDoc = gql`
    fragment AudiencesProspectsFormSegmentBuilderSalesforceUser on SalesforceUser {
  id
  name
}
    `;
export const AudiencesSegmentFormSegmentBuilderSalesforceUserFragmentDoc = gql`
    fragment AudiencesSegmentFormSegmentBuilderSalesforceUser on SalesforceUser {
  id
  name
}
    `;
export const AudiencesSegmentFormSegmentBuilderAttributeFragmentDoc = gql`
    fragment AudiencesSegmentFormSegmentBuilderAttribute on Attribute {
  ...SearchBuilderAttribute
}
    ${SearchBuilderAttributeFragmentDoc}`;
export const AudiencesSegmentFormAttributeFragmentDoc = gql`
    fragment AudiencesSegmentFormAttribute on Attribute {
  ...AudiencesSegmentFormSegmentBuilderAttribute
}
    ${AudiencesSegmentFormSegmentBuilderAttributeFragmentDoc}`;
export const AudiencesSegmentFormSegmentBuilderCollectionFragmentDoc = gql`
    fragment AudiencesSegmentFormSegmentBuilderCollection on Collection {
  id
  name
  segments {
    id
    collectionId
    search
    collection {
      id
      name
    }
    legacyType
    type
  }
}
    `;
export const AudiencesSegmentFormSegmentPickerCollectionFragmentDoc = gql`
    fragment AudiencesSegmentFormSegmentPickerCollection on Collection {
  id
  name
  segments {
    id
    audiences {
      totalCount
    }
    collectionId
    enabledDestinationsCount
    legacyType
    name
    resultsCount
    type
  }
}
    `;
export const AudiencesSegmentFormCollectionFragmentDoc = gql`
    fragment AudiencesSegmentFormCollection on Collection {
  id
  ...AudiencesSegmentFormSegmentBuilderCollection
  ...AudiencesSegmentFormSegmentPickerCollection
}
    ${AudiencesSegmentFormSegmentBuilderCollectionFragmentDoc}
${AudiencesSegmentFormSegmentPickerCollectionFragmentDoc}`;
export const AudiencesSegmentFormSegmentFragmentDoc = gql`
    fragment AudiencesSegmentFormSegment on Segment {
  id
  collectionId
  name
  search
  type
}
    `;
export const CompaniesListFragmentDoc = gql`
    fragment CompaniesList on Company {
  id
  name
  columns(segmentId: $companiesSegmentId)
  domain
}
    `;
export const CompaniesListConnectionFragmentDoc = gql`
    fragment CompaniesListConnection on CompanyConnection {
  edges {
    node {
      id
      ...CompaniesList
    }
  }
  pageInfo {
    endCursor
    hasNextPage
  }
  totalCount
}
    ${CompaniesListFragmentDoc}`;
export const CompanyPageDetailsFragmentFragmentDoc = gql`
    fragment CompanyPageDetailsFragment on Company {
  city
  country
  countryCode
  description
  employeesRange
  estimatedAnnualRevenue
  facebook
  id
  subIndustry
  linkedin
  marketCap
  raised
  sector
  tags
  ticker
  twitter
  type
  hubspotCompanies {
    edges {
      node {
        id
        name
        domain
        externalAccountId
        properties
        deals {
          edges {
            node {
              id
              hubspotAccountId
              daysToClose
              name
              closed
              amount
              ownerId
              properties
            }
          }
        }
      }
    }
  }
}
    `;
export const CompanyPersonListRowFragmentDoc = gql`
    fragment CompanyPersonListRow on Person {
  id
  avatar
  email
  id
  name
  title
}
    `;
export const GoogleAnalyticsDimensionMappingFragmentDoc = gql`
    fragment GoogleAnalyticsDimensionMapping on GoogleDimensionMapping {
  id
  data
  status
  externalPropertyId
  externalPropertyName
  externalAccountId
}
    `;
export const AccountConnectorSyncStatusFragmentDoc = gql`
    fragment AccountConnectorSyncStatus on AccountConnector {
  lastSyncedAt
  syncStartedAt
  nextSyncAt
  syncStatus
  syncProgress
  isInitialSync
}
    `;
export const SegmentDestinationsPageAudienceFragmentDoc = gql`
    fragment SegmentDestinationsPageAudience on Audience {
  id
  createdAt
  externalName
  subtype
  user {
    id
    name
  }
  ...AudiencesServiceIcon
  ...AudiencesTile
}
    ${AudiencesServiceIconFragmentDoc}
${AudiencesTileFragmentDoc}`;
export const DestinationsEnabledSwitchDestinationFragmentDoc = gql`
    fragment DestinationsEnabledSwitchDestination on Destination {
  id
  enabled
  segment {
    id
    name
    enabledDestinationsCount
  }
}
    `;
export const SegmentDestinationsPreloadCountFragmentDoc = gql`
    fragment SegmentDestinationsPreloadCount on Segment {
  id
  destinationsCount
  audiences {
    totalCount
  }
}
    `;
export const SegmentDestinationsFragmentDoc = gql`
    fragment SegmentDestinations on Segment {
  id
  audiences {
    edges {
      node {
        ...SegmentDestinationsPageAudience
      }
    }
  }
  destinations {
    id
    description
    type
    config
    ...DestinationsEnabledSwitchDestination
  }
  type
  ...SegmentDestinationsPreloadCount
}
    ${SegmentDestinationsPageAudienceFragmentDoc}
${DestinationsEnabledSwitchDestinationFragmentDoc}
${SegmentDestinationsPreloadCountFragmentDoc}`;
export const SegmentDestinationNewPageFacebookAccountConnectorFragmentDoc = gql`
    fragment SegmentDestinationNewPageFacebookAccountConnector on FacebookAccountConnector {
  status
  adAccounts {
    id
    name
    adPixels {
      id
      name
    }
  }
}
    `;
export const SegmentDestinationNewPageGoogleAccountConnectorFragmentDoc = gql`
    fragment SegmentDestinationNewPageGoogleAccountConnector on GoogleAccountConnector {
  status
  adAccounts {
    id
    displayName
  }
}
    `;
export const SegmentDestinationNewPageSlackAccountConnectorFragmentDoc = gql`
    fragment SegmentDestinationNewPageSlackAccountConnector on SlackAccountConnector {
  id
  remoteMeta
  status
}
    `;
export const PersonPageDetailsFragmentDoc = gql`
    fragment PersonPageDetails on Person {
  bio
  email
  employment
  location
  name
  role
  seniority
  facebook
  github
  twitter
  linkedin
  company {
    id
    name
    domain
    fitScore
    employeesRange
    estimatedAnnualRevenue
    facebook
    linkedin
    twitter
    type
    raised
    ticker
    marketCap
    country
    countryCode
    sector
    industry
    tags
    description
  }
}
    `;
export const PeopleListFragmentDoc = gql`
    fragment PeopleList on Person {
  id
  avatar
  columns(segmentId: $peopleSegmentId)
  company {
    id
    domain
  }
  title
}
    `;
export const PeopleListConnectionFragmentDoc = gql`
    fragment PeopleListConnection on PersonConnection {
  edges {
    node {
      id
      ...PeopleList
    }
  }
  pageInfo {
    endCursor
    hasNextPage
  }
  totalCount
}
    ${PeopleListFragmentDoc}`;
export const ResolveAccountNotificationDocument = gql`
    mutation ResolveAccountNotification($input: AccountNotificationResolveInput!) {
  resolveAccountNotification(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type ResolveAccountNotificationMutationFn = Apollo.MutationFunction<ResolveAccountNotificationMutation, ResolveAccountNotificationMutationVariables>;

/**
 * __useResolveAccountNotificationMutation__
 *
 * To run a mutation, you first call `useResolveAccountNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveAccountNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveAccountNotificationMutation, { data, loading, error }] = useResolveAccountNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveAccountNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ResolveAccountNotificationMutation, ResolveAccountNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveAccountNotificationMutation, ResolveAccountNotificationMutationVariables>(ResolveAccountNotificationDocument, options);
      }
export type ResolveAccountNotificationMutationHookResult = ReturnType<typeof useResolveAccountNotificationMutation>;
export type ResolveAccountNotificationMutationResult = Apollo.MutationResult<ResolveAccountNotificationMutation>;
export type ResolveAccountNotificationMutationOptions = Apollo.BaseMutationOptions<ResolveAccountNotificationMutation, ResolveAccountNotificationMutationVariables>;
export const EnrichmentHealthMetricMetricDocument = gql`
    query EnrichmentHealthMetricMetric($metricName: String!, $externalType: AccountConnectorServiceEnum!, $startDate: String!, $endDate: String!) {
  enrichmentHealthMetric(externalType: $externalType, metricName: $metricName, startDate: $startDate, endDate: $endDate) {
    uniques
  }
}
    `;

/**
 * __useEnrichmentHealthMetricMetricQuery__
 *
 * To run a query within a React component, call `useEnrichmentHealthMetricMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentHealthMetricMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentHealthMetricMetricQuery({
 *   variables: {
 *      metricName: // value for 'metricName'
 *      externalType: // value for 'externalType'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useEnrichmentHealthMetricMetricQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentHealthMetricMetricQuery, EnrichmentHealthMetricMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentHealthMetricMetricQuery, EnrichmentHealthMetricMetricQueryVariables>(EnrichmentHealthMetricMetricDocument, options);
      }
export function useEnrichmentHealthMetricMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentHealthMetricMetricQuery, EnrichmentHealthMetricMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentHealthMetricMetricQuery, EnrichmentHealthMetricMetricQueryVariables>(EnrichmentHealthMetricMetricDocument, options);
        }
export type EnrichmentHealthMetricMetricQueryHookResult = ReturnType<typeof useEnrichmentHealthMetricMetricQuery>;
export type EnrichmentHealthMetricMetricLazyQueryHookResult = ReturnType<typeof useEnrichmentHealthMetricMetricLazyQuery>;
export type EnrichmentHealthMetricMetricQueryResult = Apollo.QueryResult<EnrichmentHealthMetricMetricQuery, EnrichmentHealthMetricMetricQueryVariables>;
export const ActiveIntegrationsDocument = gql`
    query ActiveIntegrations {
  accountConnectors(status: [active], service: [salesforce, marketo, hubspot]) {
    ...ActiveIntegrationCardAccountConnector
  }
}
    ${ActiveIntegrationCardAccountConnectorFragmentDoc}`;

/**
 * __useActiveIntegrationsQuery__
 *
 * To run a query within a React component, call `useActiveIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<ActiveIntegrationsQuery, ActiveIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveIntegrationsQuery, ActiveIntegrationsQueryVariables>(ActiveIntegrationsDocument, options);
      }
export function useActiveIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveIntegrationsQuery, ActiveIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveIntegrationsQuery, ActiveIntegrationsQueryVariables>(ActiveIntegrationsDocument, options);
        }
export type ActiveIntegrationsQueryHookResult = ReturnType<typeof useActiveIntegrationsQuery>;
export type ActiveIntegrationsLazyQueryHookResult = ReturnType<typeof useActiveIntegrationsLazyQuery>;
export type ActiveIntegrationsQueryResult = Apollo.QueryResult<ActiveIntegrationsQuery, ActiveIntegrationsQueryVariables>;
export const CreateHubspotCompanyDocument = gql`
    mutation createHubspotCompany($input: HubspotCreateCompanyInput!) {
  createHubspotCompany(input: $input) {
    errors {
      messages
    }
  }
}
    `;
export type CreateHubspotCompanyMutationFn = Apollo.MutationFunction<CreateHubspotCompanyMutation, CreateHubspotCompanyMutationVariables>;

/**
 * __useCreateHubspotCompanyMutation__
 *
 * To run a mutation, you first call `useCreateHubspotCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHubspotCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHubspotCompanyMutation, { data, loading, error }] = useCreateHubspotCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHubspotCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateHubspotCompanyMutation, CreateHubspotCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHubspotCompanyMutation, CreateHubspotCompanyMutationVariables>(CreateHubspotCompanyDocument, options);
      }
export type CreateHubspotCompanyMutationHookResult = ReturnType<typeof useCreateHubspotCompanyMutation>;
export type CreateHubspotCompanyMutationResult = Apollo.MutationResult<CreateHubspotCompanyMutation>;
export type CreateHubspotCompanyMutationOptions = Apollo.BaseMutationOptions<CreateHubspotCompanyMutation, CreateHubspotCompanyMutationVariables>;
export const CrmPresenceDocument = gql`
    query CRMPresence($domains: [String!]!) {
  crmPresence(domains: $domains) {
    nodes {
      id
      existsInHubspot
    }
  }
}
    `;

/**
 * __useCrmPresenceQuery__
 *
 * To run a query within a React component, call `useCrmPresenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmPresenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmPresenceQuery({
 *   variables: {
 *      domains: // value for 'domains'
 *   },
 * });
 */
export function useCrmPresenceQuery(baseOptions: Apollo.QueryHookOptions<CrmPresenceQuery, CrmPresenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrmPresenceQuery, CrmPresenceQueryVariables>(CrmPresenceDocument, options);
      }
export function useCrmPresenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrmPresenceQuery, CrmPresenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrmPresenceQuery, CrmPresenceQueryVariables>(CrmPresenceDocument, options);
        }
export type CrmPresenceQueryHookResult = ReturnType<typeof useCrmPresenceQuery>;
export type CrmPresenceLazyQueryHookResult = ReturnType<typeof useCrmPresenceLazyQuery>;
export type CrmPresenceQueryResult = Apollo.QueryResult<CrmPresenceQuery, CrmPresenceQueryVariables>;
export const CapturePreviewDocument = gql`
    query CapturePreview($domain: String!, $seniority: [String]!, $role: [String]!) {
  prospects(domain: $domain, seniorities: $seniority, roles: $role) {
    totalCount
    nodes {
      id
      name
      title
      avatar
    }
  }
}
    `;

/**
 * __useCapturePreviewQuery__
 *
 * To run a query within a React component, call `useCapturePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapturePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapturePreviewQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      seniority: // value for 'seniority'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCapturePreviewQuery(baseOptions: Apollo.QueryHookOptions<CapturePreviewQuery, CapturePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapturePreviewQuery, CapturePreviewQueryVariables>(CapturePreviewDocument, options);
      }
export function useCapturePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapturePreviewQuery, CapturePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapturePreviewQuery, CapturePreviewQueryVariables>(CapturePreviewDocument, options);
        }
export type CapturePreviewQueryHookResult = ReturnType<typeof useCapturePreviewQuery>;
export type CapturePreviewLazyQueryHookResult = ReturnType<typeof useCapturePreviewLazyQuery>;
export type CapturePreviewQueryResult = Apollo.QueryResult<CapturePreviewQuery, CapturePreviewQueryVariables>;
export const RefreshAccountPageEventDocument = gql`
    mutation RefreshAccountPageEvent {
  account: refreshAccountPageEvent(input: {}) {
    node {
      id
      accountSetting {
        id
        firstPageEventReceivedAt
      }
    }
  }
}
    `;
export type RefreshAccountPageEventMutationFn = Apollo.MutationFunction<RefreshAccountPageEventMutation, RefreshAccountPageEventMutationVariables>;

/**
 * __useRefreshAccountPageEventMutation__
 *
 * To run a mutation, you first call `useRefreshAccountPageEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAccountPageEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAccountPageEventMutation, { data, loading, error }] = useRefreshAccountPageEventMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshAccountPageEventMutation(baseOptions?: Apollo.MutationHookOptions<RefreshAccountPageEventMutation, RefreshAccountPageEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshAccountPageEventMutation, RefreshAccountPageEventMutationVariables>(RefreshAccountPageEventDocument, options);
      }
export type RefreshAccountPageEventMutationHookResult = ReturnType<typeof useRefreshAccountPageEventMutation>;
export type RefreshAccountPageEventMutationResult = Apollo.MutationResult<RefreshAccountPageEventMutation>;
export type RefreshAccountPageEventMutationOptions = Apollo.BaseMutationOptions<RefreshAccountPageEventMutation, RefreshAccountPageEventMutationVariables>;
export const UpsertG2AccountConnectorDocument = gql`
    mutation UpsertG2AccountConnector($input: AccountConnectorsUpsertG2ConnectorInput!) {
  upsertG2Connector(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UpsertG2AccountConnectorMutationFn = Apollo.MutationFunction<UpsertG2AccountConnectorMutation, UpsertG2AccountConnectorMutationVariables>;

/**
 * __useUpsertG2AccountConnectorMutation__
 *
 * To run a mutation, you first call `useUpsertG2AccountConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertG2AccountConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertG2AccountConnectorMutation, { data, loading, error }] = useUpsertG2AccountConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertG2AccountConnectorMutation(baseOptions?: Apollo.MutationHookOptions<UpsertG2AccountConnectorMutation, UpsertG2AccountConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertG2AccountConnectorMutation, UpsertG2AccountConnectorMutationVariables>(UpsertG2AccountConnectorDocument, options);
      }
export type UpsertG2AccountConnectorMutationHookResult = ReturnType<typeof useUpsertG2AccountConnectorMutation>;
export type UpsertG2AccountConnectorMutationResult = Apollo.MutationResult<UpsertG2AccountConnectorMutation>;
export type UpsertG2AccountConnectorMutationOptions = Apollo.BaseMutationOptions<UpsertG2AccountConnectorMutation, UpsertG2AccountConnectorMutationVariables>;
export const G2ConfigurationDocument = gql`
    query G2Configuration {
  account {
    id
    flags
  }
  accountConnector(service: [g2], status: [active]) {
    id
    service
    ...G2Fields
  }
}
    ${G2FieldsFragmentDoc}`;

/**
 * __useG2ConfigurationQuery__
 *
 * To run a query within a React component, call `useG2ConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useG2ConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useG2ConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useG2ConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<G2ConfigurationQuery, G2ConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<G2ConfigurationQuery, G2ConfigurationQueryVariables>(G2ConfigurationDocument, options);
      }
export function useG2ConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<G2ConfigurationQuery, G2ConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<G2ConfigurationQuery, G2ConfigurationQueryVariables>(G2ConfigurationDocument, options);
        }
export type G2ConfigurationQueryHookResult = ReturnType<typeof useG2ConfigurationQuery>;
export type G2ConfigurationLazyQueryHookResult = ReturnType<typeof useG2ConfigurationLazyQuery>;
export type G2ConfigurationQueryResult = Apollo.QueryResult<G2ConfigurationQuery, G2ConfigurationQueryVariables>;
export const MarketoConnectionDocument = gql`
    query MarketoConnection {
  accountConnector(service: [marketo], status: [active]) {
    id
    service
    ...MarketoFields
  }
}
    ${MarketoFieldsFragmentDoc}`;

/**
 * __useMarketoConnectionQuery__
 *
 * To run a query within a React component, call `useMarketoConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketoConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketoConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketoConnectionQuery(baseOptions?: Apollo.QueryHookOptions<MarketoConnectionQuery, MarketoConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketoConnectionQuery, MarketoConnectionQueryVariables>(MarketoConnectionDocument, options);
      }
export function useMarketoConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketoConnectionQuery, MarketoConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketoConnectionQuery, MarketoConnectionQueryVariables>(MarketoConnectionDocument, options);
        }
export type MarketoConnectionQueryHookResult = ReturnType<typeof useMarketoConnectionQuery>;
export type MarketoConnectionLazyQueryHookResult = ReturnType<typeof useMarketoConnectionLazyQuery>;
export type MarketoConnectionQueryResult = Apollo.QueryResult<MarketoConnectionQuery, MarketoConnectionQueryVariables>;
export const UpsertMarketoAccountConnectorDocument = gql`
    mutation UpsertMarketoAccountConnector($input: AccountConnectorsUpsertMarketoConnectorInput!) {
  upsertMarketoConnector(input: $input) {
    node {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpsertMarketoAccountConnectorMutationFn = Apollo.MutationFunction<UpsertMarketoAccountConnectorMutation, UpsertMarketoAccountConnectorMutationVariables>;

/**
 * __useUpsertMarketoAccountConnectorMutation__
 *
 * To run a mutation, you first call `useUpsertMarketoAccountConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMarketoAccountConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMarketoAccountConnectorMutation, { data, loading, error }] = useUpsertMarketoAccountConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertMarketoAccountConnectorMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMarketoAccountConnectorMutation, UpsertMarketoAccountConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMarketoAccountConnectorMutation, UpsertMarketoAccountConnectorMutationVariables>(UpsertMarketoAccountConnectorDocument, options);
      }
export type UpsertMarketoAccountConnectorMutationHookResult = ReturnType<typeof useUpsertMarketoAccountConnectorMutation>;
export type UpsertMarketoAccountConnectorMutationResult = Apollo.MutationResult<UpsertMarketoAccountConnectorMutation>;
export type UpsertMarketoAccountConnectorMutationOptions = Apollo.BaseMutationOptions<UpsertMarketoAccountConnectorMutation, UpsertMarketoAccountConnectorMutationVariables>;
export const PardotConnectionDocument = gql`
    query PardotConnection {
  accountConnector(service: [salesforce, salesforcesandbox], status: [active]) {
    id
    service
    ...SalesforceFields
  }
}
    ${SalesforceFieldsFragmentDoc}`;

/**
 * __usePardotConnectionQuery__
 *
 * To run a query within a React component, call `usePardotConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePardotConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePardotConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePardotConnectionQuery(baseOptions?: Apollo.QueryHookOptions<PardotConnectionQuery, PardotConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PardotConnectionQuery, PardotConnectionQueryVariables>(PardotConnectionDocument, options);
      }
export function usePardotConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PardotConnectionQuery, PardotConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PardotConnectionQuery, PardotConnectionQueryVariables>(PardotConnectionDocument, options);
        }
export type PardotConnectionQueryHookResult = ReturnType<typeof usePardotConnectionQuery>;
export type PardotConnectionLazyQueryHookResult = ReturnType<typeof usePardotConnectionLazyQuery>;
export type PardotConnectionQueryResult = Apollo.QueryResult<PardotConnectionQuery, PardotConnectionQueryVariables>;
export const UpdatePardotBusinessUnitIdDocument = gql`
    mutation UpdatePardotBusinessUnitId($input: AccountConnectorsUpdatePardotBusinessUnitIdInput!) {
  updatePardotBusinessUnitId(input: $input) {
    node {
      id
      pardotBusinessUnitId
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdatePardotBusinessUnitIdMutationFn = Apollo.MutationFunction<UpdatePardotBusinessUnitIdMutation, UpdatePardotBusinessUnitIdMutationVariables>;

/**
 * __useUpdatePardotBusinessUnitIdMutation__
 *
 * To run a mutation, you first call `useUpdatePardotBusinessUnitIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePardotBusinessUnitIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePardotBusinessUnitIdMutation, { data, loading, error }] = useUpdatePardotBusinessUnitIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePardotBusinessUnitIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePardotBusinessUnitIdMutation, UpdatePardotBusinessUnitIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePardotBusinessUnitIdMutation, UpdatePardotBusinessUnitIdMutationVariables>(UpdatePardotBusinessUnitIdDocument, options);
      }
export type UpdatePardotBusinessUnitIdMutationHookResult = ReturnType<typeof useUpdatePardotBusinessUnitIdMutation>;
export type UpdatePardotBusinessUnitIdMutationResult = Apollo.MutationResult<UpdatePardotBusinessUnitIdMutation>;
export type UpdatePardotBusinessUnitIdMutationOptions = Apollo.BaseMutationOptions<UpdatePardotBusinessUnitIdMutation, UpdatePardotBusinessUnitIdMutationVariables>;
export const DevPanelFeatureFlagsDocument = gql`
    query DevPanelFeatureFlags {
  availableFeatureFlags
}
    `;

/**
 * __useDevPanelFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useDevPanelFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevPanelFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevPanelFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevPanelFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<DevPanelFeatureFlagsQuery, DevPanelFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevPanelFeatureFlagsQuery, DevPanelFeatureFlagsQueryVariables>(DevPanelFeatureFlagsDocument, options);
      }
export function useDevPanelFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevPanelFeatureFlagsQuery, DevPanelFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevPanelFeatureFlagsQuery, DevPanelFeatureFlagsQueryVariables>(DevPanelFeatureFlagsDocument, options);
        }
export type DevPanelFeatureFlagsQueryHookResult = ReturnType<typeof useDevPanelFeatureFlagsQuery>;
export type DevPanelFeatureFlagsLazyQueryHookResult = ReturnType<typeof useDevPanelFeatureFlagsLazyQuery>;
export type DevPanelFeatureFlagsQueryResult = Apollo.QueryResult<DevPanelFeatureFlagsQuery, DevPanelFeatureFlagsQueryVariables>;
export const CompanySegmentColumnsDocument = gql`
    query CompanySegmentColumns($attributeType: AttributeTypeEnum!, $columnType: ColumnTypeEnum!, $segmentId: ID) {
  columns(type: $columnType, segmentId: $segmentId)
  attributes(type: $attributeType, categories: [pageview_display, system, enrichment]) {
    value
    label
    category
    subCategory
    attributeType
  }
}
    `;

/**
 * __useCompanySegmentColumnsQuery__
 *
 * To run a query within a React component, call `useCompanySegmentColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySegmentColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySegmentColumnsQuery({
 *   variables: {
 *      attributeType: // value for 'attributeType'
 *      columnType: // value for 'columnType'
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useCompanySegmentColumnsQuery(baseOptions: Apollo.QueryHookOptions<CompanySegmentColumnsQuery, CompanySegmentColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySegmentColumnsQuery, CompanySegmentColumnsQueryVariables>(CompanySegmentColumnsDocument, options);
      }
export function useCompanySegmentColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySegmentColumnsQuery, CompanySegmentColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySegmentColumnsQuery, CompanySegmentColumnsQueryVariables>(CompanySegmentColumnsDocument, options);
        }
export type CompanySegmentColumnsQueryHookResult = ReturnType<typeof useCompanySegmentColumnsQuery>;
export type CompanySegmentColumnsLazyQueryHookResult = ReturnType<typeof useCompanySegmentColumnsLazyQuery>;
export type CompanySegmentColumnsQueryResult = Apollo.QueryResult<CompanySegmentColumnsQuery, CompanySegmentColumnsQueryVariables>;
export const EnrichmentLogsResultsDocument = gql`
    query EnrichmentLogsResults($queryExecutionId: String!) {
  enrichmentLogsResult(queryExecutionId: $queryExecutionId) {
    id
    externalId
    identifier
    image
    name
    status
    steps {
      changes {
        fieldName
        from
        to
      }
      name
      message
      status
      timestamp
    }
    subType
    timestamp
    type
  }
}
    `;

/**
 * __useEnrichmentLogsResultsQuery__
 *
 * To run a query within a React component, call `useEnrichmentLogsResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentLogsResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentLogsResultsQuery({
 *   variables: {
 *      queryExecutionId: // value for 'queryExecutionId'
 *   },
 * });
 */
export function useEnrichmentLogsResultsQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentLogsResultsQuery, EnrichmentLogsResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentLogsResultsQuery, EnrichmentLogsResultsQueryVariables>(EnrichmentLogsResultsDocument, options);
      }
export function useEnrichmentLogsResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentLogsResultsQuery, EnrichmentLogsResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentLogsResultsQuery, EnrichmentLogsResultsQueryVariables>(EnrichmentLogsResultsDocument, options);
        }
export type EnrichmentLogsResultsQueryHookResult = ReturnType<typeof useEnrichmentLogsResultsQuery>;
export type EnrichmentLogsResultsLazyQueryHookResult = ReturnType<typeof useEnrichmentLogsResultsLazyQuery>;
export type EnrichmentLogsResultsQueryResult = Apollo.QueryResult<EnrichmentLogsResultsQuery, EnrichmentLogsResultsQueryVariables>;
export const EnrichmentLogsDocument = gql`
    query EnrichmentLogs($query: String, $status: [EnrichmentLogStatusEnum!], $type: EnrichmentLogTypeEnum!) {
  enrichmentLogs(query: $query, status: $status, type: $type) {
    queryExecutionId
  }
}
    `;

/**
 * __useEnrichmentLogsQuery__
 *
 * To run a query within a React component, call `useEnrichmentLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentLogsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useEnrichmentLogsQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentLogsQuery, EnrichmentLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentLogsQuery, EnrichmentLogsQueryVariables>(EnrichmentLogsDocument, options);
      }
export function useEnrichmentLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentLogsQuery, EnrichmentLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentLogsQuery, EnrichmentLogsQueryVariables>(EnrichmentLogsDocument, options);
        }
export type EnrichmentLogsQueryHookResult = ReturnType<typeof useEnrichmentLogsQuery>;
export type EnrichmentLogsLazyQueryHookResult = ReturnType<typeof useEnrichmentLogsLazyQuery>;
export type EnrichmentLogsQueryResult = Apollo.QueryResult<EnrichmentLogsQuery, EnrichmentLogsQueryVariables>;
export const EnrichmentLogsStatusDocument = gql`
    query EnrichmentLogsStatus($queryExecutionId: String!) {
  enrichmentLogsStatus(queryExecutionId: $queryExecutionId) {
    queryExecutionId
    state
  }
}
    `;

/**
 * __useEnrichmentLogsStatusQuery__
 *
 * To run a query within a React component, call `useEnrichmentLogsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentLogsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentLogsStatusQuery({
 *   variables: {
 *      queryExecutionId: // value for 'queryExecutionId'
 *   },
 * });
 */
export function useEnrichmentLogsStatusQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentLogsStatusQuery, EnrichmentLogsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentLogsStatusQuery, EnrichmentLogsStatusQueryVariables>(EnrichmentLogsStatusDocument, options);
      }
export function useEnrichmentLogsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentLogsStatusQuery, EnrichmentLogsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentLogsStatusQuery, EnrichmentLogsStatusQueryVariables>(EnrichmentLogsStatusDocument, options);
        }
export type EnrichmentLogsStatusQueryHookResult = ReturnType<typeof useEnrichmentLogsStatusQuery>;
export type EnrichmentLogsStatusLazyQueryHookResult = ReturnType<typeof useEnrichmentLogsStatusLazyQuery>;
export type EnrichmentLogsStatusQueryResult = Apollo.QueryResult<EnrichmentLogsStatusQuery, EnrichmentLogsStatusQueryVariables>;
export const EnrichListDocument = gql`
    mutation EnrichList($input: HubspotEnrichListInput!) {
  enrichList(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type EnrichListMutationFn = Apollo.MutationFunction<EnrichListMutation, EnrichListMutationVariables>;

/**
 * __useEnrichListMutation__
 *
 * To run a mutation, you first call `useEnrichListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrichListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrichListMutation, { data, loading, error }] = useEnrichListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrichListMutation(baseOptions?: Apollo.MutationHookOptions<EnrichListMutation, EnrichListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrichListMutation, EnrichListMutationVariables>(EnrichListDocument, options);
      }
export type EnrichListMutationHookResult = ReturnType<typeof useEnrichListMutation>;
export type EnrichListMutationResult = Apollo.MutationResult<EnrichListMutation>;
export type EnrichListMutationOptions = Apollo.BaseMutationOptions<EnrichListMutation, EnrichListMutationVariables>;
export const EnrichmentConfigDocument = gql`
    query EnrichmentConfig {
  accountConnector(service: [hubspot], status: [active, disconnected, error]) {
    id
    status
    service
    createdAt
    remoteMeta
    lastSyncedAt
    syncStartedAt
    nextSyncAt
    syncStatus
    syncProgress
    isInitialSync
  }
  hubspotLists {
    nodes {
      id
      name
      createdAt
      updatedAt
      objectType
      processingStatus
      processingType
      size
    }
  }
  hubspotEnrichmentSettings {
    liveEnrichCompaniesEnabled
    liveEnrichContactsEnabled
  }
}
    `;

/**
 * __useEnrichmentConfigQuery__
 *
 * To run a query within a React component, call `useEnrichmentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnrichmentConfigQuery(baseOptions?: Apollo.QueryHookOptions<EnrichmentConfigQuery, EnrichmentConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentConfigQuery, EnrichmentConfigQueryVariables>(EnrichmentConfigDocument, options);
      }
export function useEnrichmentConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentConfigQuery, EnrichmentConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentConfigQuery, EnrichmentConfigQueryVariables>(EnrichmentConfigDocument, options);
        }
export type EnrichmentConfigQueryHookResult = ReturnType<typeof useEnrichmentConfigQuery>;
export type EnrichmentConfigLazyQueryHookResult = ReturnType<typeof useEnrichmentConfigLazyQuery>;
export type EnrichmentConfigQueryResult = Apollo.QueryResult<EnrichmentConfigQuery, EnrichmentConfigQueryVariables>;
export const MappingsDocument = gql`
    query Mappings($accountConnectorId: ID!) {
  company: fieldMapping(targetObjectType: "company", accountConnectorId: $accountConnectorId) {
    ...Mapping
  }
  contact: fieldMapping(targetObjectType: "contact", accountConnectorId: $accountConnectorId) {
    ...Mapping
  }
}
    ${MappingFragmentDoc}`;

/**
 * __useMappingsQuery__
 *
 * To run a query within a React component, call `useMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMappingsQuery({
 *   variables: {
 *      accountConnectorId: // value for 'accountConnectorId'
 *   },
 * });
 */
export function useMappingsQuery(baseOptions: Apollo.QueryHookOptions<MappingsQuery, MappingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MappingsQuery, MappingsQueryVariables>(MappingsDocument, options);
      }
export function useMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MappingsQuery, MappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MappingsQuery, MappingsQueryVariables>(MappingsDocument, options);
        }
export type MappingsQueryHookResult = ReturnType<typeof useMappingsQuery>;
export type MappingsLazyQueryHookResult = ReturnType<typeof useMappingsLazyQuery>;
export type MappingsQueryResult = Apollo.QueryResult<MappingsQuery, MappingsQueryVariables>;
export const PropertiesDocument = gql`
    query Properties {
  hubspotCompany: enrichmentAttributes(types: [hubspot_company]) {
    ...Attribute
  }
  hubspotContact: enrichmentAttributes(types: [hubspot_contact]) {
    ...Attribute
  }
}
    ${AttributeFragmentDoc}`;

/**
 * __usePropertiesQuery__
 *
 * To run a query within a React component, call `usePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertiesQuery(baseOptions?: Apollo.QueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
      }
export function usePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
        }
export type PropertiesQueryHookResult = ReturnType<typeof usePropertiesQuery>;
export type PropertiesLazyQueryHookResult = ReturnType<typeof usePropertiesLazyQuery>;
export type PropertiesQueryResult = Apollo.QueryResult<PropertiesQuery, PropertiesQueryVariables>;
export const SchemaDocument = gql`
    query Schema {
  clearbitCompany: enrichmentAttributes(types: [clearbit_company, system_traits_company], categorize: false, traitFilter: clearbit_processed_at) {
    ...Attribute
  }
  clearbitPerson: enrichmentAttributes(types: [clearbit_person, clearbit_company, system_traits_person], categorize: false, traitFilter: clearbit_processed_at, excludePersonPhone: true) {
    ...Attribute
  }
  hubspotCompany: enrichmentAttributes(types: [hubspot_company]) {
    ...Attribute
  }
  hubspotContact: enrichmentAttributes(types: [hubspot_contact]) {
    ...Attribute
  }
}
    ${AttributeFragmentDoc}`;

/**
 * __useSchemaQuery__
 *
 * To run a query within a React component, call `useSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchemaQuery(baseOptions?: Apollo.QueryHookOptions<SchemaQuery, SchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaQuery, SchemaQueryVariables>(SchemaDocument, options);
      }
export function useSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaQuery, SchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaQuery, SchemaQueryVariables>(SchemaDocument, options);
        }
export type SchemaQueryHookResult = ReturnType<typeof useSchemaQuery>;
export type SchemaLazyQueryHookResult = ReturnType<typeof useSchemaLazyQuery>;
export type SchemaQueryResult = Apollo.QueryResult<SchemaQuery, SchemaQueryVariables>;
export const UpdateHubspotLiveEnrichmentDocument = gql`
    mutation UpdateHubspotLiveEnrichment($input: AccountConnectorsUpdateHubspotLiveEnrichmentInput!) {
  updateHubspotLiveEnrichment(input: $input) {
    node {
      liveEnrichCompaniesEnabled
      liveEnrichContactsEnabled
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateHubspotLiveEnrichmentMutationFn = Apollo.MutationFunction<UpdateHubspotLiveEnrichmentMutation, UpdateHubspotLiveEnrichmentMutationVariables>;

/**
 * __useUpdateHubspotLiveEnrichmentMutation__
 *
 * To run a mutation, you first call `useUpdateHubspotLiveEnrichmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHubspotLiveEnrichmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHubspotLiveEnrichmentMutation, { data, loading, error }] = useUpdateHubspotLiveEnrichmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHubspotLiveEnrichmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHubspotLiveEnrichmentMutation, UpdateHubspotLiveEnrichmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHubspotLiveEnrichmentMutation, UpdateHubspotLiveEnrichmentMutationVariables>(UpdateHubspotLiveEnrichmentDocument, options);
      }
export type UpdateHubspotLiveEnrichmentMutationHookResult = ReturnType<typeof useUpdateHubspotLiveEnrichmentMutation>;
export type UpdateHubspotLiveEnrichmentMutationResult = Apollo.MutationResult<UpdateHubspotLiveEnrichmentMutation>;
export type UpdateHubspotLiveEnrichmentMutationOptions = Apollo.BaseMutationOptions<UpdateHubspotLiveEnrichmentMutation, UpdateHubspotLiveEnrichmentMutationVariables>;
export const HubspotListStatusDocument = gql`
    query HubspotListStatus($id: ID!) {
  hubspotList(id: $id) {
    id
    enrichmentStatus
    enrichmentError
  }
}
    `;

/**
 * __useHubspotListStatusQuery__
 *
 * To run a query within a React component, call `useHubspotListStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubspotListStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubspotListStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHubspotListStatusQuery(baseOptions: Apollo.QueryHookOptions<HubspotListStatusQuery, HubspotListStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HubspotListStatusQuery, HubspotListStatusQueryVariables>(HubspotListStatusDocument, options);
      }
export function useHubspotListStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HubspotListStatusQuery, HubspotListStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HubspotListStatusQuery, HubspotListStatusQueryVariables>(HubspotListStatusDocument, options);
        }
export type HubspotListStatusQueryHookResult = ReturnType<typeof useHubspotListStatusQuery>;
export type HubspotListStatusLazyQueryHookResult = ReturnType<typeof useHubspotListStatusLazyQuery>;
export type HubspotListStatusQueryResult = Apollo.QueryResult<HubspotListStatusQuery, HubspotListStatusQueryVariables>;
export const IdealCustomerProfilePageDocument = gql`
    query IdealCustomerProfilePage {
  account {
    connectors(service: [salesforce, salesforcesandbox], status: active) {
      id
      name
      service
      remoteMeta
      backfillActive
    }
  }
  accountNotifications {
    ...AccountNotifications
    service
  }
  fitModel(type: closedWonLoss) {
    id
    type
    status
    features
    metadata
    wonAudienceId
    lostAudienceId
    wonAudienceName
    lostAudienceName
    updatedAt
  }
}
    ${AccountNotificationsFragmentDoc}`;

/**
 * __useIdealCustomerProfilePageQuery__
 *
 * To run a query within a React component, call `useIdealCustomerProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdealCustomerProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdealCustomerProfilePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdealCustomerProfilePageQuery(baseOptions?: Apollo.QueryHookOptions<IdealCustomerProfilePageQuery, IdealCustomerProfilePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdealCustomerProfilePageQuery, IdealCustomerProfilePageQueryVariables>(IdealCustomerProfilePageDocument, options);
      }
export function useIdealCustomerProfilePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdealCustomerProfilePageQuery, IdealCustomerProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdealCustomerProfilePageQuery, IdealCustomerProfilePageQueryVariables>(IdealCustomerProfilePageDocument, options);
        }
export type IdealCustomerProfilePageQueryHookResult = ReturnType<typeof useIdealCustomerProfilePageQuery>;
export type IdealCustomerProfilePageLazyQueryHookResult = ReturnType<typeof useIdealCustomerProfilePageLazyQuery>;
export type IdealCustomerProfilePageQueryResult = Apollo.QueryResult<IdealCustomerProfilePageQuery, IdealCustomerProfilePageQueryVariables>;
export const CompanyAudiencesDocument = gql`
    query CompanyAudiences {
  audiences: collections(type: Company) {
    edges {
      node {
        id
        name
        segments {
          id
          name
          collectionId
          search
          resultsCount
        }
      }
    }
  }
}
    `;

/**
 * __useCompanyAudiencesQuery__
 *
 * To run a query within a React component, call `useCompanyAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAudiencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyAudiencesQuery(baseOptions?: Apollo.QueryHookOptions<CompanyAudiencesQuery, CompanyAudiencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAudiencesQuery, CompanyAudiencesQueryVariables>(CompanyAudiencesDocument, options);
      }
export function useCompanyAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAudiencesQuery, CompanyAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAudiencesQuery, CompanyAudiencesQueryVariables>(CompanyAudiencesDocument, options);
        }
export type CompanyAudiencesQueryHookResult = ReturnType<typeof useCompanyAudiencesQuery>;
export type CompanyAudiencesLazyQueryHookResult = ReturnType<typeof useCompanyAudiencesLazyQuery>;
export type CompanyAudiencesQueryResult = Apollo.QueryResult<CompanyAudiencesQuery, CompanyAudiencesQueryVariables>;
export const ImpersonationWarningDocument = gql`
    query ImpersonationWarning {
  viewer {
    id
    user {
      email
    }
    accountId
    isImpersonating
  }
}
    `;

/**
 * __useImpersonationWarningQuery__
 *
 * To run a query within a React component, call `useImpersonationWarningQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpersonationWarningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpersonationWarningQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpersonationWarningQuery(baseOptions?: Apollo.QueryHookOptions<ImpersonationWarningQuery, ImpersonationWarningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpersonationWarningQuery, ImpersonationWarningQueryVariables>(ImpersonationWarningDocument, options);
      }
export function useImpersonationWarningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpersonationWarningQuery, ImpersonationWarningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpersonationWarningQuery, ImpersonationWarningQueryVariables>(ImpersonationWarningDocument, options);
        }
export type ImpersonationWarningQueryHookResult = ReturnType<typeof useImpersonationWarningQuery>;
export type ImpersonationWarningLazyQueryHookResult = ReturnType<typeof useImpersonationWarningLazyQuery>;
export type ImpersonationWarningQueryResult = Apollo.QueryResult<ImpersonationWarningQuery, ImpersonationWarningQueryVariables>;
export const OnboardingTargetMarketPreviewDocument = gql`
    query OnboardingTargetMarketPreview($businessModel: [String!]!, $country: [String!]!, $employees: [String!]!, $industry: [String!]!, $raised: [String!]!, $tag: [String!]!, $type: [String!]!, $tech: [String!]!) {
  targetMarketPreview(businessModel: $businessModel, country: $country, employees: $employees, industry: $industry, raised: $raised, tag: $tag, tech: $tech, type: $type) {
    size
  }
}
    `;

/**
 * __useOnboardingTargetMarketPreviewQuery__
 *
 * To run a query within a React component, call `useOnboardingTargetMarketPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingTargetMarketPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingTargetMarketPreviewQuery({
 *   variables: {
 *      businessModel: // value for 'businessModel'
 *      country: // value for 'country'
 *      employees: // value for 'employees'
 *      industry: // value for 'industry'
 *      raised: // value for 'raised'
 *      tag: // value for 'tag'
 *      type: // value for 'type'
 *      tech: // value for 'tech'
 *   },
 * });
 */
export function useOnboardingTargetMarketPreviewQuery(baseOptions: Apollo.QueryHookOptions<OnboardingTargetMarketPreviewQuery, OnboardingTargetMarketPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingTargetMarketPreviewQuery, OnboardingTargetMarketPreviewQueryVariables>(OnboardingTargetMarketPreviewDocument, options);
      }
export function useOnboardingTargetMarketPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingTargetMarketPreviewQuery, OnboardingTargetMarketPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingTargetMarketPreviewQuery, OnboardingTargetMarketPreviewQueryVariables>(OnboardingTargetMarketPreviewDocument, options);
        }
export type OnboardingTargetMarketPreviewQueryHookResult = ReturnType<typeof useOnboardingTargetMarketPreviewQuery>;
export type OnboardingTargetMarketPreviewLazyQueryHookResult = ReturnType<typeof useOnboardingTargetMarketPreviewLazyQuery>;
export type OnboardingTargetMarketPreviewQueryResult = Apollo.QueryResult<OnboardingTargetMarketPreviewQuery, OnboardingTargetMarketPreviewQueryVariables>;
export const CancelExportCsvSegmentDocument = gql`
    mutation CancelExportCsvSegment($input: SegmentsCancelExportCsvInput!) {
  response: cancelExportCsv(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type CancelExportCsvSegmentMutationFn = Apollo.MutationFunction<CancelExportCsvSegmentMutation, CancelExportCsvSegmentMutationVariables>;

/**
 * __useCancelExportCsvSegmentMutation__
 *
 * To run a mutation, you first call `useCancelExportCsvSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelExportCsvSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelExportCsvSegmentMutation, { data, loading, error }] = useCancelExportCsvSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelExportCsvSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelExportCsvSegmentMutation, CancelExportCsvSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelExportCsvSegmentMutation, CancelExportCsvSegmentMutationVariables>(CancelExportCsvSegmentDocument, options);
      }
export type CancelExportCsvSegmentMutationHookResult = ReturnType<typeof useCancelExportCsvSegmentMutation>;
export type CancelExportCsvSegmentMutationResult = Apollo.MutationResult<CancelExportCsvSegmentMutation>;
export type CancelExportCsvSegmentMutationOptions = Apollo.BaseMutationOptions<CancelExportCsvSegmentMutation, CancelExportCsvSegmentMutationVariables>;
export const CsvExportQueryDocument = gql`
    query CsvExportQuery($attributeType: AttributeTypeEnum!, $columnType: ColumnTypeEnum!, $segmentId: ID) {
  columns(type: $columnType, segmentId: $segmentId)
  attributes(type: $attributeType, categories: [enrichment, system, salesforce, traits, pageview_display, hubspot]) {
    value
    label
    category
    subCategory
    attributeType
  }
  viewer {
    id
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useCsvExportQueryQuery__
 *
 * To run a query within a React component, call `useCsvExportQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsvExportQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsvExportQueryQuery({
 *   variables: {
 *      attributeType: // value for 'attributeType'
 *      columnType: // value for 'columnType'
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useCsvExportQueryQuery(baseOptions: Apollo.QueryHookOptions<CsvExportQueryQuery, CsvExportQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsvExportQueryQuery, CsvExportQueryQueryVariables>(CsvExportQueryDocument, options);
      }
export function useCsvExportQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsvExportQueryQuery, CsvExportQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsvExportQueryQuery, CsvExportQueryQueryVariables>(CsvExportQueryDocument, options);
        }
export type CsvExportQueryQueryHookResult = ReturnType<typeof useCsvExportQueryQuery>;
export type CsvExportQueryLazyQueryHookResult = ReturnType<typeof useCsvExportQueryLazyQuery>;
export type CsvExportQueryQueryResult = Apollo.QueryResult<CsvExportQueryQuery, CsvExportQueryQueryVariables>;
export const ExportCsvSegmentDocument = gql`
    mutation ExportCsvSegment($input: SegmentsExportCsvInput!) {
  response: exportCsv(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type ExportCsvSegmentMutationFn = Apollo.MutationFunction<ExportCsvSegmentMutation, ExportCsvSegmentMutationVariables>;

/**
 * __useExportCsvSegmentMutation__
 *
 * To run a mutation, you first call `useExportCsvSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCsvSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCsvSegmentMutation, { data, loading, error }] = useExportCsvSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportCsvSegmentMutation(baseOptions?: Apollo.MutationHookOptions<ExportCsvSegmentMutation, ExportCsvSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCsvSegmentMutation, ExportCsvSegmentMutationVariables>(ExportCsvSegmentDocument, options);
      }
export type ExportCsvSegmentMutationHookResult = ReturnType<typeof useExportCsvSegmentMutation>;
export type ExportCsvSegmentMutationResult = Apollo.MutationResult<ExportCsvSegmentMutation>;
export type ExportCsvSegmentMutationOptions = Apollo.BaseMutationOptions<ExportCsvSegmentMutation, ExportCsvSegmentMutationVariables>;
export const ExistingSegmentExportDocument = gql`
    query ExistingSegmentExport($status: [ExportStatusEnum!]!, $segmentId: ID, $type: SegmentLegacyTypeEnum!) {
  segmentExport(segmentId: $segmentId, status: $status, type: $type) {
    status
    id
    filename
    createdAt
    userName
    expired
    downloadUrl
  }
}
    `;

/**
 * __useExistingSegmentExportQuery__
 *
 * To run a query within a React component, call `useExistingSegmentExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingSegmentExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingSegmentExportQuery({
 *   variables: {
 *      status: // value for 'status'
 *      segmentId: // value for 'segmentId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useExistingSegmentExportQuery(baseOptions: Apollo.QueryHookOptions<ExistingSegmentExportQuery, ExistingSegmentExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExistingSegmentExportQuery, ExistingSegmentExportQueryVariables>(ExistingSegmentExportDocument, options);
      }
export function useExistingSegmentExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistingSegmentExportQuery, ExistingSegmentExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExistingSegmentExportQuery, ExistingSegmentExportQueryVariables>(ExistingSegmentExportDocument, options);
        }
export type ExistingSegmentExportQueryHookResult = ReturnType<typeof useExistingSegmentExportQuery>;
export type ExistingSegmentExportLazyQueryHookResult = ReturnType<typeof useExistingSegmentExportLazyQuery>;
export type ExistingSegmentExportQueryResult = Apollo.QueryResult<ExistingSegmentExportQuery, ExistingSegmentExportQueryVariables>;
export const CloneSegmentDocument = gql`
    mutation CloneSegment($input: SegmentsCloneInput!) {
  response: cloneSegment(input: $input) {
    errors {
      field
      messages
    }
    node {
      ... on Segment {
        id
        collectionId
        name
        search
        type
      }
      ...SegmentLayout
    }
  }
}
    ${SegmentLayoutFragmentDoc}`;
export type CloneSegmentMutationFn = Apollo.MutationFunction<CloneSegmentMutation, CloneSegmentMutationVariables>;

/**
 * __useCloneSegmentMutation__
 *
 * To run a mutation, you first call `useCloneSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneSegmentMutation, { data, loading, error }] = useCloneSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CloneSegmentMutation, CloneSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneSegmentMutation, CloneSegmentMutationVariables>(CloneSegmentDocument, options);
      }
export type CloneSegmentMutationHookResult = ReturnType<typeof useCloneSegmentMutation>;
export type CloneSegmentMutationResult = Apollo.MutationResult<CloneSegmentMutation>;
export type CloneSegmentMutationOptions = Apollo.BaseMutationOptions<CloneSegmentMutation, CloneSegmentMutationVariables>;
export const DestroySegmentDocument = gql`
    mutation DestroySegment($input: SegmentsDestroyInput!) {
  response: destroySegment(input: $input) {
    clientMutationId
  }
}
    `;
export type DestroySegmentMutationFn = Apollo.MutationFunction<DestroySegmentMutation, DestroySegmentMutationVariables>;

/**
 * __useDestroySegmentMutation__
 *
 * To run a mutation, you first call `useDestroySegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroySegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroySegmentMutation, { data, loading, error }] = useDestroySegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroySegmentMutation(baseOptions?: Apollo.MutationHookOptions<DestroySegmentMutation, DestroySegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroySegmentMutation, DestroySegmentMutationVariables>(DestroySegmentDocument, options);
      }
export type DestroySegmentMutationHookResult = ReturnType<typeof useDestroySegmentMutation>;
export type DestroySegmentMutationResult = Apollo.MutationResult<DestroySegmentMutation>;
export type DestroySegmentMutationOptions = Apollo.BaseMutationOptions<DestroySegmentMutation, DestroySegmentMutationVariables>;
export const SegmentActionsDeleteDocument = gql`
    query SegmentActionsDelete($segmentId: ID!, $segmentType: SegmentTypeEnum!) {
  segment(id: $segmentId, type: $segmentType) {
    id
    destinations {
      id
      type
      description
    }
  }
}
    `;

/**
 * __useSegmentActionsDeleteQuery__
 *
 * To run a query within a React component, call `useSegmentActionsDeleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentActionsDeleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentActionsDeleteQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *      segmentType: // value for 'segmentType'
 *   },
 * });
 */
export function useSegmentActionsDeleteQuery(baseOptions: Apollo.QueryHookOptions<SegmentActionsDeleteQuery, SegmentActionsDeleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentActionsDeleteQuery, SegmentActionsDeleteQueryVariables>(SegmentActionsDeleteDocument, options);
      }
export function useSegmentActionsDeleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentActionsDeleteQuery, SegmentActionsDeleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentActionsDeleteQuery, SegmentActionsDeleteQueryVariables>(SegmentActionsDeleteDocument, options);
        }
export type SegmentActionsDeleteQueryHookResult = ReturnType<typeof useSegmentActionsDeleteQuery>;
export type SegmentActionsDeleteLazyQueryHookResult = ReturnType<typeof useSegmentActionsDeleteLazyQuery>;
export type SegmentActionsDeleteQueryResult = Apollo.QueryResult<SegmentActionsDeleteQuery, SegmentActionsDeleteQueryVariables>;
export const UsageActionAllowedDocument = gql`
    query usageActionAllowed($credits: Int!) {
  usageActionAllowed(credits: $credits)
}
    `;

/**
 * __useUsageActionAllowedQuery__
 *
 * To run a query within a React component, call `useUsageActionAllowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageActionAllowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageActionAllowedQuery({
 *   variables: {
 *      credits: // value for 'credits'
 *   },
 * });
 */
export function useUsageActionAllowedQuery(baseOptions: Apollo.QueryHookOptions<UsageActionAllowedQuery, UsageActionAllowedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsageActionAllowedQuery, UsageActionAllowedQueryVariables>(UsageActionAllowedDocument, options);
      }
export function useUsageActionAllowedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsageActionAllowedQuery, UsageActionAllowedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsageActionAllowedQuery, UsageActionAllowedQueryVariables>(UsageActionAllowedDocument, options);
        }
export type UsageActionAllowedQueryHookResult = ReturnType<typeof useUsageActionAllowedQuery>;
export type UsageActionAllowedLazyQueryHookResult = ReturnType<typeof useUsageActionAllowedLazyQuery>;
export type UsageActionAllowedQueryResult = Apollo.QueryResult<UsageActionAllowedQuery, UsageActionAllowedQueryVariables>;
export const CreateCollectionDocument = gql`
    mutation CreateCollection($input: CollectionsCreateInput!) {
  response: createCollection(input: $input) {
    clientMutationId
  }
}
    `;
export type CreateCollectionMutationFn = Apollo.MutationFunction<CreateCollectionMutation, CreateCollectionMutationVariables>;

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollectionMutation, CreateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollectionMutation, CreateCollectionMutationVariables>(CreateCollectionDocument, options);
      }
export type CreateCollectionMutationHookResult = ReturnType<typeof useCreateCollectionMutation>;
export type CreateCollectionMutationResult = Apollo.MutationResult<CreateCollectionMutation>;
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<CreateCollectionMutation, CreateCollectionMutationVariables>;
export const UpdateCollectionDocument = gql`
    mutation UpdateCollection($input: CollectionsUpdateInput!) {
  response: updateCollection(input: $input) {
    node {
      id
      name
    }
  }
}
    `;
export type UpdateCollectionMutationFn = Apollo.MutationFunction<UpdateCollectionMutation, UpdateCollectionMutationVariables>;

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionMutation, UpdateCollectionMutationVariables>(UpdateCollectionDocument, options);
      }
export type UpdateCollectionMutationHookResult = ReturnType<typeof useUpdateCollectionMutation>;
export type UpdateCollectionMutationResult = Apollo.MutationResult<UpdateCollectionMutation>;
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>;
export const DestroyCollectionDocument = gql`
    mutation DestroyCollection($input: CollectionsDestroyInput!) {
  response: destroyCollection(input: $input) {
    clientMutationId
  }
}
    `;
export type DestroyCollectionMutationFn = Apollo.MutationFunction<DestroyCollectionMutation, DestroyCollectionMutationVariables>;

/**
 * __useDestroyCollectionMutation__
 *
 * To run a mutation, you first call `useDestroyCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyCollectionMutation, { data, loading, error }] = useDestroyCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DestroyCollectionMutation, DestroyCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyCollectionMutation, DestroyCollectionMutationVariables>(DestroyCollectionDocument, options);
      }
export type DestroyCollectionMutationHookResult = ReturnType<typeof useDestroyCollectionMutation>;
export type DestroyCollectionMutationResult = Apollo.MutationResult<DestroyCollectionMutation>;
export type DestroyCollectionMutationOptions = Apollo.BaseMutationOptions<DestroyCollectionMutation, DestroyCollectionMutationVariables>;
export const SegmentsMenuDocument = gql`
    query SegmentsMenu($collectionType: CollectionLegacyTypeEnum!, $segmentType: SegmentLegacyTypeEnum!) {
  segments(type: $segmentType) {
    edges {
      node {
        ... on Segment {
          id
          collectionId
          enabledDestinationsCount
          searchDependencyErrors
          name
          resultsCount
          type
          ...SegmentDestinationsPreloadCount
        }
      }
    }
  }
  companies {
    totalCount
  }
  people {
    totalCount
  }
  collections(type: $collectionType) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    ${SegmentDestinationsPreloadCountFragmentDoc}`;

/**
 * __useSegmentsMenuQuery__
 *
 * To run a query within a React component, call `useSegmentsMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsMenuQuery({
 *   variables: {
 *      collectionType: // value for 'collectionType'
 *      segmentType: // value for 'segmentType'
 *   },
 * });
 */
export function useSegmentsMenuQuery(baseOptions: Apollo.QueryHookOptions<SegmentsMenuQuery, SegmentsMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentsMenuQuery, SegmentsMenuQueryVariables>(SegmentsMenuDocument, options);
      }
export function useSegmentsMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentsMenuQuery, SegmentsMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentsMenuQuery, SegmentsMenuQueryVariables>(SegmentsMenuDocument, options);
        }
export type SegmentsMenuQueryHookResult = ReturnType<typeof useSegmentsMenuQuery>;
export type SegmentsMenuLazyQueryHookResult = ReturnType<typeof useSegmentsMenuLazyQuery>;
export type SegmentsMenuQueryResult = Apollo.QueryResult<SegmentsMenuQuery, SegmentsMenuQueryVariables>;
export const CompanyActivityEventsDocument = gql`
    query CompanyActivityEvents($id: ID!, $type: EventTypeEnum, $path: String, $excludingAnonymous: Boolean, $first: Int!, $after: String) {
  company(id: $id) {
    id
    events(first: $first, type: $type, path: $path, excludingAnonymous: $excludingAnonymous, after: $after) {
      edges {
        node {
          id
          context
          person {
            id
            name
            avatar
          }
          properties
          timestamp
          type
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useCompanyActivityEventsQuery__
 *
 * To run a query within a React component, call `useCompanyActivityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyActivityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyActivityEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      path: // value for 'path'
 *      excludingAnonymous: // value for 'excludingAnonymous'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCompanyActivityEventsQuery(baseOptions: Apollo.QueryHookOptions<CompanyActivityEventsQuery, CompanyActivityEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyActivityEventsQuery, CompanyActivityEventsQueryVariables>(CompanyActivityEventsDocument, options);
      }
export function useCompanyActivityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyActivityEventsQuery, CompanyActivityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyActivityEventsQuery, CompanyActivityEventsQueryVariables>(CompanyActivityEventsDocument, options);
        }
export type CompanyActivityEventsQueryHookResult = ReturnType<typeof useCompanyActivityEventsQuery>;
export type CompanyActivityEventsLazyQueryHookResult = ReturnType<typeof useCompanyActivityEventsLazyQuery>;
export type CompanyActivityEventsQueryResult = Apollo.QueryResult<CompanyActivityEventsQuery, CompanyActivityEventsQueryVariables>;
export const PersonActivityEventsDocument = gql`
    query PersonActivityEvents($id: ID!, $type: EventTypeEnum, $path: String, $first: Int!, $after: String) {
  person(id: $id) {
    id
    events(type: $type, path: $path, first: $first, after: $after) {
      edges {
        node {
          id
          context
          person {
            id
            name
            avatar
          }
          properties
          timestamp
          type
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __usePersonActivityEventsQuery__
 *
 * To run a query within a React component, call `usePersonActivityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonActivityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonActivityEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      path: // value for 'path'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePersonActivityEventsQuery(baseOptions: Apollo.QueryHookOptions<PersonActivityEventsQuery, PersonActivityEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonActivityEventsQuery, PersonActivityEventsQueryVariables>(PersonActivityEventsDocument, options);
      }
export function usePersonActivityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonActivityEventsQuery, PersonActivityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonActivityEventsQuery, PersonActivityEventsQueryVariables>(PersonActivityEventsDocument, options);
        }
export type PersonActivityEventsQueryHookResult = ReturnType<typeof usePersonActivityEventsQuery>;
export type PersonActivityEventsLazyQueryHookResult = ReturnType<typeof usePersonActivityEventsLazyQuery>;
export type PersonActivityEventsQueryResult = Apollo.QueryResult<PersonActivityEventsQuery, PersonActivityEventsQueryVariables>;
export const EventTypesDocument = gql`
    query EventTypes {
  eventTypes
}
    `;

/**
 * __useEventTypesQuery__
 *
 * To run a query within a React component, call `useEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<EventTypesQuery, EventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventTypesQuery, EventTypesQueryVariables>(EventTypesDocument, options);
      }
export function useEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventTypesQuery, EventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventTypesQuery, EventTypesQueryVariables>(EventTypesDocument, options);
        }
export type EventTypesQueryHookResult = ReturnType<typeof useEventTypesQuery>;
export type EventTypesLazyQueryHookResult = ReturnType<typeof useEventTypesLazyQuery>;
export type EventTypesQueryResult = Apollo.QueryResult<EventTypesQuery, EventTypesQueryVariables>;
export const CreateTargetMarketDocument = gql`
    mutation CreateTargetMarket($input: TargetMarketsCreateInput!) {
  createTargetMarket(input: $input) {
    node {
      id
      name
      search
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateTargetMarketMutationFn = Apollo.MutationFunction<CreateTargetMarketMutation, CreateTargetMarketMutationVariables>;

/**
 * __useCreateTargetMarketMutation__
 *
 * To run a mutation, you first call `useCreateTargetMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTargetMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTargetMarketMutation, { data, loading, error }] = useCreateTargetMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTargetMarketMutation(baseOptions?: Apollo.MutationHookOptions<CreateTargetMarketMutation, CreateTargetMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTargetMarketMutation, CreateTargetMarketMutationVariables>(CreateTargetMarketDocument, options);
      }
export type CreateTargetMarketMutationHookResult = ReturnType<typeof useCreateTargetMarketMutation>;
export type CreateTargetMarketMutationResult = Apollo.MutationResult<CreateTargetMarketMutation>;
export type CreateTargetMarketMutationOptions = Apollo.BaseMutationOptions<CreateTargetMarketMutation, CreateTargetMarketMutationVariables>;
export const DestroyTargetMarketDocument = gql`
    mutation DestroyTargetMarket($input: TargetMarketsDestroyInput!) {
  destroyTargetMarket(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DestroyTargetMarketMutationFn = Apollo.MutationFunction<DestroyTargetMarketMutation, DestroyTargetMarketMutationVariables>;

/**
 * __useDestroyTargetMarketMutation__
 *
 * To run a mutation, you first call `useDestroyTargetMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyTargetMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyTargetMarketMutation, { data, loading, error }] = useDestroyTargetMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyTargetMarketMutation(baseOptions?: Apollo.MutationHookOptions<DestroyTargetMarketMutation, DestroyTargetMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyTargetMarketMutation, DestroyTargetMarketMutationVariables>(DestroyTargetMarketDocument, options);
      }
export type DestroyTargetMarketMutationHookResult = ReturnType<typeof useDestroyTargetMarketMutation>;
export type DestroyTargetMarketMutationResult = Apollo.MutationResult<DestroyTargetMarketMutation>;
export type DestroyTargetMarketMutationOptions = Apollo.BaseMutationOptions<DestroyTargetMarketMutation, DestroyTargetMarketMutationVariables>;
export const TargetMarketCompaniesDocument = gql`
    query TargetMarketCompanies($country: [String!]!, $description: [String!]!, $employees: [String!]!, $industry: [String!]!, $raised: [String!]!, $tag: [String!]!, $tech: [String!]!, $type: [String!]!, $page: Int) {
  targetMarketCompanies(country: $country, description: $description, employees: $employees, industry: $industry, raised: $raised, tag: $tag, tech: $tech, type: $type, page: $page)
}
    `;

/**
 * __useTargetMarketCompaniesQuery__
 *
 * To run a query within a React component, call `useTargetMarketCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetMarketCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetMarketCompaniesQuery({
 *   variables: {
 *      country: // value for 'country'
 *      description: // value for 'description'
 *      employees: // value for 'employees'
 *      industry: // value for 'industry'
 *      raised: // value for 'raised'
 *      tag: // value for 'tag'
 *      tech: // value for 'tech'
 *      type: // value for 'type'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTargetMarketCompaniesQuery(baseOptions: Apollo.QueryHookOptions<TargetMarketCompaniesQuery, TargetMarketCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetMarketCompaniesQuery, TargetMarketCompaniesQueryVariables>(TargetMarketCompaniesDocument, options);
      }
export function useTargetMarketCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetMarketCompaniesQuery, TargetMarketCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetMarketCompaniesQuery, TargetMarketCompaniesQueryVariables>(TargetMarketCompaniesDocument, options);
        }
export type TargetMarketCompaniesQueryHookResult = ReturnType<typeof useTargetMarketCompaniesQuery>;
export type TargetMarketCompaniesLazyQueryHookResult = ReturnType<typeof useTargetMarketCompaniesLazyQuery>;
export type TargetMarketCompaniesQueryResult = Apollo.QueryResult<TargetMarketCompaniesQuery, TargetMarketCompaniesQueryVariables>;
export const TargetMarketsDocument = gql`
    query TargetMarkets {
  targetMarkets
}
    `;

/**
 * __useTargetMarketsQuery__
 *
 * To run a query within a React component, call `useTargetMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetMarketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTargetMarketsQuery(baseOptions?: Apollo.QueryHookOptions<TargetMarketsQuery, TargetMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetMarketsQuery, TargetMarketsQueryVariables>(TargetMarketsDocument, options);
      }
export function useTargetMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetMarketsQuery, TargetMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetMarketsQuery, TargetMarketsQueryVariables>(TargetMarketsDocument, options);
        }
export type TargetMarketsQueryHookResult = ReturnType<typeof useTargetMarketsQuery>;
export type TargetMarketsLazyQueryHookResult = ReturnType<typeof useTargetMarketsLazyQuery>;
export type TargetMarketsQueryResult = Apollo.QueryResult<TargetMarketsQuery, TargetMarketsQueryVariables>;
export const UpdateTargetMarketDocument = gql`
    mutation UpdateTargetMarket($input: TargetMarketsUpdateInput!) {
  updateTargetMarket(input: $input) {
    node {
      id
      name
      search
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateTargetMarketMutationFn = Apollo.MutationFunction<UpdateTargetMarketMutation, UpdateTargetMarketMutationVariables>;

/**
 * __useUpdateTargetMarketMutation__
 *
 * To run a mutation, you first call `useUpdateTargetMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTargetMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTargetMarketMutation, { data, loading, error }] = useUpdateTargetMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTargetMarketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTargetMarketMutation, UpdateTargetMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTargetMarketMutation, UpdateTargetMarketMutationVariables>(UpdateTargetMarketDocument, options);
      }
export type UpdateTargetMarketMutationHookResult = ReturnType<typeof useUpdateTargetMarketMutation>;
export type UpdateTargetMarketMutationResult = Apollo.MutationResult<UpdateTargetMarketMutation>;
export type UpdateTargetMarketMutationOptions = Apollo.BaseMutationOptions<UpdateTargetMarketMutation, UpdateTargetMarketMutationVariables>;
export const UserMenuDocument = gql`
    query UserMenu {
  account {
    id
    domain
  }
  viewer {
    id
    user {
      id
      ...AccountSwitch
    }
  }
}
    ${AccountSwitchFragmentDoc}`;

/**
 * __useUserMenuQuery__
 *
 * To run a query within a React component, call `useUserMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMenuQuery(baseOptions?: Apollo.QueryHookOptions<UserMenuQuery, UserMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMenuQuery, UserMenuQueryVariables>(UserMenuDocument, options);
      }
export function useUserMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMenuQuery, UserMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMenuQuery, UserMenuQueryVariables>(UserMenuDocument, options);
        }
export type UserMenuQueryHookResult = ReturnType<typeof useUserMenuQuery>;
export type UserMenuLazyQueryHookResult = ReturnType<typeof useUserMenuLazyQuery>;
export type UserMenuQueryResult = Apollo.QueryResult<UserMenuQuery, UserMenuQueryVariables>;
export const ApiChartUsageDocument = gql`
    query ApiChartUsage {
  apiUsage {
    data
    total
    active
    billingPeriodCounts
  }
}
    `;

/**
 * __useApiChartUsageQuery__
 *
 * To run a query within a React component, call `useApiChartUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiChartUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiChartUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiChartUsageQuery(baseOptions?: Apollo.QueryHookOptions<ApiChartUsageQuery, ApiChartUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiChartUsageQuery, ApiChartUsageQueryVariables>(ApiChartUsageDocument, options);
      }
export function useApiChartUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiChartUsageQuery, ApiChartUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiChartUsageQuery, ApiChartUsageQueryVariables>(ApiChartUsageDocument, options);
        }
export type ApiChartUsageQueryHookResult = ReturnType<typeof useApiChartUsageQuery>;
export type ApiChartUsageLazyQueryHookResult = ReturnType<typeof useApiChartUsageLazyQuery>;
export type ApiChartUsageQueryResult = Apollo.QueryResult<ApiChartUsageQuery, ApiChartUsageQueryVariables>;
export const CancelDowngradeAccountSubscriptionDocument = gql`
    mutation CancelDowngradeAccountSubscription($input: AccountCancelDowngradeSubscriptionInput!) {
  cancelDowngradeAccountSubscription(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type CancelDowngradeAccountSubscriptionMutationFn = Apollo.MutationFunction<CancelDowngradeAccountSubscriptionMutation, CancelDowngradeAccountSubscriptionMutationVariables>;

/**
 * __useCancelDowngradeAccountSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelDowngradeAccountSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDowngradeAccountSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDowngradeAccountSubscriptionMutation, { data, loading, error }] = useCancelDowngradeAccountSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelDowngradeAccountSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelDowngradeAccountSubscriptionMutation, CancelDowngradeAccountSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDowngradeAccountSubscriptionMutation, CancelDowngradeAccountSubscriptionMutationVariables>(CancelDowngradeAccountSubscriptionDocument, options);
      }
export type CancelDowngradeAccountSubscriptionMutationHookResult = ReturnType<typeof useCancelDowngradeAccountSubscriptionMutation>;
export type CancelDowngradeAccountSubscriptionMutationResult = Apollo.MutationResult<CancelDowngradeAccountSubscriptionMutation>;
export type CancelDowngradeAccountSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelDowngradeAccountSubscriptionMutation, CancelDowngradeAccountSubscriptionMutationVariables>;
export const CreateAccountSubscriptionDocument = gql`
    mutation CreateAccountSubscription($input: AccountCreateSubscriptionInput!) {
  createAccountSubscription(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateAccountSubscriptionMutationFn = Apollo.MutationFunction<CreateAccountSubscriptionMutation, CreateAccountSubscriptionMutationVariables>;

/**
 * __useCreateAccountSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateAccountSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountSubscriptionMutation, { data, loading, error }] = useCreateAccountSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountSubscriptionMutation, CreateAccountSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountSubscriptionMutation, CreateAccountSubscriptionMutationVariables>(CreateAccountSubscriptionDocument, options);
      }
export type CreateAccountSubscriptionMutationHookResult = ReturnType<typeof useCreateAccountSubscriptionMutation>;
export type CreateAccountSubscriptionMutationResult = Apollo.MutationResult<CreateAccountSubscriptionMutation>;
export type CreateAccountSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateAccountSubscriptionMutation, CreateAccountSubscriptionMutationVariables>;
export const DowngradeAccountSubscriptionDocument = gql`
    mutation DowngradeAccountSubscription($input: AccountDowngradeSubscriptionInput!) {
  downgradeAccountSubscription(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DowngradeAccountSubscriptionMutationFn = Apollo.MutationFunction<DowngradeAccountSubscriptionMutation, DowngradeAccountSubscriptionMutationVariables>;

/**
 * __useDowngradeAccountSubscriptionMutation__
 *
 * To run a mutation, you first call `useDowngradeAccountSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDowngradeAccountSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downgradeAccountSubscriptionMutation, { data, loading, error }] = useDowngradeAccountSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDowngradeAccountSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DowngradeAccountSubscriptionMutation, DowngradeAccountSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DowngradeAccountSubscriptionMutation, DowngradeAccountSubscriptionMutationVariables>(DowngradeAccountSubscriptionDocument, options);
      }
export type DowngradeAccountSubscriptionMutationHookResult = ReturnType<typeof useDowngradeAccountSubscriptionMutation>;
export type DowngradeAccountSubscriptionMutationResult = Apollo.MutationResult<DowngradeAccountSubscriptionMutation>;
export type DowngradeAccountSubscriptionMutationOptions = Apollo.BaseMutationOptions<DowngradeAccountSubscriptionMutation, DowngradeAccountSubscriptionMutationVariables>;
export const AccountSettingsDocument = gql`
    query AccountSettings {
  account {
    id
    name
    publishableToken
    secretToken
    webhookUrl
    mfaEnforced
    remoteAllowedReferrers
    apiVersions {
      person {
        current
        latest
      }
      company {
        current
        latest
      }
      prospector {
        current
        latest
      }
      watchlist {
        current
        latest
      }
      risk {
        current
        latest
      }
      reveal {
        current
        latest
      }
    }
    suppressionSettings {
      person
      prospector
    }
  }
}
    `;

/**
 * __useAccountSettingsQuery__
 *
 * To run a query within a React component, call `useAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(AccountSettingsDocument, options);
      }
export function useAccountSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(AccountSettingsDocument, options);
        }
export type AccountSettingsQueryHookResult = ReturnType<typeof useAccountSettingsQuery>;
export type AccountSettingsLazyQueryHookResult = ReturnType<typeof useAccountSettingsLazyQuery>;
export type AccountSettingsQueryResult = Apollo.QueryResult<AccountSettingsQuery, AccountSettingsQueryVariables>;
export const AccountUpdateApiVersionDocument = gql`
    mutation AccountUpdateApiVersion($input: AccountUpdateApiVersionInput!) {
  updateAccountApiVersion(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AccountUpdateApiVersionMutationFn = Apollo.MutationFunction<AccountUpdateApiVersionMutation, AccountUpdateApiVersionMutationVariables>;

/**
 * __useAccountUpdateApiVersionMutation__
 *
 * To run a mutation, you first call `useAccountUpdateApiVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateApiVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateApiVersionMutation, { data, loading, error }] = useAccountUpdateApiVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpdateApiVersionMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateApiVersionMutation, AccountUpdateApiVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateApiVersionMutation, AccountUpdateApiVersionMutationVariables>(AccountUpdateApiVersionDocument, options);
      }
export type AccountUpdateApiVersionMutationHookResult = ReturnType<typeof useAccountUpdateApiVersionMutation>;
export type AccountUpdateApiVersionMutationResult = Apollo.MutationResult<AccountUpdateApiVersionMutation>;
export type AccountUpdateApiVersionMutationOptions = Apollo.BaseMutationOptions<AccountUpdateApiVersionMutation, AccountUpdateApiVersionMutationVariables>;
export const AccountUpdateBillingInfoDocument = gql`
    mutation AccountUpdateBillingInfo($input: AccountUpdateBillingInfoInput!) {
  updateAccountBillingInfo(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AccountUpdateBillingInfoMutationFn = Apollo.MutationFunction<AccountUpdateBillingInfoMutation, AccountUpdateBillingInfoMutationVariables>;

/**
 * __useAccountUpdateBillingInfoMutation__
 *
 * To run a mutation, you first call `useAccountUpdateBillingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateBillingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateBillingInfoMutation, { data, loading, error }] = useAccountUpdateBillingInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpdateBillingInfoMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateBillingInfoMutation, AccountUpdateBillingInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateBillingInfoMutation, AccountUpdateBillingInfoMutationVariables>(AccountUpdateBillingInfoDocument, options);
      }
export type AccountUpdateBillingInfoMutationHookResult = ReturnType<typeof useAccountUpdateBillingInfoMutation>;
export type AccountUpdateBillingInfoMutationResult = Apollo.MutationResult<AccountUpdateBillingInfoMutation>;
export type AccountUpdateBillingInfoMutationOptions = Apollo.BaseMutationOptions<AccountUpdateBillingInfoMutation, AccountUpdateBillingInfoMutationVariables>;
export const AccountUpdateDetailsDocument = gql`
    mutation AccountUpdateDetails($input: AccountUpdateDetailsInput!) {
  updateAccountDetails(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AccountUpdateDetailsMutationFn = Apollo.MutationFunction<AccountUpdateDetailsMutation, AccountUpdateDetailsMutationVariables>;

/**
 * __useAccountUpdateDetailsMutation__
 *
 * To run a mutation, you first call `useAccountUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateDetailsMutation, { data, loading, error }] = useAccountUpdateDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpdateDetailsMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateDetailsMutation, AccountUpdateDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateDetailsMutation, AccountUpdateDetailsMutationVariables>(AccountUpdateDetailsDocument, options);
      }
export type AccountUpdateDetailsMutationHookResult = ReturnType<typeof useAccountUpdateDetailsMutation>;
export type AccountUpdateDetailsMutationResult = Apollo.MutationResult<AccountUpdateDetailsMutation>;
export type AccountUpdateDetailsMutationOptions = Apollo.BaseMutationOptions<AccountUpdateDetailsMutation, AccountUpdateDetailsMutationVariables>;
export const AccountUpdateSettingsDocument = gql`
    mutation AccountUpdateSettings($input: AccountUpdateSettingsInput!) {
  updateAccountSettings(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AccountUpdateSettingsMutationFn = Apollo.MutationFunction<AccountUpdateSettingsMutation, AccountUpdateSettingsMutationVariables>;

/**
 * __useAccountUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useAccountUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateSettingsMutation, { data, loading, error }] = useAccountUpdateSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateSettingsMutation, AccountUpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateSettingsMutation, AccountUpdateSettingsMutationVariables>(AccountUpdateSettingsDocument, options);
      }
export type AccountUpdateSettingsMutationHookResult = ReturnType<typeof useAccountUpdateSettingsMutation>;
export type AccountUpdateSettingsMutationResult = Apollo.MutationResult<AccountUpdateSettingsMutation>;
export type AccountUpdateSettingsMutationOptions = Apollo.BaseMutationOptions<AccountUpdateSettingsMutation, AccountUpdateSettingsMutationVariables>;
export const UpdateAccountSubscriptionDocument = gql`
    mutation UpdateAccountSubscription($input: AccountUpdateSubscriptionInput!) {
  updateAccountSubscription(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateAccountSubscriptionMutationFn = Apollo.MutationFunction<UpdateAccountSubscriptionMutation, UpdateAccountSubscriptionMutationVariables>;

/**
 * __useUpdateAccountSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateAccountSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountSubscriptionMutation, { data, loading, error }] = useUpdateAccountSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountSubscriptionMutation, UpdateAccountSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountSubscriptionMutation, UpdateAccountSubscriptionMutationVariables>(UpdateAccountSubscriptionDocument, options);
      }
export type UpdateAccountSubscriptionMutationHookResult = ReturnType<typeof useUpdateAccountSubscriptionMutation>;
export type UpdateAccountSubscriptionMutationResult = Apollo.MutationResult<UpdateAccountSubscriptionMutation>;
export type UpdateAccountSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateAccountSubscriptionMutation, UpdateAccountSubscriptionMutationVariables>;
export const AccountUpdateSuppressionSettingsDocument = gql`
    mutation AccountUpdateSuppressionSettings($input: AccountUpdateSuppressionSettingsInput!) {
  updateAccountSuppressionSettings(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AccountUpdateSuppressionSettingsMutationFn = Apollo.MutationFunction<AccountUpdateSuppressionSettingsMutation, AccountUpdateSuppressionSettingsMutationVariables>;

/**
 * __useAccountUpdateSuppressionSettingsMutation__
 *
 * To run a mutation, you first call `useAccountUpdateSuppressionSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateSuppressionSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateSuppressionSettingsMutation, { data, loading, error }] = useAccountUpdateSuppressionSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpdateSuppressionSettingsMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateSuppressionSettingsMutation, AccountUpdateSuppressionSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateSuppressionSettingsMutation, AccountUpdateSuppressionSettingsMutationVariables>(AccountUpdateSuppressionSettingsDocument, options);
      }
export type AccountUpdateSuppressionSettingsMutationHookResult = ReturnType<typeof useAccountUpdateSuppressionSettingsMutation>;
export type AccountUpdateSuppressionSettingsMutationResult = Apollo.MutationResult<AccountUpdateSuppressionSettingsMutation>;
export type AccountUpdateSuppressionSettingsMutationOptions = Apollo.BaseMutationOptions<AccountUpdateSuppressionSettingsMutation, AccountUpdateSuppressionSettingsMutationVariables>;
export const UpgradeAccountPlanDocument = gql`
    mutation UpgradeAccountPlan($input: AccountUpgradePlanInput!) {
  upgradeAccountPlan(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UpgradeAccountPlanMutationFn = Apollo.MutationFunction<UpgradeAccountPlanMutation, UpgradeAccountPlanMutationVariables>;

/**
 * __useUpgradeAccountPlanMutation__
 *
 * To run a mutation, you first call `useUpgradeAccountPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeAccountPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeAccountPlanMutation, { data, loading, error }] = useUpgradeAccountPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpgradeAccountPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeAccountPlanMutation, UpgradeAccountPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeAccountPlanMutation, UpgradeAccountPlanMutationVariables>(UpgradeAccountPlanDocument, options);
      }
export type UpgradeAccountPlanMutationHookResult = ReturnType<typeof useUpgradeAccountPlanMutation>;
export type UpgradeAccountPlanMutationResult = Apollo.MutationResult<UpgradeAccountPlanMutation>;
export type UpgradeAccountPlanMutationOptions = Apollo.BaseMutationOptions<UpgradeAccountPlanMutation, UpgradeAccountPlanMutationVariables>;
export const BatchAuthDocument = gql`
    query BatchAuth {
  account {
    secretToken
  }
}
    `;

/**
 * __useBatchAuthQuery__
 *
 * To run a query within a React component, call `useBatchAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useBatchAuthQuery(baseOptions?: Apollo.QueryHookOptions<BatchAuthQuery, BatchAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BatchAuthQuery, BatchAuthQueryVariables>(BatchAuthDocument, options);
      }
export function useBatchAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BatchAuthQuery, BatchAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BatchAuthQuery, BatchAuthQueryVariables>(BatchAuthDocument, options);
        }
export type BatchAuthQueryHookResult = ReturnType<typeof useBatchAuthQuery>;
export type BatchAuthLazyQueryHookResult = ReturnType<typeof useBatchAuthLazyQuery>;
export type BatchAuthQueryResult = Apollo.QueryResult<BatchAuthQuery, BatchAuthQueryVariables>;
export const AccountBillingInfoDocument = gql`
    query AccountBillingInfo {
  accountBillingInfo {
    billingName
    billingEmail
    address
    invoices {
      id
      startAt
      endAt
      amount
    }
    showAutomaticBillingMessage
    cardType
    cardLastFour
    nextStripeInvoiceAmount
    nextInvoiceAt
    billingTerm
  }
}
    `;

/**
 * __useAccountBillingInfoQuery__
 *
 * To run a query within a React component, call `useAccountBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBillingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountBillingInfoQuery(baseOptions?: Apollo.QueryHookOptions<AccountBillingInfoQuery, AccountBillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountBillingInfoQuery, AccountBillingInfoQueryVariables>(AccountBillingInfoDocument, options);
      }
export function useAccountBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountBillingInfoQuery, AccountBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountBillingInfoQuery, AccountBillingInfoQueryVariables>(AccountBillingInfoDocument, options);
        }
export type AccountBillingInfoQueryHookResult = ReturnType<typeof useAccountBillingInfoQuery>;
export type AccountBillingInfoLazyQueryHookResult = ReturnType<typeof useAccountBillingInfoLazyQuery>;
export type AccountBillingInfoQueryResult = Apollo.QueryResult<AccountBillingInfoQuery, AccountBillingInfoQueryVariables>;
export const AddAllowedSiteDocument = gql`
    mutation AddAllowedSite($input: FormsAddAllowedSiteInput!) {
  response: formsAddAllowedSite(input: $input) {
    node {
      ...SiteConfigurationFields
    }
    errors {
      field
      messages
    }
  }
}
    ${SiteConfigurationFieldsFragmentDoc}`;
export type AddAllowedSiteMutationFn = Apollo.MutationFunction<AddAllowedSiteMutation, AddAllowedSiteMutationVariables>;

/**
 * __useAddAllowedSiteMutation__
 *
 * To run a mutation, you first call `useAddAllowedSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAllowedSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAllowedSiteMutation, { data, loading, error }] = useAddAllowedSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAllowedSiteMutation(baseOptions?: Apollo.MutationHookOptions<AddAllowedSiteMutation, AddAllowedSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAllowedSiteMutation, AddAllowedSiteMutationVariables>(AddAllowedSiteDocument, options);
      }
export type AddAllowedSiteMutationHookResult = ReturnType<typeof useAddAllowedSiteMutation>;
export type AddAllowedSiteMutationResult = Apollo.MutationResult<AddAllowedSiteMutation>;
export type AddAllowedSiteMutationOptions = Apollo.BaseMutationOptions<AddAllowedSiteMutation, AddAllowedSiteMutationVariables>;
export const FormConfigurationPageDocument = gql`
    query FormConfigurationPage($integration: FormIntegrationEnum!) {
  formConfiguration(integration: $integration) {
    ...SiteConfigurationFields
  }
}
    ${SiteConfigurationFieldsFragmentDoc}`;

/**
 * __useFormConfigurationPageQuery__
 *
 * To run a query within a React component, call `useFormConfigurationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormConfigurationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormConfigurationPageQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useFormConfigurationPageQuery(baseOptions: Apollo.QueryHookOptions<FormConfigurationPageQuery, FormConfigurationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormConfigurationPageQuery, FormConfigurationPageQueryVariables>(FormConfigurationPageDocument, options);
      }
export function useFormConfigurationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormConfigurationPageQuery, FormConfigurationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormConfigurationPageQuery, FormConfigurationPageQueryVariables>(FormConfigurationPageDocument, options);
        }
export type FormConfigurationPageQueryHookResult = ReturnType<typeof useFormConfigurationPageQuery>;
export type FormConfigurationPageLazyQueryHookResult = ReturnType<typeof useFormConfigurationPageLazyQuery>;
export type FormConfigurationPageQueryResult = Apollo.QueryResult<FormConfigurationPageQuery, FormConfigurationPageQueryVariables>;
export const RemoveAllowedSiteDocument = gql`
    mutation RemoveAllowedSite($input: FormsRemoveAllowedSiteInput!) {
  response: formsRemoveAllowedSite(input: $input) {
    node {
      ...SiteConfigurationFields
    }
    errors {
      field
      messages
    }
  }
}
    ${SiteConfigurationFieldsFragmentDoc}`;
export type RemoveAllowedSiteMutationFn = Apollo.MutationFunction<RemoveAllowedSiteMutation, RemoveAllowedSiteMutationVariables>;

/**
 * __useRemoveAllowedSiteMutation__
 *
 * To run a mutation, you first call `useRemoveAllowedSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllowedSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllowedSiteMutation, { data, loading, error }] = useRemoveAllowedSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAllowedSiteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAllowedSiteMutation, RemoveAllowedSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAllowedSiteMutation, RemoveAllowedSiteMutationVariables>(RemoveAllowedSiteDocument, options);
      }
export type RemoveAllowedSiteMutationHookResult = ReturnType<typeof useRemoveAllowedSiteMutation>;
export type RemoveAllowedSiteMutationResult = Apollo.MutationResult<RemoveAllowedSiteMutation>;
export type RemoveAllowedSiteMutationOptions = Apollo.BaseMutationOptions<RemoveAllowedSiteMutation, RemoveAllowedSiteMutationVariables>;
export const UpdateFormConfigurationDocument = gql`
    mutation UpdateFormConfiguration($input: FormsUpdateConfigurationInput!) {
  response: formsUpdateConfiguration(input: $input) {
    node {
      ...SiteConfigurationFields
    }
    errors {
      field
      messages
    }
  }
}
    ${SiteConfigurationFieldsFragmentDoc}`;
export type UpdateFormConfigurationMutationFn = Apollo.MutationFunction<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>;

/**
 * __useUpdateFormConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateFormConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormConfigurationMutation, { data, loading, error }] = useUpdateFormConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>(UpdateFormConfigurationDocument, options);
      }
export type UpdateFormConfigurationMutationHookResult = ReturnType<typeof useUpdateFormConfigurationMutation>;
export type UpdateFormConfigurationMutationResult = Apollo.MutationResult<UpdateFormConfigurationMutation>;
export type UpdateFormConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>;
export const FormAttributesDocument = gql`
    query FormAttributes($targetTypes: [EnrichmentAttributeTypeEnum!]!, $refreshAttributes: Boolean!, $excludePersonPhone: Boolean!) {
  sourceAttributes: enrichmentAttributes(types: [clearbit_company, clearbit_person], excludePersonPhone: $excludePersonPhone) {
    ...Attribute
    children {
      ...Attribute
      children {
        ...Attribute
      }
    }
  }
  targetAttributes: enrichmentAttributes(types: $targetTypes, refreshAttributes: $refreshAttributes) {
    ...Attribute
    children {
      ...Attribute
    }
  }
}
    ${AttributeFragmentDoc}`;

/**
 * __useFormAttributesQuery__
 *
 * To run a query within a React component, call `useFormAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormAttributesQuery({
 *   variables: {
 *      targetTypes: // value for 'targetTypes'
 *      refreshAttributes: // value for 'refreshAttributes'
 *      excludePersonPhone: // value for 'excludePersonPhone'
 *   },
 * });
 */
export function useFormAttributesQuery(baseOptions: Apollo.QueryHookOptions<FormAttributesQuery, FormAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormAttributesQuery, FormAttributesQueryVariables>(FormAttributesDocument, options);
      }
export function useFormAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormAttributesQuery, FormAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormAttributesQuery, FormAttributesQueryVariables>(FormAttributesDocument, options);
        }
export type FormAttributesQueryHookResult = ReturnType<typeof useFormAttributesQuery>;
export type FormAttributesLazyQueryHookResult = ReturnType<typeof useFormAttributesLazyQuery>;
export type FormAttributesQueryResult = Apollo.QueryResult<FormAttributesQuery, FormAttributesQueryVariables>;
export const FieldMappingsDocument = gql`
    query FieldMappings($integration: FormIntegrationEnum!) {
  formFieldMapping(integration: $integration) {
    integration
    fieldMappings {
      id
      sourceAttribute
      targetAttribute
    }
  }
}
    `;

/**
 * __useFieldMappingsQuery__
 *
 * To run a query within a React component, call `useFieldMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldMappingsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useFieldMappingsQuery(baseOptions: Apollo.QueryHookOptions<FieldMappingsQuery, FieldMappingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldMappingsQuery, FieldMappingsQueryVariables>(FieldMappingsDocument, options);
      }
export function useFieldMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldMappingsQuery, FieldMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldMappingsQuery, FieldMappingsQueryVariables>(FieldMappingsDocument, options);
        }
export type FieldMappingsQueryHookResult = ReturnType<typeof useFieldMappingsQuery>;
export type FieldMappingsLazyQueryHookResult = ReturnType<typeof useFieldMappingsLazyQuery>;
export type FieldMappingsQueryResult = Apollo.QueryResult<FieldMappingsQuery, FieldMappingsQueryVariables>;
export const UpsertFieldMappingsDocument = gql`
    mutation UpsertFieldMappings($input: FormsUpsertFieldMappingsInput!) {
  response: formsUpsertFieldMappings(input: $input) {
    node {
      integration
      fieldMappings {
        id
        sourceAttribute
        targetAttribute
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpsertFieldMappingsMutationFn = Apollo.MutationFunction<UpsertFieldMappingsMutation, UpsertFieldMappingsMutationVariables>;

/**
 * __useUpsertFieldMappingsMutation__
 *
 * To run a mutation, you first call `useUpsertFieldMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFieldMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFieldMappingsMutation, { data, loading, error }] = useUpsertFieldMappingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertFieldMappingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFieldMappingsMutation, UpsertFieldMappingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFieldMappingsMutation, UpsertFieldMappingsMutationVariables>(UpsertFieldMappingsDocument, options);
      }
export type UpsertFieldMappingsMutationHookResult = ReturnType<typeof useUpsertFieldMappingsMutation>;
export type UpsertFieldMappingsMutationResult = Apollo.MutationResult<UpsertFieldMappingsMutation>;
export type UpsertFieldMappingsMutationOptions = Apollo.BaseMutationOptions<UpsertFieldMappingsMutation, UpsertFieldMappingsMutationVariables>;
export const DataOverviewDocument = gql`
    query DataOverview($start: Date!, $end: Date!) {
  rollupCounts(start: $start, end: $end) {
    visitorsTotalUniques
    enrichmentsByEmailTotalUniques
    enrichmentsByDomainTotalUniques
  }
}
    `;

/**
 * __useDataOverviewQuery__
 *
 * To run a query within a React component, call `useDataOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataOverviewQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useDataOverviewQuery(baseOptions: Apollo.QueryHookOptions<DataOverviewQuery, DataOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataOverviewQuery, DataOverviewQueryVariables>(DataOverviewDocument, options);
      }
export function useDataOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataOverviewQuery, DataOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataOverviewQuery, DataOverviewQueryVariables>(DataOverviewDocument, options);
        }
export type DataOverviewQueryHookResult = ReturnType<typeof useDataOverviewQuery>;
export type DataOverviewLazyQueryHookResult = ReturnType<typeof useDataOverviewLazyQuery>;
export type DataOverviewQueryResult = Apollo.QueryResult<DataOverviewQuery, DataOverviewQueryVariables>;
export const ConnectorLayoutAccountConnectorDocument = gql`
    query ConnectorLayoutAccountConnector($service: [AccountConnectorServiceEnum!]!) {
  accountConnector(service: $service, status: [active]) {
    id
    service
    remoteMeta
    ...SalesforceFields
  }
}
    ${SalesforceFieldsFragmentDoc}`;

/**
 * __useConnectorLayoutAccountConnectorQuery__
 *
 * To run a query within a React component, call `useConnectorLayoutAccountConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorLayoutAccountConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorLayoutAccountConnectorQuery({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useConnectorLayoutAccountConnectorQuery(baseOptions: Apollo.QueryHookOptions<ConnectorLayoutAccountConnectorQuery, ConnectorLayoutAccountConnectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorLayoutAccountConnectorQuery, ConnectorLayoutAccountConnectorQueryVariables>(ConnectorLayoutAccountConnectorDocument, options);
      }
export function useConnectorLayoutAccountConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorLayoutAccountConnectorQuery, ConnectorLayoutAccountConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorLayoutAccountConnectorQuery, ConnectorLayoutAccountConnectorQueryVariables>(ConnectorLayoutAccountConnectorDocument, options);
        }
export type ConnectorLayoutAccountConnectorQueryHookResult = ReturnType<typeof useConnectorLayoutAccountConnectorQuery>;
export type ConnectorLayoutAccountConnectorLazyQueryHookResult = ReturnType<typeof useConnectorLayoutAccountConnectorLazyQuery>;
export type ConnectorLayoutAccountConnectorQueryResult = Apollo.QueryResult<ConnectorLayoutAccountConnectorQuery, ConnectorLayoutAccountConnectorQueryVariables>;
export const RefreshSegmentDocument = gql`
    mutation RefreshSegment($input: SegmentsRefreshInput!) {
  response: refreshSegment(input: $input) {
    node {
      id
    }
  }
}
    `;
export type RefreshSegmentMutationFn = Apollo.MutationFunction<RefreshSegmentMutation, RefreshSegmentMutationVariables>;

/**
 * __useRefreshSegmentMutation__
 *
 * To run a mutation, you first call `useRefreshSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSegmentMutation, { data, loading, error }] = useRefreshSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshSegmentMutation(baseOptions?: Apollo.MutationHookOptions<RefreshSegmentMutation, RefreshSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshSegmentMutation, RefreshSegmentMutationVariables>(RefreshSegmentDocument, options);
      }
export type RefreshSegmentMutationHookResult = ReturnType<typeof useRefreshSegmentMutation>;
export type RefreshSegmentMutationResult = Apollo.MutationResult<RefreshSegmentMutation>;
export type RefreshSegmentMutationOptions = Apollo.BaseMutationOptions<RefreshSegmentMutation, RefreshSegmentMutationVariables>;
export const SegmentDocument = gql`
    query Segment($id: ID!, $type: SegmentTypeEnum!) {
  segment(id: $id, type: $type) {
    id
    resultsCount
    type
    updatedAt
  }
}
    `;

/**
 * __useSegmentQuery__
 *
 * To run a query within a React component, call `useSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSegmentQuery(baseOptions: Apollo.QueryHookOptions<SegmentQuery, SegmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentQuery, SegmentQueryVariables>(SegmentDocument, options);
      }
export function useSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentQuery, SegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentQuery, SegmentQueryVariables>(SegmentDocument, options);
        }
export type SegmentQueryHookResult = ReturnType<typeof useSegmentQuery>;
export type SegmentLazyQueryHookResult = ReturnType<typeof useSegmentLazyQuery>;
export type SegmentQueryResult = Apollo.QueryResult<SegmentQuery, SegmentQueryVariables>;
export const LookupPersonRecordDocument = gql`
    query LookupPersonRecord($email: String!) {
  people(first: 1, query: $email) {
    edges {
      node {
        id
        email
        name
      }
    }
  }
}
    `;

/**
 * __useLookupPersonRecordQuery__
 *
 * To run a query within a React component, call `useLookupPersonRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupPersonRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupPersonRecordQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLookupPersonRecordQuery(baseOptions: Apollo.QueryHookOptions<LookupPersonRecordQuery, LookupPersonRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupPersonRecordQuery, LookupPersonRecordQueryVariables>(LookupPersonRecordDocument, options);
      }
export function useLookupPersonRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupPersonRecordQuery, LookupPersonRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupPersonRecordQuery, LookupPersonRecordQueryVariables>(LookupPersonRecordDocument, options);
        }
export type LookupPersonRecordQueryHookResult = ReturnType<typeof useLookupPersonRecordQuery>;
export type LookupPersonRecordLazyQueryHookResult = ReturnType<typeof useLookupPersonRecordLazyQuery>;
export type LookupPersonRecordQueryResult = Apollo.QueryResult<LookupPersonRecordQuery, LookupPersonRecordQueryVariables>;
export const AccountInviteCancelDocument = gql`
    mutation AccountInviteCancel($input: AccountInviteCancelInput!) {
  inviteCancel(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AccountInviteCancelMutationFn = Apollo.MutationFunction<AccountInviteCancelMutation, AccountInviteCancelMutationVariables>;

/**
 * __useAccountInviteCancelMutation__
 *
 * To run a mutation, you first call `useAccountInviteCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountInviteCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountInviteCancelMutation, { data, loading, error }] = useAccountInviteCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountInviteCancelMutation(baseOptions?: Apollo.MutationHookOptions<AccountInviteCancelMutation, AccountInviteCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountInviteCancelMutation, AccountInviteCancelMutationVariables>(AccountInviteCancelDocument, options);
      }
export type AccountInviteCancelMutationHookResult = ReturnType<typeof useAccountInviteCancelMutation>;
export type AccountInviteCancelMutationResult = Apollo.MutationResult<AccountInviteCancelMutation>;
export type AccountInviteCancelMutationOptions = Apollo.BaseMutationOptions<AccountInviteCancelMutation, AccountInviteCancelMutationVariables>;
export const AccountInviteUserDocument = gql`
    mutation AccountInviteUser($input: AccountInviteUserInput!) {
  inviteUser(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AccountInviteUserMutationFn = Apollo.MutationFunction<AccountInviteUserMutation, AccountInviteUserMutationVariables>;

/**
 * __useAccountInviteUserMutation__
 *
 * To run a mutation, you first call `useAccountInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountInviteUserMutation, { data, loading, error }] = useAccountInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<AccountInviteUserMutation, AccountInviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountInviteUserMutation, AccountInviteUserMutationVariables>(AccountInviteUserDocument, options);
      }
export type AccountInviteUserMutationHookResult = ReturnType<typeof useAccountInviteUserMutation>;
export type AccountInviteUserMutationResult = Apollo.MutationResult<AccountInviteUserMutation>;
export type AccountInviteUserMutationOptions = Apollo.BaseMutationOptions<AccountInviteUserMutation, AccountInviteUserMutationVariables>;
export const AccountMembersDocument = gql`
    query AccountMembers {
  account {
    id
    members {
      nodes {
        id
        role
        user {
          id
          name
          email
        }
        account {
          id
          name
          domain
        }
        notificationSettings {
          usageEnabled
          billingEnabled
          adsManagementEnabled
        }
      }
    }
    membershipInvites {
      nodes {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useAccountMembersQuery__
 *
 * To run a query within a React component, call `useAccountMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountMembersQuery(baseOptions?: Apollo.QueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountMembersQuery, AccountMembersQueryVariables>(AccountMembersDocument, options);
      }
export function useAccountMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountMembersQuery, AccountMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountMembersQuery, AccountMembersQueryVariables>(AccountMembersDocument, options);
        }
export type AccountMembersQueryHookResult = ReturnType<typeof useAccountMembersQuery>;
export type AccountMembersLazyQueryHookResult = ReturnType<typeof useAccountMembersLazyQuery>;
export type AccountMembersQueryResult = Apollo.QueryResult<AccountMembersQuery, AccountMembersQueryVariables>;
export const UserDestroyDocument = gql`
    mutation UserDestroy($input: UserDestroyInput!) {
  destroyUser(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UserDestroyMutationFn = Apollo.MutationFunction<UserDestroyMutation, UserDestroyMutationVariables>;

/**
 * __useUserDestroyMutation__
 *
 * To run a mutation, you first call `useUserDestroyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDestroyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDestroyMutation, { data, loading, error }] = useUserDestroyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserDestroyMutation(baseOptions?: Apollo.MutationHookOptions<UserDestroyMutation, UserDestroyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDestroyMutation, UserDestroyMutationVariables>(UserDestroyDocument, options);
      }
export type UserDestroyMutationHookResult = ReturnType<typeof useUserDestroyMutation>;
export type UserDestroyMutationResult = Apollo.MutationResult<UserDestroyMutation>;
export type UserDestroyMutationOptions = Apollo.BaseMutationOptions<UserDestroyMutation, UserDestroyMutationVariables>;
export const UserUpdateRoleDocument = gql`
    mutation UserUpdateRole($input: UserUpdateRoleInput!) {
  updateUserRole(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UserUpdateRoleMutationFn = Apollo.MutationFunction<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>;

/**
 * __useUserUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUserUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateRoleMutation, { data, loading, error }] = useUserUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>(UserUpdateRoleDocument, options);
      }
export type UserUpdateRoleMutationHookResult = ReturnType<typeof useUserUpdateRoleMutation>;
export type UserUpdateRoleMutationResult = Apollo.MutationResult<UserUpdateRoleMutation>;
export type UserUpdateRoleMutationOptions = Apollo.BaseMutationOptions<UserUpdateRoleMutation, UserUpdateRoleMutationVariables>;
export const AccountCreateDocument = gql`
    mutation AccountCreate($input: AccountCreateInput!) {
  createAccount(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type AccountCreateMutationFn = Apollo.MutationFunction<AccountCreateMutation, AccountCreateMutationVariables>;

/**
 * __useAccountCreateMutation__
 *
 * To run a mutation, you first call `useAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountCreateMutation, { data, loading, error }] = useAccountCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccountCreateMutation, AccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountCreateMutation, AccountCreateMutationVariables>(AccountCreateDocument, options);
      }
export type AccountCreateMutationHookResult = ReturnType<typeof useAccountCreateMutation>;
export type AccountCreateMutationResult = Apollo.MutationResult<AccountCreateMutation>;
export type AccountCreateMutationOptions = Apollo.BaseMutationOptions<AccountCreateMutation, AccountCreateMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  viewer {
    id
    role
    user {
      id
      name
      firstName
      lastName
      email
      mailing
      sso
      accounts {
        id
        name
        domain
      }
    }
  }
  account {
    id
    name
    flags
    plans
    domain
    mfaEnforced
    creditsBasedTier
    subscriptions {
      amount
      limit
      limitOverride
      planId
      status
      limitTerm {
        startAt
        endAt
      }
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const UserUpdatePasswordDocument = gql`
    mutation UserUpdatePassword($input: UserUpdatePasswordInput!) {
  updateUserPassword(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UserUpdatePasswordMutationFn = Apollo.MutationFunction<UserUpdatePasswordMutation, UserUpdatePasswordMutationVariables>;

/**
 * __useUserUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUserUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdatePasswordMutation, { data, loading, error }] = useUserUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdatePasswordMutation, UserUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdatePasswordMutation, UserUpdatePasswordMutationVariables>(UserUpdatePasswordDocument, options);
      }
export type UserUpdatePasswordMutationHookResult = ReturnType<typeof useUserUpdatePasswordMutation>;
export type UserUpdatePasswordMutationResult = Apollo.MutationResult<UserUpdatePasswordMutation>;
export type UserUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UserUpdatePasswordMutation, UserUpdatePasswordMutationVariables>;
export const UserUpdateProfileDocument = gql`
    mutation UserUpdateProfile($input: UserUpdateProfileInput!) {
  updateUserProfile(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UserUpdateProfileMutationFn = Apollo.MutationFunction<UserUpdateProfileMutation, UserUpdateProfileMutationVariables>;

/**
 * __useUserUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUserUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateProfileMutation, { data, loading, error }] = useUserUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateProfileMutation, UserUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateProfileMutation, UserUpdateProfileMutationVariables>(UserUpdateProfileDocument, options);
      }
export type UserUpdateProfileMutationHookResult = ReturnType<typeof useUserUpdateProfileMutation>;
export type UserUpdateProfileMutationResult = Apollo.MutationResult<UserUpdateProfileMutation>;
export type UserUpdateProfileMutationOptions = Apollo.BaseMutationOptions<UserUpdateProfileMutation, UserUpdateProfileMutationVariables>;
export const UserMembershipsDocument = gql`
    query UserMemberships {
  viewer {
    id
    user {
      memberships {
        nodes {
          id
          role
          account {
            id
            name
            domain
          }
          user {
            id
            name
            email
          }
          notificationSettings {
            usageEnabled
            billingEnabled
            adsManagementEnabled
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserMembershipsQuery__
 *
 * To run a query within a React component, call `useUserMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<UserMembershipsQuery, UserMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMembershipsQuery, UserMembershipsQueryVariables>(UserMembershipsDocument, options);
      }
export function useUserMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMembershipsQuery, UserMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMembershipsQuery, UserMembershipsQueryVariables>(UserMembershipsDocument, options);
        }
export type UserMembershipsQueryHookResult = ReturnType<typeof useUserMembershipsQuery>;
export type UserMembershipsLazyQueryHookResult = ReturnType<typeof useUserMembershipsLazyQuery>;
export type UserMembershipsQueryResult = Apollo.QueryResult<UserMembershipsQuery, UserMembershipsQueryVariables>;
export const CancelProspectListExportDocument = gql`
    mutation CancelProspectListExport($input: ProspectListExportCancelInput!) {
  cancelProspectListExport(input: $input) {
    node {
      ...ProspectListExportFragment
    }
    errors {
      field
      messages
    }
  }
}
    ${ProspectListExportFragmentFragmentDoc}`;
export type CancelProspectListExportMutationFn = Apollo.MutationFunction<CancelProspectListExportMutation, CancelProspectListExportMutationVariables>;

/**
 * __useCancelProspectListExportMutation__
 *
 * To run a mutation, you first call `useCancelProspectListExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelProspectListExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelProspectListExportMutation, { data, loading, error }] = useCancelProspectListExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelProspectListExportMutation(baseOptions?: Apollo.MutationHookOptions<CancelProspectListExportMutation, CancelProspectListExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelProspectListExportMutation, CancelProspectListExportMutationVariables>(CancelProspectListExportDocument, options);
      }
export type CancelProspectListExportMutationHookResult = ReturnType<typeof useCancelProspectListExportMutation>;
export type CancelProspectListExportMutationResult = Apollo.MutationResult<CancelProspectListExportMutation>;
export type CancelProspectListExportMutationOptions = Apollo.BaseMutationOptions<CancelProspectListExportMutation, CancelProspectListExportMutationVariables>;
export const CopyProspectListDocument = gql`
    mutation CopyProspectList($input: ProspectListCopyInput!) {
  copyProspectList(input: $input) {
    node {
      ...ProspectListFragment
    }
    errors {
      field
      messages
    }
  }
}
    ${ProspectListFragmentFragmentDoc}`;
export type CopyProspectListMutationFn = Apollo.MutationFunction<CopyProspectListMutation, CopyProspectListMutationVariables>;

/**
 * __useCopyProspectListMutation__
 *
 * To run a mutation, you first call `useCopyProspectListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyProspectListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyProspectListMutation, { data, loading, error }] = useCopyProspectListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyProspectListMutation(baseOptions?: Apollo.MutationHookOptions<CopyProspectListMutation, CopyProspectListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyProspectListMutation, CopyProspectListMutationVariables>(CopyProspectListDocument, options);
      }
export type CopyProspectListMutationHookResult = ReturnType<typeof useCopyProspectListMutation>;
export type CopyProspectListMutationResult = Apollo.MutationResult<CopyProspectListMutation>;
export type CopyProspectListMutationOptions = Apollo.BaseMutationOptions<CopyProspectListMutation, CopyProspectListMutationVariables>;
export const CreateProspectListDocument = gql`
    mutation CreateProspectList($input: ProspectListCreateInput!) {
  createProspectList(input: $input) {
    node {
      ...ProspectListFragment
    }
    errors {
      field
      messages
    }
  }
}
    ${ProspectListFragmentFragmentDoc}`;
export type CreateProspectListMutationFn = Apollo.MutationFunction<CreateProspectListMutation, CreateProspectListMutationVariables>;

/**
 * __useCreateProspectListMutation__
 *
 * To run a mutation, you first call `useCreateProspectListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProspectListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProspectListMutation, { data, loading, error }] = useCreateProspectListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProspectListMutation(baseOptions?: Apollo.MutationHookOptions<CreateProspectListMutation, CreateProspectListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProspectListMutation, CreateProspectListMutationVariables>(CreateProspectListDocument, options);
      }
export type CreateProspectListMutationHookResult = ReturnType<typeof useCreateProspectListMutation>;
export type CreateProspectListMutationResult = Apollo.MutationResult<CreateProspectListMutation>;
export type CreateProspectListMutationOptions = Apollo.BaseMutationOptions<CreateProspectListMutation, CreateProspectListMutationVariables>;
export const DestroyProspectListDocument = gql`
    mutation DestroyProspectList($input: ProspectListDestroyInput!) {
  destroyProspectList(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DestroyProspectListMutationFn = Apollo.MutationFunction<DestroyProspectListMutation, DestroyProspectListMutationVariables>;

/**
 * __useDestroyProspectListMutation__
 *
 * To run a mutation, you first call `useDestroyProspectListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyProspectListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyProspectListMutation, { data, loading, error }] = useDestroyProspectListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyProspectListMutation(baseOptions?: Apollo.MutationHookOptions<DestroyProspectListMutation, DestroyProspectListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyProspectListMutation, DestroyProspectListMutationVariables>(DestroyProspectListDocument, options);
      }
export type DestroyProspectListMutationHookResult = ReturnType<typeof useDestroyProspectListMutation>;
export type DestroyProspectListMutationResult = Apollo.MutationResult<DestroyProspectListMutation>;
export type DestroyProspectListMutationOptions = Apollo.BaseMutationOptions<DestroyProspectListMutation, DestroyProspectListMutationVariables>;
export const DownloadProspectListExportDocument = gql`
    mutation DownloadProspectListExport($input: ProspectListExportDownloadInput!) {
  downloadProspectListExport(input: $input) {
    node {
      ...ProspectListExportFragment
    }
    errors {
      field
      messages
    }
  }
}
    ${ProspectListExportFragmentFragmentDoc}`;
export type DownloadProspectListExportMutationFn = Apollo.MutationFunction<DownloadProspectListExportMutation, DownloadProspectListExportMutationVariables>;

/**
 * __useDownloadProspectListExportMutation__
 *
 * To run a mutation, you first call `useDownloadProspectListExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadProspectListExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadProspectListExportMutation, { data, loading, error }] = useDownloadProspectListExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadProspectListExportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadProspectListExportMutation, DownloadProspectListExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadProspectListExportMutation, DownloadProspectListExportMutationVariables>(DownloadProspectListExportDocument, options);
      }
export type DownloadProspectListExportMutationHookResult = ReturnType<typeof useDownloadProspectListExportMutation>;
export type DownloadProspectListExportMutationResult = Apollo.MutationResult<DownloadProspectListExportMutation>;
export type DownloadProspectListExportMutationOptions = Apollo.BaseMutationOptions<DownloadProspectListExportMutation, DownloadProspectListExportMutationVariables>;
export const CreateProspectListExportDocument = gql`
    mutation CreateProspectListExport($input: ProspectListExportCreateInput!) {
  createProspectListExport(input: $input) {
    node {
      ...ProspectListExportFragment
    }
    errors {
      field
      messages
    }
  }
}
    ${ProspectListExportFragmentFragmentDoc}`;
export type CreateProspectListExportMutationFn = Apollo.MutationFunction<CreateProspectListExportMutation, CreateProspectListExportMutationVariables>;

/**
 * __useCreateProspectListExportMutation__
 *
 * To run a mutation, you first call `useCreateProspectListExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProspectListExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProspectListExportMutation, { data, loading, error }] = useCreateProspectListExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProspectListExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateProspectListExportMutation, CreateProspectListExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProspectListExportMutation, CreateProspectListExportMutationVariables>(CreateProspectListExportDocument, options);
      }
export type CreateProspectListExportMutationHookResult = ReturnType<typeof useCreateProspectListExportMutation>;
export type CreateProspectListExportMutationResult = Apollo.MutationResult<CreateProspectListExportMutation>;
export type CreateProspectListExportMutationOptions = Apollo.BaseMutationOptions<CreateProspectListExportMutation, CreateProspectListExportMutationVariables>;
export const ProspectCrmPresencesDocument = gql`
    query ProspectCrmPresences($prospectIds: [String!]!) {
  prospectCrmPresences(prospectIds: $prospectIds) {
    __typename
    existsInHubspot
    prospectId
  }
}
    `;

/**
 * __useProspectCrmPresencesQuery__
 *
 * To run a query within a React component, call `useProspectCrmPresencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectCrmPresencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectCrmPresencesQuery({
 *   variables: {
 *      prospectIds: // value for 'prospectIds'
 *   },
 * });
 */
export function useProspectCrmPresencesQuery(baseOptions: Apollo.QueryHookOptions<ProspectCrmPresencesQuery, ProspectCrmPresencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectCrmPresencesQuery, ProspectCrmPresencesQueryVariables>(ProspectCrmPresencesDocument, options);
      }
export function useProspectCrmPresencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectCrmPresencesQuery, ProspectCrmPresencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectCrmPresencesQuery, ProspectCrmPresencesQueryVariables>(ProspectCrmPresencesDocument, options);
        }
export type ProspectCrmPresencesQueryHookResult = ReturnType<typeof useProspectCrmPresencesQuery>;
export type ProspectCrmPresencesLazyQueryHookResult = ReturnType<typeof useProspectCrmPresencesLazyQuery>;
export type ProspectCrmPresencesQueryResult = Apollo.QueryResult<ProspectCrmPresencesQuery, ProspectCrmPresencesQueryVariables>;
export const ProspectFiltersDocument = gql`
    query ProspectFilters {
  prospectFilters(version: 2) {
    countries {
      value
      label
    }
    title {
      value
      label
    }
    role {
      value
      label
    }
    seniority {
      value
      label
    }
    employeesRanges {
      value
      label
    }
    industries {
      value
      label
    }
    companyCountries {
      value
      label
    }
    companyTags {
      value
      label
      count
    }
    companyTech {
      value
      label
      count
    }
  }
}
    `;

/**
 * __useProspectFiltersQuery__
 *
 * To run a query within a React component, call `useProspectFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProspectFiltersQuery(baseOptions?: Apollo.QueryHookOptions<ProspectFiltersQuery, ProspectFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectFiltersQuery, ProspectFiltersQueryVariables>(ProspectFiltersDocument, options);
      }
export function useProspectFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectFiltersQuery, ProspectFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectFiltersQuery, ProspectFiltersQueryVariables>(ProspectFiltersDocument, options);
        }
export type ProspectFiltersQueryHookResult = ReturnType<typeof useProspectFiltersQuery>;
export type ProspectFiltersLazyQueryHookResult = ReturnType<typeof useProspectFiltersLazyQuery>;
export type ProspectFiltersQueryResult = Apollo.QueryResult<ProspectFiltersQuery, ProspectFiltersQueryVariables>;
export const ProspectListExportDocument = gql`
    query ProspectListExport($id: ID!) {
  prospectListExport(id: $id) {
    ...ProspectListExportFragment
    items {
      nodes {
        id
        name
        email
        phone
        role
        title
        linkedin
        companyName
        companyDomain
        companyLocation
        companyCity
        companyState
        companyCountry
      }
    }
  }
}
    ${ProspectListExportFragmentFragmentDoc}`;

/**
 * __useProspectListExportQuery__
 *
 * To run a query within a React component, call `useProspectListExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectListExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectListExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProspectListExportQuery(baseOptions: Apollo.QueryHookOptions<ProspectListExportQuery, ProspectListExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectListExportQuery, ProspectListExportQueryVariables>(ProspectListExportDocument, options);
      }
export function useProspectListExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectListExportQuery, ProspectListExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectListExportQuery, ProspectListExportQueryVariables>(ProspectListExportDocument, options);
        }
export type ProspectListExportQueryHookResult = ReturnType<typeof useProspectListExportQuery>;
export type ProspectListExportLazyQueryHookResult = ReturnType<typeof useProspectListExportLazyQuery>;
export type ProspectListExportQueryResult = Apollo.QueryResult<ProspectListExportQuery, ProspectListExportQueryVariables>;
export const ProspectListExportsDocument = gql`
    query ProspectListExports {
  pendingExports: prospectListExports(filter: pending) {
    nodes {
      ...ProspectListExportFragment
    }
  }
  purchasedExports: prospectListExports(filter: purchased) {
    nodes {
      ...ProspectListExportFragment
    }
  }
}
    ${ProspectListExportFragmentFragmentDoc}`;

/**
 * __useProspectListExportsQuery__
 *
 * To run a query within a React component, call `useProspectListExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectListExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectListExportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProspectListExportsQuery(baseOptions?: Apollo.QueryHookOptions<ProspectListExportsQuery, ProspectListExportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectListExportsQuery, ProspectListExportsQueryVariables>(ProspectListExportsDocument, options);
      }
export function useProspectListExportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectListExportsQuery, ProspectListExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectListExportsQuery, ProspectListExportsQueryVariables>(ProspectListExportsDocument, options);
        }
export type ProspectListExportsQueryHookResult = ReturnType<typeof useProspectListExportsQuery>;
export type ProspectListExportsLazyQueryHookResult = ReturnType<typeof useProspectListExportsLazyQuery>;
export type ProspectListExportsQueryResult = Apollo.QueryResult<ProspectListExportsQuery, ProspectListExportsQueryVariables>;
export const ProspectListDocument = gql`
    query ProspectList($id: ID!) {
  prospectList(id: $id) {
    ...ProspectListFragment
  }
}
    ${ProspectListFragmentFragmentDoc}`;

/**
 * __useProspectListQuery__
 *
 * To run a query within a React component, call `useProspectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProspectListQuery(baseOptions: Apollo.QueryHookOptions<ProspectListQuery, ProspectListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectListQuery, ProspectListQueryVariables>(ProspectListDocument, options);
      }
export function useProspectListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectListQuery, ProspectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectListQuery, ProspectListQueryVariables>(ProspectListDocument, options);
        }
export type ProspectListQueryHookResult = ReturnType<typeof useProspectListQuery>;
export type ProspectListLazyQueryHookResult = ReturnType<typeof useProspectListLazyQuery>;
export type ProspectListQueryResult = Apollo.QueryResult<ProspectListQuery, ProspectListQueryVariables>;
export const ProspectListingDocument = gql`
    query ProspectListing {
  prospectLists {
    nodes {
      ...ProspectListFragment
    }
  }
}
    ${ProspectListFragmentFragmentDoc}`;

/**
 * __useProspectListingQuery__
 *
 * To run a query within a React component, call `useProspectListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useProspectListingQuery(baseOptions?: Apollo.QueryHookOptions<ProspectListingQuery, ProspectListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectListingQuery, ProspectListingQueryVariables>(ProspectListingDocument, options);
      }
export function useProspectListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectListingQuery, ProspectListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectListingQuery, ProspectListingQueryVariables>(ProspectListingDocument, options);
        }
export type ProspectListingQueryHookResult = ReturnType<typeof useProspectListingQuery>;
export type ProspectListingLazyQueryHookResult = ReturnType<typeof useProspectListingLazyQuery>;
export type ProspectListingQueryResult = Apollo.QueryResult<ProspectListingQuery, ProspectListingQueryVariables>;
export const ProspectsDocument = gql`
    query Prospects($cities: [String!]!, $companyCities: [String!]!, $companyCountries: [String!]!, $companyStates: [String!]!, $companyTags: [String!]!, $companyTech: [String!]!, $countries: [String!]!, $domains: [String!]!, $employeesRanges: [String!]!, $industries: [String!]!, $names: [String!]!, $roles: [String]!, $seniorities: [String]!, $titles: [String!]!, $states: [String!]!, $page: Int) {
  prospects(cities: $cities, companyCities: $companyCities, companyCountries: $companyCountries, companyStates: $companyStates, companyTags: $companyTags, companyTech: $companyTech, countries: $countries, domains: $domains, employeesRanges: $employeesRanges, industries: $industries, names: $names, page: $page, pageSize: 20, roles: $roles, seniorities: $seniorities, titles: $titles, states: $states) {
    totalCount
    totalCompanies
    nodes {
      id
      name
      title
      avatar
      companyName
      companyDomain
      companyIndustry
      companyLocation
      companyLogo
      email
      phone
      linkedin
      twitter
    }
  }
}
    `;

/**
 * __useProspectsQuery__
 *
 * To run a query within a React component, call `useProspectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProspectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProspectsQuery({
 *   variables: {
 *      cities: // value for 'cities'
 *      companyCities: // value for 'companyCities'
 *      companyCountries: // value for 'companyCountries'
 *      companyStates: // value for 'companyStates'
 *      companyTags: // value for 'companyTags'
 *      companyTech: // value for 'companyTech'
 *      countries: // value for 'countries'
 *      domains: // value for 'domains'
 *      employeesRanges: // value for 'employeesRanges'
 *      industries: // value for 'industries'
 *      names: // value for 'names'
 *      roles: // value for 'roles'
 *      seniorities: // value for 'seniorities'
 *      titles: // value for 'titles'
 *      states: // value for 'states'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProspectsQuery(baseOptions: Apollo.QueryHookOptions<ProspectsQuery, ProspectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProspectsQuery, ProspectsQueryVariables>(ProspectsDocument, options);
      }
export function useProspectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProspectsQuery, ProspectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProspectsQuery, ProspectsQueryVariables>(ProspectsDocument, options);
        }
export type ProspectsQueryHookResult = ReturnType<typeof useProspectsQuery>;
export type ProspectsLazyQueryHookResult = ReturnType<typeof useProspectsLazyQuery>;
export type ProspectsQueryResult = Apollo.QueryResult<ProspectsQuery, ProspectsQueryVariables>;
export const UpdateProspectListDocument = gql`
    mutation UpdateProspectList($input: ProspectListUpdateInput!) {
  updateProspectList(input: $input) {
    node {
      ...ProspectListFragment
    }
    errors {
      field
      messages
    }
  }
}
    ${ProspectListFragmentFragmentDoc}`;
export type UpdateProspectListMutationFn = Apollo.MutationFunction<UpdateProspectListMutation, UpdateProspectListMutationVariables>;

/**
 * __useUpdateProspectListMutation__
 *
 * To run a mutation, you first call `useUpdateProspectListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProspectListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProspectListMutation, { data, loading, error }] = useUpdateProspectListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProspectListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProspectListMutation, UpdateProspectListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProspectListMutation, UpdateProspectListMutationVariables>(UpdateProspectListDocument, options);
      }
export type UpdateProspectListMutationHookResult = ReturnType<typeof useUpdateProspectListMutation>;
export type UpdateProspectListMutationResult = Apollo.MutationResult<UpdateProspectListMutation>;
export type UpdateProspectListMutationOptions = Apollo.BaseMutationOptions<UpdateProspectListMutation, UpdateProspectListMutationVariables>;
export const UsageDashboardFeaturesListDocument = gql`
    query UsageDashboardFeaturesList {
  productFeatures {
    id
    currentPeriodEndDate
    currentPeriodStartDate
    currentPeriodTotalUsage
    description
    documentationUrl
    meteredUnit
    usageTerm
    name
    usageLimit
    usageMetricGraph
    currentPeriodEndDate
  }
}
    `;

/**
 * __useUsageDashboardFeaturesListQuery__
 *
 * To run a query within a React component, call `useUsageDashboardFeaturesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageDashboardFeaturesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageDashboardFeaturesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsageDashboardFeaturesListQuery(baseOptions?: Apollo.QueryHookOptions<UsageDashboardFeaturesListQuery, UsageDashboardFeaturesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsageDashboardFeaturesListQuery, UsageDashboardFeaturesListQueryVariables>(UsageDashboardFeaturesListDocument, options);
      }
export function useUsageDashboardFeaturesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsageDashboardFeaturesListQuery, UsageDashboardFeaturesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsageDashboardFeaturesListQuery, UsageDashboardFeaturesListQueryVariables>(UsageDashboardFeaturesListDocument, options);
        }
export type UsageDashboardFeaturesListQueryHookResult = ReturnType<typeof useUsageDashboardFeaturesListQuery>;
export type UsageDashboardFeaturesListLazyQueryHookResult = ReturnType<typeof useUsageDashboardFeaturesListLazyQuery>;
export type UsageDashboardFeaturesListQueryResult = Apollo.QueryResult<UsageDashboardFeaturesListQuery, UsageDashboardFeaturesListQueryVariables>;
export const UsageBreakdownDocument = gql`
    query UsageBreakdown($usageTerm: SubscriptionBillingTermEnum!, $startDate: Date!, $endDate: Date!, $usageMetricGraph: Json!, $granularity: UsageBreakdownGranularityEnum!) {
  usageBreakdown(usageTerm: $usageTerm, startDate: $startDate, endDate: $endDate, usageMetricGraph: $usageMetricGraph, granularity: $granularity)
}
    `;

/**
 * __useUsageBreakdownQuery__
 *
 * To run a query within a React component, call `useUsageBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageBreakdownQuery({
 *   variables: {
 *      usageTerm: // value for 'usageTerm'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      usageMetricGraph: // value for 'usageMetricGraph'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useUsageBreakdownQuery(baseOptions: Apollo.QueryHookOptions<UsageBreakdownQuery, UsageBreakdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsageBreakdownQuery, UsageBreakdownQueryVariables>(UsageBreakdownDocument, options);
      }
export function useUsageBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsageBreakdownQuery, UsageBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsageBreakdownQuery, UsageBreakdownQueryVariables>(UsageBreakdownDocument, options);
        }
export type UsageBreakdownQueryHookResult = ReturnType<typeof useUsageBreakdownQuery>;
export type UsageBreakdownLazyQueryHookResult = ReturnType<typeof useUsageBreakdownLazyQuery>;
export type UsageBreakdownQueryResult = Apollo.QueryResult<UsageBreakdownQuery, UsageBreakdownQueryVariables>;
export const ProductFeatureDetailsDocument = gql`
    query ProductFeatureDetails($id: ProductFeatureEnum!) {
  productFeature(id: $id) {
    currentPeriodEndDate
    currentPeriodStartDate
    currentPeriodTotalUsage
    description
    documentationUrl
    detailedBreakdownDescription
    detailedBreakdownTitle
    metricSubsets
    id
    meteredUnit
    name
    usageLimit
    usageTerm
    usageMetricGraph
    usageBreakdownDetails
  }
}
    `;

/**
 * __useProductFeatureDetailsQuery__
 *
 * To run a query within a React component, call `useProductFeatureDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFeatureDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFeatureDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductFeatureDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductFeatureDetailsQuery, ProductFeatureDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFeatureDetailsQuery, ProductFeatureDetailsQueryVariables>(ProductFeatureDetailsDocument, options);
      }
export function useProductFeatureDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFeatureDetailsQuery, ProductFeatureDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFeatureDetailsQuery, ProductFeatureDetailsQueryVariables>(ProductFeatureDetailsDocument, options);
        }
export type ProductFeatureDetailsQueryHookResult = ReturnType<typeof useProductFeatureDetailsQuery>;
export type ProductFeatureDetailsLazyQueryHookResult = ReturnType<typeof useProductFeatureDetailsLazyQuery>;
export type ProductFeatureDetailsQueryResult = Apollo.QueryResult<ProductFeatureDetailsQuery, ProductFeatureDetailsQueryVariables>;
export const EnrichmentRecentUsageDocument = gql`
    query EnrichmentRecentUsage {
  enrichmentRecentUsage {
    date
    usage
  }
}
    `;

/**
 * __useEnrichmentRecentUsageQuery__
 *
 * To run a query within a React component, call `useEnrichmentRecentUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentRecentUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentRecentUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnrichmentRecentUsageQuery(baseOptions?: Apollo.QueryHookOptions<EnrichmentRecentUsageQuery, EnrichmentRecentUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentRecentUsageQuery, EnrichmentRecentUsageQueryVariables>(EnrichmentRecentUsageDocument, options);
      }
export function useEnrichmentRecentUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentRecentUsageQuery, EnrichmentRecentUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentRecentUsageQuery, EnrichmentRecentUsageQueryVariables>(EnrichmentRecentUsageDocument, options);
        }
export type EnrichmentRecentUsageQueryHookResult = ReturnType<typeof useEnrichmentRecentUsageQuery>;
export type EnrichmentRecentUsageLazyQueryHookResult = ReturnType<typeof useEnrichmentRecentUsageLazyQuery>;
export type EnrichmentRecentUsageQueryResult = Apollo.QueryResult<EnrichmentRecentUsageQuery, EnrichmentRecentUsageQueryVariables>;
export const CurrentAccountDocument = gql`
    query CurrentAccount {
  account {
    id
    name
    flags
    plans
    domain
    creditsBasedTier
    connectors(service: [salesforce, salesforcesandbox, hubspot], status: [active]) {
      id
      name
      remoteMeta
      service
      syncStatus
      status
      ... on HubspotAccountConnector {
        hubspotAccountId
      }
    }
    platformAccess {
      legacyPlan
      acquisitions
      capture
      conversions
      operations
      usage
    }
    subscriptions {
      amount
      downgradeDate
      downgradeLimit
      planId
      startDate
      status
    }
  }
}
    `;

/**
 * __useCurrentAccountQuery__
 *
 * To run a query within a React component, call `useCurrentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAccountQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAccountQuery, CurrentAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAccountQuery, CurrentAccountQueryVariables>(CurrentAccountDocument, options);
      }
export function useCurrentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAccountQuery, CurrentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAccountQuery, CurrentAccountQueryVariables>(CurrentAccountDocument, options);
        }
export type CurrentAccountQueryHookResult = ReturnType<typeof useCurrentAccountQuery>;
export type CurrentAccountLazyQueryHookResult = ReturnType<typeof useCurrentAccountLazyQuery>;
export type CurrentAccountQueryResult = Apollo.QueryResult<CurrentAccountQuery, CurrentAccountQueryVariables>;
export const JobHistoryDocument = gql`
    query JobHistory($jobId: String!, $queue: String!) {
  jobHistory(jobId: $jobId, queue: $queue) {
    jobId
    queue
    status
    runId
    timestamp
  }
}
    `;

/**
 * __useJobHistoryQuery__
 *
 * To run a query within a React component, call `useJobHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobHistoryQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      queue: // value for 'queue'
 *   },
 * });
 */
export function useJobHistoryQuery(baseOptions: Apollo.QueryHookOptions<JobHistoryQuery, JobHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobHistoryQuery, JobHistoryQueryVariables>(JobHistoryDocument, options);
      }
export function useJobHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobHistoryQuery, JobHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobHistoryQuery, JobHistoryQueryVariables>(JobHistoryDocument, options);
        }
export type JobHistoryQueryHookResult = ReturnType<typeof useJobHistoryQuery>;
export type JobHistoryLazyQueryHookResult = ReturnType<typeof useJobHistoryLazyQuery>;
export type JobHistoryQueryResult = Apollo.QueryResult<JobHistoryQuery, JobHistoryQueryVariables>;
export const PublishableKeysDocument = gql`
    query PublishableKeys {
  publishableKeys {
    id
    value
  }
}
    `;

/**
 * __usePublishableKeysQuery__
 *
 * To run a query within a React component, call `usePublishableKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishableKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishableKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublishableKeysQuery(baseOptions?: Apollo.QueryHookOptions<PublishableKeysQuery, PublishableKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishableKeysQuery, PublishableKeysQueryVariables>(PublishableKeysDocument, options);
      }
export function usePublishableKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishableKeysQuery, PublishableKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishableKeysQuery, PublishableKeysQueryVariables>(PublishableKeysDocument, options);
        }
export type PublishableKeysQueryHookResult = ReturnType<typeof usePublishableKeysQuery>;
export type PublishableKeysLazyQueryHookResult = ReturnType<typeof usePublishableKeysLazyQuery>;
export type PublishableKeysQueryResult = Apollo.QueryResult<PublishableKeysQuery, PublishableKeysQueryVariables>;
export const AnalyzeCsvImportDocument = gql`
    mutation AnalyzeCsvImport($input: CsvImportsAnalyzeInput!) {
  response: analyzeCsvImport(input: $input) {
    node {
      id
      uploadUrl
      filename
      mapping
      sampleData
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type AnalyzeCsvImportMutationFn = Apollo.MutationFunction<AnalyzeCsvImportMutation, AnalyzeCsvImportMutationVariables>;

/**
 * __useAnalyzeCsvImportMutation__
 *
 * To run a mutation, you first call `useAnalyzeCsvImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeCsvImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzeCsvImportMutation, { data, loading, error }] = useAnalyzeCsvImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyzeCsvImportMutation(baseOptions?: Apollo.MutationHookOptions<AnalyzeCsvImportMutation, AnalyzeCsvImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyzeCsvImportMutation, AnalyzeCsvImportMutationVariables>(AnalyzeCsvImportDocument, options);
      }
export type AnalyzeCsvImportMutationHookResult = ReturnType<typeof useAnalyzeCsvImportMutation>;
export type AnalyzeCsvImportMutationResult = Apollo.MutationResult<AnalyzeCsvImportMutation>;
export type AnalyzeCsvImportMutationOptions = Apollo.BaseMutationOptions<AnalyzeCsvImportMutation, AnalyzeCsvImportMutationVariables>;
export const CreateCsvImportDocument = gql`
    mutation CreateCsvImport($input: CsvImportsCreateInput!) {
  response: createCsvImport(input: $input) {
    node {
      id
      uploadUrl
      filename
      type
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateCsvImportMutationFn = Apollo.MutationFunction<CreateCsvImportMutation, CreateCsvImportMutationVariables>;

/**
 * __useCreateCsvImportMutation__
 *
 * To run a mutation, you first call `useCreateCsvImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCsvImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCsvImportMutation, { data, loading, error }] = useCreateCsvImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCsvImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateCsvImportMutation, CreateCsvImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCsvImportMutation, CreateCsvImportMutationVariables>(CreateCsvImportDocument, options);
      }
export type CreateCsvImportMutationHookResult = ReturnType<typeof useCreateCsvImportMutation>;
export type CreateCsvImportMutationResult = Apollo.MutationResult<CreateCsvImportMutation>;
export type CreateCsvImportMutationOptions = Apollo.BaseMutationOptions<CreateCsvImportMutation, CreateCsvImportMutationVariables>;
export const CreateCsvSegmentDocument = gql`
    mutation CreateCsvSegment($input: CsvImportsCreateSegmentInput!) {
  response: createCsvSegment(input: $input) {
    node {
      id
      segmentId
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateCsvSegmentMutationFn = Apollo.MutationFunction<CreateCsvSegmentMutation, CreateCsvSegmentMutationVariables>;

/**
 * __useCreateCsvSegmentMutation__
 *
 * To run a mutation, you first call `useCreateCsvSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCsvSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCsvSegmentMutation, { data, loading, error }] = useCreateCsvSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCsvSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCsvSegmentMutation, CreateCsvSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCsvSegmentMutation, CreateCsvSegmentMutationVariables>(CreateCsvSegmentDocument, options);
      }
export type CreateCsvSegmentMutationHookResult = ReturnType<typeof useCreateCsvSegmentMutation>;
export type CreateCsvSegmentMutationResult = Apollo.MutationResult<CreateCsvSegmentMutation>;
export type CreateCsvSegmentMutationOptions = Apollo.BaseMutationOptions<CreateCsvSegmentMutation, CreateCsvSegmentMutationVariables>;
export const DestroyCsvImportDocument = gql`
    mutation DestroyCsvImport($input: CsvImportsDestroyInput!) {
  response: destroyCsvImport(input: $input) {
    clientMutationId
  }
}
    `;
export type DestroyCsvImportMutationFn = Apollo.MutationFunction<DestroyCsvImportMutation, DestroyCsvImportMutationVariables>;

/**
 * __useDestroyCsvImportMutation__
 *
 * To run a mutation, you first call `useDestroyCsvImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyCsvImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyCsvImportMutation, { data, loading, error }] = useDestroyCsvImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyCsvImportMutation(baseOptions?: Apollo.MutationHookOptions<DestroyCsvImportMutation, DestroyCsvImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyCsvImportMutation, DestroyCsvImportMutationVariables>(DestroyCsvImportDocument, options);
      }
export type DestroyCsvImportMutationHookResult = ReturnType<typeof useDestroyCsvImportMutation>;
export type DestroyCsvImportMutationResult = Apollo.MutationResult<DestroyCsvImportMutation>;
export type DestroyCsvImportMutationOptions = Apollo.BaseMutationOptions<DestroyCsvImportMutation, DestroyCsvImportMutationVariables>;
export const ImportCsvIndexPageDocument = gql`
    query ImportCsvIndexPage($type: String!, $collectionType: CollectionLegacyTypeEnum!) {
  csvImports(type: $type) {
    ...CsvImportFragment
  }
  collections(type: $collectionType) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    ${CsvImportFragmentFragmentDoc}`;

/**
 * __useImportCsvIndexPageQuery__
 *
 * To run a query within a React component, call `useImportCsvIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportCsvIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportCsvIndexPageQuery({
 *   variables: {
 *      type: // value for 'type'
 *      collectionType: // value for 'collectionType'
 *   },
 * });
 */
export function useImportCsvIndexPageQuery(baseOptions: Apollo.QueryHookOptions<ImportCsvIndexPageQuery, ImportCsvIndexPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportCsvIndexPageQuery, ImportCsvIndexPageQueryVariables>(ImportCsvIndexPageDocument, options);
      }
export function useImportCsvIndexPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportCsvIndexPageQuery, ImportCsvIndexPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportCsvIndexPageQuery, ImportCsvIndexPageQueryVariables>(ImportCsvIndexPageDocument, options);
        }
export type ImportCsvIndexPageQueryHookResult = ReturnType<typeof useImportCsvIndexPageQuery>;
export type ImportCsvIndexPageLazyQueryHookResult = ReturnType<typeof useImportCsvIndexPageLazyQuery>;
export type ImportCsvIndexPageQueryResult = Apollo.QueryResult<ImportCsvIndexPageQuery, ImportCsvIndexPageQueryVariables>;
export const ParseCsvImportDocument = gql`
    mutation ParseCsvImport($input: CsvImportsParseInput!) {
  response: parseCsvImport(input: $input) {
    node {
      id
      rowsSkippedCount
      rowsMatchedCount
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ParseCsvImportMutationFn = Apollo.MutationFunction<ParseCsvImportMutation, ParseCsvImportMutationVariables>;

/**
 * __useParseCsvImportMutation__
 *
 * To run a mutation, you first call `useParseCsvImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseCsvImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseCsvImportMutation, { data, loading, error }] = useParseCsvImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useParseCsvImportMutation(baseOptions?: Apollo.MutationHookOptions<ParseCsvImportMutation, ParseCsvImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParseCsvImportMutation, ParseCsvImportMutationVariables>(ParseCsvImportDocument, options);
      }
export type ParseCsvImportMutationHookResult = ReturnType<typeof useParseCsvImportMutation>;
export type ParseCsvImportMutationResult = Apollo.MutationResult<ParseCsvImportMutation>;
export type ParseCsvImportMutationOptions = Apollo.BaseMutationOptions<ParseCsvImportMutation, ParseCsvImportMutationVariables>;
export const ImportCsvPageDocument = gql`
    query ImportCsvPage($id: ID!, $attributeType: AttributeTypeEnum!, $collectionType: CollectionLegacyTypeEnum!) {
  csvImport(id: $id) {
    id
    filename
    sourceName
    mapping
    sampleData
    type
    status
    segmentId
    rowsMatchedCount
    rowsSkippedCount
    primaryIdentifierColumn
    sourceNameUsed
  }
  searchAttributes(type: $attributeType, categories: [traits, system]) {
    details
    label
    value
    category
    subCategory
    attributeType
  }
  collections(type: $collectionType) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useImportCsvPageQuery__
 *
 * To run a query within a React component, call `useImportCsvPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportCsvPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportCsvPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      attributeType: // value for 'attributeType'
 *      collectionType: // value for 'collectionType'
 *   },
 * });
 */
export function useImportCsvPageQuery(baseOptions: Apollo.QueryHookOptions<ImportCsvPageQuery, ImportCsvPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportCsvPageQuery, ImportCsvPageQueryVariables>(ImportCsvPageDocument, options);
      }
export function useImportCsvPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportCsvPageQuery, ImportCsvPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportCsvPageQuery, ImportCsvPageQueryVariables>(ImportCsvPageDocument, options);
        }
export type ImportCsvPageQueryHookResult = ReturnType<typeof useImportCsvPageQuery>;
export type ImportCsvPageLazyQueryHookResult = ReturnType<typeof useImportCsvPageLazyQuery>;
export type ImportCsvPageQueryResult = Apollo.QueryResult<ImportCsvPageQuery, ImportCsvPageQueryVariables>;
export const UpdateSegmentDocument = gql`
    mutation UpdateSegment($input: SegmentsUpdateInput!) {
  response: updateSegment(input: $input) {
    node {
      id
      ...SegmentEdit
    }
    errors {
      field
      messages
    }
  }
}
    ${SegmentEditFragmentDoc}`;
export type UpdateSegmentMutationFn = Apollo.MutationFunction<UpdateSegmentMutation, UpdateSegmentMutationVariables>;

/**
 * __useUpdateSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentMutation, { data, loading, error }] = useUpdateSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSegmentMutation, UpdateSegmentMutationVariables>(UpdateSegmentDocument, options);
      }
export type UpdateSegmentMutationHookResult = ReturnType<typeof useUpdateSegmentMutation>;
export type UpdateSegmentMutationResult = Apollo.MutationResult<UpdateSegmentMutation>;
export type UpdateSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>;
export const SegmentEditPageDocument = gql`
    query SegmentEditPage($id: ID!, $type: SegmentTypeEnum!, $attributeType: AttributeTypeEnum!, $collectionType: CollectionLegacyTypeEnum!, $salesforceSubCategories: [AttributeSalesforceSubCategoryEnum!]!, $hubspotSubCategories: [AttributeHubspotSubCategoryEnum!]!) {
  segment(id: $id, type: $type) {
    id
    ...SegmentEdit
  }
  searchAttributes(type: $attributeType, categories: [system, enrichment, salesforce, hubspot, g2, target_market, traits, pageview_filter], salesforceSubCategories: $salesforceSubCategories, hubspotSubCategories: $hubspotSubCategories) {
    ...SegmentFormAttribute
  }
  salesforceUsers {
    ...SegmentFormSegmentBuilderSalesforceUser
  }
  collections(type: $collectionType) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    ${SegmentEditFragmentDoc}
${SegmentFormAttributeFragmentDoc}
${SegmentFormSegmentBuilderSalesforceUserFragmentDoc}`;

/**
 * __useSegmentEditPageQuery__
 *
 * To run a query within a React component, call `useSegmentEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentEditPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      attributeType: // value for 'attributeType'
 *      collectionType: // value for 'collectionType'
 *      salesforceSubCategories: // value for 'salesforceSubCategories'
 *      hubspotSubCategories: // value for 'hubspotSubCategories'
 *   },
 * });
 */
export function useSegmentEditPageQuery(baseOptions: Apollo.QueryHookOptions<SegmentEditPageQuery, SegmentEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentEditPageQuery, SegmentEditPageQueryVariables>(SegmentEditPageDocument, options);
      }
export function useSegmentEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentEditPageQuery, SegmentEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentEditPageQuery, SegmentEditPageQueryVariables>(SegmentEditPageDocument, options);
        }
export type SegmentEditPageQueryHookResult = ReturnType<typeof useSegmentEditPageQuery>;
export type SegmentEditPageLazyQueryHookResult = ReturnType<typeof useSegmentEditPageLazyQuery>;
export type SegmentEditPageQueryResult = Apollo.QueryResult<SegmentEditPageQuery, SegmentEditPageQueryVariables>;
export const CreateSegmentDocument = gql`
    mutation CreateSegment($input: SegmentsCreateInput!) {
  response: createSegment(input: $input) {
    node {
      id
      name
      type
      search
      resultsCount
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateSegmentMutationFn = Apollo.MutationFunction<CreateSegmentMutation, CreateSegmentMutationVariables>;

/**
 * __useCreateSegmentMutation__
 *
 * To run a mutation, you first call `useCreateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentMutation, { data, loading, error }] = useCreateSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSegmentMutation, CreateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSegmentMutation, CreateSegmentMutationVariables>(CreateSegmentDocument, options);
      }
export type CreateSegmentMutationHookResult = ReturnType<typeof useCreateSegmentMutation>;
export type CreateSegmentMutationResult = Apollo.MutationResult<CreateSegmentMutation>;
export type CreateSegmentMutationOptions = Apollo.BaseMutationOptions<CreateSegmentMutation, CreateSegmentMutationVariables>;
export const SegmentNewPageDocument = gql`
    query SegmentNewPage($type: AttributeTypeEnum!, $collectionType: CollectionLegacyTypeEnum!, $salesforceSubCategories: [AttributeSalesforceSubCategoryEnum!]!, $hubspotSubCategories: [AttributeHubspotSubCategoryEnum!]!) {
  searchAttributes(type: $type, categories: [system, enrichment, salesforce, hubspot, g2, target_market, traits, pageview_filter], salesforceSubCategories: $salesforceSubCategories, hubspotSubCategories: $hubspotSubCategories) {
    ...SegmentFormAttribute
  }
  salesforceUsers {
    ...SegmentFormSegmentBuilderSalesforceUser
  }
  collections(type: $collectionType) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    ${SegmentFormAttributeFragmentDoc}
${SegmentFormSegmentBuilderSalesforceUserFragmentDoc}`;

/**
 * __useSegmentNewPageQuery__
 *
 * To run a query within a React component, call `useSegmentNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentNewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentNewPageQuery({
 *   variables: {
 *      type: // value for 'type'
 *      collectionType: // value for 'collectionType'
 *      salesforceSubCategories: // value for 'salesforceSubCategories'
 *      hubspotSubCategories: // value for 'hubspotSubCategories'
 *   },
 * });
 */
export function useSegmentNewPageQuery(baseOptions: Apollo.QueryHookOptions<SegmentNewPageQuery, SegmentNewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentNewPageQuery, SegmentNewPageQueryVariables>(SegmentNewPageDocument, options);
      }
export function useSegmentNewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentNewPageQuery, SegmentNewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentNewPageQuery, SegmentNewPageQueryVariables>(SegmentNewPageDocument, options);
        }
export type SegmentNewPageQueryHookResult = ReturnType<typeof useSegmentNewPageQuery>;
export type SegmentNewPageLazyQueryHookResult = ReturnType<typeof useSegmentNewPageLazyQuery>;
export type SegmentNewPageQueryResult = Apollo.QueryResult<SegmentNewPageQuery, SegmentNewPageQueryVariables>;
export const AudienceEditPageDocument = gql`
    query AudienceEditPage($id: ID!) {
  account {
    id
    ...AudiencesProspectsFormAccount
  }
  audience(id: $id) {
    id
    companySearch
    externalName
    name
    segment {
      id
      collectionId
      collection {
        id
        name
      }
      enabledDestinationsCount
      name
      search
      type
      ...AudiencesSegmentFormSegment
    }
    service
    subtype
    personSearch
    ...AudiencesLayout
  }
  companyCollections: collections(type: Company) {
    edges {
      node {
        id
        ...AudiencesSegmentFormCollection
      }
    }
  }
  companySearchAttributes: searchAttributes(categories: [system, enrichment, salesforce, hubspot, traits, pageview_filter], salesforceSubCategories: [account, opportunity], hubspotSubCategories: [company, deal], type: Company) {
    ...AudiencesSegmentFormAttribute
  }
  personCollections: collections(type: Person) {
    edges {
      node {
        id
        ...AudiencesSegmentFormCollection
      }
    }
  }
  personSearchAttributes: searchAttributes(categories: [system, enrichment, salesforce, hubspot, traits, pageview_filter], salesforceSubCategories: [account, contact, lead], hubspotSubCategories: [company, contact], type: Person) {
    ...AudiencesSegmentFormAttribute
  }
  prospectAudienceCompanySearchAttributes: searchAttributes(categories: [system, enrichment], type: Company) {
    ...AudiencesProspectsFormAttribute
  }
  prospectAudiencePersonSearchAttributes: searchAttributes(categories: [system, enrichment], type: Person) {
    ...AudiencesProspectsFormAttribute
  }
  salesforceUsers {
    ...AudiencesSegmentFormSegmentBuilderSalesforceUser
    ...AudiencesProspectsFormSegmentBuilderSalesforceUser
  }
  viewer {
    id
    ...AudiencesLayoutViewer
  }
}
    ${AudiencesProspectsFormAccountFragmentDoc}
${AudiencesSegmentFormSegmentFragmentDoc}
${AudiencesLayoutFragmentDoc}
${AudiencesSegmentFormCollectionFragmentDoc}
${AudiencesSegmentFormAttributeFragmentDoc}
${AudiencesProspectsFormAttributeFragmentDoc}
${AudiencesSegmentFormSegmentBuilderSalesforceUserFragmentDoc}
${AudiencesProspectsFormSegmentBuilderSalesforceUserFragmentDoc}
${AudiencesLayoutViewerFragmentDoc}`;

/**
 * __useAudienceEditPageQuery__
 *
 * To run a query within a React component, call `useAudienceEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceEditPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAudienceEditPageQuery(baseOptions: Apollo.QueryHookOptions<AudienceEditPageQuery, AudienceEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceEditPageQuery, AudienceEditPageQueryVariables>(AudienceEditPageDocument, options);
      }
export function useAudienceEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceEditPageQuery, AudienceEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceEditPageQuery, AudienceEditPageQueryVariables>(AudienceEditPageDocument, options);
        }
export type AudienceEditPageQueryHookResult = ReturnType<typeof useAudienceEditPageQuery>;
export type AudienceEditPageLazyQueryHookResult = ReturnType<typeof useAudienceEditPageLazyQuery>;
export type AudienceEditPageQueryResult = Apollo.QueryResult<AudienceEditPageQuery, AudienceEditPageQueryVariables>;
export const UpdateDocument = gql`
    mutation Update($input: SalesPipelinesUpdateInput!) {
  response: updateSalesPipeline(input: $input) {
    node {
      ...SalesPipeline
    }
  }
}
    ${SalesPipelineFragmentDoc}`;
export type UpdateMutationFn = Apollo.MutationFunction<UpdateMutation, UpdateMutationVariables>;

/**
 * __useUpdateMutation__
 *
 * To run a mutation, you first call `useUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMutation, { data, loading, error }] = useUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMutation, UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMutation, UpdateMutationVariables>(UpdateDocument, options);
      }
export type UpdateMutationHookResult = ReturnType<typeof useUpdateMutation>;
export type UpdateMutationResult = Apollo.MutationResult<UpdateMutation>;
export type UpdateMutationOptions = Apollo.BaseMutationOptions<UpdateMutation, UpdateMutationVariables>;
export const RoiConfigurationQueryDocument = gql`
    query ROIConfigurationQuery {
  searchAttributes(categories: [system, enrichment, salesforce, hubspot, traits, pageview_filter], salesforceSubCategories: [account, contact, lead], hubspotSubCategories: [company, contact], type: Person) {
    ...SearchBuilderAttribute
  }
  salesPipeline {
    ...SalesPipeline
  }
}
    ${SearchBuilderAttributeFragmentDoc}
${SalesPipelineFragmentDoc}`;

/**
 * __useRoiConfigurationQueryQuery__
 *
 * To run a query within a React component, call `useRoiConfigurationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoiConfigurationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoiConfigurationQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoiConfigurationQueryQuery(baseOptions?: Apollo.QueryHookOptions<RoiConfigurationQueryQuery, RoiConfigurationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoiConfigurationQueryQuery, RoiConfigurationQueryQueryVariables>(RoiConfigurationQueryDocument, options);
      }
export function useRoiConfigurationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoiConfigurationQueryQuery, RoiConfigurationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoiConfigurationQueryQuery, RoiConfigurationQueryQueryVariables>(RoiConfigurationQueryDocument, options);
        }
export type RoiConfigurationQueryQueryHookResult = ReturnType<typeof useRoiConfigurationQueryQuery>;
export type RoiConfigurationQueryLazyQueryHookResult = ReturnType<typeof useRoiConfigurationQueryLazyQuery>;
export type RoiConfigurationQueryQueryResult = Apollo.QueryResult<RoiConfigurationQueryQuery, RoiConfigurationQueryQueryVariables>;
export const UpdateAudienceDocument = gql`
    mutation UpdateAudience($input: AudiencesUpdateInput!) {
  response: updateAudience(input: $input) {
    node {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateAudienceMutationFn = Apollo.MutationFunction<UpdateAudienceMutation, UpdateAudienceMutationVariables>;

/**
 * __useUpdateAudienceMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceMutation, { data, loading, error }] = useUpdateAudienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAudienceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAudienceMutation, UpdateAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAudienceMutation, UpdateAudienceMutationVariables>(UpdateAudienceDocument, options);
      }
export type UpdateAudienceMutationHookResult = ReturnType<typeof useUpdateAudienceMutation>;
export type UpdateAudienceMutationResult = Apollo.MutationResult<UpdateAudienceMutation>;
export type UpdateAudienceMutationOptions = Apollo.BaseMutationOptions<UpdateAudienceMutation, UpdateAudienceMutationVariables>;
export const ExportSalesPipelineQueryDocument = gql`
    query ExportSalesPipelineQuery($dateWindow: DateWindowEnum) {
  salesPipeline(dateWindow: $dateWindow) {
    snapshots {
      date
      exportProxyUrl
    }
  }
}
    `;

/**
 * __useExportSalesPipelineQueryQuery__
 *
 * To run a query within a React component, call `useExportSalesPipelineQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSalesPipelineQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSalesPipelineQueryQuery({
 *   variables: {
 *      dateWindow: // value for 'dateWindow'
 *   },
 * });
 */
export function useExportSalesPipelineQueryQuery(baseOptions?: Apollo.QueryHookOptions<ExportSalesPipelineQueryQuery, ExportSalesPipelineQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSalesPipelineQueryQuery, ExportSalesPipelineQueryQueryVariables>(ExportSalesPipelineQueryDocument, options);
      }
export function useExportSalesPipelineQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSalesPipelineQueryQuery, ExportSalesPipelineQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSalesPipelineQueryQuery, ExportSalesPipelineQueryQueryVariables>(ExportSalesPipelineQueryDocument, options);
        }
export type ExportSalesPipelineQueryQueryHookResult = ReturnType<typeof useExportSalesPipelineQueryQuery>;
export type ExportSalesPipelineQueryLazyQueryHookResult = ReturnType<typeof useExportSalesPipelineQueryLazyQuery>;
export type ExportSalesPipelineQueryQueryResult = Apollo.QueryResult<ExportSalesPipelineQueryQuery, ExportSalesPipelineQueryQueryVariables>;
export const AudiencesPageDocument = gql`
    query AudiencesPage($order: AudienceOrderEnum, $query: String, $dateWindow: DateWindowEnum) {
  accountNotifications {
    ...AccountNotifications
  }
  audiences(order: $order, query: $query) {
    edges {
      node {
        id
        createdAt
        externalName
        name
        pushProgress
        pushedAt
        status
        statusMessage
        subtype
        user {
          id
          name
        }
        ...AudiencesHealthIndicator
        ...AudiencesServiceIcon
        ...AudiencesStatusIcon
        ...AudiencesTile
      }
    }
    totalCount
  }
  adMetrics(dateWindow: $dateWindow) {
    ...AdMetrics
  }
  campaigns(dateWindow: $dateWindow) {
    ...Campaigns
  }
  salesPipeline(dateWindow: $dateWindow) {
    ...SalesPipeline
  }
  viewer {
    canExportAdAudiencesToLinkedin
    canAccessSalesPipelineExports
    id
  }
}
    ${AccountNotificationsFragmentDoc}
${AudiencesHealthIndicatorFragmentDoc}
${AudiencesServiceIconFragmentDoc}
${AudiencesStatusIconFragmentDoc}
${AudiencesTileFragmentDoc}
${AdMetricsFragmentDoc}
${CampaignsFragmentDoc}
${SalesPipelineFragmentDoc}`;

/**
 * __useAudiencesPageQuery__
 *
 * To run a query within a React component, call `useAudiencesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesPageQuery({
 *   variables: {
 *      order: // value for 'order'
 *      query: // value for 'query'
 *      dateWindow: // value for 'dateWindow'
 *   },
 * });
 */
export function useAudiencesPageQuery(baseOptions?: Apollo.QueryHookOptions<AudiencesPageQuery, AudiencesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencesPageQuery, AudiencesPageQueryVariables>(AudiencesPageDocument, options);
      }
export function useAudiencesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencesPageQuery, AudiencesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencesPageQuery, AudiencesPageQueryVariables>(AudiencesPageDocument, options);
        }
export type AudiencesPageQueryHookResult = ReturnType<typeof useAudiencesPageQuery>;
export type AudiencesPageLazyQueryHookResult = ReturnType<typeof useAudiencesPageLazyQuery>;
export type AudiencesPageQueryResult = Apollo.QueryResult<AudiencesPageQuery, AudiencesPageQueryVariables>;
export const CreateAudienceDocument = gql`
    mutation CreateAudience($input: AudiencesCreateInput!) {
  response: createAudience(input: $input) {
    node {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateAudienceMutationFn = Apollo.MutationFunction<CreateAudienceMutation, CreateAudienceMutationVariables>;

/**
 * __useCreateAudienceMutation__
 *
 * To run a mutation, you first call `useCreateAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceMutation, { data, loading, error }] = useCreateAudienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAudienceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudienceMutation, CreateAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudienceMutation, CreateAudienceMutationVariables>(CreateAudienceDocument, options);
      }
export type CreateAudienceMutationHookResult = ReturnType<typeof useCreateAudienceMutation>;
export type CreateAudienceMutationResult = Apollo.MutationResult<CreateAudienceMutation>;
export type CreateAudienceMutationOptions = Apollo.BaseMutationOptions<CreateAudienceMutation, CreateAudienceMutationVariables>;
export const AudienceNewPageDocument = gql`
    query AudienceNewPage($segmentId: ID, $segmentType: SegmentTypeEnum) {
  account {
    id
    ...AudienceNewPageTypePickerAccount
    ...AudiencesProspectsFormAccount
  }
  companyCollections: collections(type: Company) {
    edges {
      node {
        id
        ...AudiencesSegmentFormCollection
      }
    }
  }
  companySearchAttributes: searchAttributes(categories: [system, enrichment, salesforce, hubspot, traits, pageview_filter], salesforceSubCategories: [account, opportunity], hubspotSubCategories: [company, deal], type: Company) {
    ...AudiencesSegmentFormAttribute
  }
  personCollections: collections(type: Person) {
    edges {
      node {
        id
        ...AudiencesSegmentFormCollection
      }
    }
  }
  personSearchAttributes: searchAttributes(categories: [system, enrichment, salesforce, hubspot, traits, pageview_filter], salesforceSubCategories: [account, contact, lead], hubspotSubCategories: [company, contact], type: Person) {
    ...AudiencesSegmentFormAttribute
  }
  prospectAudienceCompanySearchAttributes: searchAttributes(categories: [system, enrichment], type: Company) {
    ...AudiencesProspectsFormAttribute
  }
  prospectAudiencePersonSearchAttributes: searchAttributes(categories: [system, enrichment], type: Person) {
    ...AudiencesProspectsFormAttribute
  }
  salesforceUsers {
    ...AudiencesSegmentFormSegmentBuilderSalesforceUser
    ...AudiencesProspectsFormSegmentBuilderSalesforceUser
  }
  segment(id: $segmentId, type: $segmentType) {
    id
    name
    type
    ...AudiencesSegmentFormSegment
  }
  viewer {
    id
    canAccessGoogleContactAudiences
    canAccessGoogleManagedVisitorAudiences
  }
}
    ${AudienceNewPageTypePickerAccountFragmentDoc}
${AudiencesProspectsFormAccountFragmentDoc}
${AudiencesSegmentFormCollectionFragmentDoc}
${AudiencesSegmentFormAttributeFragmentDoc}
${AudiencesProspectsFormAttributeFragmentDoc}
${AudiencesSegmentFormSegmentBuilderSalesforceUserFragmentDoc}
${AudiencesProspectsFormSegmentBuilderSalesforceUserFragmentDoc}
${AudiencesSegmentFormSegmentFragmentDoc}`;

/**
 * __useAudienceNewPageQuery__
 *
 * To run a query within a React component, call `useAudienceNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceNewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceNewPageQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *      segmentType: // value for 'segmentType'
 *   },
 * });
 */
export function useAudienceNewPageQuery(baseOptions?: Apollo.QueryHookOptions<AudienceNewPageQuery, AudienceNewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceNewPageQuery, AudienceNewPageQueryVariables>(AudienceNewPageDocument, options);
      }
export function useAudienceNewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceNewPageQuery, AudienceNewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceNewPageQuery, AudienceNewPageQueryVariables>(AudienceNewPageDocument, options);
        }
export type AudienceNewPageQueryHookResult = ReturnType<typeof useAudienceNewPageQuery>;
export type AudienceNewPageLazyQueryHookResult = ReturnType<typeof useAudienceNewPageLazyQuery>;
export type AudienceNewPageQueryResult = Apollo.QueryResult<AudienceNewPageQuery, AudienceNewPageQueryVariables>;
export const AudiencePageDocument = gql`
    query AudiencePage($id: ID!) {
  audience(id: $id) {
    id
    name
    status
    subtype
    ...AudienceCompanyInsights
    ...AudiencePersonInsights
    ...AudienceSourceDestinationInfo
    ...AudienceSummary
    ...AudiencesLayout
  }
  viewer {
    id
    ...AudiencesLayoutViewer
  }
}
    ${AudienceCompanyInsightsFragmentDoc}
${AudiencePersonInsightsFragmentDoc}
${AudienceSourceDestinationInfoFragmentDoc}
${AudienceSummaryFragmentDoc}
${AudiencesLayoutFragmentDoc}
${AudiencesLayoutViewerFragmentDoc}`;

/**
 * __useAudiencePageQuery__
 *
 * To run a query within a React component, call `useAudiencePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAudiencePageQuery(baseOptions: Apollo.QueryHookOptions<AudiencePageQuery, AudiencePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencePageQuery, AudiencePageQueryVariables>(AudiencePageDocument, options);
      }
export function useAudiencePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencePageQuery, AudiencePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencePageQuery, AudiencePageQueryVariables>(AudiencePageDocument, options);
        }
export type AudiencePageQueryHookResult = ReturnType<typeof useAudiencePageQuery>;
export type AudiencePageLazyQueryHookResult = ReturnType<typeof useAudiencePageLazyQuery>;
export type AudiencePageQueryResult = Apollo.QueryResult<AudiencePageQuery, AudiencePageQueryVariables>;
export const DestroyAudienceDocument = gql`
    mutation DestroyAudience($input: AudiencesDestroyInput!) {
  response: destroyAudience(input: $input) {
    clientMutationId
  }
}
    `;
export type DestroyAudienceMutationFn = Apollo.MutationFunction<DestroyAudienceMutation, DestroyAudienceMutationVariables>;

/**
 * __useDestroyAudienceMutation__
 *
 * To run a mutation, you first call `useDestroyAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyAudienceMutation, { data, loading, error }] = useDestroyAudienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyAudienceMutation(baseOptions?: Apollo.MutationHookOptions<DestroyAudienceMutation, DestroyAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyAudienceMutation, DestroyAudienceMutationVariables>(DestroyAudienceDocument, options);
      }
export type DestroyAudienceMutationHookResult = ReturnType<typeof useDestroyAudienceMutation>;
export type DestroyAudienceMutationResult = Apollo.MutationResult<DestroyAudienceMutation>;
export type DestroyAudienceMutationOptions = Apollo.BaseMutationOptions<DestroyAudienceMutation, DestroyAudienceMutationVariables>;
export const ExportAudienceDocument = gql`
    mutation ExportAudience($input: AudiencesExportInput!) {
  response: exportAudience(input: $input) {
    clientMutationId
    errors {
      field
      messages
    }
  }
}
    `;
export type ExportAudienceMutationFn = Apollo.MutationFunction<ExportAudienceMutation, ExportAudienceMutationVariables>;

/**
 * __useExportAudienceMutation__
 *
 * To run a mutation, you first call `useExportAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAudienceMutation, { data, loading, error }] = useExportAudienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportAudienceMutation(baseOptions?: Apollo.MutationHookOptions<ExportAudienceMutation, ExportAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAudienceMutation, ExportAudienceMutationVariables>(ExportAudienceDocument, options);
      }
export type ExportAudienceMutationHookResult = ReturnType<typeof useExportAudienceMutation>;
export type ExportAudienceMutationResult = Apollo.MutationResult<ExportAudienceMutation>;
export type ExportAudienceMutationOptions = Apollo.BaseMutationOptions<ExportAudienceMutation, ExportAudienceMutationVariables>;
export const CreateAudienceSizePreviewDocument = gql`
    mutation CreateAudienceSizePreview($input: AudiencePreviewsCreateInput!) {
  response: createAudiencePreview(input: $input) {
    node {
      id
      status
    }
  }
}
    `;
export type CreateAudienceSizePreviewMutationFn = Apollo.MutationFunction<CreateAudienceSizePreviewMutation, CreateAudienceSizePreviewMutationVariables>;

/**
 * __useCreateAudienceSizePreviewMutation__
 *
 * To run a mutation, you first call `useCreateAudienceSizePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceSizePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceSizePreviewMutation, { data, loading, error }] = useCreateAudienceSizePreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAudienceSizePreviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudienceSizePreviewMutation, CreateAudienceSizePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudienceSizePreviewMutation, CreateAudienceSizePreviewMutationVariables>(CreateAudienceSizePreviewDocument, options);
      }
export type CreateAudienceSizePreviewMutationHookResult = ReturnType<typeof useCreateAudienceSizePreviewMutation>;
export type CreateAudienceSizePreviewMutationResult = Apollo.MutationResult<CreateAudienceSizePreviewMutation>;
export type CreateAudienceSizePreviewMutationOptions = Apollo.BaseMutationOptions<CreateAudienceSizePreviewMutation, CreateAudienceSizePreviewMutationVariables>;
export const AudiencePreviewDocument = gql`
    query AudiencePreview($id: ID!) {
  audiencePreview(id: $id) {
    estimatedExternalSize
    id
    status
  }
}
    `;

/**
 * __useAudiencePreviewQuery__
 *
 * To run a query within a React component, call `useAudiencePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAudiencePreviewQuery(baseOptions: Apollo.QueryHookOptions<AudiencePreviewQuery, AudiencePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencePreviewQuery, AudiencePreviewQueryVariables>(AudiencePreviewDocument, options);
      }
export function useAudiencePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencePreviewQuery, AudiencePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencePreviewQuery, AudiencePreviewQueryVariables>(AudiencePreviewDocument, options);
        }
export type AudiencePreviewQueryHookResult = ReturnType<typeof useAudiencePreviewQuery>;
export type AudiencePreviewLazyQueryHookResult = ReturnType<typeof useAudiencePreviewLazyQuery>;
export type AudiencePreviewQueryResult = Apollo.QueryResult<AudiencePreviewQuery, AudiencePreviewQueryVariables>;
export const RefreshFacebookAdAccountDocument = gql`
    mutation RefreshFacebookAdAccount($input: AccountConnectorsRefreshFacebookAdAccountInput!) {
  response: refreshFacebookAdAccount(input: $input) {
    node {
      id
      termsAccepted
    }
  }
}
    `;
export type RefreshFacebookAdAccountMutationFn = Apollo.MutationFunction<RefreshFacebookAdAccountMutation, RefreshFacebookAdAccountMutationVariables>;

/**
 * __useRefreshFacebookAdAccountMutation__
 *
 * To run a mutation, you first call `useRefreshFacebookAdAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshFacebookAdAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshFacebookAdAccountMutation, { data, loading, error }] = useRefreshFacebookAdAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshFacebookAdAccountMutation(baseOptions?: Apollo.MutationHookOptions<RefreshFacebookAdAccountMutation, RefreshFacebookAdAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshFacebookAdAccountMutation, RefreshFacebookAdAccountMutationVariables>(RefreshFacebookAdAccountDocument, options);
      }
export type RefreshFacebookAdAccountMutationHookResult = ReturnType<typeof useRefreshFacebookAdAccountMutation>;
export type RefreshFacebookAdAccountMutationResult = Apollo.MutationResult<RefreshFacebookAdAccountMutation>;
export type RefreshFacebookAdAccountMutationOptions = Apollo.BaseMutationOptions<RefreshFacebookAdAccountMutation, RefreshFacebookAdAccountMutationVariables>;
export const AudienceNewPageSyncStepDocument = gql`
    query AudienceNewPageSyncStep($fetchGoogle: Boolean!) {
  facebookAccountConnector: accountConnector(service: [facebook], status: active) {
    id
    ... on FacebookAccountConnector {
      adAccounts {
        id
        termsUrl
        adPixels {
          id
          name
        }
        termsAccepted
        name
      }
    }
  }
  googleAccountConnector: accountConnector(service: [google], status: active) @include(if: $fetchGoogle) {
    id
    remoteMeta
    ... on GoogleAccountConnector {
      adAccounts {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAudienceNewPageSyncStepQuery__
 *
 * To run a query within a React component, call `useAudienceNewPageSyncStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceNewPageSyncStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceNewPageSyncStepQuery({
 *   variables: {
 *      fetchGoogle: // value for 'fetchGoogle'
 *   },
 * });
 */
export function useAudienceNewPageSyncStepQuery(baseOptions: Apollo.QueryHookOptions<AudienceNewPageSyncStepQuery, AudienceNewPageSyncStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceNewPageSyncStepQuery, AudienceNewPageSyncStepQueryVariables>(AudienceNewPageSyncStepDocument, options);
      }
export function useAudienceNewPageSyncStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceNewPageSyncStepQuery, AudienceNewPageSyncStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceNewPageSyncStepQuery, AudienceNewPageSyncStepQueryVariables>(AudienceNewPageSyncStepDocument, options);
        }
export type AudienceNewPageSyncStepQueryHookResult = ReturnType<typeof useAudienceNewPageSyncStepQuery>;
export type AudienceNewPageSyncStepLazyQueryHookResult = ReturnType<typeof useAudienceNewPageSyncStepLazyQuery>;
export type AudienceNewPageSyncStepQueryResult = Apollo.QueryResult<AudienceNewPageSyncStepQuery, AudienceNewPageSyncStepQueryVariables>;
export const AllCompaniesPageDocument = gql`
    query AllCompaniesPage($companiesSegmentId: ID) {
  columns(type: Company)
  companies: allCompanies {
    ...CompaniesListConnection
  }
  account {
    ...InitialSyncAlert
  }
}
    ${CompaniesListConnectionFragmentDoc}
${InitialSyncAlertFragmentDoc}`;

/**
 * __useAllCompaniesPageQuery__
 *
 * To run a query within a React component, call `useAllCompaniesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompaniesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompaniesPageQuery({
 *   variables: {
 *      companiesSegmentId: // value for 'companiesSegmentId'
 *   },
 * });
 */
export function useAllCompaniesPageQuery(baseOptions?: Apollo.QueryHookOptions<AllCompaniesPageQuery, AllCompaniesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompaniesPageQuery, AllCompaniesPageQueryVariables>(AllCompaniesPageDocument, options);
      }
export function useAllCompaniesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompaniesPageQuery, AllCompaniesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompaniesPageQuery, AllCompaniesPageQueryVariables>(AllCompaniesPageDocument, options);
        }
export type AllCompaniesPageQueryHookResult = ReturnType<typeof useAllCompaniesPageQuery>;
export type AllCompaniesPageLazyQueryHookResult = ReturnType<typeof useAllCompaniesPageLazyQuery>;
export type AllCompaniesPageQueryResult = Apollo.QueryResult<AllCompaniesPageQuery, AllCompaniesPageQueryVariables>;
export const CompaniesSegmentPageDocument = gql`
    query CompaniesSegmentPage($companiesSegmentId: ID!) {
  columns(segmentId: $companiesSegmentId, type: Company)
  companies(segmentId: $companiesSegmentId) {
    totalCount
    ...CompaniesListConnection
  }
  segment(id: $companiesSegmentId, type: CompanySegment) {
    id
    type
    ...SegmentLayout
  }
}
    ${CompaniesListConnectionFragmentDoc}
${SegmentLayoutFragmentDoc}`;

/**
 * __useCompaniesSegmentPageQuery__
 *
 * To run a query within a React component, call `useCompaniesSegmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesSegmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesSegmentPageQuery({
 *   variables: {
 *      companiesSegmentId: // value for 'companiesSegmentId'
 *   },
 * });
 */
export function useCompaniesSegmentPageQuery(baseOptions: Apollo.QueryHookOptions<CompaniesSegmentPageQuery, CompaniesSegmentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesSegmentPageQuery, CompaniesSegmentPageQueryVariables>(CompaniesSegmentPageDocument, options);
      }
export function useCompaniesSegmentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesSegmentPageQuery, CompaniesSegmentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesSegmentPageQuery, CompaniesSegmentPageQueryVariables>(CompaniesSegmentPageDocument, options);
        }
export type CompaniesSegmentPageQueryHookResult = ReturnType<typeof useCompaniesSegmentPageQuery>;
export type CompaniesSegmentPageLazyQueryHookResult = ReturnType<typeof useCompaniesSegmentPageLazyQuery>;
export type CompaniesSegmentPageQueryResult = Apollo.QueryResult<CompaniesSegmentPageQuery, CompaniesSegmentPageQueryVariables>;
export const CompaniesPagePeopleDocument = gql`
    query CompaniesPagePeople($id: ID!, $first: Int!, $after: String, $searchQuery: String) {
  company(id: $id) {
    id
    people(after: $after, first: $first, query: $searchQuery) {
      edges {
        node {
          ...CompanyPersonListRow
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${CompanyPersonListRowFragmentDoc}`;

/**
 * __useCompaniesPagePeopleQuery__
 *
 * To run a query within a React component, call `useCompaniesPagePeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesPagePeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesPagePeopleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useCompaniesPagePeopleQuery(baseOptions: Apollo.QueryHookOptions<CompaniesPagePeopleQuery, CompaniesPagePeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesPagePeopleQuery, CompaniesPagePeopleQueryVariables>(CompaniesPagePeopleDocument, options);
      }
export function useCompaniesPagePeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesPagePeopleQuery, CompaniesPagePeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesPagePeopleQuery, CompaniesPagePeopleQueryVariables>(CompaniesPagePeopleDocument, options);
        }
export type CompaniesPagePeopleQueryHookResult = ReturnType<typeof useCompaniesPagePeopleQuery>;
export type CompaniesPagePeopleLazyQueryHookResult = ReturnType<typeof useCompaniesPagePeopleLazyQuery>;
export type CompaniesPagePeopleQueryResult = Apollo.QueryResult<CompaniesPagePeopleQuery, CompaniesPagePeopleQueryVariables>;
export const CompanySegmentsPageDocument = gql`
    query CompanySegmentsPage($id: ID!) {
  company(id: $id) {
    id
    segments {
      totalCount
      edges {
        node {
          type
          id
          name
          audiences {
            totalCount
          }
          destinationsCount
          collection {
            id
            name
          }
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useCompanySegmentsPageQuery__
 *
 * To run a query within a React component, call `useCompanySegmentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySegmentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySegmentsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanySegmentsPageQuery(baseOptions: Apollo.QueryHookOptions<CompanySegmentsPageQuery, CompanySegmentsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanySegmentsPageQuery, CompanySegmentsPageQueryVariables>(CompanySegmentsPageDocument, options);
      }
export function useCompanySegmentsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanySegmentsPageQuery, CompanySegmentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanySegmentsPageQuery, CompanySegmentsPageQueryVariables>(CompanySegmentsPageDocument, options);
        }
export type CompanySegmentsPageQueryHookResult = ReturnType<typeof useCompanySegmentsPageQuery>;
export type CompanySegmentsPageLazyQueryHookResult = ReturnType<typeof useCompanySegmentsPageLazyQuery>;
export type CompanySegmentsPageQueryResult = Apollo.QueryResult<CompanySegmentsPageQuery, CompanySegmentsPageQueryVariables>;
export const CompanyPageDocument = gql`
    query CompanyPage($id: ID!) {
  company(id: $id) {
    id
    name
    domain
    employeesRange
    enrichment
    description
    domain
    description
    legalName
    revenue
    location
    fitScore
    twitter
    facebook
    github
    linkedin
    traits
    people {
      totalCount
    }
    salesforceAccounts {
      edges {
        node {
          id
          ...CompanyPageActionsSalesforceAccount
        }
      }
    }
    hubspotCompanies {
      edges {
        node {
          ...CompanyPageActionsHubspotCompany
        }
      }
    }
    ...CompanyAttributeBrowser
    ...CompanyPageDetailsFragment
  }
  salesforceAccountConnector: accountConnector(service: [salesforce, salesforcesandbox], status: active) {
    id
    ...CompanyPageActionsSalesforceAccountConnector
    ...CompanyAttributeBrowserSalesforceAccountConnector
  }
  hubspotAccountConnector: accountConnector(service: hubspot, status: active) {
    id
    ...CompanyPageActionsHubspotAccountConnector
  }
}
    ${CompanyPageActionsSalesforceAccountFragmentDoc}
${CompanyPageActionsHubspotCompanyFragmentDoc}
${CompanyAttributeBrowserFragmentDoc}
${CompanyPageDetailsFragmentFragmentDoc}
${CompanyPageActionsSalesforceAccountConnectorFragmentDoc}
${CompanyAttributeBrowserSalesforceAccountConnectorFragmentDoc}
${CompanyPageActionsHubspotAccountConnectorFragmentDoc}`;

/**
 * __useCompanyPageQuery__
 *
 * To run a query within a React component, call `useCompanyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyPageQuery(baseOptions: Apollo.QueryHookOptions<CompanyPageQuery, CompanyPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyPageQuery, CompanyPageQueryVariables>(CompanyPageDocument, options);
      }
export function useCompanyPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyPageQuery, CompanyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyPageQuery, CompanyPageQueryVariables>(CompanyPageDocument, options);
        }
export type CompanyPageQueryHookResult = ReturnType<typeof useCompanyPageQuery>;
export type CompanyPageLazyQueryHookResult = ReturnType<typeof useCompanyPageLazyQuery>;
export type CompanyPageQueryResult = Apollo.QueryResult<CompanyPageQuery, CompanyPageQueryVariables>;
export const ConfigurationPageDocument = gql`
    query ConfigurationPage {
  account {
    id
    accountSetting {
      id
      dataSources
    }
    connectors {
      id
      service
      status
      createdAt
      ... on SalesforceAccountConnector {
        remoteMeta
        ...AccountConnectorSyncStatus
      }
      ... on HubspotAccountConnector {
        remoteMeta
        ...AccountConnectorSyncStatus
      }
      ... on MarketoAccountConnector {
        remoteMeta
      }
    }
    flags
  }
  viewer {
    id
    canAccessGaDataLayer
  }
  tagManager(service: google) {
    id
    status
    pushToDataLayer
  }
  googleAnalyticsConfig {
    id
    enabled
  }
  googleTagManagerConfig {
    id
    enabled
  }
}
    ${AccountConnectorSyncStatusFragmentDoc}`;

/**
 * __useConfigurationPageQuery__
 *
 * To run a query within a React component, call `useConfigurationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfigurationPageQuery(baseOptions?: Apollo.QueryHookOptions<ConfigurationPageQuery, ConfigurationPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationPageQuery, ConfigurationPageQueryVariables>(ConfigurationPageDocument, options);
      }
export function useConfigurationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationPageQuery, ConfigurationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationPageQuery, ConfigurationPageQueryVariables>(ConfigurationPageDocument, options);
        }
export type ConfigurationPageQueryHookResult = ReturnType<typeof useConfigurationPageQuery>;
export type ConfigurationPageLazyQueryHookResult = ReturnType<typeof useConfigurationPageLazyQuery>;
export type ConfigurationPageQueryResult = Apollo.QueryResult<ConfigurationPageQuery, ConfigurationPageQueryVariables>;
export const UpsertTagManagerDocument = gql`
    mutation UpsertTagManager($input: TagManagerUpsertInput!) {
  response: upsertTagManager(input: $input) {
    clientMutationId
  }
}
    `;
export type UpsertTagManagerMutationFn = Apollo.MutationFunction<UpsertTagManagerMutation, UpsertTagManagerMutationVariables>;

/**
 * __useUpsertTagManagerMutation__
 *
 * To run a mutation, you first call `useUpsertTagManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTagManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTagManagerMutation, { data, loading, error }] = useUpsertTagManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTagManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTagManagerMutation, UpsertTagManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTagManagerMutation, UpsertTagManagerMutationVariables>(UpsertTagManagerDocument, options);
      }
export type UpsertTagManagerMutationHookResult = ReturnType<typeof useUpsertTagManagerMutation>;
export type UpsertTagManagerMutationResult = Apollo.MutationResult<UpsertTagManagerMutation>;
export type UpsertTagManagerMutationOptions = Apollo.BaseMutationOptions<UpsertTagManagerMutation, UpsertTagManagerMutationVariables>;
export const DestroyAccountConnectorDocument = gql`
    mutation DestroyAccountConnector($input: AccountConnectorsDestroyInput!) {
  response: destroyAccountConnector(input: $input) {
    node {
      id
      status
    }
  }
}
    `;
export type DestroyAccountConnectorMutationFn = Apollo.MutationFunction<DestroyAccountConnectorMutation, DestroyAccountConnectorMutationVariables>;

/**
 * __useDestroyAccountConnectorMutation__
 *
 * To run a mutation, you first call `useDestroyAccountConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyAccountConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyAccountConnectorMutation, { data, loading, error }] = useDestroyAccountConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyAccountConnectorMutation(baseOptions?: Apollo.MutationHookOptions<DestroyAccountConnectorMutation, DestroyAccountConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyAccountConnectorMutation, DestroyAccountConnectorMutationVariables>(DestroyAccountConnectorDocument, options);
      }
export type DestroyAccountConnectorMutationHookResult = ReturnType<typeof useDestroyAccountConnectorMutation>;
export type DestroyAccountConnectorMutationResult = Apollo.MutationResult<DestroyAccountConnectorMutation>;
export type DestroyAccountConnectorMutationOptions = Apollo.BaseMutationOptions<DestroyAccountConnectorMutation, DestroyAccountConnectorMutationVariables>;
export const AccountConnectorConfigurationDocument = gql`
    query AccountConnectorConfiguration($service: [AccountConnectorServiceEnum!]!) {
  accountConnector(service: $service, status: [active, disconnected, error]) {
    id
    status
    service
    createdAt
    remoteMeta
    notification {
      ...AccountNotifications
    }
    ...AccountConnectorSyncStatus
    ... on GoogleAccountConnector {
      adAccounts {
        id
        name
        displayName
      }
    }
    ... on HubspotAccountConnector {
      hubspotAccountId
    }
  }
}
    ${AccountNotificationsFragmentDoc}
${AccountConnectorSyncStatusFragmentDoc}`;

/**
 * __useAccountConnectorConfigurationQuery__
 *
 * To run a query within a React component, call `useAccountConnectorConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountConnectorConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountConnectorConfigurationQuery({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useAccountConnectorConfigurationQuery(baseOptions: Apollo.QueryHookOptions<AccountConnectorConfigurationQuery, AccountConnectorConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountConnectorConfigurationQuery, AccountConnectorConfigurationQueryVariables>(AccountConnectorConfigurationDocument, options);
      }
export function useAccountConnectorConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountConnectorConfigurationQuery, AccountConnectorConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountConnectorConfigurationQuery, AccountConnectorConfigurationQueryVariables>(AccountConnectorConfigurationDocument, options);
        }
export type AccountConnectorConfigurationQueryHookResult = ReturnType<typeof useAccountConnectorConfigurationQuery>;
export type AccountConnectorConfigurationLazyQueryHookResult = ReturnType<typeof useAccountConnectorConfigurationLazyQuery>;
export type AccountConnectorConfigurationQueryResult = Apollo.QueryResult<AccountConnectorConfigurationQuery, AccountConnectorConfigurationQueryVariables>;
export const DisconnectedAccountConnectorDocument = gql`
    query DisconnectedAccountConnector($service: [AccountConnectorServiceEnum!]!) {
  accountConnector(service: $service, status: [active]) {
    id
    service
  }
}
    `;

/**
 * __useDisconnectedAccountConnectorQuery__
 *
 * To run a query within a React component, call `useDisconnectedAccountConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisconnectedAccountConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisconnectedAccountConnectorQuery({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useDisconnectedAccountConnectorQuery(baseOptions: Apollo.QueryHookOptions<DisconnectedAccountConnectorQuery, DisconnectedAccountConnectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisconnectedAccountConnectorQuery, DisconnectedAccountConnectorQueryVariables>(DisconnectedAccountConnectorDocument, options);
      }
export function useDisconnectedAccountConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisconnectedAccountConnectorQuery, DisconnectedAccountConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisconnectedAccountConnectorQuery, DisconnectedAccountConnectorQueryVariables>(DisconnectedAccountConnectorDocument, options);
        }
export type DisconnectedAccountConnectorQueryHookResult = ReturnType<typeof useDisconnectedAccountConnectorQuery>;
export type DisconnectedAccountConnectorLazyQueryHookResult = ReturnType<typeof useDisconnectedAccountConnectorLazyQuery>;
export type DisconnectedAccountConnectorQueryResult = Apollo.QueryResult<DisconnectedAccountConnectorQuery, DisconnectedAccountConnectorQueryVariables>;
export const UpdateDisconnectedAccountConnectorDocument = gql`
    mutation UpdateDisconnectedAccountConnector($input: AccountConnectorsUpdateInput!) {
  response: updateAccountConnector(input: $input) {
    node {
      id
      service
    }
  }
}
    `;
export type UpdateDisconnectedAccountConnectorMutationFn = Apollo.MutationFunction<UpdateDisconnectedAccountConnectorMutation, UpdateDisconnectedAccountConnectorMutationVariables>;

/**
 * __useUpdateDisconnectedAccountConnectorMutation__
 *
 * To run a mutation, you first call `useUpdateDisconnectedAccountConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisconnectedAccountConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisconnectedAccountConnectorMutation, { data, loading, error }] = useUpdateDisconnectedAccountConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDisconnectedAccountConnectorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDisconnectedAccountConnectorMutation, UpdateDisconnectedAccountConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDisconnectedAccountConnectorMutation, UpdateDisconnectedAccountConnectorMutationVariables>(UpdateDisconnectedAccountConnectorDocument, options);
      }
export type UpdateDisconnectedAccountConnectorMutationHookResult = ReturnType<typeof useUpdateDisconnectedAccountConnectorMutation>;
export type UpdateDisconnectedAccountConnectorMutationResult = Apollo.MutationResult<UpdateDisconnectedAccountConnectorMutation>;
export type UpdateDisconnectedAccountConnectorMutationOptions = Apollo.BaseMutationOptions<UpdateDisconnectedAccountConnectorMutation, UpdateDisconnectedAccountConnectorMutationVariables>;
export const SegmentConfigDocument = gql`
    query SegmentConfig {
  account {
    id
    publishableToken
  }
}
    `;

/**
 * __useSegmentConfigQuery__
 *
 * To run a query within a React component, call `useSegmentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentConfigQuery(baseOptions?: Apollo.QueryHookOptions<SegmentConfigQuery, SegmentConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentConfigQuery, SegmentConfigQueryVariables>(SegmentConfigDocument, options);
      }
export function useSegmentConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentConfigQuery, SegmentConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentConfigQuery, SegmentConfigQueryVariables>(SegmentConfigDocument, options);
        }
export type SegmentConfigQueryHookResult = ReturnType<typeof useSegmentConfigQuery>;
export type SegmentConfigLazyQueryHookResult = ReturnType<typeof useSegmentConfigLazyQuery>;
export type SegmentConfigQueryResult = Apollo.QueryResult<SegmentConfigQuery, SegmentConfigQueryVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($input: AccountUpdateInput!) {
  response: updateAccount(input: $input) {
    node {
      id
      remoteAllowedReferrers
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const JavaScriptConfigurationDocument = gql`
    query JavaScriptConfiguration {
  account {
    id
    plans
    publishableToken
    remoteAllowedReferrers
  }
  tagManager(service: reveal) {
    id
    status
  }
}
    `;

/**
 * __useJavaScriptConfigurationQuery__
 *
 * To run a query within a React component, call `useJavaScriptConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useJavaScriptConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJavaScriptConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useJavaScriptConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<JavaScriptConfigurationQuery, JavaScriptConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JavaScriptConfigurationQuery, JavaScriptConfigurationQueryVariables>(JavaScriptConfigurationDocument, options);
      }
export function useJavaScriptConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JavaScriptConfigurationQuery, JavaScriptConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JavaScriptConfigurationQuery, JavaScriptConfigurationQueryVariables>(JavaScriptConfigurationDocument, options);
        }
export type JavaScriptConfigurationQueryHookResult = ReturnType<typeof useJavaScriptConfigurationQuery>;
export type JavaScriptConfigurationLazyQueryHookResult = ReturnType<typeof useJavaScriptConfigurationLazyQuery>;
export type JavaScriptConfigurationQueryResult = Apollo.QueryResult<JavaScriptConfigurationQuery, JavaScriptConfigurationQueryVariables>;
export const UpdateGoogleAccountTypeDocument = gql`
    mutation UpdateGoogleAccountType($input: AccountConnectorsUpdateInput!) {
  response: updateAccountConnector(input: $input) {
    node {
      id
      remoteMeta
    }
  }
}
    `;
export type UpdateGoogleAccountTypeMutationFn = Apollo.MutationFunction<UpdateGoogleAccountTypeMutation, UpdateGoogleAccountTypeMutationVariables>;

/**
 * __useUpdateGoogleAccountTypeMutation__
 *
 * To run a mutation, you first call `useUpdateGoogleAccountTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoogleAccountTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoogleAccountTypeMutation, { data, loading, error }] = useUpdateGoogleAccountTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGoogleAccountTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoogleAccountTypeMutation, UpdateGoogleAccountTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoogleAccountTypeMutation, UpdateGoogleAccountTypeMutationVariables>(UpdateGoogleAccountTypeDocument, options);
      }
export type UpdateGoogleAccountTypeMutationHookResult = ReturnType<typeof useUpdateGoogleAccountTypeMutation>;
export type UpdateGoogleAccountTypeMutationResult = Apollo.MutationResult<UpdateGoogleAccountTypeMutation>;
export type UpdateGoogleAccountTypeMutationOptions = Apollo.BaseMutationOptions<UpdateGoogleAccountTypeMutation, UpdateGoogleAccountTypeMutationVariables>;
export const CreateOrUpdateGoogleDimensionMappingDocument = gql`
    mutation CreateOrUpdateGoogleDimensionMapping($input: GoogleDimensionMappingCreateOrUpdateInput!) {
  response: createOrUpdateGoogleDimensionMapping(input: $input) {
    node {
      ...GoogleAnalyticsDimensionMapping
    }
  }
}
    ${GoogleAnalyticsDimensionMappingFragmentDoc}`;
export type CreateOrUpdateGoogleDimensionMappingMutationFn = Apollo.MutationFunction<CreateOrUpdateGoogleDimensionMappingMutation, CreateOrUpdateGoogleDimensionMappingMutationVariables>;

/**
 * __useCreateOrUpdateGoogleDimensionMappingMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateGoogleDimensionMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateGoogleDimensionMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateGoogleDimensionMappingMutation, { data, loading, error }] = useCreateOrUpdateGoogleDimensionMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateGoogleDimensionMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateGoogleDimensionMappingMutation, CreateOrUpdateGoogleDimensionMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateGoogleDimensionMappingMutation, CreateOrUpdateGoogleDimensionMappingMutationVariables>(CreateOrUpdateGoogleDimensionMappingDocument, options);
      }
export type CreateOrUpdateGoogleDimensionMappingMutationHookResult = ReturnType<typeof useCreateOrUpdateGoogleDimensionMappingMutation>;
export type CreateOrUpdateGoogleDimensionMappingMutationResult = Apollo.MutationResult<CreateOrUpdateGoogleDimensionMappingMutation>;
export type CreateOrUpdateGoogleDimensionMappingMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateGoogleDimensionMappingMutation, CreateOrUpdateGoogleDimensionMappingMutationVariables>;
export const DestroyGoogleDimensionMappingDocument = gql`
    mutation DestroyGoogleDimensionMapping($input: GoogleDimensionMappingDestroyInput!) {
  response: destroyGoogleDimensionMapping(input: $input) {
    clientMutationId
  }
}
    `;
export type DestroyGoogleDimensionMappingMutationFn = Apollo.MutationFunction<DestroyGoogleDimensionMappingMutation, DestroyGoogleDimensionMappingMutationVariables>;

/**
 * __useDestroyGoogleDimensionMappingMutation__
 *
 * To run a mutation, you first call `useDestroyGoogleDimensionMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyGoogleDimensionMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyGoogleDimensionMappingMutation, { data, loading, error }] = useDestroyGoogleDimensionMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyGoogleDimensionMappingMutation(baseOptions?: Apollo.MutationHookOptions<DestroyGoogleDimensionMappingMutation, DestroyGoogleDimensionMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyGoogleDimensionMappingMutation, DestroyGoogleDimensionMappingMutationVariables>(DestroyGoogleDimensionMappingDocument, options);
      }
export type DestroyGoogleDimensionMappingMutationHookResult = ReturnType<typeof useDestroyGoogleDimensionMappingMutation>;
export type DestroyGoogleDimensionMappingMutationResult = Apollo.MutationResult<DestroyGoogleDimensionMappingMutation>;
export type DestroyGoogleDimensionMappingMutationOptions = Apollo.BaseMutationOptions<DestroyGoogleDimensionMappingMutation, DestroyGoogleDimensionMappingMutationVariables>;
export const RevealGaDocument = gql`
    query RevealGA($attributeType: AttributeTypeEnum!) {
  attributes(type: $attributeType, categories: [enrichment]) {
    value
    label
    category
    subCategory
    attributeType
  }
  tagManager(service: google) {
    id
    pushToDataLayer
    googleDimensionMappings {
      ...GoogleAnalyticsDimensionMapping
    }
  }
  googleTagManagerConfig {
    id
  }
}
    ${GoogleAnalyticsDimensionMappingFragmentDoc}`;

/**
 * __useRevealGaQuery__
 *
 * To run a query within a React component, call `useRevealGaQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevealGaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevealGaQuery({
 *   variables: {
 *      attributeType: // value for 'attributeType'
 *   },
 * });
 */
export function useRevealGaQuery(baseOptions: Apollo.QueryHookOptions<RevealGaQuery, RevealGaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevealGaQuery, RevealGaQueryVariables>(RevealGaDocument, options);
      }
export function useRevealGaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevealGaQuery, RevealGaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevealGaQuery, RevealGaQueryVariables>(RevealGaDocument, options);
        }
export type RevealGaQueryHookResult = ReturnType<typeof useRevealGaQuery>;
export type RevealGaLazyQueryHookResult = ReturnType<typeof useRevealGaLazyQuery>;
export type RevealGaQueryResult = Apollo.QueryResult<RevealGaQuery, RevealGaQueryVariables>;
export const RefreshRemoteMetaDocument = gql`
    mutation RefreshRemoteMeta($input: AccountConnectorsRefreshRemoteMetaInput!) {
  response: refreshRemoteMeta(input: $input) {
    node {
      id
      remoteMeta
    }
  }
}
    `;
export type RefreshRemoteMetaMutationFn = Apollo.MutationFunction<RefreshRemoteMetaMutation, RefreshRemoteMetaMutationVariables>;

/**
 * __useRefreshRemoteMetaMutation__
 *
 * To run a mutation, you first call `useRefreshRemoteMetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshRemoteMetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshRemoteMetaMutation, { data, loading, error }] = useRefreshRemoteMetaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshRemoteMetaMutation(baseOptions?: Apollo.MutationHookOptions<RefreshRemoteMetaMutation, RefreshRemoteMetaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshRemoteMetaMutation, RefreshRemoteMetaMutationVariables>(RefreshRemoteMetaDocument, options);
      }
export type RefreshRemoteMetaMutationHookResult = ReturnType<typeof useRefreshRemoteMetaMutation>;
export type RefreshRemoteMetaMutationResult = Apollo.MutationResult<RefreshRemoteMetaMutation>;
export type RefreshRemoteMetaMutationOptions = Apollo.BaseMutationOptions<RefreshRemoteMetaMutation, RefreshRemoteMetaMutationVariables>;
export const ToggleStatusGoogleDimensionMappingDocument = gql`
    mutation ToggleStatusGoogleDimensionMapping($input: GoogleDimensionMappingToggleStatusInput!) {
  response: toggleGoogleDimensionMappingStatus(input: $input) {
    node {
      ...GoogleAnalyticsDimensionMapping
    }
  }
}
    ${GoogleAnalyticsDimensionMappingFragmentDoc}`;
export type ToggleStatusGoogleDimensionMappingMutationFn = Apollo.MutationFunction<ToggleStatusGoogleDimensionMappingMutation, ToggleStatusGoogleDimensionMappingMutationVariables>;

/**
 * __useToggleStatusGoogleDimensionMappingMutation__
 *
 * To run a mutation, you first call `useToggleStatusGoogleDimensionMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleStatusGoogleDimensionMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleStatusGoogleDimensionMappingMutation, { data, loading, error }] = useToggleStatusGoogleDimensionMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleStatusGoogleDimensionMappingMutation(baseOptions?: Apollo.MutationHookOptions<ToggleStatusGoogleDimensionMappingMutation, ToggleStatusGoogleDimensionMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleStatusGoogleDimensionMappingMutation, ToggleStatusGoogleDimensionMappingMutationVariables>(ToggleStatusGoogleDimensionMappingDocument, options);
      }
export type ToggleStatusGoogleDimensionMappingMutationHookResult = ReturnType<typeof useToggleStatusGoogleDimensionMappingMutation>;
export type ToggleStatusGoogleDimensionMappingMutationResult = Apollo.MutationResult<ToggleStatusGoogleDimensionMappingMutation>;
export type ToggleStatusGoogleDimensionMappingMutationOptions = Apollo.BaseMutationOptions<ToggleStatusGoogleDimensionMappingMutation, ToggleStatusGoogleDimensionMappingMutationVariables>;
export const RefreshGoogleAdsConnectorDocument = gql`
    mutation RefreshGoogleAdsConnector {
  refreshGoogleAdAccounts(input: {}) {
    node {
      id
      ...AccountConnectorSyncStatus
    }
  }
}
    ${AccountConnectorSyncStatusFragmentDoc}`;
export type RefreshGoogleAdsConnectorMutationFn = Apollo.MutationFunction<RefreshGoogleAdsConnectorMutation, RefreshGoogleAdsConnectorMutationVariables>;

/**
 * __useRefreshGoogleAdsConnectorMutation__
 *
 * To run a mutation, you first call `useRefreshGoogleAdsConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshGoogleAdsConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshGoogleAdsConnectorMutation, { data, loading, error }] = useRefreshGoogleAdsConnectorMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshGoogleAdsConnectorMutation(baseOptions?: Apollo.MutationHookOptions<RefreshGoogleAdsConnectorMutation, RefreshGoogleAdsConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshGoogleAdsConnectorMutation, RefreshGoogleAdsConnectorMutationVariables>(RefreshGoogleAdsConnectorDocument, options);
      }
export type RefreshGoogleAdsConnectorMutationHookResult = ReturnType<typeof useRefreshGoogleAdsConnectorMutation>;
export type RefreshGoogleAdsConnectorMutationResult = Apollo.MutationResult<RefreshGoogleAdsConnectorMutation>;
export type RefreshGoogleAdsConnectorMutationOptions = Apollo.BaseMutationOptions<RefreshGoogleAdsConnectorMutation, RefreshGoogleAdsConnectorMutationVariables>;
export const ConfigureAnalytics4Document = gql`
    mutation ConfigureAnalytics4($input: TagManagerUpsertGoogleAnalyticsConfigInput!) {
  upsertGoogleAnalyticsConfig(input: $input) {
    node {
      id
      enabled
    }
  }
}
    `;
export type ConfigureAnalytics4MutationFn = Apollo.MutationFunction<ConfigureAnalytics4Mutation, ConfigureAnalytics4MutationVariables>;

/**
 * __useConfigureAnalytics4Mutation__
 *
 * To run a mutation, you first call `useConfigureAnalytics4Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureAnalytics4Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureAnalytics4Mutation, { data, loading, error }] = useConfigureAnalytics4Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureAnalytics4Mutation(baseOptions?: Apollo.MutationHookOptions<ConfigureAnalytics4Mutation, ConfigureAnalytics4MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureAnalytics4Mutation, ConfigureAnalytics4MutationVariables>(ConfigureAnalytics4Document, options);
      }
export type ConfigureAnalytics4MutationHookResult = ReturnType<typeof useConfigureAnalytics4Mutation>;
export type ConfigureAnalytics4MutationResult = Apollo.MutationResult<ConfigureAnalytics4Mutation>;
export type ConfigureAnalytics4MutationOptions = Apollo.BaseMutationOptions<ConfigureAnalytics4Mutation, ConfigureAnalytics4MutationVariables>;
export const GoogleAnalytics4ConfigurationDocument = gql`
    query GoogleAnalytics4Configuration {
  googleAnalyticsConfig {
    id
    enabled
  }
}
    `;

/**
 * __useGoogleAnalytics4ConfigurationQuery__
 *
 * To run a query within a React component, call `useGoogleAnalytics4ConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleAnalytics4ConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleAnalytics4ConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoogleAnalytics4ConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GoogleAnalytics4ConfigurationQuery, GoogleAnalytics4ConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleAnalytics4ConfigurationQuery, GoogleAnalytics4ConfigurationQueryVariables>(GoogleAnalytics4ConfigurationDocument, options);
      }
export function useGoogleAnalytics4ConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleAnalytics4ConfigurationQuery, GoogleAnalytics4ConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleAnalytics4ConfigurationQuery, GoogleAnalytics4ConfigurationQueryVariables>(GoogleAnalytics4ConfigurationDocument, options);
        }
export type GoogleAnalytics4ConfigurationQueryHookResult = ReturnType<typeof useGoogleAnalytics4ConfigurationQuery>;
export type GoogleAnalytics4ConfigurationLazyQueryHookResult = ReturnType<typeof useGoogleAnalytics4ConfigurationLazyQuery>;
export type GoogleAnalytics4ConfigurationQueryResult = Apollo.QueryResult<GoogleAnalytics4ConfigurationQuery, GoogleAnalytics4ConfigurationQueryVariables>;
export const ConfigureGoogleTagManagerDocument = gql`
    mutation ConfigureGoogleTagManager($input: TagManagerUpsertGoogleTagManagerConfigInput!) {
  upsertGoogleTagManagerConfig(input: $input) {
    node {
      id
      enabled
    }
  }
}
    `;
export type ConfigureGoogleTagManagerMutationFn = Apollo.MutationFunction<ConfigureGoogleTagManagerMutation, ConfigureGoogleTagManagerMutationVariables>;

/**
 * __useConfigureGoogleTagManagerMutation__
 *
 * To run a mutation, you first call `useConfigureGoogleTagManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureGoogleTagManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureGoogleTagManagerMutation, { data, loading, error }] = useConfigureGoogleTagManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureGoogleTagManagerMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureGoogleTagManagerMutation, ConfigureGoogleTagManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureGoogleTagManagerMutation, ConfigureGoogleTagManagerMutationVariables>(ConfigureGoogleTagManagerDocument, options);
      }
export type ConfigureGoogleTagManagerMutationHookResult = ReturnType<typeof useConfigureGoogleTagManagerMutation>;
export type ConfigureGoogleTagManagerMutationResult = Apollo.MutationResult<ConfigureGoogleTagManagerMutation>;
export type ConfigureGoogleTagManagerMutationOptions = Apollo.BaseMutationOptions<ConfigureGoogleTagManagerMutation, ConfigureGoogleTagManagerMutationVariables>;
export const GoogleTagManagerConfigurationDocument = gql`
    query GoogleTagManagerConfiguration {
  googleTagManagerConfig {
    id
    enabled
  }
}
    `;

/**
 * __useGoogleTagManagerConfigurationQuery__
 *
 * To run a query within a React component, call `useGoogleTagManagerConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleTagManagerConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleTagManagerConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoogleTagManagerConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GoogleTagManagerConfigurationQuery, GoogleTagManagerConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleTagManagerConfigurationQuery, GoogleTagManagerConfigurationQueryVariables>(GoogleTagManagerConfigurationDocument, options);
      }
export function useGoogleTagManagerConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleTagManagerConfigurationQuery, GoogleTagManagerConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleTagManagerConfigurationQuery, GoogleTagManagerConfigurationQueryVariables>(GoogleTagManagerConfigurationDocument, options);
        }
export type GoogleTagManagerConfigurationQueryHookResult = ReturnType<typeof useGoogleTagManagerConfigurationQuery>;
export type GoogleTagManagerConfigurationLazyQueryHookResult = ReturnType<typeof useGoogleTagManagerConfigurationLazyQuery>;
export type GoogleTagManagerConfigurationQueryResult = Apollo.QueryResult<GoogleTagManagerConfigurationQuery, GoogleTagManagerConfigurationQueryVariables>;
export const DestroyDestinationDocument = gql`
    mutation DestroyDestination($input: DestinationsDestroyInput!) {
  response: destroyDestination(input: $input) {
    clientMutationId
  }
}
    `;
export type DestroyDestinationMutationFn = Apollo.MutationFunction<DestroyDestinationMutation, DestroyDestinationMutationVariables>;

/**
 * __useDestroyDestinationMutation__
 *
 * To run a mutation, you first call `useDestroyDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyDestinationMutation, { data, loading, error }] = useDestroyDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyDestinationMutation(baseOptions?: Apollo.MutationHookOptions<DestroyDestinationMutation, DestroyDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyDestinationMutation, DestroyDestinationMutationVariables>(DestroyDestinationDocument, options);
      }
export type DestroyDestinationMutationHookResult = ReturnType<typeof useDestroyDestinationMutation>;
export type DestroyDestinationMutationResult = Apollo.MutationResult<DestroyDestinationMutation>;
export type DestroyDestinationMutationOptions = Apollo.BaseMutationOptions<DestroyDestinationMutation, DestroyDestinationMutationVariables>;
export const SegmentDestinationEditPageDocument = gql`
    query SegmentDestinationEditPage($attributeType: AttributeTypeEnum!, $destinationId: ID!, $segmentId: ID!, $segmentType: SegmentTypeEnum!) {
  facebookAccountConnector: accountConnector(service: [facebook], status: [active, disconnected]) {
    id
    ...SegmentDestinationNewPageFacebookAccountConnector
  }
  googleAccountConnector: accountConnector(service: [google], status: [active, disconnected]) {
    id
    ...SegmentDestinationNewPageGoogleAccountConnector
  }
  hubspotAccountConnector: accountConnector(service: [hubspot], status: [active, disconnected]) {
    id
  }
  salesforceAccountConnector: accountConnector(service: [salesforce, salesforcesandbox], status: [active, disconnected]) {
    id
    status
  }
  slackAccountConnector: accountConnector(service: [slack], status: [active, disconnected]) {
    id
    ...SegmentDestinationNewPageSlackAccountConnector
  }
  attributes(type: $attributeType, categories: [enrichment, traits, salesforce, hubspot, pageview_display]) {
    value
    label
    category
    subCategory
    attributeType
  }
  segment(id: $segmentId, type: $segmentType) {
    id
    name
    collection {
      id
      name
    }
    destination(id: $destinationId) {
      id
      config
      triggerType
      type
      accountConnector {
        id
        remoteMeta
        status
      }
    }
    type
  }
  destinationOptions {
    facebookCurrencyOptions
    facebookEventTypeOptions
  }
}
    ${SegmentDestinationNewPageFacebookAccountConnectorFragmentDoc}
${SegmentDestinationNewPageGoogleAccountConnectorFragmentDoc}
${SegmentDestinationNewPageSlackAccountConnectorFragmentDoc}`;

/**
 * __useSegmentDestinationEditPageQuery__
 *
 * To run a query within a React component, call `useSegmentDestinationEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentDestinationEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentDestinationEditPageQuery({
 *   variables: {
 *      attributeType: // value for 'attributeType'
 *      destinationId: // value for 'destinationId'
 *      segmentId: // value for 'segmentId'
 *      segmentType: // value for 'segmentType'
 *   },
 * });
 */
export function useSegmentDestinationEditPageQuery(baseOptions: Apollo.QueryHookOptions<SegmentDestinationEditPageQuery, SegmentDestinationEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentDestinationEditPageQuery, SegmentDestinationEditPageQueryVariables>(SegmentDestinationEditPageDocument, options);
      }
export function useSegmentDestinationEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentDestinationEditPageQuery, SegmentDestinationEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentDestinationEditPageQuery, SegmentDestinationEditPageQueryVariables>(SegmentDestinationEditPageDocument, options);
        }
export type SegmentDestinationEditPageQueryHookResult = ReturnType<typeof useSegmentDestinationEditPageQuery>;
export type SegmentDestinationEditPageLazyQueryHookResult = ReturnType<typeof useSegmentDestinationEditPageLazyQuery>;
export type SegmentDestinationEditPageQueryResult = Apollo.QueryResult<SegmentDestinationEditPageQuery, SegmentDestinationEditPageQueryVariables>;
export const UpdateDestinationDocument = gql`
    mutation UpdateDestination($input: DestinationsUpdateInput!) {
  response: updateDestination(input: $input) {
    node {
      id
      config
      triggerType
      segment {
        id
        type
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateDestinationMutationFn = Apollo.MutationFunction<UpdateDestinationMutation, UpdateDestinationMutationVariables>;

/**
 * __useUpdateDestinationMutation__
 *
 * To run a mutation, you first call `useUpdateDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDestinationMutation, { data, loading, error }] = useUpdateDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDestinationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDestinationMutation, UpdateDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDestinationMutation, UpdateDestinationMutationVariables>(UpdateDestinationDocument, options);
      }
export type UpdateDestinationMutationHookResult = ReturnType<typeof useUpdateDestinationMutation>;
export type UpdateDestinationMutationResult = Apollo.MutationResult<UpdateDestinationMutation>;
export type UpdateDestinationMutationOptions = Apollo.BaseMutationOptions<UpdateDestinationMutation, UpdateDestinationMutationVariables>;
export const SegmentDestinationsPageDocument = gql`
    query SegmentDestinationsPage($segmentId: ID!, $segmentType: SegmentTypeEnum!) {
  account {
    id
    plans
  }
  slackAccountConnector: accountConnector(service: [slack], status: active) {
    id
    remoteMeta
  }
  segment(id: $segmentId, type: $segmentType) {
    id
    name
    resultsCount
    enabledDestinationsCount
    updatedAt
    ...SegmentDestinations
    ...SegmentLayout
  }
}
    ${SegmentDestinationsFragmentDoc}
${SegmentLayoutFragmentDoc}`;

/**
 * __useSegmentDestinationsPageQuery__
 *
 * To run a query within a React component, call `useSegmentDestinationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentDestinationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentDestinationsPageQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *      segmentType: // value for 'segmentType'
 *   },
 * });
 */
export function useSegmentDestinationsPageQuery(baseOptions: Apollo.QueryHookOptions<SegmentDestinationsPageQuery, SegmentDestinationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentDestinationsPageQuery, SegmentDestinationsPageQueryVariables>(SegmentDestinationsPageDocument, options);
      }
export function useSegmentDestinationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentDestinationsPageQuery, SegmentDestinationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentDestinationsPageQuery, SegmentDestinationsPageQueryVariables>(SegmentDestinationsPageDocument, options);
        }
export type SegmentDestinationsPageQueryHookResult = ReturnType<typeof useSegmentDestinationsPageQuery>;
export type SegmentDestinationsPageLazyQueryHookResult = ReturnType<typeof useSegmentDestinationsPageLazyQuery>;
export type SegmentDestinationsPageQueryResult = Apollo.QueryResult<SegmentDestinationsPageQuery, SegmentDestinationsPageQueryVariables>;
export const CreateDestinationDocument = gql`
    mutation CreateDestination($input: DestinationsCreateInput!) {
  response: createDestination(input: $input) {
    node {
      id
      type
      config
      triggerType
      accountConnector {
        id
        remoteMeta
        status
      }
      segment {
        id
        name
        type
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateDestinationMutationFn = Apollo.MutationFunction<CreateDestinationMutation, CreateDestinationMutationVariables>;

/**
 * __useCreateDestinationMutation__
 *
 * To run a mutation, you first call `useCreateDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDestinationMutation, { data, loading, error }] = useCreateDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDestinationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDestinationMutation, CreateDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDestinationMutation, CreateDestinationMutationVariables>(CreateDestinationDocument, options);
      }
export type CreateDestinationMutationHookResult = ReturnType<typeof useCreateDestinationMutation>;
export type CreateDestinationMutationResult = Apollo.MutationResult<CreateDestinationMutation>;
export type CreateDestinationMutationOptions = Apollo.BaseMutationOptions<CreateDestinationMutation, CreateDestinationMutationVariables>;
export const SegmentDestinationNewPageDocument = gql`
    query SegmentDestinationNewPage($attributeType: AttributeTypeEnum!, $includeFacebookAccountConnector: Boolean!, $includeGoogleAccountConnector: Boolean!, $includeHubspotAccountConnector: Boolean!, $includeSalesforceAccountConnector: Boolean!, $includeSlackAccountConnector: Boolean!, $segmentId: ID!, $segmentType: SegmentTypeEnum!) {
  facebookAccountConnector: accountConnector(service: [facebook], status: active) @include(if: $includeFacebookAccountConnector) {
    id
    ...SegmentDestinationNewPageFacebookAccountConnector
  }
  googleAccountConnector: accountConnector(service: [google], status: active) @include(if: $includeGoogleAccountConnector) {
    id
    ...SegmentDestinationNewPageGoogleAccountConnector
  }
  hubspotAccountConnector: accountConnector(service: [hubspot], status: active) @include(if: $includeHubspotAccountConnector) {
    id
  }
  salesforceAccountConnector: accountConnector(service: [salesforce, salesforcesandbox], status: active) @include(if: $includeSalesforceAccountConnector) {
    id
    status
  }
  slackAccountConnector: accountConnector(service: [slack], status: active) @include(if: $includeSlackAccountConnector) {
    id
    ...SegmentDestinationNewPageSlackAccountConnector
  }
  attributes(type: $attributeType, categories: [enrichment, traits, salesforce, hubspot, pageview_display]) {
    value
    label
    category
    subCategory
    attributeType
  }
  segment(id: $segmentId, type: $segmentType) {
    id
    collection {
      id
      name
    }
    name
    type
  }
  viewer {
    id
    user {
      id
      firstName
    }
  }
  destinationOptions {
    facebookCurrencyOptions
    facebookEventTypeOptions
  }
}
    ${SegmentDestinationNewPageFacebookAccountConnectorFragmentDoc}
${SegmentDestinationNewPageGoogleAccountConnectorFragmentDoc}
${SegmentDestinationNewPageSlackAccountConnectorFragmentDoc}`;

/**
 * __useSegmentDestinationNewPageQuery__
 *
 * To run a query within a React component, call `useSegmentDestinationNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentDestinationNewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentDestinationNewPageQuery({
 *   variables: {
 *      attributeType: // value for 'attributeType'
 *      includeFacebookAccountConnector: // value for 'includeFacebookAccountConnector'
 *      includeGoogleAccountConnector: // value for 'includeGoogleAccountConnector'
 *      includeHubspotAccountConnector: // value for 'includeHubspotAccountConnector'
 *      includeSalesforceAccountConnector: // value for 'includeSalesforceAccountConnector'
 *      includeSlackAccountConnector: // value for 'includeSlackAccountConnector'
 *      segmentId: // value for 'segmentId'
 *      segmentType: // value for 'segmentType'
 *   },
 * });
 */
export function useSegmentDestinationNewPageQuery(baseOptions: Apollo.QueryHookOptions<SegmentDestinationNewPageQuery, SegmentDestinationNewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentDestinationNewPageQuery, SegmentDestinationNewPageQueryVariables>(SegmentDestinationNewPageDocument, options);
      }
export function useSegmentDestinationNewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentDestinationNewPageQuery, SegmentDestinationNewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentDestinationNewPageQuery, SegmentDestinationNewPageQueryVariables>(SegmentDestinationNewPageDocument, options);
        }
export type SegmentDestinationNewPageQueryHookResult = ReturnType<typeof useSegmentDestinationNewPageQuery>;
export type SegmentDestinationNewPageLazyQueryHookResult = ReturnType<typeof useSegmentDestinationNewPageLazyQuery>;
export type SegmentDestinationNewPageQueryResult = Apollo.QueryResult<SegmentDestinationNewPageQuery, SegmentDestinationNewPageQueryVariables>;
export const ConversionEventsDocument = gql`
    query ConversionEvents($destinationId: ID!) {
  conversionEvents(destinationId: $destinationId, first: 20) {
    nodes {
      clickId
      pageviewAt
      createdAt
      person {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useConversionEventsQuery__
 *
 * To run a query within a React component, call `useConversionEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversionEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversionEventsQuery({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *   },
 * });
 */
export function useConversionEventsQuery(baseOptions: Apollo.QueryHookOptions<ConversionEventsQuery, ConversionEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversionEventsQuery, ConversionEventsQueryVariables>(ConversionEventsDocument, options);
      }
export function useConversionEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversionEventsQuery, ConversionEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversionEventsQuery, ConversionEventsQueryVariables>(ConversionEventsDocument, options);
        }
export type ConversionEventsQueryHookResult = ReturnType<typeof useConversionEventsQuery>;
export type ConversionEventsLazyQueryHookResult = ReturnType<typeof useConversionEventsLazyQuery>;
export type ConversionEventsQueryResult = Apollo.QueryResult<ConversionEventsQuery, ConversionEventsQueryVariables>;
export const DeliverTestDestinationDocument = gql`
    mutation DeliverTestDestination($input: DestinationsDeliverTestInput!) {
  response: deliverTestDestination(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeliverTestDestinationMutationFn = Apollo.MutationFunction<DeliverTestDestinationMutation, DeliverTestDestinationMutationVariables>;

/**
 * __useDeliverTestDestinationMutation__
 *
 * To run a mutation, you first call `useDeliverTestDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliverTestDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliverTestDestinationMutation, { data, loading, error }] = useDeliverTestDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeliverTestDestinationMutation(baseOptions?: Apollo.MutationHookOptions<DeliverTestDestinationMutation, DeliverTestDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeliverTestDestinationMutation, DeliverTestDestinationMutationVariables>(DeliverTestDestinationDocument, options);
      }
export type DeliverTestDestinationMutationHookResult = ReturnType<typeof useDeliverTestDestinationMutation>;
export type DeliverTestDestinationMutationResult = Apollo.MutationResult<DeliverTestDestinationMutation>;
export type DeliverTestDestinationMutationOptions = Apollo.BaseMutationOptions<DeliverTestDestinationMutation, DeliverTestDestinationMutationVariables>;
export const UpdateDestinationEnabledDocument = gql`
    mutation UpdateDestinationEnabled($input: DestinationsUpdateInput!) {
  response: updateDestination(input: $input) {
    node {
      id
      enabled
      segment {
        id
        enabledDestinationsCount
      }
    }
  }
}
    `;
export type UpdateDestinationEnabledMutationFn = Apollo.MutationFunction<UpdateDestinationEnabledMutation, UpdateDestinationEnabledMutationVariables>;

/**
 * __useUpdateDestinationEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateDestinationEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDestinationEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDestinationEnabledMutation, { data, loading, error }] = useUpdateDestinationEnabledMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDestinationEnabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDestinationEnabledMutation, UpdateDestinationEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDestinationEnabledMutation, UpdateDestinationEnabledMutationVariables>(UpdateDestinationEnabledDocument, options);
      }
export type UpdateDestinationEnabledMutationHookResult = ReturnType<typeof useUpdateDestinationEnabledMutation>;
export type UpdateDestinationEnabledMutationResult = Apollo.MutationResult<UpdateDestinationEnabledMutation>;
export type UpdateDestinationEnabledMutationOptions = Apollo.BaseMutationOptions<UpdateDestinationEnabledMutation, UpdateDestinationEnabledMutationVariables>;
export const CreateExternalRecordsSalesforceAccountsDocument = gql`
    query CreateExternalRecordsSalesforceAccounts {
  salesforceTraits(objectType: account) {
    name
    label
    type
    objectType
    required
    options {
      label
      value
    }
  }
  companyAttributes: enrichmentAttributes(types: [clearbit_company]) {
    ...Attribute
    children {
      ...Attribute
      children {
        ...Attribute
      }
    }
  }
}
    ${AttributeFragmentDoc}`;

/**
 * __useCreateExternalRecordsSalesforceAccountsQuery__
 *
 * To run a query within a React component, call `useCreateExternalRecordsSalesforceAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalRecordsSalesforceAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateExternalRecordsSalesforceAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateExternalRecordsSalesforceAccountsQuery(baseOptions?: Apollo.QueryHookOptions<CreateExternalRecordsSalesforceAccountsQuery, CreateExternalRecordsSalesforceAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateExternalRecordsSalesforceAccountsQuery, CreateExternalRecordsSalesforceAccountsQueryVariables>(CreateExternalRecordsSalesforceAccountsDocument, options);
      }
export function useCreateExternalRecordsSalesforceAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateExternalRecordsSalesforceAccountsQuery, CreateExternalRecordsSalesforceAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateExternalRecordsSalesforceAccountsQuery, CreateExternalRecordsSalesforceAccountsQueryVariables>(CreateExternalRecordsSalesforceAccountsDocument, options);
        }
export type CreateExternalRecordsSalesforceAccountsQueryHookResult = ReturnType<typeof useCreateExternalRecordsSalesforceAccountsQuery>;
export type CreateExternalRecordsSalesforceAccountsLazyQueryHookResult = ReturnType<typeof useCreateExternalRecordsSalesforceAccountsLazyQuery>;
export type CreateExternalRecordsSalesforceAccountsQueryResult = Apollo.QueryResult<CreateExternalRecordsSalesforceAccountsQuery, CreateExternalRecordsSalesforceAccountsQueryVariables>;
export const CreateExternalRecordsSalesforceContactsDocument = gql`
    query CreateExternalRecordsSalesforceContacts {
  salesforceTraits(objectType: contact) {
    name
    label
    type
    objectType
    required
    options {
      label
      value
    }
  }
  personAttributes: enrichmentAttributes(types: [clearbit_person]) {
    ...Attribute
    children {
      ...Attribute
      children {
        ...Attribute
      }
    }
  }
  prospectFilters {
    role {
      value
      label
    }
    seniority {
      value
      label
    }
    country {
      value
      label
    }
    title {
      value
      label
    }
  }
}
    ${AttributeFragmentDoc}`;

/**
 * __useCreateExternalRecordsSalesforceContactsQuery__
 *
 * To run a query within a React component, call `useCreateExternalRecordsSalesforceContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalRecordsSalesforceContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateExternalRecordsSalesforceContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateExternalRecordsSalesforceContactsQuery(baseOptions?: Apollo.QueryHookOptions<CreateExternalRecordsSalesforceContactsQuery, CreateExternalRecordsSalesforceContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateExternalRecordsSalesforceContactsQuery, CreateExternalRecordsSalesforceContactsQueryVariables>(CreateExternalRecordsSalesforceContactsDocument, options);
      }
export function useCreateExternalRecordsSalesforceContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateExternalRecordsSalesforceContactsQuery, CreateExternalRecordsSalesforceContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateExternalRecordsSalesforceContactsQuery, CreateExternalRecordsSalesforceContactsQueryVariables>(CreateExternalRecordsSalesforceContactsDocument, options);
        }
export type CreateExternalRecordsSalesforceContactsQueryHookResult = ReturnType<typeof useCreateExternalRecordsSalesforceContactsQuery>;
export type CreateExternalRecordsSalesforceContactsLazyQueryHookResult = ReturnType<typeof useCreateExternalRecordsSalesforceContactsLazyQuery>;
export type CreateExternalRecordsSalesforceContactsQueryResult = Apollo.QueryResult<CreateExternalRecordsSalesforceContactsQuery, CreateExternalRecordsSalesforceContactsQueryVariables>;
export const CreateExternalRecordsSalesforceLeadsDocument = gql`
    query CreateExternalRecordsSalesforceLeads {
  salesforceTraits(objectType: lead) {
    name
    label
    type
    objectType
    required
    options {
      label
      value
    }
  }
  personAttributes: enrichmentAttributes(types: [clearbit_person]) {
    ...Attribute
    children {
      ...Attribute
      children {
        ...Attribute
      }
    }
  }
  companyAttributes: enrichmentAttributes(types: [clearbit_company]) {
    ...Attribute
    children {
      ...Attribute
      children {
        ...Attribute
      }
    }
  }
  prospectFilters {
    role {
      value
      label
    }
    seniority {
      value
      label
    }
    country {
      value
      label
    }
    title {
      value
      label
    }
  }
}
    ${AttributeFragmentDoc}`;

/**
 * __useCreateExternalRecordsSalesforceLeadsQuery__
 *
 * To run a query within a React component, call `useCreateExternalRecordsSalesforceLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalRecordsSalesforceLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateExternalRecordsSalesforceLeadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateExternalRecordsSalesforceLeadsQuery(baseOptions?: Apollo.QueryHookOptions<CreateExternalRecordsSalesforceLeadsQuery, CreateExternalRecordsSalesforceLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateExternalRecordsSalesforceLeadsQuery, CreateExternalRecordsSalesforceLeadsQueryVariables>(CreateExternalRecordsSalesforceLeadsDocument, options);
      }
export function useCreateExternalRecordsSalesforceLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateExternalRecordsSalesforceLeadsQuery, CreateExternalRecordsSalesforceLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateExternalRecordsSalesforceLeadsQuery, CreateExternalRecordsSalesforceLeadsQueryVariables>(CreateExternalRecordsSalesforceLeadsDocument, options);
        }
export type CreateExternalRecordsSalesforceLeadsQueryHookResult = ReturnType<typeof useCreateExternalRecordsSalesforceLeadsQuery>;
export type CreateExternalRecordsSalesforceLeadsLazyQueryHookResult = ReturnType<typeof useCreateExternalRecordsSalesforceLeadsLazyQuery>;
export type CreateExternalRecordsSalesforceLeadsQueryResult = Apollo.QueryResult<CreateExternalRecordsSalesforceLeadsQuery, CreateExternalRecordsSalesforceLeadsQueryVariables>;
export const GoogleConversionTrackerLookupDocument = gql`
    query GoogleConversionTrackerLookup($adAccountId: String!) {
  googleConversionTrackers(adAccountId: $adAccountId) {
    id
    name
    defaultValue
    defaultCurrency
    allowsCustomValues
  }
}
    `;

/**
 * __useGoogleConversionTrackerLookupQuery__
 *
 * To run a query within a React component, call `useGoogleConversionTrackerLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleConversionTrackerLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleConversionTrackerLookupQuery({
 *   variables: {
 *      adAccountId: // value for 'adAccountId'
 *   },
 * });
 */
export function useGoogleConversionTrackerLookupQuery(baseOptions: Apollo.QueryHookOptions<GoogleConversionTrackerLookupQuery, GoogleConversionTrackerLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleConversionTrackerLookupQuery, GoogleConversionTrackerLookupQueryVariables>(GoogleConversionTrackerLookupDocument, options);
      }
export function useGoogleConversionTrackerLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleConversionTrackerLookupQuery, GoogleConversionTrackerLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleConversionTrackerLookupQuery, GoogleConversionTrackerLookupQueryVariables>(GoogleConversionTrackerLookupDocument, options);
        }
export type GoogleConversionTrackerLookupQueryHookResult = ReturnType<typeof useGoogleConversionTrackerLookupQuery>;
export type GoogleConversionTrackerLookupLazyQueryHookResult = ReturnType<typeof useGoogleConversionTrackerLookupLazyQuery>;
export type GoogleConversionTrackerLookupQueryResult = Apollo.QueryResult<GoogleConversionTrackerLookupQuery, GoogleConversionTrackerLookupQueryVariables>;
export const EnrichmentLogsShowPageDocument = gql`
    query EnrichmentLogsShowPage($service: [AccountConnectorServiceEnum!]!) {
  accountConnector(service: $service, status: [active]) {
    id
    service
    remoteMeta
  }
}
    `;

/**
 * __useEnrichmentLogsShowPageQuery__
 *
 * To run a query within a React component, call `useEnrichmentLogsShowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentLogsShowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentLogsShowPageQuery({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useEnrichmentLogsShowPageQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentLogsShowPageQuery, EnrichmentLogsShowPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentLogsShowPageQuery, EnrichmentLogsShowPageQueryVariables>(EnrichmentLogsShowPageDocument, options);
      }
export function useEnrichmentLogsShowPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentLogsShowPageQuery, EnrichmentLogsShowPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentLogsShowPageQuery, EnrichmentLogsShowPageQueryVariables>(EnrichmentLogsShowPageDocument, options);
        }
export type EnrichmentLogsShowPageQueryHookResult = ReturnType<typeof useEnrichmentLogsShowPageQuery>;
export type EnrichmentLogsShowPageLazyQueryHookResult = ReturnType<typeof useEnrichmentLogsShowPageLazyQuery>;
export type EnrichmentLogsShowPageQueryResult = Apollo.QueryResult<EnrichmentLogsShowPageQuery, EnrichmentLogsShowPageQueryVariables>;
export const EnrichmentLogResultsDocument = gql`
    query EnrichmentLogResults($queryExecutionId: String!) {
  enrichmentLogResult(queryExecutionId: $queryExecutionId) {
    id
    externalId
    identifier
    image
    name
    status
    steps {
      changes {
        fieldName
        from
        to
      }
      name
      message
      status
      timestamp
    }
    subType
    type
  }
}
    `;

/**
 * __useEnrichmentLogResultsQuery__
 *
 * To run a query within a React component, call `useEnrichmentLogResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentLogResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentLogResultsQuery({
 *   variables: {
 *      queryExecutionId: // value for 'queryExecutionId'
 *   },
 * });
 */
export function useEnrichmentLogResultsQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentLogResultsQuery, EnrichmentLogResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentLogResultsQuery, EnrichmentLogResultsQueryVariables>(EnrichmentLogResultsDocument, options);
      }
export function useEnrichmentLogResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentLogResultsQuery, EnrichmentLogResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentLogResultsQuery, EnrichmentLogResultsQueryVariables>(EnrichmentLogResultsDocument, options);
        }
export type EnrichmentLogResultsQueryHookResult = ReturnType<typeof useEnrichmentLogResultsQuery>;
export type EnrichmentLogResultsLazyQueryHookResult = ReturnType<typeof useEnrichmentLogResultsLazyQuery>;
export type EnrichmentLogResultsQueryResult = Apollo.QueryResult<EnrichmentLogResultsQuery, EnrichmentLogResultsQueryVariables>;
export const EnrichmentLogDocument = gql`
    query EnrichmentLog($type: EnrichmentLogTypeEnum!, $id: ID!) {
  enrichmentLog(id: $id, type: $type) {
    queryExecutionId
  }
}
    `;

/**
 * __useEnrichmentLogQuery__
 *
 * To run a query within a React component, call `useEnrichmentLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentLogQuery({
 *   variables: {
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnrichmentLogQuery(baseOptions: Apollo.QueryHookOptions<EnrichmentLogQuery, EnrichmentLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentLogQuery, EnrichmentLogQueryVariables>(EnrichmentLogDocument, options);
      }
export function useEnrichmentLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentLogQuery, EnrichmentLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentLogQuery, EnrichmentLogQueryVariables>(EnrichmentLogDocument, options);
        }
export type EnrichmentLogQueryHookResult = ReturnType<typeof useEnrichmentLogQuery>;
export type EnrichmentLogLazyQueryHookResult = ReturnType<typeof useEnrichmentLogLazyQuery>;
export type EnrichmentLogQueryResult = Apollo.QueryResult<EnrichmentLogQuery, EnrichmentLogQueryVariables>;
export const CancelBackfillDocument = gql`
    mutation CancelBackfill($input: AccountConnectorsCancelBackfillInput!) {
  response: cancelBackfill(input: $input) {
    clientMutationId
  }
}
    `;
export type CancelBackfillMutationFn = Apollo.MutationFunction<CancelBackfillMutation, CancelBackfillMutationVariables>;

/**
 * __useCancelBackfillMutation__
 *
 * To run a mutation, you first call `useCancelBackfillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBackfillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBackfillMutation, { data, loading, error }] = useCancelBackfillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelBackfillMutation(baseOptions?: Apollo.MutationHookOptions<CancelBackfillMutation, CancelBackfillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBackfillMutation, CancelBackfillMutationVariables>(CancelBackfillDocument, options);
      }
export type CancelBackfillMutationHookResult = ReturnType<typeof useCancelBackfillMutation>;
export type CancelBackfillMutationResult = Apollo.MutationResult<CancelBackfillMutation>;
export type CancelBackfillMutationOptions = Apollo.BaseMutationOptions<CancelBackfillMutation, CancelBackfillMutationVariables>;
export const TriggerBackfillDocument = gql`
    mutation TriggerBackfill($input: AccountConnectorsTriggerBackfillInput!) {
  response: triggerBackfill(input: $input) {
    clientMutationId
    errors {
      field
      messages
    }
  }
}
    `;
export type TriggerBackfillMutationFn = Apollo.MutationFunction<TriggerBackfillMutation, TriggerBackfillMutationVariables>;

/**
 * __useTriggerBackfillMutation__
 *
 * To run a mutation, you first call `useTriggerBackfillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerBackfillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerBackfillMutation, { data, loading, error }] = useTriggerBackfillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerBackfillMutation(baseOptions?: Apollo.MutationHookOptions<TriggerBackfillMutation, TriggerBackfillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerBackfillMutation, TriggerBackfillMutationVariables>(TriggerBackfillDocument, options);
      }
export type TriggerBackfillMutationHookResult = ReturnType<typeof useTriggerBackfillMutation>;
export type TriggerBackfillMutationResult = Apollo.MutationResult<TriggerBackfillMutation>;
export type TriggerBackfillMutationOptions = Apollo.BaseMutationOptions<TriggerBackfillMutation, TriggerBackfillMutationVariables>;
export const FieldMappingDocument = gql`
    query FieldMapping($targetObjectType: String!, $accountConnectorId: ID!) {
  fieldMapping(targetObjectType: $targetObjectType, accountConnectorId: $accountConnectorId) {
    targetType
    targetAccountId
    targetObjectType
    fieldMappings
    enabled
  }
}
    `;

/**
 * __useFieldMappingQuery__
 *
 * To run a query within a React component, call `useFieldMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldMappingQuery({
 *   variables: {
 *      targetObjectType: // value for 'targetObjectType'
 *      accountConnectorId: // value for 'accountConnectorId'
 *   },
 * });
 */
export function useFieldMappingQuery(baseOptions: Apollo.QueryHookOptions<FieldMappingQuery, FieldMappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldMappingQuery, FieldMappingQueryVariables>(FieldMappingDocument, options);
      }
export function useFieldMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldMappingQuery, FieldMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldMappingQuery, FieldMappingQueryVariables>(FieldMappingDocument, options);
        }
export type FieldMappingQueryHookResult = ReturnType<typeof useFieldMappingQuery>;
export type FieldMappingLazyQueryHookResult = ReturnType<typeof useFieldMappingLazyQuery>;
export type FieldMappingQueryResult = Apollo.QueryResult<FieldMappingQuery, FieldMappingQueryVariables>;
export const UpdateFieldMappingDocument = gql`
    mutation UpdateFieldMapping($input: AccountConnectorsUpdateFieldMappingInput!) {
  response: updateFieldMapping(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateFieldMappingMutationFn = Apollo.MutationFunction<UpdateFieldMappingMutation, UpdateFieldMappingMutationVariables>;

/**
 * __useUpdateFieldMappingMutation__
 *
 * To run a mutation, you first call `useUpdateFieldMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldMappingMutation, { data, loading, error }] = useUpdateFieldMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFieldMappingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldMappingMutation, UpdateFieldMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldMappingMutation, UpdateFieldMappingMutationVariables>(UpdateFieldMappingDocument, options);
      }
export type UpdateFieldMappingMutationHookResult = ReturnType<typeof useUpdateFieldMappingMutation>;
export type UpdateFieldMappingMutationResult = Apollo.MutationResult<UpdateFieldMappingMutation>;
export type UpdateFieldMappingMutationOptions = Apollo.BaseMutationOptions<UpdateFieldMappingMutation, UpdateFieldMappingMutationVariables>;
export const FieldMappingFormDocument = gql`
    query FieldMappingForm($service: [AccountConnectorServiceEnum!]!, $sourceTypes: [EnrichmentAttributeTypeEnum!]!, $targetObjectType: String!, $targetTypes: [EnrichmentAttributeTypeEnum!]!, $refreshAttributes: Boolean!, $externalObjectType: String!) {
  accountConnector(service: $service, status: [active]) {
    id
    service
    backfillActive(targetObjectType: $targetObjectType)
    selectiveEnrichmentFilters(externalObjectType: $externalObjectType) {
      filters
    }
  }
  sourceAttributes: enrichmentAttributes(types: $sourceTypes, service: $service) {
    ...Attribute
    children {
      ...Attribute
      children {
        ...Attribute
      }
    }
  }
  targetAttributes: enrichmentAttributes(types: $targetTypes, service: $service, refreshAttributes: $refreshAttributes) {
    ...Attribute
  }
}
    ${AttributeFragmentDoc}`;

/**
 * __useFieldMappingFormQuery__
 *
 * To run a query within a React component, call `useFieldMappingFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldMappingFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldMappingFormQuery({
 *   variables: {
 *      service: // value for 'service'
 *      sourceTypes: // value for 'sourceTypes'
 *      targetObjectType: // value for 'targetObjectType'
 *      targetTypes: // value for 'targetTypes'
 *      refreshAttributes: // value for 'refreshAttributes'
 *      externalObjectType: // value for 'externalObjectType'
 *   },
 * });
 */
export function useFieldMappingFormQuery(baseOptions: Apollo.QueryHookOptions<FieldMappingFormQuery, FieldMappingFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldMappingFormQuery, FieldMappingFormQueryVariables>(FieldMappingFormDocument, options);
      }
export function useFieldMappingFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldMappingFormQuery, FieldMappingFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldMappingFormQuery, FieldMappingFormQueryVariables>(FieldMappingFormDocument, options);
        }
export type FieldMappingFormQueryHookResult = ReturnType<typeof useFieldMappingFormQuery>;
export type FieldMappingFormLazyQueryHookResult = ReturnType<typeof useFieldMappingFormLazyQuery>;
export type FieldMappingFormQueryResult = Apollo.QueryResult<FieldMappingFormQuery, FieldMappingFormQueryVariables>;
export const ReexportPropertiesDocument = gql`
    mutation ReexportProperties($input: AccountConnectorsReexportPropertiesInput!) {
  reexportProperties(input: $input) {
    node {
      jobId
      queue
      status
      runId
      timestamp
    }
  }
}
    `;
export type ReexportPropertiesMutationFn = Apollo.MutationFunction<ReexportPropertiesMutation, ReexportPropertiesMutationVariables>;

/**
 * __useReexportPropertiesMutation__
 *
 * To run a mutation, you first call `useReexportPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReexportPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reexportPropertiesMutation, { data, loading, error }] = useReexportPropertiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReexportPropertiesMutation(baseOptions?: Apollo.MutationHookOptions<ReexportPropertiesMutation, ReexportPropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReexportPropertiesMutation, ReexportPropertiesMutationVariables>(ReexportPropertiesDocument, options);
      }
export type ReexportPropertiesMutationHookResult = ReturnType<typeof useReexportPropertiesMutation>;
export type ReexportPropertiesMutationResult = Apollo.MutationResult<ReexportPropertiesMutation>;
export type ReexportPropertiesMutationOptions = Apollo.BaseMutationOptions<ReexportPropertiesMutation, ReexportPropertiesMutationVariables>;
export const ToggleFieldMappingDocument = gql`
    mutation ToggleFieldMapping($input: AccountConnectorsToggleFieldMappingInput!, $targetObjectType: String!) {
  response: toggleFieldMapping(input: $input) {
    node {
      id
      fieldMapping(targetObjectType: $targetObjectType) {
        targetObjectType
        enabled
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ToggleFieldMappingMutationFn = Apollo.MutationFunction<ToggleFieldMappingMutation, ToggleFieldMappingMutationVariables>;

/**
 * __useToggleFieldMappingMutation__
 *
 * To run a mutation, you first call `useToggleFieldMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFieldMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFieldMappingMutation, { data, loading, error }] = useToggleFieldMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *      targetObjectType: // value for 'targetObjectType'
 *   },
 * });
 */
export function useToggleFieldMappingMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFieldMappingMutation, ToggleFieldMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFieldMappingMutation, ToggleFieldMappingMutationVariables>(ToggleFieldMappingDocument, options);
      }
export type ToggleFieldMappingMutationHookResult = ReturnType<typeof useToggleFieldMappingMutation>;
export type ToggleFieldMappingMutationResult = Apollo.MutationResult<ToggleFieldMappingMutation>;
export type ToggleFieldMappingMutationOptions = Apollo.BaseMutationOptions<ToggleFieldMappingMutation, ToggleFieldMappingMutationVariables>;
export const DeleteSelectiveEnrichmentDocument = gql`
    mutation DeleteSelectiveEnrichment($input: AccountConnectorsDeleteSelectiveEnrichmentInput!) {
  response: deleteSelectiveEnrichment(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteSelectiveEnrichmentMutationFn = Apollo.MutationFunction<DeleteSelectiveEnrichmentMutation, DeleteSelectiveEnrichmentMutationVariables>;

/**
 * __useDeleteSelectiveEnrichmentMutation__
 *
 * To run a mutation, you first call `useDeleteSelectiveEnrichmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSelectiveEnrichmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSelectiveEnrichmentMutation, { data, loading, error }] = useDeleteSelectiveEnrichmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSelectiveEnrichmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSelectiveEnrichmentMutation, DeleteSelectiveEnrichmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSelectiveEnrichmentMutation, DeleteSelectiveEnrichmentMutationVariables>(DeleteSelectiveEnrichmentDocument, options);
      }
export type DeleteSelectiveEnrichmentMutationHookResult = ReturnType<typeof useDeleteSelectiveEnrichmentMutation>;
export type DeleteSelectiveEnrichmentMutationResult = Apollo.MutationResult<DeleteSelectiveEnrichmentMutation>;
export type DeleteSelectiveEnrichmentMutationOptions = Apollo.BaseMutationOptions<DeleteSelectiveEnrichmentMutation, DeleteSelectiveEnrichmentMutationVariables>;
export const SaveSelectiveEnrichmentDocument = gql`
    mutation SaveSelectiveEnrichment($input: AccountConnectorsSaveSelectiveEnrichmentInput!) {
  response: saveSelectiveEnrichment(input: $input) {
    clientMutationId
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveSelectiveEnrichmentMutationFn = Apollo.MutationFunction<SaveSelectiveEnrichmentMutation, SaveSelectiveEnrichmentMutationVariables>;

/**
 * __useSaveSelectiveEnrichmentMutation__
 *
 * To run a mutation, you first call `useSaveSelectiveEnrichmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSelectiveEnrichmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSelectiveEnrichmentMutation, { data, loading, error }] = useSaveSelectiveEnrichmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSelectiveEnrichmentMutation(baseOptions?: Apollo.MutationHookOptions<SaveSelectiveEnrichmentMutation, SaveSelectiveEnrichmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSelectiveEnrichmentMutation, SaveSelectiveEnrichmentMutationVariables>(SaveSelectiveEnrichmentDocument, options);
      }
export type SaveSelectiveEnrichmentMutationHookResult = ReturnType<typeof useSaveSelectiveEnrichmentMutation>;
export type SaveSelectiveEnrichmentMutationResult = Apollo.MutationResult<SaveSelectiveEnrichmentMutation>;
export type SaveSelectiveEnrichmentMutationOptions = Apollo.BaseMutationOptions<SaveSelectiveEnrichmentMutation, SaveSelectiveEnrichmentMutationVariables>;
export const SelectiveEnrichmentConfigDocument = gql`
    query SelectiveEnrichmentConfig($type: AttributeTypeEnum!, $integrationCategory: AttributeCategoryEnum!, $collectionType: CollectionLegacyTypeEnum!, $salesforceSubCategories: [AttributeSalesforceSubCategoryEnum!]!, $hubspotSubCategories: [AttributeHubspotSubCategoryEnum!]!, $marketoSubCategories: [AttributeMarketoSubCategoryEnum!]!) {
  searchAttributes(type: $type, categories: [$integrationCategory], salesforceSubCategories: $salesforceSubCategories, hubspotSubCategories: $hubspotSubCategories, marketoSubCategories: $marketoSubCategories) {
    ...SegmentFormAttribute
  }
  salesforceUsers {
    ...SegmentFormSegmentBuilderSalesforceUser
  }
  collections(type: $collectionType) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    ${SegmentFormAttributeFragmentDoc}
${SegmentFormSegmentBuilderSalesforceUserFragmentDoc}`;

/**
 * __useSelectiveEnrichmentConfigQuery__
 *
 * To run a query within a React component, call `useSelectiveEnrichmentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectiveEnrichmentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectiveEnrichmentConfigQuery({
 *   variables: {
 *      type: // value for 'type'
 *      integrationCategory: // value for 'integrationCategory'
 *      collectionType: // value for 'collectionType'
 *      salesforceSubCategories: // value for 'salesforceSubCategories'
 *      hubspotSubCategories: // value for 'hubspotSubCategories'
 *      marketoSubCategories: // value for 'marketoSubCategories'
 *   },
 * });
 */
export function useSelectiveEnrichmentConfigQuery(baseOptions: Apollo.QueryHookOptions<SelectiveEnrichmentConfigQuery, SelectiveEnrichmentConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectiveEnrichmentConfigQuery, SelectiveEnrichmentConfigQueryVariables>(SelectiveEnrichmentConfigDocument, options);
      }
export function useSelectiveEnrichmentConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectiveEnrichmentConfigQuery, SelectiveEnrichmentConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectiveEnrichmentConfigQuery, SelectiveEnrichmentConfigQueryVariables>(SelectiveEnrichmentConfigDocument, options);
        }
export type SelectiveEnrichmentConfigQueryHookResult = ReturnType<typeof useSelectiveEnrichmentConfigQuery>;
export type SelectiveEnrichmentConfigLazyQueryHookResult = ReturnType<typeof useSelectiveEnrichmentConfigLazyQuery>;
export type SelectiveEnrichmentConfigQueryResult = Apollo.QueryResult<SelectiveEnrichmentConfigQuery, SelectiveEnrichmentConfigQueryVariables>;
export const WebhookConfigAccountConnectorDocument = gql`
    query WebhookConfigAccountConnector($service: [AccountConnectorServiceEnum!]!) {
  accountConnector(service: $service, status: [active]) {
    id
    service
    remoteMeta
    webhookPassword
  }
}
    `;

/**
 * __useWebhookConfigAccountConnectorQuery__
 *
 * To run a query within a React component, call `useWebhookConfigAccountConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhookConfigAccountConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookConfigAccountConnectorQuery({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useWebhookConfigAccountConnectorQuery(baseOptions: Apollo.QueryHookOptions<WebhookConfigAccountConnectorQuery, WebhookConfigAccountConnectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebhookConfigAccountConnectorQuery, WebhookConfigAccountConnectorQueryVariables>(WebhookConfigAccountConnectorDocument, options);
      }
export function useWebhookConfigAccountConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebhookConfigAccountConnectorQuery, WebhookConfigAccountConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebhookConfigAccountConnectorQuery, WebhookConfigAccountConnectorQueryVariables>(WebhookConfigAccountConnectorDocument, options);
        }
export type WebhookConfigAccountConnectorQueryHookResult = ReturnType<typeof useWebhookConfigAccountConnectorQuery>;
export type WebhookConfigAccountConnectorLazyQueryHookResult = ReturnType<typeof useWebhookConfigAccountConnectorLazyQuery>;
export type WebhookConfigAccountConnectorQueryResult = Apollo.QueryResult<WebhookConfigAccountConnectorQuery, WebhookConfigAccountConnectorQueryVariables>;
export const EnrichmentShowDocument = gql`
    query EnrichmentShow($service: AccountConnectorServiceEnum) {
  account {
    id
    flags
  }
  accountNotifications(service: $service) {
    ...AccountNotifications
    service
  }
}
    ${AccountNotificationsFragmentDoc}`;

/**
 * __useEnrichmentShowQuery__
 *
 * To run a query within a React component, call `useEnrichmentShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentShowQuery({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useEnrichmentShowQuery(baseOptions?: Apollo.QueryHookOptions<EnrichmentShowQuery, EnrichmentShowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentShowQuery, EnrichmentShowQueryVariables>(EnrichmentShowDocument, options);
      }
export function useEnrichmentShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentShowQuery, EnrichmentShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentShowQuery, EnrichmentShowQueryVariables>(EnrichmentShowDocument, options);
        }
export type EnrichmentShowQueryHookResult = ReturnType<typeof useEnrichmentShowQuery>;
export type EnrichmentShowLazyQueryHookResult = ReturnType<typeof useEnrichmentShowLazyQuery>;
export type EnrichmentShowQueryResult = Apollo.QueryResult<EnrichmentShowQuery, EnrichmentShowQueryVariables>;
export const HomePageDocument = gql`
    query HomePage {
  account {
    id
    name
    domain
  }
  accountConnectors(status: [disconnected]) {
    ...ActiveIntegrationCardAccountConnector
  }
  viewer {
    id
    user {
      firstName
      ...AccountSwitch
    }
  }
  accountNotifications {
    ...AccountNotifications
  }
  news {
    articles
  }
}
    ${ActiveIntegrationCardAccountConnectorFragmentDoc}
${AccountSwitchFragmentDoc}
${AccountNotificationsFragmentDoc}`;

/**
 * __useHomePageQuery__
 *
 * To run a query within a React component, call `useHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomePageQuery(baseOptions?: Apollo.QueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
      }
export function useHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageQuery, HomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageQuery, HomePageQueryVariables>(HomePageDocument, options);
        }
export type HomePageQueryHookResult = ReturnType<typeof useHomePageQuery>;
export type HomePageLazyQueryHookResult = ReturnType<typeof useHomePageLazyQuery>;
export type HomePageQueryResult = Apollo.QueryResult<HomePageQuery, HomePageQueryVariables>;
export const PeoplePageDocument = gql`
    query PeoplePage($peopleCursor: String, $peoplePageSize: Int!, $peopleSearchQuery: String, $peopleSegmentId: ID) {
  columns(segmentId: $peopleSegmentId, type: Person)
  people(after: $peopleCursor, first: $peoplePageSize, query: $peopleSearchQuery, segmentId: $peopleSegmentId) {
    totalCount
    ...PeopleListConnection
  }
  account {
    ...InitialSyncAlert
  }
}
    ${PeopleListConnectionFragmentDoc}
${InitialSyncAlertFragmentDoc}`;

/**
 * __usePeoplePageQuery__
 *
 * To run a query within a React component, call `usePeoplePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeoplePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeoplePageQuery({
 *   variables: {
 *      peopleCursor: // value for 'peopleCursor'
 *      peoplePageSize: // value for 'peoplePageSize'
 *      peopleSearchQuery: // value for 'peopleSearchQuery'
 *      peopleSegmentId: // value for 'peopleSegmentId'
 *   },
 * });
 */
export function usePeoplePageQuery(baseOptions: Apollo.QueryHookOptions<PeoplePageQuery, PeoplePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeoplePageQuery, PeoplePageQueryVariables>(PeoplePageDocument, options);
      }
export function usePeoplePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeoplePageQuery, PeoplePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeoplePageQuery, PeoplePageQueryVariables>(PeoplePageDocument, options);
        }
export type PeoplePageQueryHookResult = ReturnType<typeof usePeoplePageQuery>;
export type PeoplePageLazyQueryHookResult = ReturnType<typeof usePeoplePageLazyQuery>;
export type PeoplePageQueryResult = Apollo.QueryResult<PeoplePageQuery, PeoplePageQueryVariables>;
export const PeopleSegmentPageDocument = gql`
    query PeopleSegmentPage($peopleCursor: String, $peoplePageSize: Int!, $peopleSearchQuery: String, $peopleSegmentId: ID!) {
  columns(segmentId: $peopleSegmentId, type: Person)
  people(after: $peopleCursor, first: $peoplePageSize, query: $peopleSearchQuery, segmentId: $peopleSegmentId) {
    totalCount
    ...PeopleListConnection
  }
  segment(id: $peopleSegmentId, type: PersonSegment) {
    id
    type
    ...SegmentLayout
  }
}
    ${PeopleListConnectionFragmentDoc}
${SegmentLayoutFragmentDoc}`;

/**
 * __usePeopleSegmentPageQuery__
 *
 * To run a query within a React component, call `usePeopleSegmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleSegmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleSegmentPageQuery({
 *   variables: {
 *      peopleCursor: // value for 'peopleCursor'
 *      peoplePageSize: // value for 'peoplePageSize'
 *      peopleSearchQuery: // value for 'peopleSearchQuery'
 *      peopleSegmentId: // value for 'peopleSegmentId'
 *   },
 * });
 */
export function usePeopleSegmentPageQuery(baseOptions: Apollo.QueryHookOptions<PeopleSegmentPageQuery, PeopleSegmentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleSegmentPageQuery, PeopleSegmentPageQueryVariables>(PeopleSegmentPageDocument, options);
      }
export function usePeopleSegmentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleSegmentPageQuery, PeopleSegmentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleSegmentPageQuery, PeopleSegmentPageQueryVariables>(PeopleSegmentPageDocument, options);
        }
export type PeopleSegmentPageQueryHookResult = ReturnType<typeof usePeopleSegmentPageQuery>;
export type PeopleSegmentPageLazyQueryHookResult = ReturnType<typeof usePeopleSegmentPageLazyQuery>;
export type PeopleSegmentPageQueryResult = Apollo.QueryResult<PeopleSegmentPageQuery, PeopleSegmentPageQueryVariables>;
export const PersonSegmentsDocument = gql`
    query PersonSegments($id: ID!) {
  person(id: $id) {
    id
    segments {
      type
      id
      name
      audiences {
        edges {
          node {
            id
          }
        }
      }
      destinations {
        id
        description
        type
      }
      collection {
        id
        name
      }
      updatedAt
    }
  }
}
    `;

/**
 * __usePersonSegmentsQuery__
 *
 * To run a query within a React component, call `usePersonSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonSegmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonSegmentsQuery(baseOptions: Apollo.QueryHookOptions<PersonSegmentsQuery, PersonSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonSegmentsQuery, PersonSegmentsQueryVariables>(PersonSegmentsDocument, options);
      }
export function usePersonSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonSegmentsQuery, PersonSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonSegmentsQuery, PersonSegmentsQueryVariables>(PersonSegmentsDocument, options);
        }
export type PersonSegmentsQueryHookResult = ReturnType<typeof usePersonSegmentsQuery>;
export type PersonSegmentsLazyQueryHookResult = ReturnType<typeof usePersonSegmentsLazyQuery>;
export type PersonSegmentsQueryResult = Apollo.QueryResult<PersonSegmentsQuery, PersonSegmentsQueryVariables>;
export const PersonPageDocument = gql`
    query PersonPage($id: ID!) {
  person(id: $id) {
    id
    name
    email
    avatar
    enrichment
    traits
    companyEnrichment
    ...PersonPageDetails
    ...PersonAttributeBrowser
    salesforceAccounts {
      edges {
        node {
          id
          name
          properties
        }
      }
    }
    salesforceContacts {
      edges {
        node {
          id
          ...PersonPageActionsSalesforceContact
        }
      }
    }
    salesforceLeads {
      edges {
        node {
          id
          ...PersonPageActionsSalesforceLead
        }
      }
    }
    hubspotCompanies {
      edges {
        node {
          id
          ...PersonPageActionsHubspotCompany
        }
      }
    }
  }
  salesforceAccountConnector: accountConnector(service: [salesforce, salesforcesandbox], status: active) {
    id
    ...PersonPageActionsSalesforceAccountConnector
  }
  hubspotAccountConnector: accountConnector(service: hubspot, status: active) {
    id
    ...PersonPageActionsHubspotAccountConnector
  }
}
    ${PersonPageDetailsFragmentDoc}
${PersonAttributeBrowserFragmentDoc}
${PersonPageActionsSalesforceContactFragmentDoc}
${PersonPageActionsSalesforceLeadFragmentDoc}
${PersonPageActionsHubspotCompanyFragmentDoc}
${PersonPageActionsSalesforceAccountConnectorFragmentDoc}
${PersonPageActionsHubspotAccountConnectorFragmentDoc}`;

/**
 * __usePersonPageQuery__
 *
 * To run a query within a React component, call `usePersonPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonPageQuery(baseOptions: Apollo.QueryHookOptions<PersonPageQuery, PersonPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonPageQuery, PersonPageQueryVariables>(PersonPageDocument, options);
      }
export function usePersonPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonPageQuery, PersonPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonPageQuery, PersonPageQueryVariables>(PersonPageDocument, options);
        }
export type PersonPageQueryHookResult = ReturnType<typeof usePersonPageQuery>;
export type PersonPageLazyQueryHookResult = ReturnType<typeof usePersonPageLazyQuery>;
export type PersonPageQueryResult = Apollo.QueryResult<PersonPageQuery, PersonPageQueryVariables>;